// import { Easel } from '../_models/easel';

export interface Sheet {
      id: number;
      mat_id: number;
      mat_name: string;
      mat_desc: string;
      retal: boolean;
      barcode: string;
      width: number;
      height: number;
      depth: number;
      kg_m2: number;
      unit: number;
      side: number;
      id_process: number; // Posible identificación de un proceso especial que pudiese llevar aplicada la hoja (0 sería ninguno).
      lager: string;
      location: string;
      reference: string;
      pieces: Traverse[]; // Listado de piezas que se sacaron de ella.
      traverses: Traverse[];
      draws: Draw[];
      used: boolean;
      diecutting: number;
      max_diecutting: number;
      disband: Disband;
      ts: number; // Total total hoja (sheet)
      tb: number; // Total area bruta
      tn: number; // Total area neta
      tr: number; // Total area retal
      td: number; // Total area desperdicio
      tm: number; // Total merma tanto por ciento

}

export interface Disband {
  left: number;
  bottom: number;
  right: number;
  top: number;
}

// Para manejar la relacion única "caballete - pieza - grupo".
export interface PieceToEasel {
      easel_id: number;
      easel_num: number;
      easel_name: string;
      easel_side: number;
      easel_stack: number;
      easel_barcode: string;
      easel_width: number;
      easel_height: number;
      easel_depth: number;
      easel_weight: number;
      easel_max_width: number;
      easel_max_height: number;
      easel_max_depth: number;
      easel_max_weight: number;
      easel_stacks: number;
      easel_sides: number;
      easel_separator: number;
      easel_flip: boolean;
      piece_id: number;
      piece_name_id: string;
      piece_steps: string;
      piece_mat_id: number;
      piece_material: string;
      piece_desc: string;
      piece_width: number;
      piece_height: number;
      piece_depth: number;
      piece_area: number;
      piece_group: string;
      piece_lot: number;
      piece_sequence: number;
      piece_sequence_unit: number;
      piece_sequence_broked: boolean;
      piece_total_unit: number;
      piece_orderno: number;
      piece_orderpos: number;
      piece_priority?: number;
      piece_paneno: number;
      piece_barcode: string;
      piece_num: number;
      piece_cut: boolean;
      piece_rotation: number;
      piece_decoat: number;
      piece_id_line: number;
      piece_id_client: number;
      piece_client: string;
      piece_figure: number;
      piece_figure_input?: number;
      piece_l: number;
      piece_l1: number;
      piece_l2: number;
      piece_h: number;
      piece_h1: number;
      piece_h2: number;
      piece_r: number;
      piece_r2: number;
      piece_r3: number;
      piece_r4: number;
      piece_b1: number;
      piece_b2: number;
      piece_b3: number;
      piece_b4: number;
      piece_dxf_name?: string;
      piece_dxf_points?: any;
      piece_dxf_w?: number;
      piece_dxf_h?: number;
      piece_oef_internal_polygons?: Point[][];
      piece_oef_generated?: boolean;
      piece_oef_primitive_w?: number;
      piece_oef_primitive_h?: number;
      piece_oef_effective_area?: number;
      piece_oef_real_units?: number;
      piece_oef_lock_rotation?: boolean;
      piece_oef_layout_priority?: number;
      piece_num_of: number;
      piece_pos_of: number;
      piece_set: PieceToEasel[];
      piece_matrix: any;
      piece_flip: boolean;
      draw_w: number;
      draw_h: number;
      draw: Draw;
      // traverse: Traverse;
}

export interface Traverse {
      id: number;
      sheet_id: number; // Id de la hoja en la que está la travera.
      sheet_width: number;
      sheet_height: number;
      name: string;
      axis: string;
      width: number;
      height: number;
      depth: number;
      piece: PieceToEasel; // Pieza que se ha sacado de esta travera.
      father: number; // Id de la travera de la que proviene.
      used: boolean;
      diecutting: number;
      max_diecutting: number;
      disband: Disband;
      origin_x: number; // Valor origen en el eje X.
      origin_y: number; // Valor origen en el eje Y.
      draw: Draw;
      old: boolean;
      level: number; // Nivel de profundidad de la travera vertical.
      level_h: number; // Nivel de profundidad de la travera horizontal.
      points: any // coordenadas
}

// Camino-Línea que siguen las hojas.
// export interface trailEasel {
//       name: string;
//       number: number;
//       family: number;
//       trail: Sheet[]
//       completed: boolean; // Cuando se vacíe el listado de hojas de su campo "trail".
// }

// Punto con sus coordenadas.
export interface Point {
      x: number;
      y: number;
}
// Dibujo que siguen los puntos que conforman un elemento de cierto tipo.
export interface Draw {

      sheet_id: number;
      old: boolean; // Si proviene de una travera "antigua".
      name: string;
      num: number;
      label: string;
      steps: string;
      lot: number;
      sequence: number;
      sequence_unit: number;
      sequence_broked: boolean;
      total_unit: number;
      name_id: string;
      mat_id: number;
      mat_name: string;
      mat_desc: string;
      group: string;
      orderno: number;
      orderpos: number;
      priority?: number;
      paneno: number;
      easel: string;
      easel_id: number;
      easel_max_width: number;
      easel_max_height: number;
      easel_max_depth: number;
      easel_max_weight: number;
      easel_stacks: number;
      easel_sides: number;
      easel_flip: boolean;
      separator: number;
      side: number;
      stack: number;
      width: number;
      height: number;
      depth: number;
      area: number;
      weight: number;
      points: Point[];
      decoat: number;
      id_line: number;
      id_client: number;
      client: string;
      type: string; // Dibujo de Travera 'T', dibujo de pieza 'P', de retal 'T', de hoja 'S', hoja no usada 'U'.
      rotation: number;
      form_id: number;
      oef_base_form_id?: number;
      form_L: number;
      form_L1: number;
      form_L2: number;
      form_H: number;
      form_H1: number;
      form_H2: number;
      form_R: number;
      form_R2: number;
      form_R3: number;
      form_R4: number;
      form_B1: number;
      form_B2: number;
      form_B3: number;
      form_B4: number;
      form_DXF_NAME?: string;
      form_DXF_POINTS?: any;
      form_DXF_W?: number;
      form_DXF_H?: number;
      oef_internal_polygons?: Point[][];
      oef_generated?: boolean;
      oef_primitive_w?: number;
      oef_primitive_h?: number;
      oef_effective_area?: number;
      oef_real_units?: number;
      num_of: number;
      pos_of: number;
      draw_set: Draw[];
      flip: boolean;
}

export class OptiFunction {

    actionInfo: string;
    alertInfo: string;
    infoInfo: string;


    sheetList: Sheet[];
    traverseList: Traverse[];
    oldTraverseList: Traverse[];
    pieceList: Traverse[]; // PieceToEasel[];
    
    // Variables para el manejo de la simulación de optimizar una única hoja.
    sheetOneList: Sheet[];
    traverseOneList: Traverse[];
    oldTraverseOneList: Traverse[];
    pieceOneList: Traverse[];
    nextOnePiece: any; // PieceToEasel[];
    // Variable que va a contener múltiples listados donde cada uno representa
    // una ordenación diferente de las piezas que se quieren optimizar.
    pieceListMultiple: any;

    nextSheet: Sheet;
    finalSheet: Sheet;
    nextTraverse: Traverse;
    nextPiece: PieceToEasel[];
    last_piece: PieceToEasel;
    currentPiece: any;
    	
	// Límite de hojas vacías en que una pieza se intenta colocar.
	null_sheet_limit: number;
    
    // Variable que va a contener todas las piezas ordenadas por salida en
    // el proceso de tronzado. La pieza en el índice 0 será la primera que
    // el operario sacará y la pieza en el índice (size - 1) será la última.
    cutting_ordered: Draw[];

    // Variable que va a contener el listado de piezas asociado cada "grupo de optimización".
    // totalPieceList: PieceToEasel[][];
    pieceInfoList: PieceToEasel[][];
    groupInfoList: any;
    groupListMode1: any;
    groupListMode2: any;

    sheet_count: number;
    traverse_count: number;
    piece_count: number;
    retal_count: number;
    
    // El lado mínimo que tendrá que tener un retal para
    // poder tener probabilidad de ser usado alguna vez.
    min_traverse_side: number;
    
    // Almacenará la pieza con el lado más corto que existe en toda la optimización.
    // Ningún retal que no tenga al menos un lado que mida igual o más que esto podrá servir.
    piece_min: any;
    min_side: number;
    piece_min_side: any;
    min_area: number;
    
    // Almacenará la pieza con el lado más largo que existe en toda la optimización.
    // Si no hay ninguna plancha que tenga al menos uno de sus lados igual o mayor, entonces
    // la pieza no podrá ser cortada y la optimización no será nunca del todo completa.
    piece_max: any;
    max_side: number;
    piece_max_side: any;
    max_area: number;
    
    // El mayor ancho y el mayor alto existente en las hojas que se usarán en una optimización.
    max_sheet_width: number;
    max_sheet_height: number;

    kg_m2: number;

    axis: string; // Eje general usado en la optimización.

    disband: Disband; // Valor general para el desbande de la hoja inical que se carga.

    min_die_cutting: number; // Valor general para la distancia mínima de troquelado que debe cumplirse.
    max_die_cutting: number; // Valor máximo para el ancho de travera (siempre eje X).

    retal_width: number;
    retal_height: number;

    piece_draw: Point[];
    traverse_draw: Point[];

    end_pieces: boolean;

    useOldTraverses: boolean;
    
    useBlocks: boolean;
    
    // Un contador global genérico.
    globalCount: number;
    
    // Para controlar la cantidad de iteraciones máximas permitidas
    // cuando se revisen las traveras a la hora de colocar una pieza.
    traverseIterator: number;
    oldTraverseIterator: number;
    
    // Para controlar la cantidad de prómesas máximas permitidas
    // cuando se lancen procesos de colocación de una pieza.
    promeseItertor: number;
    oldPromeseItertor: number;
    
    // Va a guardar el número de planchas que se pueden sacar seguidas sin colocar una pieza.
    continueCutLimit: number;
    
    // Va a contener el nivel de profundidad "infinito" para optimización.
    infinite_level: number;
    // Indica el nivel máximo de profundidad al que puede llegar la optimización.
    max_depth_level: number;
    // Activa una variante conservadora que, al iniciar una plancha, puede
    // adelantar una serie repetida para compartir su travera con la pieza
    // candidata que de otro modo consumiría una travera independiente.
    useSharedStripLookahead: boolean;
    // Decisión pendiente de alineación exterior para la pieza invitada de una
    // travera compartida. Se conserva fuera del objeto de pieza porque las
    // unidades equivalentes pueden reconstruirse durante la optimización.
    sharedStripAlignmentTarget: any;
    // Permite cambiar la partición de dos restos contiguos en forma de L
    // cuando ambos son demasiado estrechos para alojar cualquier pieza.
    // La superficie libre no cambia, pero se favorece una franja común ancha.
    useRemainderConsolidation: boolean;

 constructor() {
   
   this.globalCount = 0;
   
   // Por defecto se mirarán por pieza las 30 primeras traveras existentes.
   this.traverseIterator = 1000;
   this.oldTraverseIterator = 1000;
   
   // Por defecto se lanzarán por pieza un máximo de 10 promesas.
   this.promeseItertor = 1000;
   this.oldPromeseItertor = 1000;
   
   // Por defecto el límite de hojas que se van a intentar sacar seguidas será de 10.
   this.continueCutLimit = 1000;
   
   this.kg_m2 = 2.5;

   this.end_pieces = false;

   this.disband = {
      left: 0,
      bottom: 0,
      right: 0,
      top: 0,
    };

   this.min_die_cutting = 0;
   this.max_die_cutting = 6000; // Por defecto será 6000 siempre.

   this.sheet_count = 0;
   this.traverse_count = 0;
   this.piece_count = 0;
   this.retal_count = 0;

   this.retal_width = 0;
   this.retal_height = 0;

   this.piece_draw = [];
   this.traverse_draw = [];

   this.sheetList = [];
   this.traverseList = [];
   this.oldTraverseList = [];
   this.pieceList = [];
   
   this.sheetOneList = [];
   this.traverseOneList = [];
   this.oldTraverseOneList = [];
   this.pieceOneList = [];
   this.nextOnePiece = [];

   this.pieceInfoList = [];
   this.groupInfoList = [];
   this.groupListMode1 = [];
   this.groupListMode2 = [];

   this.nextSheet = null;
   this.finalSheet = null;
   this.nextTraverse = null;
   this.nextPiece = [];
   this.last_piece = null;
   this.currentPiece = [];
   
   this.null_sheet_limit = 30;

   this.cutting_ordered = [];
   
   this.infinite_level = 20;
   this.useSharedStripLookahead = false;
   this.sharedStripAlignmentTarget = null;
   this.useRemainderConsolidation = true;
 }

  // -------------------------
  //  FUNCIONES PESO/DENSIDAD
  // -------------------------

  setKgM2(value: number) {

    this.kg_m2 = value;

  } // End function setKgM2

  getKgM2() {

    return this.kg_m2;

  } // End function getKgM2

  // -----------------------
  //  FUNCIONES DE TRAVERAS
  // -----------------------
  
  compareCoordenates(c1: any, c2: any) {
	// console.log(' -> Ejecutando compareCoordenates...');
	// console.log(c1);
	// console.log(c2);
	
	let igual = false;
	
	if (c1[0].x === c2[0].x && c1[0].y === c2[0].y &&
	    c1[1].x === c2[1].x && c1[1].y === c1[1].y &&
	    c1[2].x === c2[2].x && c1[2].y === c2[2].y &&
	    c1[3].x === c2[3].x && c1[3].y === c2[3].y) {
			
		igual = true;
	}
	
	return igual;
	
  } // End function compareCoordenates
  
  // Función que devuelve el nivel de profundidad en el que está
  // la travera/retal que se quiere usar para colocar una pieza.
  async getRetalLevelX(levelIn: number, elemIn: any, elementListIn: any, retalPoints: any, axisIn: string) {
	
	// console.log('-> Ejecutando getRetalLevelX nivel ' + levelIn + ' para id = ' + elemIn.id + ' name = ' + elemIn.name);
	// console.log(elementListIn);
	// console.log(retalPoints);
	/*
	if (!elementListIn) {
		console.log('-> getRetalLevelX no hay elementos de entrada. Se para la búsqueda de nivel');
		return { level: levelIn, pieces: null, points: retalPoints };
	}
	if (!retalPoints){
		console.log('-> getRetalLevelX no hay coordenadas de entrada. Se para la búsqueda de nivel');
		return { level: levelIn, pieces: elementListIn, points: null };
	}
	
	if (this.compareCoordenates(retalPoints, elemIn.points)) {
		console.log('-> getRetalLevelX El marco y el elemento coinciden. Se para la búsqueda de nivel.');
		return { level: levelIn, pieces: elementListIn, points: elemIn.points };
	} // */
	
	if (levelIn > 20){
		console.log('-> getRetalLevelX bucle superado... ' + levelIn);
		console.log(elemIn);
		console.log(retalPoints);
		console.log(elementListIn);  
		return { level: levelIn, pieces: elementListIn, points: null };
	}
	
	if (elementListIn.length === 1) {
		console.log('-> getRetalLevelX Sólo hay un elemento. Se para la búsqueda en el nivel ' + levelIn);
		return { level: levelIn, pieces: elementListIn, points: elemIn.points };
	}
	
	// Las piezas que no estén dentro del rango del eje X e Y
    // de la zona estudiada no se tienen en cuenta.    
    elementListIn = elementListIn.filter( p =>
    	  (p.points[0].x >= retalPoints[0].x && p.points[3].x <= retalPoints[3].x &&
          p.points[0].y >= retalPoints[0].y && p.points[1].y <= retalPoints[1].y));
    
    elementListIn = elementListIn.filter( p => {
		
		if (this.compareCoordenates(p.points, retalPoints)) {
			// console.log('-> getRetalLevelX elemento encontrado igual que el marco. Se saca. ');
			// console.log(p);
			// console.log(retalPoints);
			
			return false;
		}
		
		return true;
	});
    
    // if (elemIn.height === 1464 && elemIn.width === 38) {
		// console.log('-> getRetalLevelX elementListIn = ' + elemIn.name);
		// console.log(elementListIn);
	// }
	
    let trav_X = [];
    
    // Hacemos grupos según donde empieza la pieza en X.
    elementListIn.forEach( p => {
	  // console.log(' -> elem p:');
      // console.log(p);     

	  let key = 'x_' + p.points[0].x;

      if (!trav_X[key]) {
        trav_X[key] = [];
      }

      trav_X['x_' + p.points[0].x].push(p);
   
    });
    
    let final_trav_X = [];

	// Se añade el eje X representante del lado del extremo izquierdo (cero) y derecho de la plancha.
	final_trav_X.push(retalPoints[0].x);    
    final_trav_X.push(retalPoints[3].x);
    
    let retal_x = null;

    for (let trav in trav_X) {
      // console.log(' --> -> getRetalLevelX traveras X:');
      // console.log(trav_X[trav]);

      let p_first = false;
      let p_last = false;

      let current_X = -1;

      // Confirmar cuales son realmente traveras X (cruzan todo el eje Y).
      // Condición: tienen una pieza que comienza en "y=0" y otra que termina en "y=(alto de hoja)"
      trav_X[trav].forEach( p => {
		
        // console.log(' --> getRetalLevelX pieza en travera: ' + trav);
        // console.log(p);
        
        if (elemIn.id === p.id && elemIn.name === p.name) {
			// console.log(' --> Identificado retal en X = ' + trav);
        	// console.log(p);
        	
        	// if (p.height === 854 && p.width === 450) {
			// 	console.log(' --> getRetalLevelX Encontrado elemento problema.');	
			// }
        	
        	retal_x = p.points[0].x;
		}

        current_X = p.points[0].x;

        if (p.points[0].y === retalPoints[0].y) {
          p_first = true;
        }

        if (p.points[1].y === retalPoints[1].y) {
          p_last = true;
        }
      });

      if (p_last && p_first) {

        // console.log(' --> getRetalLevelX SI es travera X en ' + trav);

        if (!final_trav_X.includes(current_X)) {
			
		  // console.log(' --> X es travera: ' + trav);
          final_trav_X.push(current_X);
        }

      } else {
        // console.log(' --> NO es travera X en ' + trav);
      }
    } // End For trav_X 

    final_trav_X = this.orderByNum(final_trav_X, false);
    
    // console.log(' --> X origen del retal = ' + retal_x);
    
    // Se comprueba si el retal está adyacente a una travera principal.
	// let tr_adyacent = final_trav_X.indexOf(retal_x);
	
	// console.log(' --> Lista traveras X. tr_adyacent = ' + tr_adyacent);
	// console.log(final_trav_X);
	
	// Se hallan las coordenadas de la travera principal que contiene al elemento estudiado.
	let coordenates_tr_x = [];
	
	let xB = final_trav_X.find(tx => tx > retal_x);
		
	if (xB) {
		let ind_xB = final_trav_X.indexOf(xB);
		
		// Coordenada esquina superior izquierda.
		coordenates_tr_x.push({x: final_trav_X[ind_xB - 1], y: retalPoints[0].y});
		// Coordenada esquina inferior izquierda.
		coordenates_tr_x.push({x: final_trav_X[ind_xB - 1], y: retalPoints[1].y});
		// Coordenada esquina inferior derecha.
		coordenates_tr_x.push({x: final_trav_X[ind_xB], y: retalPoints[2].y});
		// Coordenada esquina superior derecha.
		coordenates_tr_x.push({x: final_trav_X[ind_xB], y: retalPoints[3].y});
	} else {
		console.log(' --> getRetalLevelX No hay travera mayor = ' + retal_x);
		return { level: levelIn, pieces: elementListIn, points: elemIn.points };
	}
	/*
	if (coordenates_tr_x[0].x === undefined || coordenates_tr_x[0].y === undefined ||
	    coordenates_tr_x[1].x === undefined || coordenates_tr_x[1].y === undefined ||
	    coordenates_tr_x[2].x === undefined || coordenates_tr_x[2].y === undefined ||
	    coordenates_tr_x[3].x === undefined || coordenates_tr_x[3].y === undefined) {
			
		console.log(' --> getRetalLevelX coordenadas nula encontrada:');
		console.log(coordenates_tr_x);
		console.log(elemIn);
	} // */
	
	// console.log(' --> getRetalLevelX coordenadas travera X donde está el elemento:');
	// console.log(coordenates_tr_x);
	
	let promise_tr = new Promise(async (resolve, reject) => {
		/*
		if (elemIn.height === 1464 && elemIn.width === 38) {
			console.log(' --> getRetalLevelX Encontrado elemento problema B.');
			console.log(final_trav_X);
			console.log(' --> getRetalLevelX coordenadas travera X donde está el elemento:');
			console.log(coordenates_tr_x);
		} // */
    
    	// Si las coordenadas de la siguiente zona no son igual a
    	// las coordenadas de la zona en estudio, entonces se sigue profundizando.
    	if (!this.compareCoordenates(coordenates_tr_x, elemIn.points)) {
    		
    		let end_x = false;
    		
    		// Si las coordenadas de búsqueda van a ser las mismas en el siguiente ciclo.
			if (this.compareCoordenates(coordenates_tr_x, retalPoints)) {
				
				// console.log(' --> getRetalLevelX coinciden las coordenadas de entrada y de salida: ' + elemIn.name);
				// console.log(coordenates_tr_x);
				// console.log(retalPoints);
				
				// Se estrecha el marco de búsqueda hasta el lado derecho del elemento buscado.
				coordenates_tr_x[2].x = elemIn.points[2].x;
				coordenates_tr_x[3].x = elemIn.points[3].x;
				
				// Si la anchura es la misma entonces se termina de profundizar.
				if (coordenates_tr_x[3].x - coordenates_tr_x[0].x === elemIn.points[3].x - elemIn.points[0].x) {
					
					// console.log(' --> getRetalLevelX misma anchura. Finaliza búsqueda: ' + elemIn.name);
					
					end_x = true;
				}
			}
			
			if (!end_x) {
				
				// if (elemIn.height === 1464 && elemIn.width === 38) {
				// 	console.log(' --> getRetalLevelX continua retal: ' + elemIn.name);
				// }
				
				let next_trav_Y = await this.getRetalLevelY((levelIn + 1), elemIn, elementListIn, coordenates_tr_x, axisIn);
				
				// if (elemIn.height === 1464 && elemIn.width === 38) {
				// 	console.log(' --> getRetalLevelX next_trav_Y:');
				// 	console.log(next_trav_Y);
				// }
				
				if (next_trav_Y) {
					
					resolve(JSON.parse(JSON.stringify(next_trav_Y)));
					
				} else {
					
					// console.log(' --> getRetalLevelX No hay valor para next_trav_Y.');
					
					let result = { level: (levelIn + 1), pieces: elementListIn ? elementListIn : null, points: coordenates_tr_x };
					resolve(result);
				}
				
			} else {
				// if (elemIn.height === 1464 && elemIn.width === 38) {
				// 	console.log(' --> getRetalLevelX Finaliza retal A:' + elemIn.name);
				// 	console.log('Su nivel de profundidad obtenido es ' + levelIn);
				// }
				
				resolve({ level: levelIn, pieces: elemIn, points: coordenates_tr_x });
			}
			
		} else {
			// if (elemIn.height === 1464 && elemIn.width === 38) {
			// 	console.log(' --> getRetalLevelX Finaliza retal B:' + elemIn.name);
			// 	console.log('Su nivel de profundidad obtenido es ' + levelIn);
			// }
			
			resolve({ level: levelIn, pieces: elemIn, points: coordenates_tr_x });
		}
	});
	
	return promise_tr.then((trav_Y: any): any => {
      // console.log('->> getRetalLevelX promise_tr:');
      // console.log(trav_Y);
      
      if (trav_Y) {
		// Resultado devuelto tras resolver la creación (new) de la promesa promise_tr.
      	return trav_Y;
      
	  } else {
		return null;
	  }
    });

  } // End function getRetalLevelX.
  
  // Función que devuelve el nivel de profundidad en el que está
  // la travera/retal que se quiere usar para colocar una pieza.
  async getRetalLevelY(levelIn: number, elemIn: any, elementListIn: any, retalPoints: any, axisIn: string) {
	
	// console.log('-> Ejecutando getRetalLevelY nivel ' + levelIn + ' para id = ' + elemIn.id + ' name = ' + elemIn.name);
	// console.log(elementListIn);
	// console.log(retalPoints);
	/*
	if (!elementListIn) {
		console.log('-> getRetalLevelY no hay elementos de entrada. Se para la búsqueda de nivel.');
		return { level: levelIn, pieces: null, points: retalPoints };
	}
	
	if (!retalPoints){
		console.log('-> getRetalLevelY no hay coordenadas de entrada. Se para la búsqueda de nivel.');
		return { level: levelIn, pieces: elementListIn, points: null };
	}
	
	if (this.compareCoordenates(retalPoints, elemIn.points)) {
		console.log('-> getRetalLevelY El marco y el elemento coinciden. Se para la búsqueda de nivel.');
		return { level: levelIn, pieces: elementListIn, points: elemIn.points };
	} // */
	
	if (levelIn > 20){
		console.log('-> getRetalLevelY bucle superado... ' + levelIn);
		// console.log(elemIn);
		// console.log(elementListIn); 
		return { level: levelIn, pieces: elementListIn, points: null };
	}
	
	if (elementListIn.length === 1) {
		console.log('-> getRetalLevelY Sólo hay un elemento. Se para la búsqueda de nivel ' + levelIn);
		return { level: levelIn, pieces: elementListIn, points: elemIn.points };
	}
	
	// Las piezas que no estén dentro del rango del eje X e Y
    // de la zona estudiada no se tienen en cuenta. 
    elementListIn = elementListIn.filter( p =>
    	  (p.points[0].x >= retalPoints[0].x && p.points[3].x <= retalPoints[3].x &&
          p.points[0].y >= retalPoints[0].y && p.points[1].y <= retalPoints[1].y));
    
    elementListIn = elementListIn.filter( p => {
		
		if (this.compareCoordenates(p.points, retalPoints)) {
			// console.log('-> getRetalLevelY elemento encontrado igual que el marco. Se saca. ');
			// console.log(p);
			// console.log(retalPoints);
			
			return false;
		}
		
		return true;
	});
	
	// if (elemIn.height === 1464 && elemIn.width === 38) {
	// 	console.log('-> getRetalLevelY elementListIn = ' + elemIn.name);
	// 	console.log(elementListIn);
	// }
	
    let trav_Y = [];
    
    // Hacemos grupos según donde empieza la pieza en X.
    elementListIn.forEach( p => {
	  // console.log(' -> elem p:');
      // console.log(p);

	  let key = 'y_' + p.points[0].y;

      if (!trav_Y[key]) {
        trav_Y[key] = [];
      }

      trav_Y['y_' + p.points[0].y].push(p);
   
    });
    
    let final_trav_Y = [];

	// Se añade el eje Y representante del lado del extremo de abajo de la plancha (cero) y el superior.
	final_trav_Y.push(retalPoints[0].y);    
    final_trav_Y.push(retalPoints[2].y);
    
    let retal_y = null;

    for (let trav in trav_Y) {
      // console.log(' --> -> getRetalLevelY traveras Y:');
      // console.log(trav_Y[trav]);

      let p_first = false;
      let p_last = false;

      let current_Y = -1;
      
      // Confirmar cuales son realmente traveras Y (cruzan todo el eje X).
      // Condición: tienen una pieza que comienza en "x=0" y otra que termina en "x=(ancho de hoja)"     
      trav_Y[trav].forEach( p => {

        // console.log(' --> getRetalLevelY pieza en travera: ' + trav);
        // console.log(p);
        
        if (elemIn.id === p.id && elemIn.name === p.name) {
			// console.log(' --> Identificado retal en Y = ' + trav);
        	// console.log(p);
        	
        	retal_y = p.points[0].y;
		}

        current_Y = p.points[0].y;
        
        if (p.points[0].x === retalPoints[0].x) {
          p_first = true;
        }

        if (p.points[3].x === retalPoints[3].x) {
          p_last = true;
        }
      });
      
      if (p_last && p_first) {
		
        if (!final_trav_Y.includes(current_Y)) {
			
		  // console.log(' --> Y es travera: ' + trav);
          final_trav_Y.push(current_Y);
        }

      } // else {
        // console.log(' --> NO es travera Y en ' + trav);
      // }
    } // End For trav_Y

    final_trav_Y = this.orderByNum(final_trav_Y, false);
    
    // -------------
    if (axisIn !== 'Y') {

	    let falses_traverses = [];
	    
	    // Comprobamos el listado de posibles traveras Y para descartar
	    // las que realmente tienen una pieza entre medias que las rompe.
	    final_trav_Y.forEach( (y_value, actual) => {
			
			// console.log(' --> trav_Y actual y_value = ' + y_value);
			
			if (actual > 0) {
				
				let previus_y_value = final_trav_Y[actual - 1];
				
				for (let trav in trav_Y) {
					// Si existe una pieza que "rompa travera" estará en la travera anterior.
					if (trav_Y['y_' + previus_y_value]) {
							trav_Y['y_' + previus_y_value].forEach( pp => {
								
							// console.log(' --> Testeo pieza por si rompe la travera y_' + previus_y_value);
		    				// console.log(pp);
		    				
		    				if (y_value > pp.points[0].y && y_value < pp.points[2].y) {
								// console.log('-> La pieza rompe la travera Y = ' + y_value);
								
								// No es una travera. Se incluye ese valor en el listado de falsas traveras.
								if(!falses_traverses.includes(actual)) {
									falses_traverses.push(actual);
								}
							}
						});
					}
				}
			} // End If actual
			
			if (falses_traverses && falses_traverses.length > 0) {
				// console.log(' --> falses_traverses:');
	    		// console.log(falses_traverses);
	    		
	    		falses_traverses.forEach(ft => {
					// console.log(' --> Eliminando falsa travera:');
	    			// console.log(ft);
					final_trav_Y.splice(ft, 1);
				});
			}
		});
	} // */
    // -------------
    
    // console.log(' --> X origen del retal = ' + retal_y);
    
    // Se comprueba si el retal está adyacente a una travera principal.
	// let tr_adyacent = final_trav_Y.indexOf(retal_y);
	
	// console.log(' --> Lista traveras Y. tr_adyacent = ' + tr_adyacent);
	// console.log(final_trav_Y);
	
	// Se hallan las coordenadas de la travera principal que contiene al elemento estudiado.
	let coordenates_tr_y = [];
	
	let yB = final_trav_Y.find(ty => ty > retal_y);
		
	if (yB) {
		let ind_yB = final_trav_Y.indexOf(yB);
		
		// console.log(' --> Lista traveras Y. tr_adyacent = ' + ind_yB);
		// console.log(yB);
		// console.log(final_trav_Y);
		
		// Coordenada esquina superior izquierda.
		coordenates_tr_y.push({x: retalPoints[0].x, y: final_trav_Y[ind_yB - 1]});
		// Coordenada esquina inferior izquierda.
		coordenates_tr_y.push({x: retalPoints[1].x, y: final_trav_Y[ind_yB]});
		// Coordenada esquina inferior derecha.
		coordenates_tr_y.push({x: retalPoints[2].x, y: final_trav_Y[ind_yB]});
		// Coordenada esquina superior derecha.
		coordenates_tr_y.push({x: retalPoints[3].x, y: final_trav_Y[ind_yB - 1]});
	} else {
		console.log(' --> getRetalLevelY No hay travera mayor = ' + retal_y);
		return { level: levelIn, pieces: elementListIn, points: elemIn.points };
	}
	/*
	if (coordenates_tr_y[0].x === undefined || coordenates_tr_y[0].y === undefined ||
	    coordenates_tr_y[1].x === undefined || coordenates_tr_y[1].y === undefined ||
	    coordenates_tr_y[2].x === undefined || coordenates_tr_y[2].y === undefined||
	    coordenates_tr_y[3].x === undefined || coordenates_tr_y[3].y === undefined) {
			
		console.log(' --> getRetalLevelY coordenadas nula encontrada:');
		console.log(coordenates_tr_y);
		console.log(elemIn);
	} // */
	
	// console.log(' --> getRetalLevelY coordenadas travera Y donde está el elemento:');
	// console.log(coordenates_tr_y);
	
	let promise_tr = new Promise(async (resolve, reject) => {
		/*
		if (elemIn.height === 1464 && elemIn.width === 38) {
			console.log(' --> getRetalLevelY Encontrado elemento problema B.');
			console.log(final_trav_Y);
			console.log(' --> getRetalLevelY coordenadas travera Y donde está el elemento:');
			console.log(coordenates_tr_y);
		} // */
    
    	// Si las coordenadas de la siguiente zona no son igual a
    	// las coordenadas de la zona en estudio, entonces se sigue profundizando.
    	if (!this.compareCoordenates(coordenates_tr_y, elemIn.points)) {
    		// && !this.compareCoordenates(coordenates_tr_y, retalPoints)) {
			
			let end_y = false;
			
			// Si las coordenadas de búsqueda van a ser las mismas en el siguiente ciclo.
			if (this.compareCoordenates(coordenates_tr_y, retalPoints)) {
				
				// console.log(' --> getRetalLevelY coinciden las coordenadas de entrada y de salida: ' + elemIn.name);
				// console.log(coordenates_tr_y);
				// console.log(elemIn);
				
				// Se estrecha el marco de búsqueda hasta el lado derecho del elemento buscado.
				coordenates_tr_y[0].y = elemIn.points[0].y;
				coordenates_tr_y[3].y = elemIn.points[3].y;
				
				// Si la altura es la misma entonces se termina de profundizar.
				if (coordenates_tr_y[1].y - coordenates_tr_y[0].y === elemIn.points[1].y - elemIn.points[0].y) {
					
					// console.log(' --> getRetalLevelY misma altura. Finaliza búsqueda: ' + elemIn.name);
					
					end_y = true;
					resolve({ level: levelIn, pieces: elemIn, points: coordenates_tr_y });
				}
			}
			
			if (!end_y) {
				
				// if (elemIn.height === 1464 && elemIn.width === 38) {
					// console.log(' --> getRetalLevelY continua retal: ' + elemIn.name);
				// }
				let next_trav_X = await this.getRetalLevelX((levelIn + 1), elemIn, elementListIn, coordenates_tr_y, axisIn);
				
				// if (elemIn.height === 1464 && elemIn.width === 38) {
					// console.log(' --> getRetalLevelY next_trav_X:');
					// console.log(next_trav_X);
				// }
				
				if (next_trav_X) {
					
					resolve(JSON.parse(JSON.stringify(next_trav_X)));
					
				} else {
					
					// console.log(' --> getRetalLevelY No hay valor para next_trav_X.');
					
					let result = { level: (levelIn + 1), pieces: elementListIn ? elementListIn : null, points: coordenates_tr_y };
					resolve(result);
				}
			} else {
				
				// if (elemIn.height === 1464 && elemIn.width === 38) {
				// 	console.log(' --> getRetalLevelY Finaliza retal A:' + elemIn.name);
				// 	console.log('Su nivel de profundidad obtenido es ' + levelIn);
				// }
				
				resolve({ level: levelIn, pieces: elemIn, points: coordenates_tr_y });
			}
		} else {
			// if (elemIn.height === 1464 && elemIn.width === 38) {
			// 	console.log(' --> getRetalLevelY Finaliza retal B:' + elemIn.name);
			// 	console.log('Su nivel de profundidad obtenido es ' + levelIn);
			// }
			
			resolve({ level: levelIn, pieces: elemIn, points: coordenates_tr_y });
		}
	});
	
	return promise_tr.then((trav_Y: any): any => {
      // console.log('->> getRetalLevelY promise_tr:');
      // console.log(trav_Y);
      
      if (trav_Y) {
		// Resultado devuelto tras resolver la creación (new) de la promesa promise_tr.
      	return trav_Y;
      
	  } else {
		return null;
	  }
    });

  } // End function getRetalLevelY.
  
  // Función que devuelve false si en la hoja (id pasado como primer parámetro)
  // supera el nivel de profundidad indicado en el último parámetro.
  async testSheetLevel(idSheetIn: number, depthLevelIn: number) {
	
	console.log('Ejecutando testSheetLevel para la hoja con id = ' + idSheetIn);
	console.log(depthLevelIn);
	
	// -----
	
	let piecesIn = null;
	let traversesIn = null;
	let sheetListIn = null;
	let trv_sheet = null;
	let actual_sheet = false;
  	
  	let id_actual_sheet = this.nextSheet.id;
  	// console.log('ID hoja acutal id_sheet = ' + id_actual_sheet);
  	
  	// Primero se obtiene la hoja en la que está ese retal:  	
  	if (id_actual_sheet === idSheetIn) actual_sheet = true;
  	
	if (actual_sheet) {
		
		// console.log('getLevel el retal pertenece a la hoja actual.');
		traversesIn = JSON.parse(JSON.stringify(this.traverseList));
		piecesIn = JSON.parse(JSON.stringify(this.pieceList));
		
		trv_sheet = this.nextSheet;
		
	} else {
		
		sheetListIn = JSON.parse(JSON.stringify(this.sheetList));
		
		// console.log('getLevel el retal pertenece a una hoja antigua.');
		trv_sheet = sheetListIn.find(sheet => sheet.id === idSheetIn);
		
		if (trv_sheet && trv_sheet.traverses) traversesIn = trv_sheet.traverses;
		if (trv_sheet && trv_sheet.pieces) piecesIn = trv_sheet.pieces;
	}

	if (!piecesIn && !traversesIn) {
		
		console.log(' --> testSheetLevel se sale por no existir piezas ni traveras en la hoja con id = ' + idSheetIn);
		
		return;
	}
	
	let disband_aux = trv_sheet.disband;
	
	if (piecesIn && piecesIn[0]) disband_aux = piecesIn[0].disband;
	
	// Construimos los punto que definen las dimensiones de la hoja actual.
	let coordinates = [];
	
	let extrem_sheet_w = trv_sheet.width - disband_aux.left - disband_aux.right;
	let extrem_sheet_h = trv_sheet.height - disband_aux.top - disband_aux.bottom;
	
	// Coordenada esquina superior izquierda.
	coordinates.push({x: 0, y: 0});
	// Coordenada esquina inferior izquierda.
	coordinates.push({x: 0, y: extrem_sheet_h});
	// Coordenada esquina inferior derecha.
	coordinates.push({x: extrem_sheet_w, y: extrem_sheet_h});
	// Coordenada esquina superior derecha.
	coordinates.push({x: extrem_sheet_w, y: 0});
	
	let framePoints = coordinates;
	
	// console.log(' --> getLevel coordenadas de la hoja del retal -> framePoints:');
    // console.log(framePoints);
	
    let elementList = [];
    
    piecesIn.forEach( elem => {
		elementList.push(elem.piece);
	});
	
	traversesIn.forEach( elem => {
		elementList.push(elem);
	});
	
	// console.log(' --> getLevel piezas y retales en la hoja -> elementList:');
    // console.log(elementList);
    
    let initial_elements = [];
    
    // Preparamos la información de los elementos iniciales
    // que hay en la hoja (tanto piezas como retales).
    elementList.forEach( p => {
		
	  let p_clone = JSON.parse(JSON.stringify(p));
	  
	  // Si el elemento es un retal que tiene una pieza dentro
	  // entonces son las coordenadas de la pieza las que se cogen.
	  if (p_clone['piece']) {
		p_clone.points = p_clone['piece'].points;
	  }
	  
	  initial_elements.push(p_clone);
    });
	
	// -----
	
	let promise_tr = new Promise(async (resolve, reject) => {
		
		let correct_level = this.testPiecesLevel(null, initial_elements, framePoints, depthLevelIn);
	
		// console.log(' -> testLevel correct_level después de testPiecesLevel: ');
		// console.log(correct_level);
			
		resolve(correct_level);
	});
	
	return promise_tr.then((trav: any): any => {
      console.log('->> testSheetLevel promise_tr resultado:');
      console.log(trav);
      
      return trav;
    });
  } // End function testSheetLevel.
  
  // Función que devuelve false si en la hoja se ha superado el nivel de corte
  // indicado en el último parámetro.
  async testLevel(axisIn: string, fitIn: any, traverseIn: any, travListIn: any, depthLevelIn: number) {
	
	// console.log('Ejecutando testLevel para la hoja con id = ' + traverseIn.sheet_id);
	// console.log(traverseIn);
	// console.log(fitIn);
	// console.log(travListIn);
	// console.log(depthLevelIn);
	
	// -----
	
	let piecesIn = null;
	let traversesIn = null;
	let sheetListIn = null;
	let trv_sheet = null;
	let actual_sheet = false;
  	
  	let id_actual_sheet = this.nextSheet.id;
  	// console.log('ID hoja acutal id_sheet = ' + id_actual_sheet);
  	
  	// Primero se obtiene la hoja en la que está ese retal:  	
  	if (id_actual_sheet === traverseIn.sheet_id) actual_sheet = true;
  	
	if (actual_sheet) {
		
		// console.log('getLevel el retal pertenece a la hoja actual.');
		traversesIn = JSON.parse(JSON.stringify(this.traverseList));
		piecesIn = JSON.parse(JSON.stringify(this.pieceList));
		
		trv_sheet = this.nextSheet;
		
	} else {
		
		sheetListIn = JSON.parse(JSON.stringify(this.sheetList));
		
		// console.log('getLevel el retal pertenece a una hoja antigua.');
		trv_sheet = sheetListIn.find(sheet => sheet.id === traverseIn.sheet_id);
		
		if (trv_sheet && trv_sheet.traverses) traversesIn = trv_sheet.traverses;
		if (trv_sheet && trv_sheet.pieces) piecesIn = trv_sheet.pieces;
	}

	if (!piecesIn && !traversesIn) {
		
		console.log(' --> testLevel se sale por no existir piezas ni traveras.');
		
		return;
	}
	
	let disband_aux = trv_sheet.disband;
	
	if (piecesIn && piecesIn[0]) disband_aux = piecesIn[0].disband;
	
	// Construimos los punto que definen las dimensiones de la hoja actual.
	let coordinates = [];
	
	let extrem_sheet_w = trv_sheet.width - disband_aux.left - disband_aux.right;
	let extrem_sheet_h = trv_sheet.height - disband_aux.top - disband_aux.bottom;
	
	// Coordenada esquina superior izquierda.
	coordinates.push({x: 0, y: 0});
	// Coordenada esquina inferior izquierda.
	coordinates.push({x: 0, y: extrem_sheet_h});
	// Coordenada esquina inferior derecha.
	coordinates.push({x: extrem_sheet_w, y: extrem_sheet_h});
	// Coordenada esquina superior derecha.
	coordinates.push({x: extrem_sheet_w, y: 0});
	
	let framePoints = coordinates;
	
	// console.log(' --> getLevel coordenadas de la hoja del retal -> framePoints:');
    // console.log(framePoints);
	
    let elementList = [];
    
    piecesIn.forEach( elem => {
		elementList.push(elem.piece);
	});
	
	traversesIn.forEach( elem => {
		elementList.push(elem);
	});
	
	// Se añaden los retales que surgirían tras colocar la pieza
	// que se está testeando para comprobar la profundidad del corte.
	// Hay que hacerlo aquí porque en la hoja real aún no están
	// definidos estos retales, son aún posibles colocaciones.
	travListIn.forEach( elem => {
		if (elem) elementList.push(elem);
	});
	
	if (fitIn) {
		// Hay que tener también en cuenta la pieza que se colocaría para el corte.
		// Construimos los puntos que definen los vértices de la pieza en la hoja.
		let fit_coordinates = [];
	    
		const overrideX = Number(fitIn.packing_origin_x_override);
		const overrideY = Number(fitIn.packing_origin_y_override);
		const fitOriginX = Number.isFinite(overrideX) ? overrideX : traverseIn.origin_x;
		const fitOriginY = Number.isFinite(overrideY) ? overrideY : traverseIn.origin_y;

		// Coordenada esquina superior izquierda.
		fit_coordinates.push({x: fitOriginX, y: fitOriginY});
		// Coordenada esquina inferior izquierda.
		fit_coordinates.push({x: fitOriginX, y: fitOriginY + fitIn.piece_height});
		// Coordenada esquina inferior derecha.
		fit_coordinates.push({x: fitOriginX + fitIn.piece_width, y: fitOriginY + fitIn.piece_height});
		// Coordenada esquina superior derecha.
		fit_coordinates.push({x: fitOriginX + fitIn.piece_width, y: fitOriginY});
		
		// Se asignan a un nuevo campo "points"".
		fitIn['points'] = fit_coordinates;
		
		elementList.push(fitIn);
	}
	
	// console.log(' --> getLevel piezas y retales en la hoja -> elementList:');
    // console.log(elementList);
    
    let initial_elements = [];
    
    // Preparamos la información de los elementos iniciales
    // que hay en la hoja (tanto piezas como retales).
    elementList.forEach( p => {
		
	  let p_clone = JSON.parse(JSON.stringify(p));
	  
	  // Si el elemento es un retal que tiene una pieza dentro
	  // entonces son las coordenadas de la pieza las que se cogen.
	  if (p_clone['piece']) {
		p_clone.points = p_clone['piece'].points;
	  }
	  
	  initial_elements.push(p_clone);
    });
	
	// -----
	
	let promise_tr = new Promise(async (resolve, reject) => {
		
		let correct_level = this.testPiecesLevel(fitIn, initial_elements, framePoints, depthLevelIn);
	
		// console.log(' -> testLevel correct_level después de testPiecesLevel: ');
		// console.log(correct_level);
			
		resolve(correct_level);
	});
	
	return promise_tr.then((trav: any): any => {
      // console.log('->> testLevel promise_tr resultado:');
      // console.log(trav);
      
      return trav;
    }); 
  } // End function testLevel.
    
  // Función que devuelve el nivel de profundidad en el que está
  // en la hoja (tercer parámetro) cada retal de una lista (cuarto parámetro).
  async getLevel(axisIn: string, fitIn: any, traverseIn: any, travListIn: any) {
	
	// console.log('Ejecutando getLevel para la hoja con id = ' + traverseIn.sheet_id);
	// console.log(fitIn);
	// console.log(travListIn);
	
	let piecesIn = null;
	let traversesIn = null;
	let sheetListIn = null;
	let trv_sheet = null;
	let actual_sheet = false;
	
	let id_actual_sheet = this.nextSheet.id;
  	// console.log('ID hoja acutal id_sheet = ' + id_actual_sheet);
  	
  	// Primero se obtiene la hoja en la que está ese retal:  	
  	if (id_actual_sheet === traverseIn.sheet_id) actual_sheet = true;
  	
	if (actual_sheet) {
		
		// console.log('getLevel el retal pertenece a la hoja actual.');
		traversesIn = JSON.parse(JSON.stringify(this.traverseList));
		piecesIn = JSON.parse(JSON.stringify(this.pieceList));
		
		trv_sheet = this.nextSheet;
		
	} else {
		
		sheetListIn = JSON.parse(JSON.stringify(this.sheetList));
		
		// console.log('getLevel el retal pertenece a una hoja antigua.');
		trv_sheet = sheetListIn.find(sheet => sheet.id === traverseIn.sheet_id);
		
		if (trv_sheet && trv_sheet.traverses) traversesIn = trv_sheet.traverses;
		if (trv_sheet && trv_sheet.pieces) piecesIn = trv_sheet.pieces;
	}
	
    // console.log(' --> getLevel traversesIn: ');
    // console.log(traversesIn);
	
    // console.log(' --> getLevel piecesIn: ');
    // console.log(piecesIn);

	if (!piecesIn && !traversesIn) return;
	
	let disband_aux = trv_sheet.disband;
	
	if (piecesIn && piecesIn[0]) disband_aux = piecesIn[0].disband;
	
	// Construimos los punto que definen las dimensiones de la hoja actual.
	let coordinates = [];
	
	let extrem_sheet_w = trv_sheet.width - disband_aux.left - disband_aux.right;
	let extrem_sheet_h = trv_sheet.height - disband_aux.top - disband_aux.bottom;
	
	// Coordenada esquina superior izquierda.
	coordinates.push({x: 0, y: 0});
	// Coordenada esquina inferior izquierda.
	coordinates.push({x: 0, y: extrem_sheet_h});
	// Coordenada esquina inferior derecha.
	coordinates.push({x: extrem_sheet_w, y: extrem_sheet_h});
	// Coordenada esquina superior derecha.
	coordinates.push({x: extrem_sheet_w, y: 0});
	
	let framePoints = coordinates;
	
	// console.log(' --> getLevel coordenadas de la hoja del retal -> framePoints:');
    // console.log(framePoints);
	
    let elementList = [];
    
    piecesIn.forEach( elem => {
		elementList.push(elem.piece);
	});
	
	traversesIn.forEach( elem => {
		elementList.push(elem);
	});
	
	// Se añaden los retales que surgirían tras colocar la pieza
	// que se está testeando para comprobar la profundidad del corte.
	// Hay que hacerlo aquí porque en la hoja real aún no están
	// definidos estos retales, son aún posibles colocaciones.
	travListIn.forEach( elem => {
		if (elem) elementList.push(elem);
	});
	
	if (fitIn) {
		// Hay que tener también en cuenta la pieza que se colocaría para el corte.
		// Construimos los puntos que definen los vértices de la pieza en la hoja.
		let fit_coordinates = [];
	    
		const overrideX = Number(fitIn.packing_origin_x_override);
		const overrideY = Number(fitIn.packing_origin_y_override);
		const fitOriginX = Number.isFinite(overrideX) ? overrideX : traverseIn.origin_x;
		const fitOriginY = Number.isFinite(overrideY) ? overrideY : traverseIn.origin_y;

		// Coordenada esquina superior izquierda.
		fit_coordinates.push({x: fitOriginX, y: fitOriginY});
		// Coordenada esquina inferior izquierda.
		fit_coordinates.push({x: fitOriginX, y: fitOriginY + fitIn.piece_height});
		// Coordenada esquina inferior derecha.
		fit_coordinates.push({x: fitOriginX + fitIn.piece_width, y: fitOriginY + fitIn.piece_height});
		// Coordenada esquina superior derecha.
		fit_coordinates.push({x: fitOriginX + fitIn.piece_width, y: fitOriginY});
		
		// Se asignan a un nuevo campo "points"".
		fitIn['points'] = fit_coordinates;
		
		elementList.push(fitIn);
	}
	
	// console.log(' --> getLevel piezas y retales en la hoja -> elementList:');
    // console.log(elementList);
    
    let initial_elements = [];
    
    // Preparamos la información de los elementos iniciales
    // que hay en la hoja (tanto piezas como retales).
    elementList.forEach( p => {
		
	  let p_clone = JSON.parse(JSON.stringify(p));
	  
	  // Si el elemento es un retal que tiene una pieza dentro
	  // entonces son las coordenadas de la pieza las que se cogen.
	  if (p_clone['piece']) {
		p_clone.points = p_clone['piece'].points;
	  }
	  
	  initial_elements.push(p_clone);
    });
    
	let promise_tr = new Promise(async (resolve, reject) => {
		
	    travListIn.forEach(async (new_elem, index) => {
			
			let final_level_list = [];
			
			if (new_elem) {
				
				let elem_level = null;
				
				if (axisIn === 'X') {
					elem_level = await this.getRetalLevelX(1, new_elem, initial_elements, framePoints, axisIn);
				} else if (axisIn === 'Y') {
					elem_level = await this.getRetalLevelY(1, new_elem, initial_elements, framePoints, axisIn);
				} else {
					console.log(' --> Eje no identificado. Se interpreta como eje X. Eje = ' + axisIn);
					elem_level = await this.getRetalLevelX(1, new_elem, initial_elements, framePoints, axisIn);
				}
				
				// console.log(' --> El nivel del retal ' + new_elem.id + ' ' + new_elem.name);
	    		// console.log(elem_level);
	    		// console.log(new_elem);
			    
			    final_level_list.push(elem_level);
			    
			    if (index === travListIn.length - 1) resolve(final_level_list);
			} else {
				if (index === travListIn.length - 1) resolve(final_level_list);
			}
		});
	});
	
	return promise_tr.then((trav: any): any => {
      // console.log('->> getLevel promise_tr:');
      // console.log(trav);
      
      // Resultado devuelto tras resolver la creación (new) de la promesa promise_tr.
      return trav;
    });
    
  } // End function getLevel.
  
  // Función que devuelve un array con los valores de las Traveras X
  // principales que hay en ese momento en la hoja a la que pertenece
  // el retal pasado como parámetro. Si hay una pieza ya colocada adyacente
  // en la parte superior, entonces la devuelte también.
  getTX(travIn: any) {
	
	// console.log('Ejecutando getTX...');
	
	let piecesIn = null;
	let traversesIn = null;
	let trv_sheet = null;
	let actual_sheet = false;
	
	let id_actual_sheet = this.nextSheet.id;
  	// console.log('ID hoja acutal id_sheet = ' + id_actual_sheet);
  	
  	if (id_actual_sheet === travIn.sheet_id) actual_sheet = true;
  	
	if (actual_sheet) {
		
		// console.log('getTX el retal pertenece a la hoja actual.');
		traversesIn = this.traverseList;
		piecesIn = this.pieceList; // JSON.parse(JSON.stringify(this.pieceList));
		
		trv_sheet = this.nextSheet;
		
	} else {
		
		// console.log('getTX el retal pertenece a una hoja antigua.');
		trv_sheet = this.sheetList.find(sheet => sheet.id === travIn.sheet_id);
		
		if (trv_sheet && trv_sheet.traverses) traversesIn = trv_sheet.traverses;
		if (trv_sheet && trv_sheet.pieces) piecesIn = trv_sheet.pieces;
	}
	
    // console.log(' --> getTX traversesIn: ');
    // console.log(traversesIn);
	
    // console.log(' --> getTX piecesIn: ');
    // console.log(piecesIn);

	if (!piecesIn && !traversesIn) return;
	
	let disband_aux = trv_sheet.disband;
	
	if (piecesIn && piecesIn[0]) disband_aux = piecesIn[0].disband;
	
	// Construimos los punto que definen las dimensiones de la hoja actual.
	let coordinates = [];
	
	let extrem_sheet_w = trv_sheet.width - disband_aux.left - disband_aux.right;
	let extrem_sheet_h = trv_sheet.height - disband_aux.top - disband_aux.bottom;
	
	// Coordenada esquina superior izquierda.
	coordinates.push({x: 0, y: 0});
	// Coordenada esquina inferior izquierda.
	coordinates.push({x: 0, y: extrem_sheet_h});
	// Coordenada esquina inferior derecha.
	coordinates.push({x: extrem_sheet_w, y: extrem_sheet_h});
	// Coordenada esquina superior derecha.
	coordinates.push({x: extrem_sheet_w, y: 0});
	
	let framePoints = coordinates;
	
    let elementList = [];
    
    piecesIn.forEach( elem => {
		elementList.push(elem.piece);
	});
	
	traversesIn.forEach( elem => {
		elementList.push(elem);
	});
	
	// console.log(' --> elementList:');
    // console.log(elementList);

    let trav_X = [];

    // La pieza está aislada en el marco de la travera por lo
    // que es candidata para ser tronzada antes que el resto.

    // Hacemos grupos según donde empieza la pieza en X.
    elementList.forEach( p => {
		
	  // console.log(' -> elem p:');
      // console.log(p);
		
      let key = 'x_' + p.points[0].x;

      if (!trav_X[key]) {
        trav_X[key] = [];
      }

      trav_X['x_' + p.points[0].x].push(p);
    });

    // console.log(' --> getTX ejes X:');
    // console.log(trav_X);

    let final_trav_X = [];

	// Se añade el eje X representante del lado del extremo izquierdo (cero) y derecho de la plancha.
	final_trav_X.push(0);    
    final_trav_X.push(framePoints[3].x);

    for (let trav in trav_X) {
      // console.log(' --> -> getTraversesX traveras X:');
      // console.log(trav_X[trav]);

      let p_first = false;
      let p_last = false;

      let current_X = -1;

      // Confirmar cuales son realmente traveras X (cruzan todo el eje Y).
      // Condición: tienen una pieza que comienza en "y=0" y otra que termina en "y=(alto de hoja)"
      trav_X[trav].forEach( p => {

        // console.log(' --> getTraversesX pieza en travera: ' + trav);
        // console.log(p);

        current_X = p.points[0].x;

        if (p.points[0].y === framePoints[0].y) {
          p_first = true;
        }

        if (p.points[1].y === framePoints[1].y) {
          p_last = true;
        }
      });

      if (p_last && p_first) {

        // console.log(' --> getTraversesX SI es travera X en ' + trav);

        if (!final_trav_X.includes(current_X)) {
          final_trav_X.push(current_X);
        }

      } else {
        // console.log(' --> getTraversesX NO es travera X en ' + trav);
      }
    } // End For trav_X 

    final_trav_X = this.orderByNum(final_trav_X, false);
 
    // console.log(' --> getTX final_trav_X:');
    // console.log(final_trav_X);
	
    return final_trav_X;
    
  } // End function getTX.

// ---------- Funciones antiguas de obtención de traveras.

  // Función que devuelve las traveras X y las piezas que
  // hay dentro de ellas pasado un listado de piezas.
  getTraversesX(countOut: number, arrayOut: any[], piecesIn: any[], framePoints: any, levelIn: string, recallIn: boolean) {

    // console.log(' --> getTraversesX entrada piezas: ' + countOut);
    // console.log(piecesIn);

    // console.log(' --> getTraversesX framePoints:');
    // console.log(framePoints);

    let cutOrderList = piecesIn;

    let trav_X = [];

    // Hacemos grupos según donde empieza la pieza en X.
    cutOrderList.forEach( p => {

      let key = 'x_' + p.points[0].x;

      if (!trav_X[key]) {
        trav_X[key] = [];
      }

      trav_X['x_' + p.points[0].x].push(p);

    });

    // console.log(' --> getTraversesX ejes X:');
    // console.log(trav_X);

    let final_trav_X = [];

    // Se añade el eje X representante del lado del extremo derecho de la plancha.
    final_trav_X.push(framePoints[3].x);

    for (let trav in trav_X) {
      // console.log(' --> -> getTraversesX traveras X:');
      // console.log(trav_X[trav]);

      let p_first = false;
      let p_last = false;

      let current_X = -1;

      // Confirmar cuales son realmente traveras X (cruzan todo el eje Y).
      // Condición: tienen una pieza que comienza en "y=0" y otra que termina en "y=(alto de hoja)"
      trav_X[trav].forEach( p => {

        // console.log(' --> getTraversesX pieza en travera: ' + trav);
        // console.log(p);

        current_X = p.points[0].x;

        if (p.points[0].y === framePoints[0].y) {
          p_first = true;
        }

        if (p.points[1].y === framePoints[1].y) {
          p_last = true;
        }
      });

      if (p_last && p_first) {

        // console.log(' --> getTraversesX SI es travera X en ' + trav);

        if (!final_trav_X.includes(current_X)) {
          final_trav_X.push(current_X);
        }

      } else {
        // console.log(' --> getTraversesX NO es travera X en ' + trav);
      }
    } // End For trav_X

    final_trav_X = this.orderByNum(final_trav_X, false);

    // console.log(' --> getTraversesX final_trav_X:');
    // console.log(final_trav_X);

    // Va a almacenar en cada posición las piezas de una travera.
    // Se va a poner un límite de 99, que debería ser siempre suficiente.
    let piecesListTraverseX = [];

    // Las traveras están ordenadas empezando con la que tiene el valor de X mayor (que coincide
    // con el lado derecho de la plancha) hasta la última que vale 0 (lado izquierdo de la plancha).
    final_trav_X.forEach( (x_value, actual) => {
      let next = actual + 1;

      if (next < final_trav_X.length) {

        let current_trav = x_value;
        let next_trav = final_trav_X[next];

        let pieces_in_trav = [];

        // Buscamos las piezas que están contenidas entre esos ejes X.
        cutOrderList.forEach( p => {

          if (p.points[0].x >= current_trav && p.points[3].x <= next_trav) {
            // console.log(' --> -> getTraversesX en travera: ' + actual);
            
            // Añadimos el nivel de anidamiento de la pieza. Servirá para
            // saber posteriormente el nivel máximo de la optimización.
            p['level'] = countOut;
            
            pieces_in_trav.push(p);
          }
        });

        // Construimos los punto que definen las dimensiones de la travera a este nivel.
        let coordinates = [];

        // Coordenada esquina superior izquierda.
        coordinates.push({x: current_trav, y: framePoints[0].y});
        // Coordenada esquina inferior izquierda.
        coordinates.push({x: current_trav, y: framePoints[1].y});
        // Coordenada esquina inferior derecha.
        coordinates.push({x: next_trav, y: framePoints[2].y});
        // Coordenada esquina superior derecha.
        coordinates.push({x: next_trav, y: framePoints[3].y});

        // NOTA: En las traveras X sólo se saca pieza antes si está en la última travera.
        // Si no se dejan para las traveras Y para que vayan después. La única excepción
        // es cuando es una travera de retal "final de plancha" que entonces siempre ira
        // como última pieza a sacar al final de toda la optimización.

        // La pieza está aislada en el marco de la travera por lo
        // que es candidata para ser tronzada antes que el resto.
        if (pieces_in_trav.length === 1 &&
            final_trav_X[final_trav_X.length - 1] === pieces_in_trav[0].points[3].x &&
            levelIn !== 'X') {
          // console.log(' -> getTraversesX pieza tronzar orden = ' + (arrayOut.length + 1));
          arrayOut.push(pieces_in_trav[0]);
          //countOut++;
        } else {

          // CAMBIADO 1a: comentado aquí para hacerlo en 1b.
          // Guardamos todas las piezas de esa travera y las coordenadas de los puntos de su marco.
          // piecesListTraverseX.unshift({ pieces: pieces_in_trav, coordinates: coordinates });

          if (recallIn && pieces_in_trav.length > 0 && pieces_in_trav.length < piecesIn.length) {
            this.getTraversesY((countOut + 1), arrayOut, pieces_in_trav, coordinates, 'Z', true);
          } else {
            // console.log(' -> getTraversesX pieza bloqueada en travera.' + (arrayOut.length + 1));
            // console.log(pieces_in_trav);
          }
        }

        // CAMBIADO 1b: Añadida línea para incluir siempre la última pieza en la información de la subtravera.
        // Guardamos todas las piezas de esa travera y las coordenadas de los puntos de su marco.
        piecesListTraverseX.unshift({ pieces: pieces_in_trav, coordinates: coordinates });

      }
    });

    // NOTA: la variable "countOut" va a almacenar el nivel de anidamiento en el que se ha disparado la función.
    // console.log(' --> -> getTraversesX piecesListTraverseX count: ' + countOut);
    // console.log(piecesListTraverseX);

    return piecesListTraverseX;
  } // End getTraversesX

  // Función que devuelve las traveras Y y las piezas que
  // hay dentro de ellas pasado un listado de piezas.
  // NOTA: No devuelve la travera Y si sólo la compone una pieza (es decir, si no tiene subniveles no la incluye).
  getTraversesY(countOut: number, arrayOut: any[], piecesIn: any[], framePoints: any, levelIn: string, recallIn: boolean) {

    // console.log(' --> getTraversesY entrada piezas:' + countOut);
    // console.log(piecesIn);

    // console.log(' --> getTraversesY framePoints:');
    // console.log(framePoints);

    let cutOrderList = piecesIn;

    let trav_Y = [];

    // Hacemos grupos según donde empieza la pieza en Y.
    cutOrderList.forEach( p => {

      let key = 'y_' + p.points[0].y;

      if (!trav_Y[key]) {
        trav_Y[key] = [];
      }

      trav_Y['y_' + p.points[0].y].push(p);

    });

    // console.log(' --> getTraversesY ejes Y length: ' + trav_Y.length);
    // console.log(trav_Y);
    
    let final_trav_Y = [];

    // Se añade el eje Y representante del lado del extremo de abajo de la plancha.
    final_trav_Y.push(framePoints[2].y);
    
    for (let trav in trav_Y) {
      // console.log(' --> -> getTraversesY traveras Y:');
      // console.log(trav_Y[trav]);

      let p_first = false;
      let p_last = false;

      let current_Y = -1;
      
      // Confirmar cuales son realmente traveras Y (cruzan todo el eje X).
      // Condición: tienen una pieza que comienza en "x=0" y otra que termina en "x=(ancho de hoja)"
      
      trav_Y[trav].forEach( p => {

        // console.log(' --> getTraversesY pieza en travera: ' + trav);
        // console.log(p);

        current_Y = p.points[0].y;
        
        if (p.points[0].x === framePoints[0].x) {
          p_first = true;
        }

        if (p.points[3].x === framePoints[3].x) {
          p_last = true;
        }
      });
      
      
      if (p_last && p_first) {
		
        if (!final_trav_Y.includes(current_Y)) {
          final_trav_Y.push(current_Y);
        }

      } else {
        // console.log(' --> getTraversesY NO es travera Y en ' + trav);
      }
    } // End For trav_Y

    final_trav_Y = this.orderByNum(final_trav_Y, false);

    // console.log(' --> getTraversesY final_trav_Y ordenado:');
    // console.log(final_trav_Y);
    
    let falses_traverses = [];
    
    // Comprobamos el listado de posibles traveras Y para descartar
    // las que realmente tienen una pieza entre medias que las rompe.
    final_trav_Y.forEach( (y_value, actual) => {
		
		// console.log(' --> trav_Y actual y_value = ' + y_value);
		
		if (actual > 0) {
			
			let previus_y_value = final_trav_Y[actual - 1];
			
			for (let trav in trav_Y) {
				// Si existe una pieza que "rompa travera" estará en la travera anterior.
				if (trav_Y['y_' + previus_y_value]) {
						trav_Y['y_' + previus_y_value].forEach( pp => {
							
						// console.log(' --> Testeo pieza por si rompe la travera y_' + previus_y_value);
	    				// console.log(pp);
	    				
	    				if (y_value > pp.points[0].y && y_value < pp.points[2].y) {
							// console.log('-> La pieza rompe la travera Y = ' + y_value);
							
							// No es una travera. Se incluye ese valor en el listado de falsas traveras.
							if(!falses_traverses.includes(actual)) {
								falses_traverses.push(actual);
							}
						}
					});
				}
			}
		} // End If actual
		
		if (falses_traverses && falses_traverses.length > 0) {
			// console.log(' --> falses_traverses:');
    		// console.log(falses_traverses);
    		
    		falses_traverses.forEach(ft => {
				// console.log(' --> Eliminando falsa travera:');
    			// console.log(ft);
				final_trav_Y.splice(ft, 1);
			});
		}
	});

    // Va a almacenar en cada posición las piezas de una travera.
    // Se va a poner un límite de 99, que debería ser siempre suficiente.
    // NOTA: Sólo se introducen las que no son "piezas aisladas", ya que estas se
    // ira quitando en cada iteración para sacar el "orden de tronzado" correcto.
    let piecesListTraverseY = [];
    
    // Este listado es similar al anterior "piecesListTraverseY"" sólo que no quita las piezas aisladas para
    // que así puedan quedar reflejadas sus subtraveras y tener toda la estructura de traveras completa.
    let totalListTraverseY = [];

    // Las traveras están ordenadas empezando con la que tiene el valor de X mayor (que coincide
    // con el lado derecho de la plancha) hasta la última que vale 0 (lado izquierdo de la plancha).
    final_trav_Y.forEach( (y_value, actual) => {
      let next = actual + 1;

      if (next < final_trav_Y.length) {

        let current_trav = y_value;
        let next_trav = final_trav_Y[next];

        let pieces_in_trav = [];

        // Buscamos las piezas que están contenidas entre esos ejes Y.
        cutOrderList.forEach( p => {

          // console.log(' --> getTraversesY incluyendo pieza travera Y: ' + p.name);
          // console.log(p);
          
          if (p.points[0].y >= current_trav && p.points[2].y <= next_trav) {
            // console.log(' --> -> getTraversesY en travera: ' + actual);
            // console.log(' --> getTraversesY pieza entre ejes Y: ' + p.name);
            
            // Añadimos el nivel de anidamiento de la pieza. Servierá para
            // saber posteriormente el nivel máximo de la optimización.
            p['level'] = countOut;
            
            pieces_in_trav.push(p);
          }
        });

        // Construimos los puntos que definen las dimensiones de la travera a este nivel.
        let coordinates = [];

        // Coordenada esquina superior izquierda.
        coordinates.push({x: framePoints[0].x, y: current_trav});
        // Coordenada esquina inferior izquierda.
        coordinates.push({x: framePoints[1].x, y: next_trav});
        // Coordenada esquina inferior derecha.
        coordinates.push({x: framePoints[2].x, y: next_trav});
        // Coordenada esquina superior derecha.
        coordinates.push({x: framePoints[3].x, y: current_trav});

        // La pieza está aislada en el marco de la travera por lo
        // que es candidata para ser tronzada antes que el resto.
        if (pieces_in_trav.length === 1) {
          // console.log(' -> getTraversesY pieza tronzar orden = ' + (arrayOut.length + 1));
          // console.log(' --> getTraversesY pieza aislada: ' + pieces_in_trav[0].name);
          arrayOut.push(pieces_in_trav[0]);
          //countOut++;
          
          // Se guarda también la "pieza aislada" para que aparezca su travera Y reflejada en el total.
          totalListTraverseY.push({ pieces: pieces_in_trav, coordinates: coordinates });
        } else {

          // console.log(' --> getTraversesY pieza aislada NO: ' + pieces_in_trav[0].name);

          // Guardamos todas las piezas de esa travera y las coordenadas de los puntos de su marco.
          piecesListTraverseY.push({ pieces: pieces_in_trav, coordinates: coordinates });
          totalListTraverseY.push({ pieces: pieces_in_trav, coordinates: coordinates, index_y: actual, tr_z: [] });

          if (recallIn && pieces_in_trav.length > 0 && pieces_in_trav.length < piecesIn.length) {
            this.getTraversesX((countOut + 1), arrayOut, pieces_in_trav, coordinates, 'Z', true);
          } else {
            // console.log(' -> getTraversesY pieza bloqueada en travera.' + (arrayOut.length + 1));
            // console.log(pieces_in_trav);
          }
        }
      }
    });

    // NOTA: la variable "countOut" va a almacenar el nivel de anidamiento en el que se ha disparado la función.
    // console.log(' --> getTraversesY piecesListTraverseY count: ' + countOut);
    // console.log(piecesListTraverseY);

    return [piecesListTraverseY, totalListTraverseY];
  } // End getTraversesY
  
// ---------- Fin Funciones antiguas de obtención de traveras.



  // Nuevas funciones para la obtención de traveras, sus piezas y el nivel de cada una.
  // Función que devuelve las traveras X y las piezas que
  // hay dentro de ellas pasado un listado de piezas.
  getLevelTraversesX(countOut: number, arrayOut: any[], piecesIn: any[], framePoints: any, levelIn: string, recallIn: boolean) {

    // console.log(' --> getLevelTraversesX entrada piezas: ' + countOut);
    // console.log(piecesIn);

    // console.log(' --> getLevelTraversesX framePoints:');
    // console.log(framePoints);

    let cutOrderList = piecesIn;

    let trav_X = [];

    // Hacemos grupos según donde empieza la pieza en X.
    cutOrderList.forEach( p => {

      let key = 'x_' + p.points[0].x;

      if (!trav_X[key]) {
        trav_X[key] = [];
      }

      trav_X['x_' + p.points[0].x].push(p);

    });

    // console.log(' --> getLevelTraversesX ejes X:');
    // console.log(trav_X);

    let final_trav_X = [];

    // Se añade el eje X representante del lado del extremo derecho de la plancha.
    final_trav_X.push(framePoints[3].x);

    for (let trav in trav_X) {
      // console.log(' --> -> getLevelTraversesX traveras X:');
      // console.log(trav_X[trav]);

      let p_first = false;
      let p_last = false;

      let current_X = -1;

      // Confirmar cuales son realmente traveras X (cruzan todo el eje Y).
      // Condición: tienen una pieza que comienza en "y=0" y otra que termina en "y=(alto de hoja)"
      trav_X[trav].forEach( p => {

        // console.log(' --> getLevelTraversesX pieza en travera: ' + trav);
        // console.log(p);

        current_X = p.points[0].x;

        if (p.points[0].y === framePoints[0].y) {
          p_first = true;
        }

        if (p.points[1].y === framePoints[1].y) {
          p_last = true;
        }
      });

      if (p_last && p_first) {

        // console.log(' --> getLevelTraversesX SI es travera X en ' + trav);

        if (!final_trav_X.includes(current_X)) {
          final_trav_X.push(current_X);
        }

      } else {
        // console.log(' --> getLevelTraversesX NO es travera X en ' + trav);
      }
    } // End For trav_X

    final_trav_X = this.orderByNum(final_trav_X, false);

    // console.log(' --> getLevelTraversesX final_trav_X:');
    // console.log(final_trav_X);

    // Va a almacenar en cada posición las piezas de una travera.
    // Se va a poner un límite de 99, que debería ser siempre suficiente.
    let piecesListTraverseX = [];
    
    // Este listado es similar al anterior "piecesListTraverseX"" sólo que no quita las piezas aisladas para
    // que así puedan quedar reflejadas sus subtraveras y tener toda la estructura de traveras completa.
    let totalListTraverseX = [];

    // Las traveras están ordenadas empezando con la que tiene el valor de X mayor (que coincide
    // con el lado derecho de la plancha) hasta la última que vale 0 (lado izquierdo de la plancha).
    final_trav_X.forEach( (x_value, actual) => {
      let next = actual + 1;

      if (next < final_trav_X.length) {

        let current_trav = x_value;
        let next_trav = final_trav_X[next];

        let pieces_in_trav = [];

        // Buscamos las piezas que están contenidas entre esos ejes X.
        cutOrderList.forEach( p => {

          if (p.points[0].x >= current_trav && p.points[3].x <= next_trav) {
            // console.log(' --> -> getLevelTraversesX en travera: ' + actual);
            
            // Añadimos el nivel de anidamiento de la pieza. Servirá para
            // saber posteriormente el nivel máximo de la optimización.
            p['level'] = countOut;
            
            pieces_in_trav.push(p);
          }
        });

        // Construimos los puntos que definen las dimensiones de la travera a este nivel.
        let coordinates = [];

        // Coordenada esquina superior izquierda.
        coordinates.push({x: current_trav, y: framePoints[0].y});
        // Coordenada esquina inferior izquierda.
        coordinates.push({x: current_trav, y: framePoints[1].y});
        // Coordenada esquina inferior derecha.
        coordinates.push({x: next_trav, y: framePoints[2].y});
        // Coordenada esquina superior derecha.
        coordinates.push({x: next_trav, y: framePoints[3].y});

        // NOTA: En las traveras X sólo se saca pieza antes si está en la última travera.
        // Si no se dejan para las traveras Y para que vayan después. La única excepción
        // es cuando es una travera de retal "final de plancha" que entonces siempre ira
        // como última pieza a sacar al final de toda la optimización.

        // La pieza está aislada en el marco de la travera por lo
        // que es candidata para ser tronzada antes que el resto.
        if (pieces_in_trav.length === 1) {
          // console.log(' -> getLevelTraversesX pieza tronzar orden = ' + (arrayOut.length + 1));
          arrayOut.push(pieces_in_trav[0]);
          //countOut++;
          
          // Se guarda también la "pieza aislada" para que aparezca su travera X reflejada en el total.
          piecesListTraverseX.unshift({ level: countOut, cut: levelIn, ind: actual, pieces: pieces_in_trav, coordinates: coordinates});
          totalListTraverseX.unshift({ level: countOut, cut: levelIn, ind: actual, pieces: pieces_in_trav, coordinates: coordinates});
          
        } else {

          // Guardamos todas las piezas de esa travera y las coordenadas de los puntos de su marco.
		  piecesListTraverseX.unshift({ level: countOut, cut: levelIn, ind: actual, pieces: pieces_in_trav, coordinates: coordinates});
		  totalListTraverseX.unshift({ level: countOut, cut: levelIn, ind: actual, pieces: pieces_in_trav, coordinates: coordinates});
        } // End Else pieces_in_trav.length.
      } // End If next.
    }); // End ForEach final_trav_X.

    // NOTA: la variable "countOut" va a almacenar el nivel de anidamiento en el que se ha disparado la función.
    // console.log(' --> -> getLevelTraversesX piecesListTraverseX count: ' + countOut);
    // console.log(piecesListTraverseX);

    return [piecesListTraverseX, totalListTraverseX];
  } // End getLevelTraversesX

  // Función que devuelve las traveras Y y las piezas que
  // hay dentro de ellas pasado un listado de piezas.
  // NOTA: No devuelve la travera Y si sólo la compone una pieza (es decir, si no tiene subniveles no la incluye).
  getLevelTraversesY(countOut: number, arrayOut: any[], piecesIn: any[], framePoints: any, levelIn: string, recallIn: boolean) {

	// console.log(' --> Ejecutando getLevelTraversesY levelIn: ' + levelIn);

	// console.log(' --> getLevelTraversesY entrada piezas:' + countOut);
	// console.log(piecesIn);
	
	// console.log(' --> getLevelTraversesY framePoints:');
	// console.log(framePoints);
    
    // Si no hay piezas de entrada se sale de la función;
    if (!piecesIn) return [[], []];

    let cutOrderList = piecesIn;

    let trav_Y = [];

    // Hacemos grupos según donde empieza la pieza en Y.
    cutOrderList.forEach( p => {

      let key = 'y_' + p.points[0].y;

      if (!trav_Y[key]) {
        trav_Y[key] = [];
      }

      trav_Y['y_' + p.points[0].y].push(p);

    });

    // console.log(' --> getLevelTraversesY ejes Y length: ' + trav_Y.length);
    // console.log(trav_Y);
    
    let final_trav_Y = [];

    // Se añade el eje Y representante del lado del extremo de abajo de la plancha.
    final_trav_Y.push(framePoints[2].y);
    
    for (let trav in trav_Y) {
      // console.log(' --> -> getLevelTraversesY traveras Y:');
      // console.log(trav_Y[trav]);

      let p_first = false;
      let p_last = false;

      let current_Y = -1;
      
      // Confirmar cuales son realmente traveras Y (cruzan todo el eje X).
      // Condición: tienen una pieza que comienza en "x=0" y otra que termina en "x=(ancho de hoja)"
      
      trav_Y[trav].forEach( p => {

        // console.log(' --> getLevelTraversesY pieza en travera: ' + trav);
        // console.log(p);

        current_Y = p.points[0].y;
        
        if (p.points[0].x === framePoints[0].x) {
          p_first = true;
        }

        if (p.points[3].x === framePoints[3].x) {
          p_last = true;
        }
      });
      
      
      if (p_last && p_first) {
		
        if (!final_trav_Y.includes(current_Y)) {
          final_trav_Y.push(current_Y);
        }

      } else {
        // console.log(' --> getLevelTraversesY NO es travera Y en ' + trav);
      }
    } // End For trav_Y

    final_trav_Y = this.orderByNum(final_trav_Y, false);

    let falses_traverses = [];
    
    // Comprobamos el listado de posibles traveras Y para descartar
    // las que realmente tienen una pieza entre medias que las rompe.
    final_trav_Y.forEach( (y_value, actual) => {
		
		// console.log(' --> trav_Y actual y_value = ' + y_value);
		
		if (actual > 0) {
			
			let previus_y_value = final_trav_Y[actual - 1];
			
			for (let trav in trav_Y) {
				// Si existe una pieza que "rompa travera" estará en la travera anterior.
				if (trav_Y['y_' + previus_y_value]) {
						trav_Y['y_' + previus_y_value].forEach( pp => {
							
						// console.log(' --> Testeo pieza por si rompe la travera y_' + previus_y_value);
	    				// console.log(pp);
	    				
	    				if (y_value > pp.points[0].y && y_value < pp.points[2].y) {
							// console.log('-> La pieza rompe la travera Y = ' + y_value);
							
							// No es una travera. Se incluye ese valor en el listado de falsas traveras.
							if(!falses_traverses.includes(actual)) {
								falses_traverses.push(actual);
							}
						}
					});
				}
			}
		} // End If actual
		
		if (falses_traverses && falses_traverses.length > 0) {
			// console.log(' --> falses_traverses:');
    		// console.log(falses_traverses);
    		
    		falses_traverses.forEach(ft => {
				// console.log(' --> Eliminando falsa travera:');
    			// console.log(ft);
				final_trav_Y.splice(ft, 1);
			});
		}
	});
	
	// console.log(' --> getLevelTraversesY final_trav_Y ordenado y sin falsas traveras:');
	// console.log(final_trav_Y);

    let piecesListTraverseY = [];
    
    // Este listado es similar al anterior "piecesListTraverseY" sólo que no quita las piezas aisladas para
    // que así puedan quedar reflejadas sus subtraveras y tener toda la estructura de traveras completa.
    let totalListTraverseY = [];

    // Las traveras están ordenadas empezando con la que tiene el valor de X mayor (que coincide
    // con el lado derecho de la plancha) hasta la última que vale 0 (lado izquierdo de la plancha).
    final_trav_Y.forEach( (y_value, actual) => {
      let next = actual + 1;

      if (next < final_trav_Y.length) {

        let current_trav = y_value;
        let next_trav = final_trav_Y[next];

        let pieces_in_trav = [];

        // Buscamos las piezas que están contenidas entre esos ejes Y.
        cutOrderList.forEach( p => {

          // console.log(' --> getLevelTraversesY incluyendo pieza travera Y: ' + p.name);
          // console.log(p);
          
          if (p.points[0].y >= current_trav && p.points[2].y <= next_trav) {
            // console.log(' --> -> getLevelTraversesY en travera: ' + actual);
            // console.log(' --> getLevelTraversesY pieza entre ejes Y: ' + p.name);
            
            // Añadimos el nivel de anidamiento de la pieza. Servierá para
            // saber posteriormente el nivel máximo de la optimización.
            p['level'] = countOut;
            
            pieces_in_trav.push(p);
          }
        });

        // Construimos los puntos que definen las dimensiones de la travera a este nivel.
        let coordinates = [];

        // Coordenada esquina superior izquierda.
        coordinates.push({x: framePoints[0].x, y: current_trav});
        // Coordenada esquina inferior izquierda.
        coordinates.push({x: framePoints[1].x, y: next_trav});
        // Coordenada esquina inferior derecha.
        coordinates.push({x: framePoints[2].x, y: next_trav});
        // Coordenada esquina superior derecha.
        coordinates.push({x: framePoints[3].x, y: current_trav});

        // La pieza está aislada en el marco de la travera por lo
        // que es candidata para ser tronzada antes que el resto.
        if (pieces_in_trav.length === 1) {
			
          // console.log(' -> getLevelTraversesY pieza tronzar orden = ' + (arrayOut.length + 1));
          // console.log(' --> getLevelTraversesY pieza aislada: ' + pieces_in_trav[0].name);
          
          arrayOut.push(pieces_in_trav[0]);
          
          //countOut++;
          
          // Se guarda también la "pieza aislada" para que aparezca su travera Y reflejada en el total.
          totalListTraverseY.push({ level: countOut, cut: levelIn, ind: actual, pieces: pieces_in_trav, coordinates: coordinates});
        
        } else {

          // console.log(' --> getLevelTraversesY pieza aislada NO: ' + pieces_in_trav[0].name);

          // Guardamos todas las piezas de esa travera y las coordenadas de los puntos de su marco.
          // piecesListTraverseY.push({ pieces: pieces_in_trav, coordinates: coordinates });
          piecesListTraverseY.push({ level: countOut, cut: levelIn, ind: actual, pieces: pieces_in_trav, coordinates: coordinates});
          totalListTraverseY.push({ level: countOut, cut: levelIn, ind: actual, pieces: pieces_in_trav, coordinates: coordinates});
          
        } // End Else pieces_in_trav.length.
      } // End If next.
    }); // End ForEach final_trav_X.

    // console.log(' --> getLevelTraversesY piecesListTraverseY count: ' + countOut);
	// console.log(piecesListTraverseY);

    return [piecesListTraverseY, totalListTraverseY];
  } // End getLevelTraversesY

// -------------------------------------------------------------------
//	Fin funciones nuevas para la obtención de traveras y sus niveles
// -------------------------------------------------------------------

  // -------------------------
  //  FUNCIONES DE ORDENACIÓN
  // -------------------------
  
  // Función que ordena el listado de traveras X pasado como primer parámetro
  // teniendo en cuenta el número de seuencia de las piezas internas que contienen.
  // Cada travera se calcula su mínima y su máxima secuencia. Si una "travera 1""
  // tiene su máxima secuencia menor que la mínima secuencia de otra "travera 2",
  // entonces la "travera 1" se puede poner detrás de la "travera 2" para así mejorar el
  // apilamiento (en caso de que no estuviese ya detrás en el orden de salida).
  // IMPORTANTE: Al cambiar de posición la travera hay que modificar también su posición
  // de origen dentro de la nueva hoja en que se coloque.
  // Se crea una primera hoja vacía y se van añadiendo traveras X dentro de ella hasta
  // que no quepan más. Entonces hay que crear una nueva hoja y añadirla ahí.
  orderTravXBySequence(arrayIn: any[], totalGraphicListIn: any[], invert: boolean) {

    console.log(' -->> orderTravXBySequence level0TraverseList:');
    console.log(arrayIn);
    console.log(' -->> orderTravXBySequence totalGraphicListIn:');
    console.log(totalGraphicListIn);

    // NOTA TÉCNICA (2026-05-11):
    // Con OEF activo no se recalcula la posición X de traveras principales.
    // Motivo: el reordenado posterior desplaza piezas por id/alias (trDisplacement)
    // y, con primitivas OEF y retales sintéticos, puede desalinear geometría y
    // provocar solapes/cruces de travera en algunas hojas (casos detectados: opti 841).
    // Se mantiene el layout original del optimizador para preservar consistencia
    // entre canvas, PDF y exportaciones.
    const hasOefGraphics = Array.isArray(totalGraphicListIn) && totalGraphicListIn.some(sheet =>
      Array.isArray(sheet) && sheet.some(g =>
        g && g.type === 'P' && Array.isArray(g.oef_internal_polygons) && g.oef_internal_polygons.length > 0
      )
    );
    if (hasOefGraphics) {
      console.log(' -->> orderTravXBySequence: OEF detectado, se omite reordenado de traveras X.');
      const passthrough = [];
      for (let prop in arrayIn) {
        if (arrayIn[prop]) {
          passthrough.push(arrayIn[prop]);
        }
      }
      return invert ? passthrough.reverse() : passthrough;
    }
    
    let sheet_new_traverse_order = [];
    const isSyntheticTraverseName = (name: any) => {
      const nameText = String(name || '');
      return nameText.startsWith('T_SYN_') || nameText.startsWith('R_SYN_');
    };
    const isSyntheticTraversePiece = (piece: any) =>
      piece && (piece.type === 'T' || piece.type === 'R') && isSyntheticTraverseName(piece.name);
    const isSyntheticOnlyTraverse = (trX: any) => {
      const pieces = (trX && Array.isArray(trX.tr_pieces)) ? trX.tr_pieces : [];
      if (pieces.length === 0) {
        return false;
      }
      const hasCutPiece = pieces.some(p => p && p.type === 'P');
      if (hasCutPiece) {
        return false;
      }
      return pieces.every(p => isSyntheticTraversePiece(p));
    };
    
    for (let prop in arrayIn) {
		
		let sheet = arrayIn[prop];
		
		// Va a almacenar todas las traveras X principales de la hoja
		// añadiéndoles el rango de secuencias que contiene.
		let trX_sheet_ordered = [];
		
		sheet.forEach(trX => {
			if (isSyntheticOnlyTraverse(trX)) {
				return;
			}
			
			// Se crea un campo en la travera X donde almacenar las secuencias que contiene.
			trX['sequence_list'] = [];
			
			if (trX.tr_pieces) {
				
				trX.tr_pieces.forEach(elem => {
			          // console.log('Pieza: ' + j);
			      	  // console.log(elem);
			      	  
			      	  if (!trX['sequence_list'].includes(elem.sequence)) {
						trX['sequence_list'].push(elem.sequence);
					  } 
			    }); // End For pieces.
			      
			    // Ordenamos las secuencias de mayor a menor.
			    trX['sequence_list'] = this.orderByNum(trX['sequence_list'], true);
			    if (trX['sequence_list'].length === 0) {
					trX['sequence_list'].push(-1);
			    }
			    
			} // End If tr_pieces.
			
		    trX_sheet_ordered.push(trX);
		    
		    /* // De momento no se va a llevar a caba la ordenación por TRAVERAS Y.
		    // NOTA: Se podría intentar ordenar aquí por secuencia las "traveras Y"
		    // contenidas dentro de cada "travera X" obtenida de cada hoja. Habría
		    // que anidar el siguiente nivel de cada travera X.
		    if (trX.sub_tr && trX.sub_tr.tr_in) {
				
				let trY_ordered = [];
				
				// Se obtienen las secuencias de las piezas contidas
				// dentro de las traveras Y que hay en cada travera X.
				trX.sub_tr.tr_in.forEach(trY => {
			          // console.log('trY: ');
			      	  // console.log(trY);
			      	  
			      	  // Se crea un campo en la travera Y donde almacenar las secuencias que contiene.
					  trY['sequence_list'] = [];
			      	  
			      	  trY.pieces.forEach(elem => {
				          // console.log('Pieza trY: ');
				      	  // console.log(elem);
				      	  
				      	  if (!trY['sequence_list'].includes(elem.sequence)) {
							trY['sequence_list'].push(elem.sequence);
						  } 
				      }); // End For pieces.
				      
				      // Ordenamos las secuencias de mayor a menor.
			    	trY['sequence_list'] = this.orderByNum(trY['sequence_list'], true);
			      	  
			      	trY_ordered.push(trY);
			      	
			    }); // End For tr_in.
			    
			    // Es menor el elemento cuya secuencia es menor.
			    trX.sub_tr.tr_in = trX.sub_tr.tr_in.sort((a, b) => {
			
			      let compare = 0;
			      
			      let max_a = a['sequence_list'][0];
			      let min_a = a['sequence_list'][a['sequence_list'].length - 1];
			      
			      let max_b = b['sequence_list'][0];
			      let min_b = b['sequence_list'][b['sequence_list'].length - 1];
			      
			      if (max_a > max_b || (max_a === max_b) && min_a > min_b) {
			        // console.log('--> A > B');
			        compare = -1;
			        
			      } else if (min_a === min_b && max_a === max_b) {
			        // console.log('--> A y B tienen las mismas secuencias mayor y menor.');
			        compare = 0; // Son iguales.
			          
			      } else {
			        // console.log('--> A < B');
			        
			        compare = 1;
			      }
			
			      return compare;
			    }); // End sort trX.sub_tr.tr_in.
			} // End If sub_tr. Fin ordenación por TRAVERAS Y. // */
			
		}); // End For sheet traveras X.
		
		// Es menor el elemento cuya secuencia es menor.
	    trX_sheet_ordered = trX_sheet_ordered.sort((a, b) => {
	
	      let compare = 0;
	      
	      let max_a = a['sequence_list'][0];
	      let min_a = a['sequence_list'][a['sequence_list'].length - 1];
	      
	      let max_b = b['sequence_list'][0];
	      let min_b = b['sequence_list'][b['sequence_list'].length - 1];
	      
	      if (max_a > max_b || (max_a === max_b) && min_a > min_b) {
	        // console.log('--> A > B');
	        compare = -1;
	        
	      } else if (min_a === min_b && max_a === max_b) {
	        // console.log('--> A y B tienen las mismas secuencias mayor y menor.');
	        compare = 0; // Son iguales.
	          
	      } else {
	        // console.log('--> A < B');
	        
	        compare = 1;
	      }
	
	      return compare;
	    }); // End sort traverseXList.
		
		sheet_new_traverse_order.push(trX_sheet_ordered);
		
	} // End For arrayIn.
	
    // Ahora hay que modificar las coordenadas de cada travera X
    // para adaptarla a su nueva posición según su orden.
    
    console.log(' -->> orderTravXBySequence sheet_new_traverse_order A:');
    console.log(JSON.parse(JSON.stringify(sheet_new_traverse_order)));
    
    sheet_new_traverse_order.forEach((sh, ind_sh) => {
		
		let x_count = 0;
		
		sh.forEach((trX, ind_trX) => {
			
			// Se aplica a las coordenadas las transformaciones para adaptarlo al punto de origen actual.
	        this.changeOriginPoint(trX.tr_coordinates, trX.sheet_width, trX.sheet_height, this.disband, trX.origin);
			
			let initial_x = trX.tr_coordinates[0].x;
			
			console.log(' -> desplazamiento inicial:');
			console.log(initial_x);
			console.log(' -> x_count A:');
			console.log(x_count);
			
			let tr_length = trX.tr_coordinates[2].x - trX.tr_coordinates[0].x;
			
			console.log(' -> tr_length:');
			console.log(tr_length);
		
			// Sólo hay que modificar el valor de X de los puntos de coordenadas.
			trX.tr_coordinates[0].x = x_count;
			trX.tr_coordinates[1].x = x_count;
			
			trX.tr_coordinates[2].x = x_count + tr_length;
			trX.tr_coordinates[3].x = x_count + tr_length;
			
			x_count += tr_length;
			
			console.log(' -> x_count B:');
			console.log(x_count);
    		  
			// Calculamos el desplazamiento con respecto a su posición de original.
			let displacement = trX.tr_coordinates[0].x - initial_x;
			
			// Si el desplazamiento es negativo quiere decir que la nueva
			// posición de la travera está más cerca del origen que antes.
			
			// console.log(' -> desplazamiento sh = ' + ind_sh + ' trX = ' + ind_trX);
    		// console.log(displacement);
    		
    		// Se aplica ese desplazamiento a las coordenadas de los elementos
    		// internos que tienen esas traveras que se han movido.
    		trX.tr_pieces.forEach(p => {
				
				p.points[0].x += displacement;
				p.points[1].x += displacement;
				p.points[2].x += displacement;
				p.points[3].x += displacement;
			});
			
				let sheet_id = trX.tr_pieces[0].sheet_id;
				
				let sheet_finded = this.sheetList.find(s => s && String(s.id) === String(sheet_id));
				if (!sheet_finded && this.sheetList[ind_sh]) {
					sheet_finded = this.sheetList[ind_sh];
				}
				if (!sheet_finded) {
					console.log('-> No se ha encontrado la hoja asociada al desplazamiento de travera X.');
					console.log({ sheet_id: sheet_id, ind_sh: ind_sh });
					return;
				}
				const pieces_in_sheet = Array.isArray(sheet_finded.pieces) ? sheet_finded.pieces : [];
				const traverses_in_sheet = Array.isArray(sheet_finded.traverses) ? sheet_finded.traverses : [];
				const pieces_in_graphic = (Array.isArray(totalGraphicListIn) && Array.isArray(totalGraphicListIn[ind_sh])) ? totalGraphicListIn[ind_sh] : [];
				const pieces_to_displace = Array.isArray(trX.tr_pieces)
					? trX.tr_pieces.filter(p => !isSyntheticTraversePiece(p))
					: [];
				
				// Se modifican las coordenadas internas.
				if (pieces_to_displace.length > 0) {
					this.trDisplacement(trX,
										pieces_to_displace, 
										trX.sub_tr, 
										pieces_in_sheet, 
										traverses_in_sheet, 
										pieces_in_graphic,
										displacement); // */
				}
			});
		}); // */
		// ----------
		// NOTA: Faltaría modificar las coordenadas de cada travera Y
	    // pero de momento esto no se va a llevar a cabo.
		// ----------
	console.log(' -->> orderTravXBySequence sheet_new_traverse_order B:');
    console.log(JSON.parse(JSON.stringify(sheet_new_traverse_order)));
    
    let resultList = sheet_new_traverse_order;

    console.log(' -->> orderTravXBySequence salida:');
    console.log(JSON.parse(JSON.stringify(resultList)));

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderTravXBySequence.
  
  // Función que aplica un desplazamiento en X a la travera pasada como primer parámetro.
  trDisplacement(sheetIn: any,
  				 piecesDisplacement: any[], 
  				 trIn: any, 
  				 piecesInSheet: any[],
  				 traversesInSheet: any[], 
  				 piecesInGraphic: any[],
  				 displacementIn) {
	/*
	console.log(' -->> trDisplacement trIn:');
    console.log(trIn);
	console.log(' -->> trDisplacement displacementIn:');
    console.log(displacementIn);
	console.log(' -->> trDisplacement piecesDisplacement:');
    console.log(JSON.parse(JSON.stringify(piecesDisplacement)));
    console.log(' -->> trDisplacement piecesInSheet:');
    console.log(JSON.parse(JSON.stringify(piecesInSheet)));
    console.log(' -->> trDisplacement traversesInSheet:');
    console.log(JSON.parse(JSON.stringify(traversesInSheet)));
    console.log(' -->> trDisplacement piecesInGraphic:');
    console.log(JSON.parse(JSON.stringify(piecesInGraphic))); // */
	 
	trIn.pieces.forEach(p => {
		const hasValue = (v: any) => (v !== undefined && v !== null && v !== '');
		const sameId = (a: any, b: any) => (hasValue(a) && hasValue(b) && String(a) === String(b));
		
		// Se busca entre el listado total de piezas desplazadas la pieza actual.
			let find_piece = piecesDisplacement.find(pg => 
				(sameId(pg.name_id, p.name_id) &&
					(!hasValue(pg.num) || !hasValue(p.num) || pg.num === p.num)) ||
				(!hasValue(pg.name_id) && !hasValue(p.name_id) &&
					pg.num === p.num && pg.name === p.name && pg.label === p.label)
			);
		
		if (find_piece) {
			
			if (find_piece.width === 2695) {
			console.log('-> Encontrado el elemento que hay que desplazar.');
			console.log(find_piece);
			}
			
				p.points = find_piece.points;
				
				let find_piece_in_graphic = piecesInGraphic.find(pg => 
					(sameId(pg.name_id, find_piece.name_id) &&
						(!hasValue(pg.num) || !hasValue(find_piece.num) || pg.num === find_piece.num)) ||
					(!hasValue(pg.name_id) && !hasValue(find_piece.name_id) &&
						pg.num === find_piece.num && pg.name === find_piece.name && pg.label === find_piece.label)
				);
			
			if (find_piece_in_graphic) {
				find_piece_in_graphic.points = find_piece.points;
			} else {
				console.log('-> No se ha encontrado la pieza que hay que desplazar en la Hoja.')
			}
			
				if (hasValue(find_piece.name_id)) {
					let find_piece_in_sheet = piecesInSheet.find(pg => 
						sameId(pg.piece.piece_name_id, find_piece.name_id) ||
						(pg.piece && pg.piece.piece_name === find_piece.name && pg.piece.piece_label === find_piece.label)
					);
				
				if (find_piece_in_sheet) {
					console.log('-> Encontrada la pieza que hay que desplazar en sheetList.');
					find_piece_in_sheet.piece.points = find_piece.points;
					find_piece_in_sheet.piece.draw.points = find_piece.points;
					find_piece_in_sheet.origin_x = find_piece.points[0].x;
					
				} else {
					console.log('-> No se ha encontrado la pieza que hay que desplazar en sheetList.')
					console.log(find_piece);
				}
			} else {
				let find_piece_in_sheet = traversesInSheet.find(pg => 
					!pg.draw.name_id && pg.draw.name === find_piece.name && pg.draw.num === find_piece.num && pg.draw.label === find_piece.label
				);
				
				if (find_piece_in_sheet) {
					
					console.log('-> Encontrado el retal que hay que desplazar en sheetList.');
					// console.log(find_piece_in_sheet);
					// console.log(find_piece);
				
					find_piece_in_sheet.points = find_piece.points;
					find_piece_in_sheet.draw.points = find_piece.points;
					find_piece_in_sheet.origin_x = find_piece.points[0].x;
					
				} else {
					console.log('-> No se ha encontrado el retal que hay que desplazar en sheetList.')
					console.log(find_piece);
				}
			}
		} else {
			console.log('-> No se ha encontrado la pieza que hay que desplazar en Travera X.')
		}
	});
	
	// Se continúa la búsqueda de piezas internas para aplicar el desplazamiento.
	if (trIn.tr_in) {
		
		trIn.tr_in.forEach(tr_in => {
			
			this.trDisplacement(
				sheetIn,
				piecesDisplacement, 
				tr_in, piecesInSheet, 
				traversesInSheet, 
				piecesInGraphic, 
				displacementIn
			);
		});
	}
	
  } // End trDisplacement
  
  // Función que ordena el listado de hojas pasado como primer parámetro
  // teniendo en cuenta el número de seuencia de las piezas internas que contienen.
  // Cada hoja se calcula su mínima y su máxima secuencia. Si una "hoja 1""
  // tiene su máxima secuencia menor que la mínima secuencia de otra "hoja 2",
  // entonces la "hoja 1" se puede poner detrás de la "hoja 2" para así mejorar el
  // apilamiento (en caso de que no estuviese ya detrás en el orden de salida).
  orderSheetsBySequence(arrayIn: any[], invert: boolean) {

    console.log(' -->> orderSheetsBySequence entrada:');
    console.log(arrayIn);
    
    let sheet_empty_off =  [];
    
    // Se descartan posibles hojas sin piezas.
    arrayIn = arrayIn.filter(sh => sh.pieces);
    
    arrayIn.forEach((sheet, i) => {
      // console.log(' --> sheet: ' + i);
      // console.log(sheet);

      let pieces = sheet.pieces;
      
      // Se crea un campo en la hoja donde almacenar las secuencias que contiene.
      sheet['sequence_list'] = [];
      
      if (pieces) {
	      for (let j = 0; j < pieces.length; j++) {
	            
	          let elem = pieces[j].piece;
	          
	          // console.log('Pieza: ' + j);
	      	  // console.log(elem);
	      	  
	      	  if (!sheet['sequence_list'].includes(elem.piece_sequence)) {
				sheet['sequence_list'].push(elem.piece_sequence);
			  } 
	      } // End For pieces.
	      
	      // Ordenamos las secuencias de mayor a menor.
	      sheet['sequence_list'] = this.orderByNum(sheet['sequence_list'], true);
	      
	      sheet_empty_off.push(sheet);
	      
	   } // End If pieces.
    }); // End Foreach sheetList.
    
    // console.log('-> sheetList con listado de secuencias:');
    // console.log(this.sheetList);
    
    // Se quita la última hoja porque la cola siempre debe ir al final de la optimización
    // por lo que esa plancha nunca debe incluirse a la hora de reordenar hojas.
    let last_sheet = sheet_empty_off.pop();
    // console.log(' -> last_sheet:');
    // console.log(last_sheet);

    // Es menor el elemento cuya secuencia es menor.
    let resultList = sheet_empty_off.sort((a, b) => {

      let compare = 0;
      
      let max_a = a['sequence_list'][0];
      let min_a = a['sequence_list'][a['sequence_list'].length - 1];
      
      let max_b = b['sequence_list'][0];
      let min_b = b['sequence_list'][b['sequence_list'].length - 1];
      
      if (max_a > max_b || (max_a === max_b) && min_a > min_b) {
        // console.log('--> A > B');
        compare = -1;
        
      } else if (min_a === min_b && max_a === max_b) {
        // console.log('--> A y B tienen las mismas secuencias mayor y menor.');
        compare = 0; // Son iguales.
          
      } else {
        // console.log('--> A < B');
        
        compare = 1;
      }

      return compare;
    });
    
    // Se vuelve a añadir la última hoja al resultado.
    resultList.push(last_sheet);

    // console.log(' -->> orderSheetsBySequence salida:');
    // console.log(JSON.parse(JSON.stringify(resultList)));

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderSheetsBySequence.
  
  // Función que ordena teniendo en cuenta el orden de tronzado total de las piezas.
  orderByTotalCut(arrayIn: any[], invert: boolean) {

    // console.log(' -->> orderByTotalCut entrada:');
    // console.log(arrayIn);

    // Es menor el elemento cuya secuencia es menor.
    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (Number(a['total_cut_order']) < Number(b['total_cut_order'])) {
        // console.log('--> A < B por orden de tronzado.');
        compare = -1;
      } else if (Number(a['total_cut_order']) > Number(b['total_cut_order'])) {
        // console.log('--> A > B por orden de tronzado.');
        compare = 1;
      } else { // Tienen el mismo lote.
          // console.log('--> A y B tienen el mismo orden de tronzado.');
          compare = 0; // Son iguales.
      }

      return compare;
    });

    console.log(' -->> orderByTotalCut salida:');
    // console.log(JSON.parse(JSON.stringify(resultList)));

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByTotalCut

  // Función que ordena teniendo en cuenta el número de lote, secuencia y paneno de las piezas.
  orderByLot(arrayIn: any[], prefix_text: string, invert: boolean) {

    // console.log(' -->> orderByLot entrada:');
    // console.log(arrayIn);
    
    // if (!arrayIn) return;

    // Es menor el elemento cuya secuencia es menor.
    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (Number(a[prefix_text + 'lot']) < Number(b[prefix_text + 'lot'])) {
        // console.log('--> A < B por lote.');
        compare = -1;
      } else if (Number(a[prefix_text + 'lot']) > Number(b[prefix_text + 'lot'])) {
        // console.log('--> A > B por lote.');
        compare = 1;
      } else { // Tienen el mismo lote.
          // console.log('--> A y B tienen el mismo lote.');
          if (Number(a[prefix_text + 'sequence']) < Number(b[prefix_text + 'sequence'])) {
	        // console.log('--> A < B por secuencia.');
	        compare = -1;
	      } else if (Number(a[prefix_text + 'sequence']) > Number(b[prefix_text + 'sequence'])) {
	        // console.log('--> A > B por secuencia.');
	        compare = 1;
	      } else { // Tienen la misma secuencia.
	          // console.log('--> A y B tienen la misma secuencia.');
	          
	          if (a[prefix_text + 'sequence_unit'] && b[prefix_text + 'sequence_unit'] && (Number(a[prefix_text + 'sequence_unit']) < Number(b[prefix_text + 'sequence_unit']))) {
		        // console.log('--> A < B por sequence_unit.');
		        compare = 1;
		      } else {
				// Nunca van a poder tener la misma secuencia de unidad.
				compare = -1;
			  }
		/*    // NOTA: no hace falta comparar más porque nunca se llegará aquí.
		      } else if (Number(a[prefix_text + 'sequence_unit'] && b[prefix_text + 'sequence_unit'] && a[prefix_text + 'sequence_unit']) > Number(b[prefix_text + 'sequence_unit'])) {
		        // console.log('--> A > B por sequence_unit.');
		        compare = -1;
		      } else { // Tienen la misma sequence_unit.
		          // console.log('--> A y B tienen la misma sequence_unit.');
		          
		          if (a[prefix_text + 'paneno'] && b[prefix_text + 'paneno'] && (Number(a[prefix_text + 'paneno']) < Number(b[prefix_text + 'paneno']))) {
			        // console.log('--> A < B por paneno.');
			        compare = -1;
			      } else if (Number(a[prefix_text + 'paneno'] && b[prefix_text + 'paneno'] && a[prefix_text + 'paneno']) > Number(b[prefix_text + 'paneno'])) {
			        // console.log('--> A > B por paneno.');
			        compare = 1;
			      } else { // Tienen el mismo paneno.
			          // console.log('--> A y B tienen el mismo paneno.');
			          compare = 0; // Son iguales.
			      }
		      } // */
	      } // End Else "misma secuencia".
      } // End Else "mismo lote".

      return compare;
    });

    // console.log(' -->> orderByLot salida:');
    // console.log(JSON.parse(JSON.stringify(resultList)));

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByLot
  
  // Función que ordena obtimizaciones teniendo en cuenta el número de pilas, hojas y merma.
  orderByOpti(arrayIn: any[], prefix_text: string, invert: boolean) {

    // console.log(' -->> orderByOpti entrada:');
    // console.log(arrayIn);
    
    // if (!arrayIn) return;

    // Es mayor el elemento cuyo número de pila es menor, número de hoja menor y merma menor.
    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (Number(a[prefix_text + 'ne']) < Number(b[prefix_text + 'ne'])) {
        // console.log('--> A < B por número de pila.');
        compare = -1;
      } else if (Number(a[prefix_text + 'ne']) > Number(b[prefix_text + 'ne'])) {
        // console.log('--> A > B por número de pila.');
        compare = 1;
      } else { // Tienen el mismo número de pila.
          // console.log('--> A y B tienen el mismo número de pila.');
          if (Number(a[prefix_text + 'ns']) < Number(b[prefix_text + 'ns'])) {
	        // console.log('--> A < B por número de hojas.');
	        compare = -1;
	      } else if (Number(a[prefix_text + 'ns']) > Number(b[prefix_text + 'ns'])) {
	        // console.log('--> A > B por número de hojas.');
	        compare = 1;
	      } else { // Tienen el mismo número de hojas.
	          // console.log('--> A y B tienen el mismo número de hojas.');
	          
	          if (Number(a[prefix_text + 'rm']) < Number(b[prefix_text + 'rm'])) {
		        // console.log('--> A < B por retal cola.');
		        compare = 1;
		      } else if (Number(a[prefix_text + 'rm']) > Number(b[prefix_text + 'rm'])) {
				// console.log('--> A > B por retal cola.');
				compare = -1;
			  } else {
				  if (Number(a[prefix_text + 'tm']) < Number(b[prefix_text + 'tm'])) {
			        // console.log('--> A > B por merma.');
			        compare = -1;
			      } else if (Number(a[prefix_text + 'tm']) > Number(b[prefix_text + 'tm'])) {
					// console.log('--> A < B por merma.');
					compare = 1;
				  } else {
					// console.log('--> A y B tienen la misma merma.');
				    compare = 0; // Son iguales.
				  }
			  }
	      } // End Else "misma secuencia".
      } // End Else "mismo lote".

      return compare;
    });

    // console.log(' -->> orderByOpti salida:');
    // console.log(JSON.parse(JSON.stringify(resultList)));

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByOpti

  // Función que ordena por el valor numérico de los elementos.
  // IMPORTANTE: Hay que hacerlo así porque por defecto la función
  // ".sort()" ordena sus entradas como si fuesen caracteres.
  orderByNum(arrayIn: any[], invert: boolean) {

    // console.log(' --> -> orderByNum entrada:');
    // console.log(arrayIn);

    let resultList = arrayIn.sort((a, b) => {

      let a_num = Number(a);
      let b_num = Number(b);

      let compare = 0;

      // Será menor quien menos ancho tenga.
      // Si tuviesen el mismo ancho quien será menor quien menos alto tenga.

      if (a_num < b_num) {
        // console.log('--> A < B.');
        compare = -1;
      } else if (a_num > b_num) {
        // console.log('--> A > B.');
        compare = 1;
      } else {
          // console.log('--> A y B son iguales.');
          compare = 0; // Son iguales.
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByNum
  
  // Función que ordena por el valor porcentaje de progreso de los elementos.
  // IMPORTANTE: Hay que hacerlo así porque por defecto la función
  // ".sort()" ordena sus entradas como si fuesen caracteres.
  orderByLotProgress(arrayIn: any[], invert: boolean) {

    // console.log(' --> -> orderByLotProgress entrada:');
    // console.log(arrayIn);

    let resultList = arrayIn.sort((a, b) => {

      let a_num = Number(a['porcent']);
      let b_num = Number(b['porcent']);
      
      let a_dim = 0;
      let b_dim = 0;
      
      if (a['max_width'] && a['max_height']) {
		a_dim = Number(a['max_width']) > Number(a['max_height']) ? Number(a['max_width']) : Number(a['max_height']);
	  }
	  
	  if (b['max_width'] && b['max_height']) {
		b_dim = Number(b['max_width']) > Number(b['max_height']) ? Number(b['max_width']) : Number(b['max_height']);
	  }
	  
      let compare = 0;

      // Será menor quien menos ancho tenga.
      // Si tuviesen el mismo ancho quien será menor quien menos alto tenga.

      if (a_num < b_num) {
        // console.log('--> A < B.');
        compare = -1;
      } else if (a_num > b_num) {
        // console.log('--> A > B.');
        compare = 1;
      } else {
		
          // console.log('--> A y B son iguales en porcentaje.');
          if (a_dim < b_dim) {
	        // console.log('--> A < B.');
	        compare = -1;
	      } else if (a_dim > b_dim) {
	        // console.log('--> A > B.');
	        compare = 1;
	      } else {
	        // console.log('--> A y B son iguales.');
	        compare = 0; // Son iguales.
	      }
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByLotProgress
  
  // ----------
  
  // Función que obtiene el nivel de profundidad de los elementos
  // (listado de piezas y retales) pasados como segundo parámetro.
  // Se supone que todos los elementos están en una misma hoja, cuyas coordenadas
  // son el tercer parámetro (dibujan el marco de la hoja).
  // Si algún elemento supera el nivel de profundidad máximo pasado como cuarto
  // parámetro, entonces la función devuelve "false".
  // Si todos los elementos cumplen el nivel entonces devuelve "true".
  testPiecesLevel(fitIn: any | null, arrayIn: any[], framePointsIn: any, depthLevelIn: number) {

    // console.log(' --> -> testPiecesLevel entrada. Nivel máximo = ' + depthLevelIn);
    // console.log(fitIn);
    // console.log(arrayIn);
    
    let totalTravList = [];

    let travXList = [];
    let travXTotalList = [];
    let sheetTraverseList = [];
    
    let correct = true;
    
    // if (this.axis === 'X') {

      // console.log(' -> testPiecesLevel eje X:');
      
      // --------- Nuevo código revisado
      
      [travXList, travXTotalList] = this.getLevelTraversesX(1, totalTravList, arrayIn, framePointsIn, 'X', false);

      // console.log(' -> NIVEL 1: traveras X de la hoja: ' + sheet.sheet_id);
      // console.log(travXList);
      // console.log(travXTotalList);
      
      // travXTotalList.reverse().forEach( (trav_x, ind_x) => {
      let some_ko = travXTotalList.reverse().some( (trav_x, ind_x) => {
		
        totalTravList[ind_x] = [];
        
        // console.log('-> trav_x ' + ind_x);
        // console.log(trav_x);
        
        let [travYList, travYListTotal] = this.getLevelTraversesY(2, totalTravList[ind_x], trav_x.pieces, trav_x.coordinates, 'Y', false);
        
        // console.log(' -> NIVEL 2: traveras Y de trX ' + ind_x);
        // console.log(travYList);
        // console.log(travYListTotal);
        
        if (trav_x.pieces.length > 1) {
			
        	if (!trav_x['tr_in']) trav_x['tr_in'] = travYListTotal;
        	
        } else if (trav_x.pieces.length === 1) {
				
			// Se le asigna a la pieza "solitaria" el nivel en el que se encuentra.
			
			// console.log(' Pieza solitaria: se asigna nivel = ' + 1);
			
			trav_x.pieces[0]['piece_level'] = 1;
			
			if (1 > depthLevelIn) {
				
				// console.log('-> Superado nivel 1 X. Se sale de testPiecesLevel.');
				
				correct = false;
				
				return true;
			}
		}
		
		return travYListTotal.some( (trav_y, ind_y) => {
		
	        // console.log('-> trav_y ' + ind_y);
	        // console.log(trav_y);
	        
	        let [travZList, travZListTotal] = this.getLevelTraversesX(3, totalTravList[ind_x], trav_y.pieces, trav_y.coordinates, 'Z', false);
	        
	        // console.log(' -> NIVEL 3: traveras Z de trX ' + ind_x + ' trY ' + ind_y);
	        // console.log(travZList);
	        // console.log(travZListTotal);
	        
	        if (trav_y.pieces.length > 1 && trav_y.pieces.length !== trav_x.pieces.length) {
	        	
	        	if (!trav_y['tr_in']) trav_y['tr_in'] = travZListTotal;
	        	
	        } else if (trav_y.pieces.length === 1 && trav_y.pieces.length !== trav_x.pieces.length) {
				
				// Se le asigna a la pieza "solitaria" el nivel en el que se encuentra.
				
				// console.log(' Pieza solitaria: se asigna nivel = ' + 2);
				
				trav_y.pieces[0]['piece_level'] = 2;
				
				if (2 > depthLevelIn) {
				
					// console.log('-> Superado nivel 2 Y. Se sale de testPiecesLevel.'); 
					
					correct = false;
					
					return true;
				}
			}
			
	        return travZListTotal.some( (trav_z, ind_z) => {
			
		        // console.log('-> trav_z ' + ind_z);
		        // console.log(trav_z);
		        
		        let [travWList, travWListTotal] = this.getLevelTraversesY(4, totalTravList[ind_x], trav_z.pieces, trav_z.coordinates, 'W', false);
		        
		        // console.log(' -> NIVEL 4: traveras W de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z);
		        // console.log(travWList);
		        // console.log(travWListTotal);
		        
		        if (trav_z.pieces.length > 1 && trav_z.pieces.length !== trav_y.pieces.length) {
					
					console.log(' -> Encontradas piezas en nivel W:');
					console.log(travWListTotal);
						
		        	if (!trav_z['tr_in']) trav_z['tr_in'] = travWListTotal;
		        	
		        } else if (trav_z.pieces.length === 1 && trav_z.pieces.length !== trav_y.pieces.length) {
				
					// Se le asigna a la pieza "solitaria" el nivel en el que se encuentra.
					
					// console.log(' Pieza solitaria: se asigna nivel = ' + 3);
					
					trav_z.pieces[0]['piece_level'] = 3;
					
					if (3 > depthLevelIn) {
				
						// console.log('-> Superado nivel 3 Z. Se sale de testPiecesLevel.'); 
						
						correct = false;
						
						return true;
					}
				}
				
		        return travWListTotal.some( (trav_w, ind_w) => {
			
			        // console.log('-> trav_w ' + ind_w);
			        // console.log(trav_w);
			        
			        let [travQList, travQListTotal] = this.getLevelTraversesX(5, totalTravList[ind_x], trav_w.pieces, trav_w.coordinates, 'Q', false);
			        
			        // console.log(' -> NIVEL 5: traveras W de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z + ' trW ' + ind_w);
			        // console.log(travQList);
			        // console.log(travQListTotal);
			        
			        if (trav_w.pieces.length > 1 && trav_w.pieces.length !== trav_z.pieces.length) {
						
						console.log(' -> testPiecesLevel Encontradas piezas en nivel Q:');
						console.log(travQListTotal);
							
			        	if (!trav_w['tr_in']) trav_w['tr_in'] = travQListTotal;
			        	
			        } else if (trav_w.pieces.length === 1 && trav_w.pieces.length !== trav_z.pieces.length) {
				
						// Se le asigna a la pieza "solitaria" el nivel en el que se encuentra.
						// console.log(' Pieza solitaria: se asigna nivel = ' + 4);
						
						trav_w.pieces[0]['piece_level'] = 4;
						
						if (4 > depthLevelIn) {
				
							// console.log('-> Superado nivel 4 W. Se sale de testPiecesLevel.'); 
							
							correct = false;
							
							return true;
						}
					}
			        
			        return travQListTotal.some( (trav_q, ind_q) => {
			
				        // console.log('-> trav_q ' + ind_q);
				        // console.log(trav_q);
				        
				        let [travRList, travRListTotal] = this.getLevelTraversesY(6, totalTravList[ind_x], trav_q.pieces, trav_q.coordinates, 'R', false);
				        
				        // console.log(' -> NIVEL 6: traveras Q de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z + ' trW ' + ind_w + ' trQ ' + ind_q);
				        // console.log(travRList);
				        // console.log(travRListTotal);
				        
				        if (trav_q.pieces.length > 1 && trav_q.pieces.length !== trav_w.pieces.length) {
							
							console.log(' -> testPiecesLevel Encontradas piezas en nivel R:');
							console.log(travRListTotal);
							
				        	if (!trav_q['tr_in']) trav_q['tr_in'] = travRListTotal;
				        	
				        } else if (trav_q.pieces.length === 1 && trav_q.pieces.length !== trav_w.pieces.length) {
				
							// Se le asigna a la pieza "solitaria" el nivel en el que se encuentra.
							// console.log(' Pieza solitaria: se asigna nivel = ' + 5);
							
							trav_q.pieces[0]['piece_level'] = 5;
							
							if (5 > depthLevelIn) {
				
								// console.log('-> Superado nivel 5 Q. Se sale de testPiecesLevel.'); 
								
								correct = false;
								
								return true;
							}
						}
				        
				        return travRListTotal.some( (trav_r, ind_r) => {
			
					        // console.log('-> trav_r ' + ind_r);
					        // console.log(trav_r);
					        
					        let [travSList, travSListTotal] = this.getLevelTraversesX(7, totalTravList[ind_x], trav_r.pieces, trav_r.coordinates, 'S', false);
					        
					        // console.log(' -> NIVEL 7: traveras R de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
					        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r);
					        // console.log(travSList);
					       //  console.log(travSListTotal);
					        
					        if (trav_r.pieces.length > 1 && trav_r.pieces.length !== trav_q.pieces.length) {
								
								console.log(' -> Encontradas piezas en nivel S:');
								console.log(travSListTotal);
								
					        	if (!trav_r['tr_in']) trav_r['tr_in'] = travSListTotal;
					        	
					        } else if (trav_r.pieces.length === 1 && trav_r.pieces.length !== trav_q.pieces.length) {
				
								// Se le asigna a la pieza "solitaria" el nivel en el que se encuentra.
								// console.log(' Pieza solitaria: se asigna nivel = ' + 6);
								
								trav_r.pieces[0]['piece_level'] = 6;
								
								if (6 > depthLevelIn) {
				
									// console.log('-> Superado nivel 6 R. Se sale de testPiecesLevel.'); 
									
									correct = false;
									
									return true;
								}
							}
							
					        return travSListTotal.some( (trav_s, ind_s) => {
			
						        // console.log('-> trav_s ' + ind_s);
						        // console.log(trav_s);
						        
						        let [travTList, travTListTotal] = this.getLevelTraversesY(8, totalTravList[ind_x], trav_s.pieces, trav_s.coordinates, 'T', false);
						        
						        // console.log(' -> NIVEL 8: traveras R de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
						        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r + ' trS ' + ind_s);
						        // console.log(travTList);
						        // console.log(travTListTotal);
						        
						        if (trav_s.pieces.length > 1 && trav_s.pieces.length !== trav_r.pieces.length) {
									
									console.log(' -> Encontradas piezas en nivel T:');
									console.log(travTListTotal);
									
						        	if (!trav_s['tr_in']) trav_s['tr_in'] = travTListTotal;
						        	
						        } else if (trav_s.pieces.length === 1 && trav_s.pieces.length !== trav_r.pieces.length) {
				
									// Se le asigna a la pieza "solitaria" el nivel en el que se encuentra.
									// console.log(' Pieza solitaria: se asigna nivel = ' + 7);
									
									trav_s.pieces[0]['piece_level'] = 7;
									
									if (7 > depthLevelIn) {
				
										// console.log('-> Superado nivel 7 S. Se sale de testPiecesLevel.'); 
										
										correct = false;
										
										return true;
									}
								}
						        
						        return travTListTotal.some( (trav_t, ind_t) => {
			
							        // console.log('-> trav_t ' + ind_t);
							        // console.log(trav_t);
							        
							        let [travUList, travUListTotal] = this.getLevelTraversesX(9, totalTravList[ind_x], trav_t.pieces, trav_t.coordinates, 'U', false);
							        
							        // console.log(' -> NIVEL 9: traveras T de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
							        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r + ' trS ' + ind_s + ' trT ' + ind_t);
							        // console.log(travUList);
							        // console.log(travUListTotal);
							        
							        if (trav_t.pieces.length > 1 && trav_t.pieces.length !== trav_s.pieces.length) {
										
										console.log(' -> Encontradas piezas en nivel U:');
										console.log(travUListTotal);
										
							        	if (!trav_t['tr_in']) trav_t['tr_in'] = travUListTotal;
							        
							        } else if (trav_t.pieces.length === 1 && trav_t.pieces.length !== trav_s.pieces.length) {
				
										// Se le asigna a la pieza "solitaria" el nivel en el que se encuentra.
										// console.log(' Pieza solitaria: se asigna nivel = ' + 8);
										
										trav_t.pieces[0]['piece_level'] = 8;
										
										if (8 > depthLevelIn) {
				
											// console.log('-> Superado nivel 8 T. Se sale de testPiecesLevel.'); 
											
											correct = false;
											
											return true;
										}
									}
							        
							        return travUListTotal.some( (trav_u, ind_u) => {
			
								        // console.log('-> trav_u ' + ind_u);
								        // console.log(trav_u);
								        
								        let [travVList, travVListTotal] = this.getLevelTraversesY(10, totalTravList[ind_x], trav_u.pieces, trav_u.coordinates, 'V', false);
								        
								        // console.log(' -> NIVEL 10: traveras U de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
								        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r + ' trS ' + ind_s + ' trT ' + ind_t + ' trU ' + ind_u);
								        // console.log(travVList);
								        // console.log(travVListTotal);
								        
								        if (trav_u.pieces.length > 1 && trav_u.pieces.length !== trav_t.pieces.length) {
											
											console.log(' -> Encontradas piezas en nivel V:');
											console.log(travVListTotal);
											
								        	if (!trav_u['tr_in']) trav_u['tr_in'] = travVListTotal;
								        
								        } else if (trav_u.pieces.length === 1 && trav_u.pieces.length !== trav_t.pieces.length) {
				
											// Se le asigna a la pieza "solitaria" el nivel en el que se encuentra.
											// console.log(' Pieza solitaria: se asigna nivel = ' + 9);
											
											trav_u.pieces[0]['piece_level'] = 9;
											
											if (9 > depthLevelIn) {
				
												// console.log('-> Superado nivel 9. Se sale de testPiecesLevel.'); 
												
												correct = false;
												
												return true;
											}
											
											// NOTA: No se encuentra ningún caso que incumpla el nivel.
											return false;
										}
							        
							        	// ----------->>>>>> Aquí se podría continuar con el siguiente nivel de profundidad...
							        
							      	}); // Fin ForEach travTTotalList.
						        
						      	}); // Fin ForEach travTTotalList.
					        
					      	}); // Fin ForEach travSTotalList.
				        
				      	}); // Fin ForEach travRTotalList.
			        
			      	}); // Fin ForEach travQTotalList.
		        
		      	}); // Fin ForEach travWTotalList.
	        
	      	}); // Fin ForEach travZTotalList.
	      	
	   }); // Fin ForEach travYTotalList.
      
       // Se guarda toda la información recopilada de la travera X actual.
       // sheetTraverseList.push(trav_x);
        
      }); // Fin ForEach travXTotalList.

    // Fin --------- Nuevo código revisado
    
    // } else if (this.axis === 'Y') { // End IF X axis.

      // console.log(' -> orderPiecesLevel eje Y:');
      
	  // ----- Código nuevo eje Y
      
      
	 // ----- Fin Código nuevo eje Y. // */
	 
    // } // End Else IF Y axis
    // -------------------------------------
    
    // 
    // return { info: sheetTraverseList, correct: correct };
	
	// console.log(' -> some_ko = ' + some_ko);
	
	correct = !some_ko;
	
    return correct;
   
  } // End function testPiecesLevel
  
  // ----------

  // Función que ordena elementos teniendo en cuenta el orden en que son tronzadas dentro de una plancha.
  // Para eso se tiene en cuenta sólo la posición del primer punto del rectángulo de la pieza.
  // Además genera la información de la estructura interna de niveles que llevan las piezas de cada hoja.
  orderPiecesLevel(arrayIn: any[], invert: boolean) {

    console.log(' --> -> orderPiecesLevel entrada: ' + arrayIn.length);
    console.log(arrayIn);

    let resultList = [];
    let totalTravList = [];

    let sheet = arrayIn.find(p => p.type === 'S');

    if (sheet) {
      sheet = JSON.parse(JSON.stringify(sheet));
    } else {
      return totalTravList;
    }

    // console.log(' --> orderPiecesLevel sheet:');
    // console.log(sheet);

    // Se quita la plancha.
    let aux_array = arrayIn.filter(p => p.type !== 'S');

    // NOTA: A la hoja principal hay que quitarle las medidas de desbande.
    sheet.points[1].y = sheet.points[1].y - this.disband.bottom - this.disband.top;
    sheet.points[2].y = sheet.points[2].y - this.disband.bottom - this.disband.top;
    sheet.points[2].x = sheet.points[2].x - this.disband.left - this.disband.right;
    sheet.points[3].x = sheet.points[3].x - this.disband.left - this.disband.right;

    let travXList = [];
    let travXTotalList = [];
    let sheetTraverseList = [];
    
    let level_fault = false;

    // if (this.axis === 'X') {

      // console.log(' -> orderPiecesLevel eje X:');
      
      // --------- Nuevo código revisado
      
      [travXList, travXTotalList] = this.getLevelTraversesX(1, totalTravList, aux_array, sheet.points, 'X', false);

      // console.log(' -> NIVEL 1: traveras X de la hoja: ' + sheet.sheet_id);
      // console.log(travXList);
      // console.log(travXTotalList);
      
      travXTotalList.reverse().forEach( (trav_x, ind_x) => {
		
        totalTravList[ind_x] = [];
        
        // console.log('-> trav_x ' + ind_x);
        // console.log(trav_x);
        
        let [travYList, travYListTotal] = this.getLevelTraversesY(2, totalTravList[ind_x], trav_x.pieces, trav_x.coordinates, 'Y', false);
        
        // console.log(' -> NIVEL 2: traveras Y de trX ' + ind_x);
        // console.log(travYList);
        // console.log(travYListTotal);
        
        if (trav_x.pieces.length > 1) {
        	if (!trav_x['tr_in']) trav_x['tr_in'] = travYListTotal;
        }
        
		travYListTotal.forEach( (trav_y, ind_y) => {
		
	        // console.log('-> trav_y ' + ind_y);
	        // console.log(trav_y);
	        
	        let [travZList, travZListTotal] = this.getLevelTraversesX(3, totalTravList[ind_x], trav_y.pieces, trav_y.coordinates, 'Z', false);
	        
	        // console.log(' -> NIVEL 3: traveras Z de trX ' + ind_x + ' trY ' + ind_y);
	        // console.log(travZList);
	        // console.log(travZListTotal);
	        
	        if (trav_y.pieces.length > 1 && trav_y.pieces.length !== trav_x.pieces.length) {
	        	if (!trav_y['tr_in']) trav_y['tr_in'] = travZListTotal;
	        }
	        
	        travZListTotal.forEach( (trav_z, ind_z) => {
			
		        // console.log('-> trav_z ' + ind_z);
		        // console.log(trav_z);
		        
		        let [travWList, travWListTotal] = this.getLevelTraversesY(4, totalTravList[ind_x], trav_z.pieces, trav_z.coordinates, 'W', false);
		        
		        // console.log(' -> NIVEL 4: traveras W de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z);
		        // console.log(travWList);
		        // console.log(travWListTotal);
		        
		        if (trav_z.pieces.length > 1 && trav_z.pieces.length !== trav_y.pieces.length) {
					
					// console.log(' -> Encontradas piezas en nivel W:');
					// console.log(travWListTotal);
						
		        	if (!trav_z['tr_in']) trav_z['tr_in'] = travWListTotal;
		        }
		        
		        travWListTotal.forEach( (trav_w, ind_w) => {
			
			        // console.log('-> trav_w ' + ind_w);
			        // console.log(trav_w);
			        
			        let [travQList, travQListTotal] = this.getLevelTraversesX(5, totalTravList[ind_x], trav_w.pieces, trav_w.coordinates, 'Q', false);
			        
			        // console.log(' -> NIVEL 5: traveras W de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z + ' trW ' + ind_w);
			        // console.log(travQList);
			        // console.log(travQListTotal);
			        
			        if (trav_w.pieces.length > 1 && trav_w.pieces.length !== trav_z.pieces.length) {
						
						console.log(' -> Encontradas piezas en nivel Q:');
						console.log(travQListTotal);
							
			        	if (!trav_w['tr_in']) trav_w['tr_in'] = travQListTotal;
			        }
			        
			        travQListTotal.forEach( (trav_q, ind_q) => {
			
				        // console.log('-> trav_q ' + ind_q);
				        // console.log(trav_q);
				        
				        let [travRList, travRListTotal] = this.getLevelTraversesY(6, totalTravList[ind_x], trav_q.pieces, trav_q.coordinates, 'R', false);
				        
				        // console.log(' -> NIVEL 6: traveras Q de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z + ' trW ' + ind_w + ' trQ ' + ind_q);
				        // console.log(travRList);
				        // console.log(travRListTotal);
				        
				        if (trav_q.pieces.length > 1 && trav_q.pieces.length !== trav_w.pieces.length) {
							
							console.log(' -> Encontradas piezas en nivel R:');
							console.log(travRListTotal);
							
				        	if (!trav_q['tr_in']) trav_q['tr_in'] = travRListTotal;
				        }
				        
				        travRListTotal.forEach( (trav_r, ind_r) => {
			
					        // console.log('-> trav_r ' + ind_r);
					        // console.log(trav_r);
					        
					        let [travSList, travSListTotal] = this.getLevelTraversesX(7, totalTravList[ind_x], trav_r.pieces, trav_r.coordinates, 'S', false);
					        
					        // console.log(' -> NIVEL 7: traveras R de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
					        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r);
					        // console.log(travSList);
					       //  console.log(travSListTotal);
					        
					        if (trav_r.pieces.length > 1 && trav_r.pieces.length !== trav_q.pieces.length) {
								
								console.log(' -> Encontradas piezas en nivel S:');
								console.log(travSListTotal);
							
					        	if (!trav_r['tr_in']) trav_r['tr_in'] = travSListTotal;
					        }
					        
					        travSListTotal.forEach( (trav_s, ind_s) => {
			
						        // console.log('-> trav_s ' + ind_s);
						        // console.log(trav_s);
						        
						        let [travTList, travTListTotal] = this.getLevelTraversesY(8, totalTravList[ind_x], trav_s.pieces, trav_s.coordinates, 'T', false);
						        
						        // console.log(' -> NIVEL 8: traveras R de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
						        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r + ' trS ' + ind_s);
						        // console.log(travTList);
						        // console.log(travTListTotal);
						        
						        if (trav_s.pieces.length > 1 && trav_s.pieces.length !== trav_r.pieces.length) {
									
									console.log(' -> Encontradas piezas en nivel T:');
									console.log(travTListTotal);
								
						        	if (!trav_s['tr_in']) trav_s['tr_in'] = travTListTotal;
						        }
						        
						        travTListTotal.forEach( (trav_t, ind_t) => {
			
							        // console.log('-> trav_t ' + ind_t);
							        // console.log(trav_t);
							        
							        let [travUList, travUListTotal] = this.getLevelTraversesX(9, totalTravList[ind_x], trav_t.pieces, trav_t.coordinates, 'U', false);
							        
							        // console.log(' -> NIVEL 9: traveras T de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
							        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r + ' trS ' + ind_s + ' trT ' + ind_t);
							        // console.log(travUList);
							        // console.log(travUListTotal);
							        
							        if (trav_t.pieces.length > 1 && trav_t.pieces.length !== trav_s.pieces.length) {
										
										console.log(' -> Encontradas piezas en nivel U:');
										console.log(travUListTotal);
									
							        	if (!trav_t['tr_in']) trav_t['tr_in'] = travUListTotal;
							        }
							        
							        travUListTotal.forEach( (trav_u, ind_u) => {
			
								        // console.log('-> trav_u ' + ind_u);
								        // console.log(trav_u);
								        
								        let [travVList, travVListTotal] = this.getLevelTraversesY(10, totalTravList[ind_x], trav_u.pieces, trav_u.coordinates, 'V', false);
								        
								        // console.log(' -> NIVEL 10: traveras U de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
								        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r + ' trS ' + ind_s + ' trT ' + ind_t + ' trU ' + ind_u);
								        // console.log(travVList);
								        // console.log(travVListTotal);
								        
								        if (trav_u.pieces.length > 1 && trav_u.pieces.length !== trav_t.pieces.length) {
											
											console.log(' -> Encontradas piezas en nivel V:');
											console.log(travVListTotal);
										
								        	if (!trav_u['tr_in']) trav_u['tr_in'] = travVListTotal;
								        }
							        
							        	// ----------->>>>>> Aquí se podría continuar con el siguiente nivel de profundidad...
							        
							      	}); // Fin ForEach travTTotalList.
						        
						      	}); // Fin ForEach travTTotalList.
					        
					      	}); // Fin ForEach travSTotalList.
				        
				      	}); // Fin ForEach travRTotalList.
			        
			      	}); // Fin ForEach travQTotalList.
		        
		      	}); // Fin ForEach travWTotalList.
	        
	      	}); // Fin ForEach travZTotalList.
	      	
	   }); // Fin ForEach travYTotalList.
      
       // Se guarda toda la información recopilada de la travera X actual.
       sheetTraverseList.push(trav_x);
        
      }); // Fin ForEach travXTotalList.

    // Fin --------- Nuevo código revisado
    
    // } else if (this.axis === 'Y') { // End IF X axis.

      // console.log(' -> orderPiecesLevel eje Y:');
      
	  // ----- Código nuevo eje Y
      
      
	 // ----- Fin Código nuevo eje Y. // */
	 
    // } // End Else IF Y axis
    // -------------------------------------

    // console.log(' -> orderPiecesByCut totalTravList:');
    // console.log(totalTravList);

    // Se crea un array colocando las piezas de travera en travera empezando por la primera travera X.
    totalTravList.forEach(tt => {

      tt.forEach(t => {
		let similar_piece = resultList.find(px => {
			if (px.name === t.name) {
				// console.log('similar_piece encontrada en el resultado actual.');
				// console.log(t);
				return true;
			}
			return false;
		});
		
		if (!similar_piece) resultList.push(t);
      });
    });

    // console.log(' -> orderPiecesLevel travXList:');
    // console.log(travXList);

    console.log(' -> orderPiecesLevel sheetTraverseList:');
    // console.log(sheetTraverseList);
    
    // console.log(' -> orderPiecesLevel infinite_level:');
    // console.log(this.infinite_level);
    
    // console.log(' -> orderPiecesLevel resultList:');
    // console.log(resultList);

    // Se devuelve un primer valor con la ordenación invertida si así se ha solicitado.
    // Como segundo valor se devuelve el listado de todas las traveras de nivel 0 de la hoja y
    // las piezas que contiene (esto es necesario para poder hacer el fichero TRA4_NEU de Lisec).
    if (invert) {
      return [resultList.reverse(), travXList, sheetTraverseList, level_fault];
    } else {
      return [resultList, travXList, sheetTraverseList, level_fault];
    }
  } // End function orderPiecesLevel
  
  
  // Función que ordena elementos teniendo en cuenta un orden concreto para el tronzadado dentro de una plancha.
  // Para eso se tiene en cuenta sólo la posición del primer punto del rectángulo de la pieza.
  // Además genera la información de la estructura interna de niveles que llevan las piezas de cada hoja.
  // NOTA: El orden se calcula teniendo en cuenta un "grado de libertad" específico.
  // tenga mayor posibilidad de acertar con el orden de secuencia.
  orderPiecesFreeGrade(arrayIn: any[], freeGrade: number, freeGradeIn: number, invert: boolean) {

    // console.log(' --> -> orderPiecesFreeGrade: ' + arrayIn.length);
    // console.log(arrayIn);

    let resultList = [];
    let totalTravList = [];
    
    let freeCutOrderList = [];
    let freeCutOrderPieces = [];

    let sheet = arrayIn.find(p => p.type === 'S');

    if (sheet) {
      sheet = JSON.parse(JSON.stringify(sheet));
    } else {
      return totalTravList;
    }

    // console.log(' --> orderPiecesFreeGrade sheet:');
    // console.log(sheet);

    // Se quita la plancha.
    let aux_array = arrayIn.filter(p => p.type !== 'S');

    // NOTA: A la hoja principal hay que quitarle las medidas de desbande.
    sheet.points[1].y = sheet.points[1].y - this.disband.bottom - this.disband.top;
    sheet.points[2].y = sheet.points[2].y - this.disband.bottom - this.disband.top;
    sheet.points[2].x = sheet.points[2].x - this.disband.left - this.disband.right;
    sheet.points[3].x = sheet.points[3].x - this.disband.left - this.disband.right;

    let travXList = [];
    let travXTotalList = [];
    let sheetTraverseList = [];
    
    let level_fault = false;

    // if (this.axis === 'X') {

      // console.log(' -> orderPiecesFreeGrade eje X:');
      
      // --------- Nuevo código revisado
      
      [travXList, travXTotalList] = this.getLevelTraversesX(1, totalTravList, aux_array, sheet.points, 'X', false);

      // console.log(' -> NIVEL 1: traveras X de la hoja: ' + sheet.sheet_id);
      // console.log(travXList);
      // console.log(travXTotalList);
      
      travXTotalList.reverse().forEach( (trav_x, ind_x) => {
		
        totalTravList[ind_x] = [];
        
        // console.log('-> trav_x ' + ind_x);
        // console.log(trav_x);
        
        let [travYList, travYListTotal] = this.getLevelTraversesY(2, totalTravList[ind_x], trav_x.pieces, trav_x.coordinates, 'Y', false);
        
        // console.log(' -> NIVEL 2: traveras Y de trX ' + ind_x);
        // console.log(travYList);
        // console.log(travYListTotal);
        
        if (trav_x.pieces.length > 1) {
        	if (!trav_x['tr_in']) trav_x['tr_in'] = travYListTotal;
        }
        
		travYListTotal.forEach( (trav_y, ind_y) => {
		
	        // console.log('-> trav_y ' + ind_y);
	        // console.log(trav_y);
	        
	        let [travZList, travZListTotal] = this.getLevelTraversesX(3, totalTravList[ind_x], trav_y.pieces, trav_y.coordinates, 'Z', false);
	        
	        // console.log(' -> NIVEL 3: traveras Z de trX ' + ind_x + ' trY ' + ind_y);
	        // console.log(travZList);
	        // console.log(travZListTotal);
	        
	        // console.log(' -> Encontradas piezas en nivel Z:');
			// console.log(travZListTotal);
	        
	        if (trav_y.pieces.length > 1 && trav_y.pieces.length !== trav_x.pieces.length) {
	        	if (!trav_y['tr_in']) trav_y['tr_in'] = travZListTotal;
	        }
	        
	        travZListTotal.forEach( (trav_z, ind_z) => {
			
		        // console.log('-> trav_z ' + ind_z);
		        // console.log(trav_z);
		        
		        let [travWList, travWListTotal] = this.getLevelTraversesY(4, totalTravList[ind_x], trav_z.pieces, trav_z.coordinates, 'W', false);
		        
		        // console.log(' -> NIVEL 4: traveras W de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z);
		        // console.log(travWList);
		        // console.log(travWListTotal);
		        
		        if (trav_z.pieces.length > 1 && trav_z.pieces.length !== trav_y.pieces.length) {
					
					// console.log(' -> Encontradas piezas en nivel W:');
					// console.log(travWListTotal);
						
		        	if (!trav_z['tr_in']) trav_z['tr_in'] = travWListTotal;
		        }
		        
		        travWListTotal.forEach( (trav_w, ind_w) => {
			
			        // console.log('-> trav_w ' + ind_w);
			        // console.log(trav_w);
			        
			        let [travQList, travQListTotal] = this.getLevelTraversesX(5, totalTravList[ind_x], trav_w.pieces, trav_w.coordinates, 'Q', false);
			        
			        // console.log(' -> NIVEL 5: traveras W de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z + ' trW ' + ind_w);
			        // console.log(travQList);
			        // console.log(travQListTotal);
			        
			        if (trav_w.pieces.length > 1 && trav_w.pieces.length !== trav_z.pieces.length) {
						
						// console.log(' -> Encontradas piezas en nivel Q:');
						// console.log(travQListTotal);
							
			        	if (!trav_w['tr_in']) trav_w['tr_in'] = travQListTotal;
			        }
			        
			        travQListTotal.forEach( (trav_q, ind_q) => {
			
				        // console.log('-> trav_q ' + ind_q);
				        // console.log(trav_q);
				        
				        let [travRList, travRListTotal] = this.getLevelTraversesY(6, totalTravList[ind_x], trav_q.pieces, trav_q.coordinates, 'R', false);
				        
				        // console.log(' -> NIVEL 6: traveras Q de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z + ' trW ' + ind_w + ' trQ ' + ind_q);
				        // console.log(travRList);
				        // console.log(travRListTotal);
				        
				        if (trav_q.pieces.length > 1 && trav_q.pieces.length !== trav_w.pieces.length) {
							
							// console.log(' -> Encontradas piezas en nivel R:');
							// console.log(travRListTotal);
							
				        	if (!trav_q['tr_in']) trav_q['tr_in'] = travRListTotal;
				        }
				        
				        travRListTotal.forEach( (trav_r, ind_r) => {
			
					        // console.log('-> trav_r ' + ind_r);
					        // console.log(trav_r);
					        
					        let [travSList, travSListTotal] = this.getLevelTraversesX(7, totalTravList[ind_x], trav_r.pieces, trav_r.coordinates, 'S', false);
					        
					        // console.log(' -> NIVEL 7: traveras R de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
					        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r);
					        // console.log(travSList);
					       //  console.log(travSListTotal);
					        
					        if (trav_r.pieces.length > 1 && trav_r.pieces.length !== trav_q.pieces.length) {
								
								// console.log(' -> Encontradas piezas en nivel S:');
								// console.log(travSListTotal);
							
					        	if (!trav_r['tr_in']) trav_r['tr_in'] = travSListTotal;
					        }
					        
					        travSListTotal.forEach( (trav_s, ind_s) => {
			
						        // console.log('-> trav_s ' + ind_s);
						        // console.log(trav_s);
						        
						        let [travTList, travTListTotal] = this.getLevelTraversesY(8, totalTravList[ind_x], trav_s.pieces, trav_s.coordinates, 'T', false);
						        
						        // console.log(' -> NIVEL 8: traveras R de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
						        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r + ' trS ' + ind_s);
						        // console.log(travTList);
						        // console.log(travTListTotal);
						        
						        if (trav_s.pieces.length > 1 && trav_s.pieces.length !== trav_r.pieces.length) {
									
									// console.log(' -> Encontradas piezas en nivel T:');
									// console.log(travTListTotal);
								
						        	if (!trav_s['tr_in']) trav_s['tr_in'] = travTListTotal;
						        }
						        
						        travTListTotal.forEach( (trav_t, ind_t) => {
			
							        // console.log('-> trav_t ' + ind_t);
							        // console.log(trav_t);
							        
							        let [travUList, travUListTotal] = this.getLevelTraversesX(9, totalTravList[ind_x], trav_t.pieces, trav_t.coordinates, 'U', false);
							        
							        // console.log(' -> NIVEL 9: traveras T de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
							        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r + ' trS ' + ind_s + ' trT ' + ind_t);
							        // console.log(travUList);
							        // console.log(travUListTotal);
							        
							        if (trav_t.pieces.length > 1 && trav_t.pieces.length !== trav_s.pieces.length) {
										
										// console.log(' -> Encontradas piezas en nivel U:');
										// console.log(travUListTotal);
									
							        	if (!trav_t['tr_in']) trav_t['tr_in'] = travUListTotal;
							        }
							        
							        travUListTotal.forEach( (trav_u, ind_u) => {
			
								        // console.log('-> trav_u ' + ind_u);
								        // console.log(trav_u);
								        
								        let [travVList, travVListTotal] = this.getLevelTraversesY(10, totalTravList[ind_x], trav_u.pieces, trav_u.coordinates, 'V', false);
								        
								        // console.log(' -> NIVEL 10: traveras U de trX ' + ind_x + ' trY ' + ind_y  + ' trZ ' + ind_z +
								        // 			' trW ' + ind_w + ' trQ ' + ind_q + ' trR ' + ind_r + ' trS ' + ind_s + ' trT ' + ind_t + ' trU ' + ind_u);
								        // console.log(travVList);
								        // console.log(travVListTotal);
								        
								        if (trav_u.pieces.length > 1 && trav_u.pieces.length !== trav_t.pieces.length) {
											
											// console.log(' -> Encontradas piezas en nivel V:');
											// console.log(travVListTotal);
										
								        	if (!trav_u['tr_in']) trav_u['tr_in'] = travVListTotal;
								        }
							        
							        	// ----------->>>>>> Aquí se podría continuar con el siguiente nivel de profundidad...
							        
							      	}); // Fin ForEach travTTotalList.
						        
						      	}); // Fin ForEach travTTotalList.
					        
					      	}); // Fin ForEach travSTotalList.
				        
				      	}); // Fin ForEach travRTotalList.
			        
			      	}); // Fin ForEach travQTotalList.
		        
		      	}); // Fin ForEach travWTotalList.
	        
	      	}); // Fin ForEach travZTotalList.
	      	
	   }); // Fin ForEach travYTotalList.
      
       // Se guarda toda la información recopilada de la travera X actual.
       sheetTraverseList.push(trav_x);
        
      }); // Fin ForEach travXTotalList.

    // Fin --------- Nuevo código revisado
    
    // } else if (this.axis === 'Y') { // End IF X axis.

      // console.log(' -> orderPiecesLevel eje Y:');
      
	  // ----- Código nuevo eje Y
      
      
	 // ----- Fin Código nuevo eje Y. // */
	 
    // } // End Else IF Y axis
    // -------------------------------------

    // console.log(' -> orderPiecesByCut totalTravList:');
    // console.log(totalTravList);

    // Se crea un array colocando las piezas de travera en travera empezando por la primera travera X.
    totalTravList.forEach(tt => {

      tt.forEach(t => {
		let similar_piece = resultList.find(px => {
			if (px.name === t.name) {
				// console.log('similar_piece encontrada en el resultado actual.');
				// console.log(t);
				return true;
			}
			return false;
		});
		
		if (!similar_piece) resultList.push(t);
      });
    });
    
    // console.log(' -> orderPiecesFreeGrade travXList:');
    // console.log(travXList);

    // console.log(' -> orderPiecesFreeGrade sheetTraverseList:');
    // console.log(sheetTraverseList);
    
    // Código para ordenar las piezas teniendo en cuenta la "libertad" por nivel.
    // Sólo se hace si se ha indicado un valor de "libertad", si no opera como siempre.
    if(freeGrade && freeGrade > 0) {
		
		// console.log('---------------------------');
		// console.log('--> sheetTraverseList: ');
		// console.log('---------------------------');
		sheetTraverseList.forEach((tr_x, x_index) => {
			
			if (freeGrade === 1 || (freeGrade > 1 && (!tr_x.tr_in || tr_x.tr_in.length === 0))) {
				// console.log(' -> Alcanzado grado de libertad:' + freeGrade);				
				// console.log(' -> Encontradas piezas libres en nivel X:');
				// console.log(tr_x.pieces);
				
				if (!freeCutOrderList['sh'])
					freeCutOrderList['sh'] = [];
					
				freeCutOrderList['sh'].push(tr_x.pieces);
			}
			
			if (tr_x.tr_in) {
			
			  let tr_Y = tr_x.tr_in;
			  
			  // console.log('--> tr_Y (lista de traveras Y interiores a travera X): ' + x_index);
			  // console.log(tr_Y);
			  
			  tr_Y.forEach((tr_y, y_index) => {
				
				// console.log('--> --> tr_y: ' + y_index);
			    // console.log(tr_y);
			    
			    if (freeGrade === 2 || (freeGrade > 2 && (!tr_y.tr_in || tr_y.tr_in.length === 0))) {
					// console.log(' -> Alcanzado grado de libertad:' + freeGrade);				
					// console.log(' -> Encontradas piezas libres en nivel Y:');
					// console.log(tr_y.pieces);
					
					if (!freeCutOrderList['trx' + x_index])
						freeCutOrderList['trx' + x_index] = [];
						
					freeCutOrderList['trx' + x_index].push(tr_y.pieces);
				}
			    
			    if (tr_y.tr_in) {
					
					let tr_Z = tr_y.tr_in;
					
					tr_Z.reverse().forEach((tr_z, z_index) => {
				
						// console.log('--> --> tr_z: ' + z_index);
					    // console.log(tr_z);
					    
					    if (freeGrade === 3 || (freeGrade > 3 && (!tr_y.tr_in || tr_y.tr_in.length === 0))) {
							// console.log(' -> Alcanzado grado de libertad:' + freeGrade);				
							// console.log(' -> Encontradas piezas libres en nivel Z:');
							// console.log(tr_z.pieces);
							
							if(!freeCutOrderList['trx' + x_index + '_try' + y_index])
								freeCutOrderList['trx' + x_index + '_try' + y_index] = [];
							
							freeCutOrderList['trx' + x_index + '_try' + y_index].push(tr_z.pieces);
						}
				
					    if (tr_z.tr_in) {
							
							let tr_W = tr_z.tr_in;
							
							tr_W.forEach((tr_w, w_index) => {
				
								// console.log('--> --> tr_w: ' + w_index);
							    // console.log(tr_w);
												    
							    if (tr_w.tr_in) {
									
									let tr_Q = tr_w.tr_in;
									
									tr_Q.forEach((tr_q, q_index) => {
				
										// console.log('--> --> tr_q: ' + q_index);
									    // console.log(tr_q);
									   						    
									    if (tr_q.tr_in) {
											
											let tr_R = tr_q.tr_in;
											
											tr_R.forEach((tr_r, r_index) => {
				
												// console.log('--> --> tr_r: ' + r_index);
											    // console.log(tr_r);
							
											    if (tr_r.tr_in) {
													
													let tr_S = tr_r.tr_in;
													
													tr_S.forEach((tr_s, s_index) => {
				
														// console.log('--> --> tr_s: ' + s_index);
													    // console.log(tr_s);
										
													    if (tr_s.tr_in) {
															
															let tr_T = tr_s.tr_in;
															
															// console.log('--> --> -> Lista traveras T: ');
													    	// console.log(tr_T);
															
														} // else {
															// console.log('--> No hay traveras T interiores en esta travera S.');
														// }
													    
													}); // End ForEach tr_S.
													
												} // else {
													// console.log('--> No hay traveras S interiores en esta travera R.');
												// }
											    
											}); // End ForEach tr_R.
											
										}//  else {
										// 	console.log('--> No hay traveras R interiores en esta travera Q.');
										// }
									    
									}); // End ForEach tr_Q.
									
								} // else {
								// 	console.log('--> No hay traveras Q interiores en esta travera W.');
								// }
							    
							}); // End ForEach tr_W.
							
						} // else {
						// 	console.log('--> No hay traveras W interiores en esta travera Z.');
						// }
					    
					}); // End ForEach tr_Z.
					
				} // else {
					// console.log('--> No hay traveras Z interiores en esta travera Y.');
				// }
			    
			  }); // End ForEach tr_Y.
			  
		  	} // else {
			// 	console.log('--> No hay traveras Y interiores en esta travera X.');
		  	// }
		  	
		  	// console.log('-------------- Fin travera ----------------');
		  }); // End ForEach.
	
	  
		// console.log(' -> orderPiecesFreeGrade freeCutOrderList:');
		// console.log(freeCutOrderList);
		
		// Número máximo de grupos de piezas del nivel seleccionado
		// que van a juntarse antes de realizar la ordenación por lote/secuencia.
		let max_count_free = freeGradeIn;
		let count_free = 0;
		
		let gp_aux = [];
		
		let freeCutOrderListAux = [];
		
		// Convertimos el array de Keys en un array normal para que tenga "length".
		for(let prop in freeCutOrderList) {
			
			freeCutOrderListAux.push(freeCutOrderList[prop]);
		}
		
		// console.log('-> freeCutOrderListAux length = ' + freeCutOrderListAux.length);
		
		freeCutOrderListAux.forEach((gt, index_gt) => {
			
			count_free++;

			gt.forEach(pp => {
				
				pp.forEach(p => {
					gp_aux.push(p);
				});
			});
			
			if (count_free >= max_count_free || 
				index_gt === freeCutOrderListAux.length - 1 || 
				max_count_free > freeCutOrderListAux.length - 1) {
					
				gp_aux = this.orderByLot(gp_aux, '', true);
				
				// console.log('-> gp_aux:');
				// console.log(gp_aux);
			
				gp_aux.forEach(p => {
					if (p.type !== 'T') {
						freeCutOrderPieces.push(p);
					}
				});
				
				// Se vacía los elementos agrupados con "libertad".
				gp_aux = [];
				count_free = 0;
			}
		}); // End ForEach freeCutOrderListAux.
		
		// console.log(' -> orderPiecesFreeGrade freeCutOrderPieces:');
		// console.log(freeCutOrderPieces);
		  
		resultList = freeCutOrderPieces;
		
	} // End freeGrade.
	
    // console.log(' -> orderPiecesFreeGrade infinite_level:');
    // console.log(this.infinite_level);
    
    // Si no se van a incluir los "restos" en la información del orden de tronzado.
    resultList = resultList.filter(p => p.type !== 'T');
    
    // console.log(' -> orderPiecesFreeGrade resultList:');
    // console.log(resultList);

    // Se devuelve un primer valor con la ordenación invertida si así se ha solicitado.
    // Como segundo valor se devuelve el listado de todas las traveras de nivel 0 de la hoja y
    // las piezas que contiene (esto es necesario para poder hacer el fichero TRA4_NEU de Lisec).
    if (invert) {
      return [resultList.reverse(), travXList, sheetTraverseList, level_fault];
    } else {
      return [resultList, travXList, sheetTraverseList, level_fault];
    }
  } // End function orderPiecesFreeGrade
  
  // -----------------------------
  
  // Función que ordena elementos teniendo en cuenta el orden en que son tronzadas dentro de una plancha.
  // Para eso se tiene en cuenta sólo la posición del primer punto del rectángulo de la pieza.
  orderPiecesByCut(arrayIn: any[], invert: boolean) {

    // console.log(' --> -> orderPiecesByCut entrada: ' + arrayIn.length);
    // console.log(arrayIn);

    let resultList = [];
    let totalTravList = [];

    let sheet = arrayIn.find(p => p.type === 'S');

    if (sheet) {
      sheet = JSON.parse(JSON.stringify(sheet));
    } else {
      return totalTravList;
    }

    // console.log(' --> orderPiecesByCut sheet:');
    // console.log(sheet);

    // Se quita la plancha.
    let aux_array = arrayIn.filter(p => p.type !== 'S');

    // NOTA: A la hoja principal hay que quitarle las medidas de desbande.
    sheet.points[1].y = sheet.points[1].y - this.disband.bottom - this.disband.top;
    sheet.points[2].y = sheet.points[2].y - this.disband.bottom - this.disband.top;
    sheet.points[2].x = sheet.points[2].x - this.disband.left - this.disband.right;
    sheet.points[3].x = sheet.points[3].x - this.disband.left - this.disband.right;

    let trav_count = 0;
/*  // NOTA: Con anidamientos continuos se produce mal funcionamiento en los cálculos de salida.
    if (this.axis === 'X') {

      this.getTraversesX(trav_count, totalTravList, aux_array, sheet.points, 'X');

    } else {

      this.getTraversesY(trav_count, totalTravList, aux_array, sheet.points, 'Y');
    }

    console.log(' -> orderPiecesByCut totalTravList:');
    console.log(totalTravList);

    // ------------------ */


    let trav1List = [];
    let subTrav1List = [];
    
    let level_fault = false;

    if (this.axis === 'X') {

      // console.log(' -> orderPiecesByCut eje X:');

      trav1List = this.getTraversesX(1, totalTravList, aux_array, sheet.points, 'X', false);

      // console.log(' -> NIVEL 1: trav1List en eje X:');
      // console.log(trav1List);

      trav1List.reverse().forEach( (trav_x, i) => {

        totalTravList[i] = [];

        let [travYList, travYListTotal] = this.getTraversesY(2, totalTravList[i], trav_x.pieces, trav_x.coordinates, 'Y', false);

        // Se guardan las subtraveras Y de las traveras X
        //subTrav1List.push({tr_content: JSON.parse(JSON.stringify(travYList)), tr_Y: []});
        subTrav1List.push({tr_content: JSON.parse(JSON.stringify(travYListTotal)), tr_Y: []});

        // console.log(' -> NIVEL 2: travYList de travera ' + (i + 1));
        // console.log(travYList);
        
        travYListTotal.forEach((trav_y, j) => {
        
           let travXList2 = this.getTraversesX(3, totalTravList[i], trav_y.pieces, trav_y.coordinates, 'Z', false);

		  	let trav_z = JSON.parse(JSON.stringify(travXList2));
		  	if (trav_z.length > 1) subTrav1List[i].tr_Y.push({tr: trav_z, ind: j});   
        });

        travYList.forEach((trav_y, j) => {

          let travXList2 = this.getTraversesX(3, totalTravList[i], trav_y.pieces, trav_y.coordinates, 'Z', false);

		  let trav_z = JSON.parse(JSON.stringify(travXList2));
          // subTrav1List[i].tr_Y.push({tr: trav_z, ind: j});
          // Se informa de las subtraveras Z internas también de forma individual para cada travera Y.
          if((subTrav1List[i].tr_content[j].index_y || subTrav1List[i].tr_content[j].index_y === 0)) {
            // console.log(' -> index_y encontrado en travera Y número ' + (j + 1));
          	subTrav1List[i].tr_content[j].tr_z.push(trav_z);
          	// console.log(subTrav1List[i].tr_content[j].tr_z);
		  }
          // console.log(' -> NIVEL 3: travXList2 de travera ' + (j + 1));
          // console.log(travXList2);

          travXList2.forEach((trav_z, k) => {

			// NOTA: Es el valor máximo que puede alcanzar una optimización para exportarla a Lisec (cortes Z).
            let [travYList2, travYList2Total] = this.getTraversesY(4, totalTravList[i], trav_z.pieces, trav_z.coordinates, 'W', false);

            // console.log(' -> NIVEL 4: travYList2 de travera ' + (k + 1));
            // console.log(travYList2);
            
            if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && !subTrav1List[i].tr_Y[j].tr[k]['tr_z']) {
				
				subTrav1List[i].tr_Y[j].tr[k]['tr_z'] = [];
			} 
            
            travYList2.forEach((trav_w, l) => {

			  level_fault = true;
			  
			  // NOTA: Si la optimización llega a este nivel entonces no podrá exportarse bien a Lisec.
              let travXList3 = this.getTraversesX(5, totalTravList[i], trav_w.pieces, trav_w.coordinates, 'V', false);

              // console.log(' -> NIVEL 5: travXList3 de travera ' + (l + 1));
              // console.log(travXList3);
              
              let trav_w_aux = JSON.parse(JSON.stringify(travXList3));
              
              
              // console.log(' -> NIVEL 5 interior k = ' + (k + 1) + ' ;l = ' + (l + 1));
              
          	  if (subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr && subTrav1List[i].tr_Y[j].tr[k]) {
				  subTrav1List[i].tr_Y[j].tr[k]['tr_z'].push({tr: trav_w_aux, ind: l, tr_w: null});
	          	  // console.log(' -> tr_z = ');
	          	  // console.log(subTrav1List[i].tr_Y[j].tr[k]);
	          	  // console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z);
			  } else {
				// console.log(' -> No hay nivel de travera W.');
			  }
          	  
	
              travXList3.forEach( (trav_v, m) => {

                let [travYList3, travYList3Total] = this.getTraversesY(6, totalTravList[i], trav_v.pieces, trav_v.coordinates, 'U', false);

                // console.log(' -> NIVEL 6: travYList3 de travera ' + (m + 1));
                // console.log(travYList3);
                
                if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && subTrav1List[i].tr_Y[j].tr[k].tr_z[m] && !subTrav1List[i].tr_Y[j].tr[k].tr_z[m]['tr_w']) {
				
					subTrav1List[i].tr_Y[j].tr[k].tr_z[m]['tr_w'] = [];
				}
                
                travYList3.forEach((trav_u, n) => {

                  let travXList4 = this.getTraversesX(7, totalTravList[i], trav_u.pieces, trav_u.coordinates, 'T', false);

                  // console.log(' -> NIVEL 7: travXList4 de travera ' + (n + 1));
                  // console.log(travXList4);
                  
                  let trav_q_aux = JSON.parse(JSON.stringify(travXList4));
                  
                  console.log(' -> subTrav1List tr_w = ');
		          console.log(subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr && subTrav1List[i].tr_Y[j].tr[k] && subTrav1List[i].tr_Y[j].tr[k]);
		          	  
                  if (subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr && subTrav1List[i].tr_Y[j].tr[k] && subTrav1List[i].tr_Y[j].tr[k].tr_z[n]) {
					
					  if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && subTrav1List[i].tr_Y[j].tr[k].tr_z[n] && !subTrav1List[i].tr_Y[j].tr[k].tr_z[n]['tr_w']) {
				
						subTrav1List[i].tr_Y[j].tr[k].tr_z[n]['tr_w'] = [];
					  }
					  
					  subTrav1List[i].tr_Y[j].tr[k].tr_z[n]['tr_w'].push({tr: trav_q_aux, ind: n});
		          	  console.log(' -> tr_w = ');
		          	  console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z[n]);
		          	  console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z[n]['tr_w']);
				  } else {
					// console.log(' -> No hay nivel de travera Q.');
				  }

                  travXList4.forEach( (trav_t, o) => {

                    let [travYList4, travYList4Total] = this.getTraversesY(8, totalTravList[i], trav_t.pieces, trav_t.coordinates, 'S', false);

                    // console.log(' -> NIVEL 8: travYList4 de travera ' + (o + 1));
                    // console.log(travYList4);
                    
                    if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && 
                    	subTrav1List[i].tr_Y[j].tr[k].tr_z[n] && subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o] && !subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o]['tr_q']) {
				
						subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o]['tr_q'] = [];
					}

                    travYList4.forEach((trav_s, p) => {

                      let travXList5 = this.getTraversesX(9, totalTravList[i], trav_s.pieces, trav_s.coordinates, 'R', false);

                      // console.log(' -> NIVEL 9: travXList5 de travera ' + (p + 1));
                      // console.log(travXList5);
                      
                      let trav_r_aux = JSON.parse(JSON.stringify(travXList5));
                  
	                  if (subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr && subTrav1List[i].tr_Y[j].tr[k] &&
	                  	  subTrav1List[i].tr_Y[j].tr[k].tr_z[n] && subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o]) {
						  
						  subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o]['tr_q'].push({tr: trav_r_aux, ind: p});
			          	  // console.log(' -> tr_z = ');
			          	  // console.log(subTrav1List[i].tr_Y[j].tr[k]);
			          	  // console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z);
					  } else {
						// console.log(' -> No hay nivel de travera R.');
					  }

                      travXList5.forEach( (trav_r, q) => {

                        let [travYList5, travYList5Total] = this.getTraversesY(10, totalTravList[i], trav_r.pieces, trav_r.coordinates, 'Q', false);

                        // console.log(' -> NIVEL 10: travYList5 de travera ' + (q + 1));
                        // console.log(travYList5);

                        travYList5.forEach((trav_q, r) => {

                          let travXList6 = this.getTraversesX(11, totalTravList[i], trav_q.pieces, trav_q.coordinates, 'P', false);

                          // console.log(' -> NIVEL 11: travXList6 de travera ' + (r + 1));
                          // console.log(travXList6);

                          travXList6.forEach( (trav_p, s) => {

                            let [travYList6, travYList6Total] = this.getTraversesY(12, totalTravList[i], trav_p.pieces, trav_p.coordinates, 'O', false);

                            // console.log(' -> NIVEL 12: travYList6 de travera ' + (s + 1));
                            // console.log(travYList6);

                            travYList6.forEach((trav_o, g) => {

                            let travXList7 = this.getTraversesX(13, totalTravList[i], trav_o.pieces, trav_o.coordinates, 'N', false);

                              // console.log(' -> NIVEL 13: travXList7 de travera ' + (g + 1));
                              // console.log(travXList7);

                              travXList7.forEach( (trav_n, h) => {

                                let [travYList7, travYList7Total] = this.getTraversesY(14, totalTravList[i], trav_n.pieces, trav_n.coordinates, 'M', false);

                                // console.log(' -> NIVEL 14: travYList7 de travera ' + (h + 1));
                                // console.log(travYList7);
                                
                                // NOTA: Si queda más de una pieza tras la última iteración
                                // entonces se añaden directamente todas las restantes
                                // ya que suponemos que el anidamiento es demasiado profundo.
                                if (travYList7 && travYList7.length > 0) {
									
									travYList7.forEach(tr_in => {
										if (tr_in.pieces && tr_in.pieces.length > 0) {
											
											tr_in.pieces.forEach(p_in => {
												totalTravList[i].push(p_in);
											});
										}
									});
								} // End If travYList7

                              });  // End forEach travXList6

                            });  // End forEach travYList5

                          });  // End forEach travXList6

                        });  // End forEach travYList5

                      });  // End forEach travXList5

                    });  // End forEach travYList4

                  });  // End forEach travXList4

                });  // End forEach travYList3

              }); // End forEach travXList3

            }); // End forEach travYList2

          }); // End forEach travXList2

        });  // End forEach travYList

      }); // End forEach travXList
    } else if (this.axis === 'Y') { // End IF axis

      // console.log(' -> orderPiecesByCut eje Y:');

      trav1List = this.getTraversesX(trav_count, totalTravList, aux_array, sheet.points, 'X', false);

      // console.log(' -> trav1List NIVEL 0 en eje Y:');
      // console.log(trav1List);

      trav1List.reverse().forEach( (trav_x, i) => {

        totalTravList[i] = [];

        let [travYList, travYListTotal] = this.getTraversesY(trav_count, totalTravList[i], trav_x.pieces, trav_x.coordinates, 'Y', false);

        // Se guardan las subtraveras Y de las traveras X
        //subTrav1List.push({tr_content: JSON.parse(JSON.stringify(travYList)), tr_Y: []});
        subTrav1List.push({tr_content: JSON.parse(JSON.stringify(travYListTotal)), tr_Y: []});

        // console.log(' -> travYList de travera ' + (i + 1));
        // console.log(travYList);
        
        travYListTotal.forEach((trav_y, j) => {
        
           let travXList2 = this.getTraversesX(trav_count, totalTravList[i], trav_y.pieces, trav_y.coordinates, 'Z', false);

		  	let trav_z = JSON.parse(JSON.stringify(travXList2));
		  	if (trav_z.length > 1) subTrav1List[i].tr_Y.push({tr: trav_z, ind: j});   
        });

        travYList.reverse().forEach((trav_y, j) => {

          let travXList2 = this.getTraversesX(trav_count, totalTravList[i], trav_y.pieces, trav_y.coordinates, 'Z', false);

          let trav_z = JSON.parse(JSON.stringify(travXList2));
          // subTrav1List[i].tr_Y.push({tr: trav_z, ind: j});
          // Se informa de las subtraveras Z internas también de forma individual para cada travera Y.
          if((subTrav1List[i].tr_content[j].index_y || subTrav1List[i].tr_content[j].index_y === 0)) {
            // console.log(' -> index_y encontrado en travera Y número ' + (j + 1));
          	subTrav1List[i].tr_content[j].tr_z.push(trav_z);
          	// console.log(subTrav1List[i].tr_content[j].tr_z);
		  }
		  
          // console.log(' -> travXList2 de travera ' + (j + 1));
          // console.log(travXList2);

          travXList2.reverse().forEach((trav_z, k) => {

            let [travYList2, travYList2Total] = this.getTraversesY(trav_count, totalTravList[i], trav_z.pieces, trav_z.coordinates, 'W', false);

            // console.log(' -> travYList2 de travera ' + (k + 1));
            // console.log(travYList2);
            
            if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && !subTrav1List[i].tr_Y[j].tr[k]['tr_z']) {
				
				subTrav1List[i].tr_Y[j].tr[k]['tr_z'] = [];
			}

            travYList2.reverse().forEach((trav_w, l) => {

              let travXList3 = this.getTraversesX(trav_count, totalTravList[i], trav_w.pieces, trav_w.coordinates, 'V', false);

              // console.log(' -> travXList3 de travera ' + (l + 1));
              // console.log(travXList3);
              
              let trav_w_aux = JSON.parse(JSON.stringify(travXList3));
              
              
              // console.log(' -> NIVEL 5 interior k = ' + (k + 1) + ' ;l = ' + (l + 1));
              
          	  if (subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr && subTrav1List[i].tr_Y[j].tr[k]) {
				  subTrav1List[i].tr_Y[j].tr[k]['tr_z'].push({tr: trav_w_aux, ind: l});
	          	  // console.log(' -> tr_z = ');
	          	  // console.log(subTrav1List[i].tr_Y[j].tr[k]);
	          	  // console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z);
			  } else {
				// console.log(' -> No hay nivel de travera k = ' + (k + 1) + ' ;l = ' + (l + 1));
			  }

              travXList3.reverse().forEach( (trav_v, m) => {

                let [travYList3, travYList3Total] = this.getTraversesY(trav_count, totalTravList[i], trav_v.pieces, trav_v.coordinates, 'U', false);

                // console.log(' -> travYList3 de travera ' + (m + 1));
                // console.log(travYList3);

                travYList3.reverse().forEach((trav_u, n) => {

                  let travXList4 = this.getTraversesX(trav_count, totalTravList[i], trav_u.pieces, trav_u.coordinates, 'T', false);

                  // console.log(' -> travXList4 de travera ' + (n + 1));
                  // console.log(travXList4);

                  travXList4.reverse().forEach( (trav_t, o) => {

                    let [travYList4, travYList4Total] = this.getTraversesY(trav_count, totalTravList[i], trav_t.pieces, trav_t.coordinates, 'S', false);

                    // console.log(' -> travYList4 de travera ' + (o + 1));
                    // console.log(travYList4);

                    travYList4.reverse().forEach((trav_s, p) => {

                      let travXList5 = this.getTraversesX(trav_count, totalTravList[i], trav_s.pieces, trav_s.coordinates, 'R', false);

                      // console.log(' -> travXList5 de travera ' + (p + 1));
                      // console.log(travXList5);

                      travXList5.reverse().forEach( (trav_r, q) => {

                        let [travYList5, travYList5Total] = this.getTraversesY(trav_count, totalTravList[i], trav_r.pieces, trav_r.coordinates, 'Q', false);

                        // console.log(' -> travYList5 de travera ' + (q + 1));
                        // console.log(travYList5);

                        travYList5.reverse().forEach((trav_q, r) => {

                          let travXList6 = this.getTraversesX(trav_count, totalTravList[i], trav_q.pieces, trav_q.coordinates, 'P', false);

                          // console.log(' -> travXList6 de travera ' + (r + 1));
                          // console.log(travXList6);

                          travXList6.reverse().forEach( (trav_p, s) => {

                            let [travYList6, travYList6Total] = this.getTraversesY(trav_count, totalTravList[i], trav_p.pieces, trav_p.coordinates, 'O', false);

                            // console.log(' -> travYList6 de travera ' + (s + 1));
                            // console.log(travYList6);

                            travYList6.reverse().forEach((trav_o, g) => {

                            let travXList7 = this.getTraversesX(trav_count, totalTravList[i], trav_o.pieces, trav_o.coordinates, 'N', false);

                              // console.log(' -> travXList7 de travera ' + (g + 1));
                              // console.log(travXList7);

                              travXList7.reverse().forEach( (trav_n, h) => {

                                let [travYList7, travYList7Total] = this.getTraversesY(trav_count, totalTravList[i], trav_n.pieces, trav_n.coordinates, 'M', false);

                                // console.log(' -> travYList7 de travera ' + (h + 1));
                                // console.log(travYList7);
                                
                                // NOTA: Si queda más de una pieza tras la última iteración
                                // entonces se añaden directamente todas las restantes
                                // ya que suponemos que el anidamiento es demasiado profundo.
                                if (travYList7 && travYList7.length > 0) {
									
									travYList7.forEach(tr_in => {
										if (tr_in.pieces && tr_in.pieces.length > 0) {
											
											tr_in.pieces.forEach(p_in => {
												totalTravList[i].push(p_in);
											});
										}
									});
								} // End If travYList7

                              });  // End forEach travXList6

                            });  // End forEach travYList5

                          });  // End forEach travXList6

                        });  // End forEach travYList5

                      });  // End forEach travXList5

                    });  // End forEach travYList4

                  });  // End forEach travXList4

                });  // End forEach travYList3

              }); // End forEach travXList3

            }); // End forEach travYList2

          }); // End forEach travXList2

        });  // End forEach travYList

      }); // End forEach travXList

    } // End IF axis
    // -------------------------------------

    // console.log(' -> orderPiecesByCut totalTravList:');
    // console.log(totalTravList);

    // Se crea un array colocando las piezas de travera en travera empezando por la primera travera X.
    totalTravList.forEach(tt => {

      tt.forEach(t => {
		let similar_piece = resultList.find(px => {
			if (px.name === t.name) {
				// console.log('similar_piece encontrada en el resultado actual.');
				// console.log(t);
				return true;
			}
			return false;
		});
		
		if (!similar_piece) resultList.push(t);
      });
    });

    // console.log(' -> orderPiecesByCut trav1List:');
    // console.log(trav1List);

    // console.log(' ->  orderPiecesByCut subTrav1List:');
    // console.log(subTrav1List);
    
    // console.log(' -> infinite_level:');
    // console.log(this.infinite_level);
    
    // console.log(' -> orderPiecesByCut resultList:');
    // console.log(resultList);

    // Se devuelve un primer valor con la ordenación invertida si así se ha solicitado.
    // Como segundo valor se devuelve el listado de todas las traveras de nivel 0 de la hoja y
    // las piezas que contiene (esto es necesario para poder hacer el fichero TRA4_NEU de Lisec).
    if (invert) {
      return [resultList.reverse(), trav1List, subTrav1List, level_fault];
    } else {
      return [resultList, trav1List, subTrav1List, level_fault];
    }
  } // End function orderPiecesByCut
  
  // Función que ordena elementos teniendo en cuenta el orden en que son tronzadas dentro de una plancha.
  // Para eso se tiene en cuenta sólo la posición del primer punto del rectángulo de la pieza.
  orderPiecesByCutFree(arrayIn: any[], freeGrade: number, freeGradeIn: number, invert: boolean) {

    // console.log(' --> -> orderPiecesByCutFree entrada: ' + arrayIn.length);
    // console.log(arrayIn);

    let resultList = [];
    let totalTravList = [];

    let sheet = arrayIn.find(p => p.type === 'S');

    if (sheet) {
      sheet = JSON.parse(JSON.stringify(sheet));
    } else {
      return totalTravList;
    }

    // console.log(' --> orderPiecesByCutFree sheet:');
    // console.log(sheet);

    // Se quita la plancha.
    let aux_array = arrayIn.filter(p => p.type !== 'S');

    // NOTA: A la hoja principal hay que quitarle las medidas de desbande.
    sheet.points[1].y = sheet.points[1].y - this.disband.bottom - this.disband.top;
    sheet.points[2].y = sheet.points[2].y - this.disband.bottom - this.disband.top;
    sheet.points[2].x = sheet.points[2].x - this.disband.left - this.disband.right;
    sheet.points[3].x = sheet.points[3].x - this.disband.left - this.disband.right;

    let trav_count = 0;

    let trav1List = [];
    let subTrav1List = [];
    
    let level_fault = false;

    if (this.axis === 'X') {

      // console.log(' -> orderPiecesByCut eje X:');

      trav1List = this.getTraversesX(1, totalTravList, aux_array, sheet.points, 'X', false);

      // console.log(' -> NIVEL 1: trav1List en eje X:');
      // console.log(trav1List);

      trav1List.reverse().forEach( (trav_x, i) => {

        totalTravList[i] = [];

        let [travYList, travYListTotal] = this.getTraversesY(2, totalTravList[i], trav_x.pieces, trav_x.coordinates, 'Y', false);

        // Se guardan las subtraveras Y de las traveras X
        //subTrav1List.push({tr_content: JSON.parse(JSON.stringify(travYList)), tr_Y: []});
        subTrav1List.push({tr_content: JSON.parse(JSON.stringify(travYListTotal)), tr_Y: []});

        // console.log(' -> NIVEL 2: travYList de travera ' + (i + 1));
        // console.log(travYList);
        
        travYListTotal.forEach((trav_y, j) => {
        
           let travXList2 = this.getTraversesX(3, totalTravList[i], trav_y.pieces, trav_y.coordinates, 'Z', false);

		  	let trav_z = JSON.parse(JSON.stringify(travXList2));
		  	if (trav_z.length > 1) subTrav1List[i].tr_Y.push({tr: trav_z, ind: j});   
        });

        travYList.forEach((trav_y, j) => {

          let travXList2 = this.getTraversesX(3, totalTravList[i], trav_y.pieces, trav_y.coordinates, 'Z', false);

		  let trav_z = JSON.parse(JSON.stringify(travXList2));
          // subTrav1List[i].tr_Y.push({tr: trav_z, ind: j});
          // Se informa de las subtraveras Z internas también de forma individual para cada travera Y.
          if((subTrav1List[i].tr_content[j].index_y || subTrav1List[i].tr_content[j].index_y === 0)) {
            // console.log(' -> index_y encontrado en travera Y número ' + (j + 1));
          	subTrav1List[i].tr_content[j].tr_z.push(trav_z);
          	// console.log(subTrav1List[i].tr_content[j].tr_z);
		  }
          // console.log(' -> NIVEL 3: travXList2 de travera ' + (j + 1));
          // console.log(travXList2);

          travXList2.forEach((trav_z, k) => {

			// NOTA: Es el valor máximo que puede alcanzar una optimización para exportarla a Lisec (cortes Z).
            let [travYList2, travYList2Total] = this.getTraversesY(4, totalTravList[i], trav_z.pieces, trav_z.coordinates, 'W', false);

            // console.log(' -> NIVEL 4: travYList2 de travera ' + (k + 1));
            // console.log(travYList2);
            
            if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && !subTrav1List[i].tr_Y[j].tr[k]['tr_z']) {
				
				subTrav1List[i].tr_Y[j].tr[k]['tr_z'] = [];
			} 
            
            travYList2.forEach((trav_w, l) => {

			  level_fault = true;
			  
			  // NOTA: Si la optimización llega a este nivel entonces no podrá exportarse bien a Lisec.
              let travXList3 = this.getTraversesX(5, totalTravList[i], trav_w.pieces, trav_w.coordinates, 'V', false);

              // console.log(' -> NIVEL 5: travXList3 de travera ' + (l + 1));
              // console.log(travXList3);
              
              let trav_w_aux = JSON.parse(JSON.stringify(travXList3));
              
              
              // console.log(' -> NIVEL 5 interior k = ' + (k + 1) + ' ;l = ' + (l + 1));
              
          	  if (subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr && subTrav1List[i].tr_Y[j].tr[k]) {
				  subTrav1List[i].tr_Y[j].tr[k]['tr_z'].push({tr: trav_w_aux, ind: l, tr_w: null});
	          	  // console.log(' -> tr_z = ');
	          	  // console.log(subTrav1List[i].tr_Y[j].tr[k]);
	          	  // console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z);
			  } else {
				// console.log(' -> No hay nivel de travera W.');
			  }
          	  
	
              travXList3.forEach( (trav_v, m) => {
				
				// console.log(' -> NIVEL 6: piezas extra i = ' + i + ' j = ' + j);
				// console.log(trav_v.pieces);
				// console.log(subTrav1List[i]);
				// console.log(subTrav1List[i].tr_Y);
				
				if (!subTrav1List[i].tr_Y['extra']) subTrav1List[i].tr_Y['extra'] = [];
				subTrav1List[i].tr_Y['extra'].push(trav_v.pieces);

                let [travYList3, travYList3Total] = this.getTraversesY(6, totalTravList[i], trav_v.pieces, trav_v.coordinates, 'U', false);

                // console.log(' -> NIVEL 6: travYList3 de travera ' + (m + 1));
                // console.log(travYList3);
                
                if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && subTrav1List[i].tr_Y[j].tr[k].tr_z[m] && !subTrav1List[i].tr_Y[j].tr[k].tr_z[m]['tr_w']) {
				
					subTrav1List[i].tr_Y[j].tr[k].tr_z[m]['tr_w'] = [];
				}
                
                travYList3.forEach((trav_u, n) => {

                  let travXList4 = this.getTraversesX(7, totalTravList[i], trav_u.pieces, trav_u.coordinates, 'T', false);

                  // console.log(' -> NIVEL 7: travXList4 de travera ' + (n + 1));
                  // console.log(travXList4);
                  
                  let trav_q_aux = JSON.parse(JSON.stringify(travXList4));
                  
                  // console.log(' -> subTrav1List tr_w = ');
		          	  
                  if (subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr && subTrav1List[i].tr_Y[j].tr[k] && subTrav1List[i].tr_Y[j].tr[k].tr_z[n]) {
					
					  if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && subTrav1List[i].tr_Y[j].tr[k].tr_z[n] && !subTrav1List[i].tr_Y[j].tr[k].tr_z[n]['tr_w']) {
				
						subTrav1List[i].tr_Y[j].tr[k].tr_z[n]['tr_w'] = [];
					  }
					  
					  subTrav1List[i].tr_Y[j].tr[k].tr_z[n]['tr_w'].push({tr: trav_q_aux, ind: n});
		          	  // console.log(' -> tr_w = ');
		          	  // console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z[n]);
		          	  // console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z[n]['tr_w']);
				  } else {
					// console.log(' -> No hay nivel de travera Q.');
				  }

                  travXList4.forEach( (trav_t, o) => {

                    let [travYList4, travYList4Total] = this.getTraversesY(8, totalTravList[i], trav_t.pieces, trav_t.coordinates, 'S', false);

                    // console.log(' -> NIVEL 8: travYList4 de travera ' + (o + 1));
                    // console.log(travYList4);
                    
                    if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && 
                    	subTrav1List[i].tr_Y[j].tr[k].tr_z[n] && subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o] && !subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o]['tr_q']) {
				
						subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o]['tr_q'] = [];
					}

                    travYList4.forEach((trav_s, p) => {

                      let travXList5 = this.getTraversesX(9, totalTravList[i], trav_s.pieces, trav_s.coordinates, 'R', false);

                      // console.log(' -> NIVEL 9: travXList5 de travera ' + (p + 1));
                      // console.log(travXList5);
                      
                      let trav_r_aux = JSON.parse(JSON.stringify(travXList5));
                  
	                  if (subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr && subTrav1List[i].tr_Y[j].tr[k] &&
	                  	  subTrav1List[i].tr_Y[j].tr[k].tr_z[n] && subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o]) {
						  
						  subTrav1List[i].tr_Y[j].tr[k].tr_z[n].tr_w[o]['tr_q'].push({tr: trav_r_aux, ind: p});
			          	  // console.log(' -> tr_z = ');
			          	  // console.log(subTrav1List[i].tr_Y[j].tr[k]);
			          	  // console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z);
					  } else {
						// console.log(' -> No hay nivel de travera R.');
					  }

                      travXList5.forEach( (trav_r, q) => {

                        let [travYList5, travYList5Total] = this.getTraversesY(10, totalTravList[i], trav_r.pieces, trav_r.coordinates, 'Q', false);

                        // console.log(' -> NIVEL 10: travYList5 de travera ' + (q + 1));
                        // console.log(travYList5);

                        travYList5.forEach((trav_q, r) => {

                          let travXList6 = this.getTraversesX(11, totalTravList[i], trav_q.pieces, trav_q.coordinates, 'P', false);

                          // console.log(' -> NIVEL 11: travXList6 de travera ' + (r + 1));
                          // console.log(travXList6);

                          travXList6.forEach( (trav_p, s) => {

                            let [travYList6, travYList6Total] = this.getTraversesY(12, totalTravList[i], trav_p.pieces, trav_p.coordinates, 'O', false);

                            // console.log(' -> NIVEL 12: travYList6 de travera ' + (s + 1));
                            // console.log(travYList6);

                            travYList6.forEach((trav_o, g) => {

                            let travXList7 = this.getTraversesX(13, totalTravList[i], trav_o.pieces, trav_o.coordinates, 'N', false);

                              // console.log(' -> NIVEL 13: travXList7 de travera ' + (g + 1));
                              // console.log(travXList7);

                              travXList7.forEach( (trav_n, h) => {

                                let [travYList7, travYList7Total] = this.getTraversesY(14, totalTravList[i], trav_n.pieces, trav_n.coordinates, 'M', false);

                                // console.log(' -> NIVEL 14: travYList7 de travera ' + (h + 1));
                                // console.log(travYList7);
                                
                                // NOTA: Si queda más de una pieza tras la última iteración
                                // entonces se añaden directamente todas las restantes
                                // ya que suponemos que el anidamiento es demasiado profundo.
                                if (travYList7 && travYList7.length > 0) {
									
									travYList7.forEach(tr_in => {
										if (tr_in.pieces && tr_in.pieces.length > 0) {
											
											tr_in.pieces.forEach(p_in => {
												totalTravList[i].push(p_in);
											});
										}
									});
								} // End If travYList7

                              });  // End forEach travXList6

                            });  // End forEach travYList5

                          });  // End forEach travXList6

                        });  // End forEach travYList5

                      });  // End forEach travXList5

                    });  // End forEach travYList4

                  });  // End forEach travXList4

                });  // End forEach travYList3

              }); // End forEach travXList3

            }); // End forEach travYList2

          }); // End forEach travXList2

        });  // End forEach travYList

      }); // End forEach travXList
    } else if (this.axis === 'Y') { // End IF axis

      // console.log(' -> orderPiecesByCut eje Y:');

      trav1List = this.getTraversesX(trav_count, totalTravList, aux_array, sheet.points, 'X', false);

      // console.log(' -> trav1List NIVEL 0 en eje Y:');
      // console.log(trav1List);

      trav1List.reverse().forEach( (trav_x, i) => {

        totalTravList[i] = [];

        let [travYList, travYListTotal] = this.getTraversesY(trav_count, totalTravList[i], trav_x.pieces, trav_x.coordinates, 'Y', false);

        // Se guardan las subtraveras Y de las traveras X
        //subTrav1List.push({tr_content: JSON.parse(JSON.stringify(travYList)), tr_Y: []});
        subTrav1List.push({tr_content: JSON.parse(JSON.stringify(travYListTotal)), tr_Y: []});

        // console.log(' -> travYList de travera ' + (i + 1));
        // console.log(travYList);
        
        travYListTotal.forEach((trav_y, j) => {
        
           let travXList2 = this.getTraversesX(trav_count, totalTravList[i], trav_y.pieces, trav_y.coordinates, 'Z', false);

		  	let trav_z = JSON.parse(JSON.stringify(travXList2));
		  	if (trav_z.length > 1) subTrav1List[i].tr_Y.push({tr: trav_z, ind: j});   
        });

        travYList.reverse().forEach((trav_y, j) => {

          let travXList2 = this.getTraversesX(trav_count, totalTravList[i], trav_y.pieces, trav_y.coordinates, 'Z', false);

          let trav_z = JSON.parse(JSON.stringify(travXList2));
          // subTrav1List[i].tr_Y.push({tr: trav_z, ind: j});
          // Se informa de las subtraveras Z internas también de forma individual para cada travera Y.
          if((subTrav1List[i].tr_content[j].index_y || subTrav1List[i].tr_content[j].index_y === 0)) {
            // console.log(' -> index_y encontrado en travera Y número ' + (j + 1));
          	subTrav1List[i].tr_content[j].tr_z.push(trav_z);
          	// console.log(subTrav1List[i].tr_content[j].tr_z);
		  }
		  
          // console.log(' -> travXList2 de travera ' + (j + 1));
          // console.log(travXList2);

          travXList2.reverse().forEach((trav_z, k) => {

            let [travYList2, travYList2Total] = this.getTraversesY(trav_count, totalTravList[i], trav_z.pieces, trav_z.coordinates, 'W', false);

            // console.log(' -> travYList2 de travera ' + (k + 1));
            // console.log(travYList2);
            
            if (subTrav1List[i].tr_Y && subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr[k] && !subTrav1List[i].tr_Y[j].tr[k]['tr_z']) {
				
				subTrav1List[i].tr_Y[j].tr[k]['tr_z'] = [];
			}

            travYList2.reverse().forEach((trav_w, l) => {

              let travXList3 = this.getTraversesX(trav_count, totalTravList[i], trav_w.pieces, trav_w.coordinates, 'V', false);

              // console.log(' -> travXList3 de travera ' + (l + 1));
              // console.log(travXList3);
              
              let trav_w_aux = JSON.parse(JSON.stringify(travXList3));
              
              
              // console.log(' -> NIVEL 5 interior k = ' + (k + 1) + ' ;l = ' + (l + 1));
              
          	  if (subTrav1List[i].tr_Y[j] && subTrav1List[i].tr_Y[j].tr && subTrav1List[i].tr_Y[j].tr[k]) {
				  subTrav1List[i].tr_Y[j].tr[k]['tr_z'].push({tr: trav_w_aux, ind: l});
	          	  // console.log(' -> tr_z = ');
	          	  // console.log(subTrav1List[i].tr_Y[j].tr[k]);
	          	  // console.log(subTrav1List[i].tr_Y[j].tr[k].tr_z);
			  } else {
				// console.log(' -> No hay nivel de travera k = ' + (k + 1) + ' ;l = ' + (l + 1));
			  }

              travXList3.reverse().forEach( (trav_v, m) => {
				
				// console.log(' -> travXList3 trav_v ' + (m + 1));
                // console.log(trav_v);
                
                if (trav_v.pieces.length === 1) {
					if (!subTrav1List[i].tr_Y['extra']) subTrav1List[i].tr_Y['extra'] = [];
					subTrav1List[i].tr_Y['extra'].push(trav_v.pieces);
				}
                	

                let [travYList3, travYList3Total] = this.getTraversesY(trav_count, totalTravList[i], trav_v.pieces, trav_v.coordinates, 'U', false);

                // console.log(' -> travYList3 de travera ' + (m + 1));
                // console.log(travYList3);
                
                travYList3.reverse().forEach((trav_u, n) => {
					
				  // console.log(' -> travYList3 trav_u ' + (m + 1));
                  // console.log(trav_u);
                  
                  if (!subTrav1List[i].tr_Y['extra']) subTrav1List[i].tr_Y['extra'] = [];
                  subTrav1List[i].tr_Y['extra'].push(trav_u.pieces);

                  let travXList4 = this.getTraversesX(trav_count, totalTravList[i], trav_u.pieces, trav_u.coordinates, 'T', false);

                  // console.log(' -> travXList4 de travera ' + (n + 1));
                  // console.log(travXList4);

                  travXList4.reverse().forEach( (trav_t, o) => {

                    let [travYList4, travYList4Total] = this.getTraversesY(trav_count, totalTravList[i], trav_t.pieces, trav_t.coordinates, 'S', false);

                    // console.log(' -> travYList4 de travera ' + (o + 1));
                    // console.log(travYList4);
                    
                    travYList4.reverse().forEach((trav_s, p) => {

                      let travXList5 = this.getTraversesX(trav_count, totalTravList[i], trav_s.pieces, trav_s.coordinates, 'R', false);

                      // console.log(' -> travXList5 de travera ' + (p + 1));
                      // console.log(travXList5);

                      travXList5.reverse().forEach( (trav_r, q) => {

                        let [travYList5, travYList5Total] = this.getTraversesY(trav_count, totalTravList[i], trav_r.pieces, trav_r.coordinates, 'Q', false);

                        // console.log(' -> travYList5 de travera ' + (q + 1));
                        // console.log(travYList5);

                        travYList5.reverse().forEach((trav_q, r) => {

                          let travXList6 = this.getTraversesX(trav_count, totalTravList[i], trav_q.pieces, trav_q.coordinates, 'P', false);

                          // console.log(' -> travXList6 de travera ' + (r + 1));
                          // console.log(travXList6);

                          travXList6.reverse().forEach( (trav_p, s) => {

                            let [travYList6, travYList6Total] = this.getTraversesY(trav_count, totalTravList[i], trav_p.pieces, trav_p.coordinates, 'O', false);

                            // console.log(' -> travYList6 de travera ' + (s + 1));
                            // console.log(travYList6);

                            travYList6.reverse().forEach((trav_o, g) => {

                            let travXList7 = this.getTraversesX(trav_count, totalTravList[i], trav_o.pieces, trav_o.coordinates, 'N', false);

                              // console.log(' -> travXList7 de travera ' + (g + 1));
                              // console.log(travXList7);

                              travXList7.reverse().forEach( (trav_n, h) => {

                                let [travYList7, travYList7Total] = this.getTraversesY(trav_count, totalTravList[i], trav_n.pieces, trav_n.coordinates, 'M', false);

                                // console.log(' -> travYList7 de travera ' + (h + 1));
                                // console.log(travYList7);
                                
                                // NOTA: Si queda más de una pieza tras la última iteración
                                // entonces se añaden directamente todas las restantes
                                // ya que suponemos que el anidamiento es demasiado profundo.
                                if (travYList7 && travYList7.length > 0) {
									
									travYList7.forEach(tr_in => {
										if (tr_in.pieces && tr_in.pieces.length > 0) {
											
											tr_in.pieces.forEach(p_in => {
												totalTravList[i].push(p_in);
											});
										}
									});
								} // End If travYList7

                              });  // End forEach travXList6

                            });  // End forEach travYList5

                          });  // End forEach travXList6

                        });  // End forEach travYList5

                      });  // End forEach travXList5

                    });  // End forEach travYList4

                  });  // End forEach travXList4

                });  // End forEach travYList3

              }); // End forEach travXList3

            }); // End forEach travYList2

          }); // End forEach travXList2

        });  // End forEach travYList

      }); // End forEach travXList

    } // End IF axis
    // -------------------------------------
    
    // Se crea un array colocando las piezas de travera en travera empezando por la primera travera X.
    totalTravList.forEach(tt => {

      tt.forEach(t => {
		let similar_piece = resultList.find(px => {
			if (px.name === t.name) {
				// console.log('similar_piece encontrada en el resultado actual.');
				// console.log(t);
				return true;
			}
			return false;
		});
		
		if (!similar_piece) resultList.push(t);
      });
    });

    // console.log(' -> orderPiecesByCutFree trav1List:');
    // console.log(trav1List);
    
    let freeCutOrderList = [];
    let freeCutOrderPieces = [];
    
    // console.log(' -> orderPiecesByCutFree subTrav1List:');
    // console.log(subTrav1List);
    
    let sheetTraverseList = subTrav1List;
    
    // Código para ordenar las piezas teniendo en cuenta la "libertad" por nivel.
    // Sólo se hace si se ha indicado un valor de "libertad", si no opera como siempre.
    if(freeGrade && freeGrade > 0) {
		
		// console.log('---------------------------');
		// console.log('--> sheetTraverseList: ');
		// console.log('---------------------------');
		
		if (freeGrade === 1) {
			
			let gp = [];
			
			sheetTraverseList.forEach((tr_x, x_index) => {

				// console.log(' -> Alcanzado grado de libertad:' + freeGrade);				
				// console.log(' -> Encontradas piezas libres en nivel X:');
				// console.log(tr_x.tr_content);
				
				if (!freeCutOrderList['sh'])
					freeCutOrderList['sh'] = [];

				tr_x.tr_content.forEach(tr_c => {
					tr_c.pieces.forEach(p => {
						gp.push(p);
					});
				});
			});
			
			freeCutOrderList['sh'].push(gp);
			
		} // End If freeGrade === 1
		
		if (freeGrade === 2) {
			
			sheetTraverseList.forEach((tr_x, x_index) => {

				// console.log(' -> Alcanzado grado de libertad:' + freeGrade);				
				// console.log(' -> Encontradas piezas libres en nivel X:');
				// console.log(tr_x);
				
				if (!freeCutOrderList['trx' + x_index])
						freeCutOrderList['trx' + x_index] = [];
				
				let gp = [];

				tr_x.tr_content.forEach(tr_c => {
					
					// Se mete el elemento de las traveras con una sóla pieza.
					if (tr_c.pieces.length === 1) {
						gp.push(tr_c.pieces[0]);
					}
				});
				
				if ((tr_x.tr_Y && tr_x.tr_Y.length > 0) || tr_x.tr_Y['extra']) {
			
				  let tr_Y = tr_x.tr_Y;
				  
				  if (tr_Y['extra']) {
					
					tr_Y['extra'].forEach(extra_p => {
						// console.log('--> Metiendo pieza profunda: ' + extra_p.num);
						// Se mete el elemento extra (pieza de nivel profundo).
						extra_p.forEach(p => {
							gp.push(p);
						});
					});
				  }
				  
				  // console.log('--> tr_Y (lista de traveras Y interiores a travera X): ' + x_index);
				  // console.log(tr_Y);
				  
				  tr_Y.forEach((tr_y, y_index) => {
					
					// console.log('--> --> tr_y: ' + y_index);
				    // console.log(tr_y);
				    
					tr_y.tr.forEach(tr_c => {
						
						tr_c.pieces.forEach(p => {
							gp.push(p);
						});
					});
				  }); // End ForEach tr_Y.
				} // End If tr_x.tr_Y.
				
				freeCutOrderList['trx' + x_index].push(gp);
				
			});  // End ForEach sheetTraverseList.
			
		} // End If freeGrade === 2
	
		// console.log(' -> orderPiecesByCutFree freeCutOrderList:');
		// console.log(freeCutOrderList);
		
		// Número máximo de grupos de piezas del nivel seleccionado
		// que van a juntarse antes de realizar la ordenación por lote/secuencia.
		let max_count_free = freeGradeIn;
		let count_free = 0;
		
		let gp_aux = [];
		
		let freeCutOrderListAux = [];
		
		// Convertimos el array de Keys en un array normal para que tenga "length".
		for(let prop in freeCutOrderList) {
			
			freeCutOrderListAux.push(freeCutOrderList[prop]);
		}
		
		// console.log('-> orderPiecesByCutFree freeCutOrderListAux length = ' + freeCutOrderListAux.length);
		// console.log(freeCutOrderListAux);
		
		freeCutOrderListAux.forEach((gt, index_gt) => {
			
			count_free++;

			gt.forEach(pp => {
				if (pp) {
					pp.forEach(p => {
						gp_aux.push(p);
					});
				}
			});
			
			if (count_free >= max_count_free || 
				index_gt === freeCutOrderListAux.length - 1 || 
				max_count_free > freeCutOrderListAux.length) {
					
				gp_aux = this.orderByLot(gp_aux, '', true);
				
				// console.log('-> gp_aux count_free = ' + count_free);
				// console.log('-> gp_aux max_count_free = ' + max_count_free);
				// console.log(gp_aux);
			
				gp_aux.forEach(p => {
					freeCutOrderPieces.push(p);
				});
				
				// Se vacía los elementos agrupados con "libertad".
				gp_aux = [];
				count_free = 0;
			}
		}); // End ForEach freeCutOrderListAux.
		
		// console.log(' -> orderPiecesByCutFree freeCutOrderPieces:');
		// console.log(freeCutOrderPieces);
		
		resultList = freeCutOrderPieces;
		
	} // End If freeGrade.
	
	resultList = resultList.filter(p => p.type !== 'T');
      
    // -------------------------------------

    // console.log(' -> orderPiecesByCut totalTravList:');
    // console.log(totalTravList);

    // console.log(' -> orderPiecesByCutFree subTrav1List:');
    // console.log(subTrav1List);
    
    // console.log(' -> infinite_level:');
    // console.log(this.infinite_level);
    
    // console.log(' -> orderPiecesByCutFree resultList:');
    // console.log(resultList);

    // Se devuelve un primer valor con la ordenación invertida si así se ha solicitado.
    // Como segundo valor se devuelve el listado de todas las traveras de nivel 0 de la hoja y
    // las piezas que contiene (esto es necesario para poder hacer el fichero TRA4_NEU de Lisec).
    if (invert) {
      return [resultList.reverse(), trav1List, subTrav1List, level_fault];
    } else {
      return [resultList, trav1List, subTrav1List, level_fault];
    }
  } // End function orderPiecesByCutFree
  
  // -----------------------------
  
  // -------------------------------------
  //	FUNCIONES PARA ORDENACIÓN ARRAY
  // -------------------------------------

  preparePieceOrder(piecesListIn: any) {
	
	console.log(' --> preparePieceOrder:');
    // console.log(piecesListIn);

	// Primero ordenamos el array de piezas según tamaño.
    piecesListIn = this.orderBy2Dimensions(piecesListIn, 'width', 'height', true);

    // En piezas compuestas OEF interesa colocarlas primero para que
    // queden ancladas al borde de plancha desde el inicio de la optimización.
    const oefFirst = [];
    const nonOef = [];
    (piecesListIn || []).forEach(p => {
      const isOef = !!(
        p && (
          p.piece_oef_generated === true ||
          p.oef_generated === true ||
          (Array.isArray(p.piece_oef_internal_polygons) && p.piece_oef_internal_polygons.length > 0) ||
          (Array.isArray(p.oef_internal_polygons) && p.oef_internal_polygons.length > 0)
        )
      );
      if (isOef) {
        oefFirst.push(p);
      } else {
        nonOef.push(p);
      }
    });
    if (oefFirst.length > 0) {
      // Entre compuestas OEF mantenemos prioridad por dimensión.
      const oefOrdered = this.orderBy2Dimensions(oefFirst, 'width', 'height', true)
        .sort((a, b) => {
          const aPriorityRaw = a && a.oef_layout_priority !== undefined
            ? a.oef_layout_priority
            : (a && a.piece_oef_layout_priority);
          const bPriorityRaw = b && b.oef_layout_priority !== undefined
            ? b.oef_layout_priority
            : (b && b.piece_oef_layout_priority);
          const aPriority = Number.isFinite(Number(aPriorityRaw))
            ? Number(aPriorityRaw)
            : 1;
          const bPriority = Number.isFinite(Number(bPriorityRaw))
            ? Number(bPriorityRaw)
            : 1;
          return aPriority - bPriority;
        });
      piecesListIn = ([] as any[]).concat(oefOrdered).concat(nonOef);
    }
    
 /* // PREPARAR: Opción A) Cambia todas las piezas largas para ponerlas en la cola.
    let candidate_list = [];
    
    // Se recorren las piezas de la lista desde la última a la primera.
    for (let i = piecesListIn.length - 1; i >= 0; i--) {
		
		let base = piecesListIn[i];
		
		let tail_candidate = false;
		
		// console.log('-> base = ');
		// console.log(base);
		
		// Si su anchura supera el doble de la altura de todas sus unidades.
		if ((2 * base.height * base.units) < base.width) {
			
			tail_candidate = true;
		}
		
		if (tail_candidate) {
			
			console.log('-> Encontrada pieza de cola candidata:');
			console.log(base);
			
			// Se gira la pieza para dejar como altura su lado más largo.
			this.turnPiece(base, 'piece_width', 'piece_height', 'piece_rotation');
			
			candidate_list.push(base);
			
			// Se saca la pieza candidata que se ha seleccionado como candidata a cola.
			piecesListIn.splice(i, 1);
		}
	}
	
	// Se ordenan para colocar las más anchas primero.
	candidate_list = this.orderBy2Dimensions(candidate_list, 'width', 'height', true);
	
	// Se ordenan para colocar las piezas según su lote y número de secuencia.
	// candidate_list = this.orderByLot(candidate_list, 'lot', false);
	
	candidate_list.forEach(pc => {

		// Se colocan las piezas candidatas al final del listado general
		// de forma que la más larga sea la última.
		piecesListIn.push(pc);
	}); 
	
	console.log('-> candidate_list = ');
	console.log(candidate_list); // */
    
    // PREPARAR: Opción B) Sólo testea y cambia la primera pieza (la más grande) y la pone en la cola.
     
	    if (piecesListIn && piecesListIn[0]) {
			
		    let base = piecesListIn[0]; // 
			
			let tail_candidate = null;
			const isOefComposite = !!(
				base && (
					base.piece_oef_generated === true ||
					(Array.isArray(base.piece_oef_internal_polygons) && base.piece_oef_internal_polygons.length > 0)
				)
			);
		
			// Si su anchura supera el doble de la altura de todas sus unidades.
			if (!isOefComposite && (2 * base.height * base.units) < base.width) {
				
				tail_candidate = base;
			}
		
		if (tail_candidate) {
			
			console.log('-> Encontrada pieza de cola candidata:');
			console.log(tail_candidate);
			
			
			// Se coloca la pieza al final de todas.
			piecesListIn.push(tail_candidate);
			
			// Se saca la pieza candidata a cola que está en el primer lugar.
			piecesListIn.splice(0, 1);
		}

	} // */
	/*
	
	// Ahora intentamos construir una travera X principal usando la pieza más grande
    // como base y luego intentando rellenar el resto con piezas que dejen pocos huecos.
    
	let area = (base_tr.width * (this.nextSheet.height - base_tr.height - this.nextSheet.disband.top - this.nextSheet.disband.bottom)) / 1000000;
    
    console.log('-> Area libre = ');
	console.log(area);
	
    // Buscamos la combinación de piezas cuya suma de anchos esté más cercana al ancho
    // de la pieza escogida como base de la Travera X principal tratada.
    
    let selected_pieces1 = [];
    let selected_pieces2 = [];
    let total_area1 = 0;
    let total_area2 = 0;
    
    // Desde el final de la lista (donde normalmente estarán las piezas más pequeñas)
    // se van buscando combinaciones hasta que se llegue al ancho de la pieza base.
    for (let i = piecesListIn.length - 1; i >= 0; i--) {
		
		let pp = piecesListIn[i];
		
		// console.log('-> pp = ');
		// console.log(pp);
		
		let area1 = ((pp.width * pp.height) / 1000000) * pp.units;
		
		if (total_area1 + area1 <= area) {
			
			total_area1 += area1;
			
			// piecesListIn.splice(i, 1);
			
			// Se selecciona la pieza.
			selected_pieces1.push({ind: i, pz: pp});
		}
	}
	
	console.log('-> total_area1 = ');
	console.log(total_area1);
	
	console.log('-> selected_pieces1 = ');
	console.log(selected_pieces1);
	
	for (let i = 0; i < piecesListIn.length; i++) {
		
		let pp = piecesListIn[i];
		
		// console.log('-> pp = ');
		// console.log(pp);
		
		let area2 = ((pp.width * pp.height) / 1000000) * pp.units;
		
		if (total_area2 + area2 <= area) {
			
			total_area2 += area2;
			
			// piecesListIn.splice(i, 1);
			
			// Se selecciona la pieza.
			selected_pieces2.unshift({ind: i, pz: pp});
		}
	}
	
	console.log('-> total_area2 = ');
	console.log(total_area2);
	
	console.log('-> selected_pieces2 = ');
	console.log(selected_pieces2);
	
	if (total_area1 > total_area2) {
		
		selected_pieces1.forEach(sel => {
			piecesListIn.splice(sel.ind, 1);
		});
		
		selected_pieces1.forEach(sel => {
			// Se añaden al inicio del listado.
			piecesListIn.unshift(sel.pz);
		});
	} else {
		
		selected_pieces2.forEach(sel => {
			piecesListIn.splice(sel.ind, 1);
		});
		
		selected_pieces2.forEach(sel => {
			// Se añaden al inicio del listado.
			piecesListIn.unshift(sel.pz);
		});
	}
	
	// piecesListIn.push(base_tr);
	piecesListIn.unshift(base_tr);
*/

	console.log('-> preparePieceOrder resultado = ');
	// console.log(piecesListIn);
	
	return piecesListIn;
	
  } // End function preparePieceOrder.

  applyUrgencyPreference(piecesListIn: any[]): any[] {
    const pieces = Array.isArray(piecesListIn) ? piecesListIn : [];
    const priorityOf = (piece: any): number => Number(
      piece && piece.priority !== undefined ? piece.priority : (piece && piece.piece_priority)
    ) > 0 ? 1 : 0;
    const hasUrgent = pieces.some(piece => priorityOf(piece) === 1);
    const hasNormal = pieces.some(piece => priorityOf(piece) === 0);
    if (!hasUrgent || !hasNormal) {
      return piecesListIn;
    }
    const isOef = (piece: any): boolean => !!(piece && (
      piece.piece_oef_generated === true || piece.oef_generated === true ||
      (Array.isArray(piece.piece_oef_internal_polygons) && piece.piece_oef_internal_polygons.length > 0) ||
      (Array.isArray(piece.oef_internal_polygons) && piece.oef_internal_polygons.length > 0)
    ));
    const stableUrgentFirst = (list: any[]): any[] => list.filter(piece => priorityOf(piece) === 1)
      .concat(list.filter(piece => priorityOf(piece) === 0));
    const oefPieces = pieces.filter(piece => isOef(piece));
    if (oefPieces.length === 0) {
      return stableUrgentFirst(pieces);
    }
    const nonOefPieces = pieces.filter(piece => !isOef(piece));
    const oefPriorityBands: {[key: string]: any[]} = {};
    const oefPriorityOrder: string[] = [];
    oefPieces.forEach(piece => {
      const raw = piece && piece.oef_layout_priority !== undefined
        ? piece.oef_layout_priority
        : piece && piece.piece_oef_layout_priority;
      const key = Number.isFinite(Number(raw)) ? Number(raw).toString() : '1';
      if (!oefPriorityBands[key]) {
        oefPriorityBands[key] = [];
        oefPriorityOrder.push(key);
      }
      oefPriorityBands[key].push(piece);
    });
    const orderedOef = [];
    oefPriorityOrder.forEach(key => orderedOef.push(...stableUrgentFirst(oefPriorityBands[key])));
    return orderedOef.concat(stableUrgentFirst(nonOefPieces));
  }
  
  // Función para la ordenación elementos teniendo en cuenta la "prioridad" del elemento.
  orderPiecesByPriority(arrayIn: any[], invert: boolean) {

    console.log(' --> -> orderPiecesByPriority entrada:');
    // console.log(arrayIn);

    // Es menor el elemento cuya prioridad es menor.
    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (a['priority'] < b['priority']) {
        // console.log('--> A < B por prioridad.');
        compare = -1;
      } else if (a['priority'] > b['priority']) {
        // console.log('--> A > B por prioridad.');
        compare = 1;
      } else { // Tienen la misma prioridad.
          // console.log('--> A y B tienen la misma prioridad.');
          compare = 0; // Son iguales.
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderPiecesByPriority

  // Función para la ordenación elementos teniendo en cuenta las dimensiones del elemento.
  orderEaselByDimension(arrayIn: any[], invert: boolean) {

    console.log(' --> -> orderEaselByDimension entrada:');
    // console.log(arrayIn);

    // Es menor el elemento cuya multiplicación de "ancho x alto" sea más pequeña.
    let resultList = arrayIn.sort((a, b) => {

      // let aDimension = a['max_width'] * a['max_height'];
      // let bDimension = b['max_width'] * b['max_height'];

      // console.log('--> a = ' + a.stockwidth + ' x ' + a.stockheight + ' = ' + aDimension);
      // console.log('--> b = ' + b.stockwidth + ' x ' + b.stockheight + ' = ' + bDimension);

      let compare = 0;

      if (a['max_width'] < b['max_width']) {
        // console.log('--> A < B por anchura.');
        compare = -1;
      } else if (a['max_width'] > b['max_width']) {
        // console.log('--> A > B por anchura.');
        compare = 1;
      } else { // Tienen el mismo ancho. Se compara el alto entonces.
        if (a['max_height'] < b['max_height']) {
          // console.log('--> A < B por altura.');
          compare = -1;
        } else if (a['max_height'] > b['max_height']) {
          // console.log('--> A > B por altura.');
          compare = 1;
        } else {
          // console.log('--> A y B tienen las mismas dimensiones.');
          compare = 0; // Son iguales.
        }
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderEaselByDimension

  orderById(arrayIn: any[], invert: boolean) {

    console.log(' --> -> orderById entrada:');
    console.log(arrayIn);

    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (a['piece_id'] < b['piece_id']) {
        // console.log('--> A < B.');
        compare = -1;
      } else if (a['piece_id'] > b['piece_id']) {
        // console.log('--> A > B.');
        compare = 1;
      } else {
          // console.log('--> A y B soniguales.');
          compare = 0; // Son iguales.
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderById


  // Función que ordena las piezas teniendo en cuenta el espacio sobrante a los lados de la travera.
  orderByPieceAjust(pieceIn: any, arrayIn: any[], width_text: string, height_text: string, invert: boolean) {

    console.log(' --> -> orderByPieceAjust entrada:');
    // console.log(arrayIn);
    // console.log(' --> -> orderByPieceAjust pieza:');
    // console.log(pieceIn);

    // Se calcula el área de las dos traveras que se van a comparar.
    // La que se acerque más al area de la pieza será la mayor en ordenación.

    let resultList = arrayIn.sort((a, b) => {

      if (a === null || a === undefined) {
        return -1;
      }

      if (b === null || b === undefined) {
        return 1;
      }

      let area_a = a[width_text] * a[height_text];
      let area_b = b[width_text] * b[height_text];
      let area_p = pieceIn.width * pieceIn.height;

      let dif_a = area_a - area_p;
      let dif_b = area_b - area_p;

      let dif_a_w = a[width_text] - pieceIn.width;
      let dif_a_h = a[height_text] - pieceIn.height;
      let dif_b_w = b[width_text] - pieceIn.width;
      let dif_b_h = b[height_text] - pieceIn.height;

      if (dif_a_w < 0 || dif_a_h < 0) {
        return -1;
      } else if (dif_b_w < 0 || dif_b_h < 0) {
        return 1;
      }

      // Si alguno de sus lados coinciden con las dimensiones de algún lado de la pieza
      // entonces directamente se considera prioritaria esa travera para ser mayor.
      if (dif_a_w === 0 || dif_a_h === 0) {
        return 1;
      } else if (dif_b_w === 0 || dif_b_h === 0) {
        return 1;
      }

      let compare = 0;

      // Será menor quien más diferencia tenga.

      if (dif_a > dif_b) {
        // console.log('--> A < B por diferencia de area.');
        compare = -1;
      } else if (dif_a < dif_b) {
        // console.log('--> A > B por diferencia de area.');
        compare = 1;
      } else { // Tienen la misma diferencia de area.
        // Quien deje menos espacio horizontal o vertical sera el mayor.
        if (dif_a_w > dif_b_w) {
          compare = -1;
        } else if (dif_a_w < dif_b_w) {
          compare = 1;
        } else if (dif_a_h > dif_b_h) {
          compare = -1;
        } else if (dif_a_h < dif_b_h) {
          compare = 1;
        } else {
          compare = 0; // Son iguales
        }
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByPieceAjust

  // Función para la ordenación elementos teniendo en cuenta las dimensiones del elemento.
  // Se pasa como parámetros el nombre de los campos de los elementos del array que se van
  // a usar para hacer las comparaciones.
  orderBy2Dimensions(arrayIn: any[], width_text: string, height_text: string, invert: boolean) {

    // console.log(' --> -> orderBy2Dimensions entrada:');
    // console.log(arrayIn);

    // a) Si tuviésemos en cuenta el área: Es menor el elemento cuya multiplicación de "ancho x alto" sea más pequeña.
    // b) Si tuviésemos en cuenta el volumen: Es menor el elemento cuya multiplicación de "ancho x alto x profundidad" sea más pequeña.

    // c) Quien tenga mayor ancho será la pieza considerada más elevada en el orden.
    // Si empatan en el ancho entonces se considera el alto.

    // Premisa: el "ancho" será siempre el primer parámetro y el "alto" el segundo
    // (ancho x alto x largo ==> línea horizontal x línea vertical x línea de profundidad).

    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (a === null || a === undefined) {
        return -1;
      }

      if (b === null || b === undefined) {
        return 1;
      }

      // Será menor quien menos ancho tenga.
      // Si tuviesen el mismo ancho será menor quien menos alto tenga.

      if (a[width_text] < b[width_text]) {
        // console.log('--> A < B por anchura.');
        compare = -1;
      } else if (a[width_text] > b[width_text]) {
        // console.log('--> A > B por anchura.');
        compare = 1;
      } else { // Tienen el mismo ancho. Se compara el alto entonces.
        if (a[height_text] < b[height_text]) {
          // console.log('--> A < B por altura.');
          compare = -1;
        } else if (a[height_text] > b[height_text]) {
          // console.log('--> A > B por altura.');
          compare = 1;
        } else {
          // console.log('--> A y B tienen las mismas dimensiones.');
          compare = 0; // Son iguales.
        }
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderBy2Dimensions
  
  // Función que ordena los elementos teniendo en cuenta que su origen
  // esté más próximo al origen de coordenadas de la hoja optimizada.
  orderByXorigin(arrayIn: any[], x_text: string, y_text: string, invert: boolean) {

    // console.log(' --> -> orderByXorigin entrada:');
    // console.log(arrayIn);

    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (a === null || a === undefined) {
        return -1;
      }

      if (b === null || b === undefined) {
        return 1;
      }

      // Será menor quien menos ancho tenga.
      // Si tuviesen el mismo ancho quien será menor quien menos alto tenga.

      if (a[x_text] < b[x_text]) {
        // console.log('--> A < B.');
        compare = -1;
      } else if (a[x_text] > b[x_text]) {
        // console.log('--> A > B.');
        compare = 1;
      } else { // Tienen la misma X de origen. Se compara entonces el origen en Y.
        if (a[y_text] < b[y_text]) {
          // console.log('--> A < B.');
          compare = -1;
        } else if (a[y_text] > b[y_text]) {
          // console.log('--> A > B.');
          compare = 1;
        } else {
          // console.log('--> A y B tiene mismo punto de origen.');
          compare = 0; // Son iguales.
        }
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByXorigin
  
  // Función que ordena las traveras de modo que coloca primero las que tienen su
  // punto de origen más cercano al punto de origen global de la optimización.
  orderTravByXorigin(arrayIn: any[], x_text: string, y_text: string, invert: boolean) {

    // console.log(' --> -> orderTravByXorigin entrada:');
    // console.log(arrayIn);

    let resultList = arrayIn.sort((at, bt) => {

      let compare = 0;
      
      let a = at.traverse;
      let b = bt.traverse;

      if (a === null || a === undefined) {
        return -1;
      }

      if (b === null || b === undefined) {
        return 1;
      }
      
      if (a['sheet_id'] < b['sheet_id']) {
		// console.log('--> A < B. A está en una hoja anterior.');
		compare = -1;
	  } else if (a['sheet_id'] > b['sheet_id']) {
		// console.log('--> A > B. A está en una hoja posterior.');
        compare = 1;
	  } else { // Ambas traveras están en la misma hoja. Hay que comparar entonces su punto de origen.
	  
	  	  // Será menor quien menos "x" tenga.
	      // Si tuviesen el mismo "x" será menor quien menos "y" tenga.
	
	      if (a[x_text] < b[x_text]) {
	        // console.log('--> A < B.');
	        compare = -1;
	      } else if (a[x_text] > b[x_text]) {
	        // console.log('--> A > B.');
	        compare = 1;
	      } else { // Tienen la misma X de origen. Se compara entonces el origen en Y.
	        if (a[y_text] < b[y_text]) {
	          // console.log('--> A < B.');
	          compare = -1;
	        } else if (a[y_text] > b[y_text]) {
	          // console.log('--> A > B.');
	          compare = 1;
	        } else {
	          // console.log('--> A y B tiene mismo punto de origen.');
	          compare = 0; // Son iguales.
	        }
	      } // End If origin.
	  } // End IF sheet_id.

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderTravByXorigin

  // Conserva la prioridad histórica del optimizador y añade el caso de un único
  // retal lateral. No se ordena globalmente por área porque eso adelanta encajes
  // de otras piezas y puede cambiar por completo la estructura de la hoja.
  selectBestTraverseFit(candidatesIn: any[]) {
    const candidates = (candidatesIn || []).filter(item =>
      item && item.traverse && !item.traverse.used && item.piece
    );

    const sameConsecutiveSeries = (itemIn: any): boolean => {
      const current = itemIn && itemIn.piece;
      const previous = this.last_piece;
      if (!current || !previous) return false;

      const sameValue = (aIn: any, bIn: any): boolean =>
        aIn !== undefined && aIn !== null && bIn !== undefined && bIn !== null &&
        aIn.toString() === bIn.toString();
      const currentSides = [Number(current.piece_width), Number(current.piece_height)].sort((a, b) => a - b);
      const previousSides = [Number(previous.piece_width), Number(previous.piece_height)].sort((a, b) => a - b);

      return sameValue(current.piece_lot, previous.piece_lot) &&
        sameValue(current.piece_sequence, previous.piece_sequence) &&
        sameValue(current.piece_orderno, previous.piece_orderno) &&
        sameValue(current.piece_orderpos, previous.piece_orderpos) &&
        sameValue(current.piece_paneno, previous.piece_paneno) &&
        currentSides[0] === previousSides[0] && currentSides[1] === previousSides[1];
    };

    return candidates.find(item => item.TA && !item.TB && !item.TC)
      // Sólo agrupamos en TB una unidad consecutiva de la misma referencia. Así
      // la primera conserva el trazado histórico y la siguiente usa su sobrante.
      || candidates.find(item => !item.TA && item.TB && !item.TC && sameConsecutiveSeries(item))
      || candidates.find(item => item.TA && item.TB && !item.TC)
      || null;
  }

  // Al empezar una plancha nueva, dos o más piezas iguales pueden formar una
  // franja cuya parte superior aloje la pieza que inicialmente iba a ocupar
  // otra travera completa. La decisión se toma después de haber probado esa
  // pieza en todos los retales antiguos, para no alterar hojas ya calculadas.
  prioritizeSharedStripAtSheetStart(): boolean {
    if (!this.useSharedStripLookahead ||
        !Array.isArray(this.nextPiece) ||
        this.nextPiece.length < 3 ||
        !Array.isArray(this.traverseList) ||
        this.traverseList.length !== 1) {
      return false;
    }

    const sheetTraverse = this.traverseList[0];
    const currentSheetId = this.nextSheet && this.nextSheet.id;
    const hasPieceInCurrentSheet = (this.pieceList || [])
      .some(item => item && item.sheet_id === currentSheetId);
    const isEmptySheetTraverse = sheetTraverse &&
      !sheetTraverse.used &&
      !sheetTraverse.piece &&
      sheetTraverse.old === false &&
      Number(sheetTraverse.father) === 0 &&
      Number(sheetTraverse.origin_x) === 0 &&
      Number(sheetTraverse.origin_y) === 0 &&
      sheetTraverse.sheet_id === currentSheetId &&
      !hasPieceInCurrentSheet;

    if (!isEmptySheetTraverse) {
      return false;
    }

    const isOefPiece = (pieceIn: any): boolean => !!(
      pieceIn &&
      (pieceIn.piece_oef_generated === true ||
       (Array.isArray(pieceIn.piece_oef_internal_polygons) &&
        pieceIn.piece_oef_internal_polygons.length > 0) ||
       Number(pieceIn.piece_oef_real_units) > 1)
    );
    const guest: any = this.nextPiece[0];
    if (!guest || guest.piece_cut || isOefPiece(guest) ||
        (Array.isArray(guest.piece_set) && guest.piece_set.length > 0)) {
      return false;
    }

    const guestWidth = Number(guest.piece_width);
    const guestHeight = Number(guest.piece_height);
    const sheetWidth = Number(sheetTraverse.width);
    const sheetHeight = Number(sheetTraverse.height);
    if (!(guestWidth > 0 && guestHeight > 0 &&
          sheetWidth > 0 && sheetHeight > 0)) {
      return false;
    }

    const sameSeries = (aIn: any, bIn: any): boolean => {
      if (!aIn || !bIn) return false;
      const same = (leftIn: any, rightIn: any): boolean =>
        (leftIn === undefined || leftIn === null) &&
        (rightIn === undefined || rightIn === null)
          ? true
          : leftIn !== undefined && leftIn !== null &&
            rightIn !== undefined && rightIn !== null &&
            leftIn.toString() === rightIn.toString();
      return Number(aIn.piece_width) === Number(bIn.piece_width) &&
        Number(aIn.piece_height) === Number(bIn.piece_height) &&
        same(aIn.piece_group, bIn.piece_group) &&
        same(aIn.piece_lot, bIn.piece_lot) &&
        same(aIn.piece_sequence, bIn.piece_sequence) &&
        same(aIn.piece_orderno, bIn.piece_orderno) &&
        same(aIn.piece_orderpos, bIn.piece_orderpos) &&
        same(aIn.piece_paneno, bIn.piece_paneno) &&
        same(aIn.piece_figure_input, bIn.piece_figure_input);
    };

    let best: any = null;
    for (let index = 1; index < this.nextPiece.length; index++) {
      const host = this.nextPiece[index];
      if (!host || host.piece_cut || isOefPiece(host) ||
          (Array.isArray(host.piece_set) && host.piece_set.length > 0)) {
        continue;
      }

      const hostWidth = Number(host.piece_width);
      const hostHeight = Number(host.piece_height);
      if (!(hostWidth >= guestWidth &&
            hostWidth <= sheetWidth &&
            hostHeight > 0 &&
            hostHeight < sheetHeight &&
            guestWidth / hostWidth >= 0.75)) {
        continue;
      }

      const seriesIndexes = [];
      for (let seriesIndex = index; seriesIndex < this.nextPiece.length; seriesIndex++) {
        const seriesPiece = this.nextPiece[seriesIndex];
        if (seriesPiece && !seriesPiece.piece_cut && sameSeries(host, seriesPiece)) {
          seriesIndexes.push(seriesIndex);
        }
      }

      const stackCapacity = Math.floor((sheetHeight - guestHeight) / hostHeight);
      const stackCount = Math.min(seriesIndexes.length, stackCapacity);
      if (stackCount < 2) {
        continue;
      }

      const combinedHeight = (stackCount * hostHeight) + guestHeight;
      if (combinedHeight > sheetHeight) {
        continue;
      }

      const candidate = {
        indexes: seriesIndexes.slice(0, stackCount),
        gap: hostWidth - guestWidth,
        stackCount: stackCount,
        hostWidth: hostWidth,
        hostHeight: hostHeight,
        combinedHeight: combinedHeight
      };
      if (!best ||
          candidate.gap < best.gap ||
          (candidate.gap === best.gap && candidate.stackCount > best.stackCount)) {
        best = candidate;
      }
    }

    if (!best) {
      return false;
    }

    // La pieza invitada es más estrecha que la serie que forma su travera.
    // La colocación histórica la apoyaba en el origen interior y dejaba la
    // diferencia como una franja estrecha entre columnas. Conservamos aquí
    // el marco exacto en el que debe apoyarse en el lado contrario para que
    // esa franja quede en el borde exterior de la hoja.
    if (best.gap > 0) {
      this.sharedStripAlignmentTarget = {
        sheet_id: currentSheetId,
        parent_origin_x: Number(sheetTraverse.origin_x),
        parent_origin_y:
          Number(sheetTraverse.origin_y) + (best.stackCount * best.hostHeight),
        parent_width: best.hostWidth,
        guest_width: guestWidth,
        guest_height: guestHeight,
        piece_id: guest.piece_id,
        piece_name_id: guest.piece_name_id,
        piece_group: guest.piece_group,
        piece_lot: guest.piece_lot,
        piece_sequence: guest.piece_sequence,
        piece_orderno: guest.piece_orderno,
        piece_orderpos: guest.piece_orderpos,
        piece_paneno: guest.piece_paneno,
        piece_figure_input: guest.piece_figure_input
      };
      guest.packing_shared_strip_edge_align = true;
      guest.packing_shared_strip_parent_sheet_id = currentSheetId;
      guest.packing_shared_strip_parent_origin_x = Number(sheetTraverse.origin_x);
      guest.packing_shared_strip_parent_origin_y =
        Number(sheetTraverse.origin_y) + (best.stackCount * best.hostHeight);
      guest.packing_shared_strip_parent_width = best.hostWidth;
      guest.packing_shared_strip_guest_width = guestWidth;
      guest.packing_shared_strip_guest_height = guestHeight;
    }

    const hosts = best.indexes.map(index => this.nextPiece[index]);
    best.indexes.slice().sort((a, b) => b - a)
      .forEach(index => this.nextPiece.splice(index, 1));
    this.nextPiece.unshift(...hosts);

    console.log('--> Anticipación de travera compartida aplicada:', {
      sheet_id: currentSheetId,
      host_units: hosts.length,
      host_width: best.hostWidth,
      guest_width: guestWidth,
      occupied_height: best.combinedHeight,
      sheet_height: sheetHeight
    });
    if (this.sharedStripAlignmentTarget) {
      console.log('[Shared-strip alignment pending] ' + JSON.stringify(
        this.sharedStripAlignmentTarget
      ));
    }
    return true;
  }

  // Aplica a la travera usada el origen alternativo calculado al crear una
  // franja compartida. Las traveras libres ya se generaron con esa misma
  // partición en setPieceInTraverse; aquí se sincroniza la pieza que consumen
  // canvas, orden de corte, CNC y PDF.
  applyPiecePlacementOverride(traverseIn: any, pieceIn: any): boolean {
    if (!traverseIn || !pieceIn ||
        pieceIn.packing_shared_strip_edge_align !== true) {
      return false;
    }

    const eps = 0.001;
    const originX = Number(pieceIn.packing_origin_x_override);
    const originY = Number(pieceIn.packing_origin_y_override);
    const pieceWidth = Number(pieceIn.piece_width);
    const pieceHeight = Number(pieceIn.piece_height);
    const sheetWidth = Number(traverseIn.sheet_width);
    const sheetHeight = Number(traverseIn.sheet_height);
    if (!(Number.isFinite(originX) && Number.isFinite(originY) &&
          Number.isFinite(pieceWidth) && pieceWidth > eps &&
          Number.isFinite(pieceHeight) && pieceHeight > eps &&
          Number.isFinite(sheetWidth) && Number.isFinite(sheetHeight) &&
          originX >= -eps && originY >= -eps &&
          originX + pieceWidth <= sheetWidth + eps &&
          originY + pieceHeight <= sheetHeight + eps)) {
      return false;
    }

    const previousOriginX = Number(traverseIn.origin_x);
    traverseIn.origin_x = originX;
    traverseIn.origin_y = originY;
    pieceIn.points = this.getPieceCoordinates(
      originX,
      originY,
      pieceWidth,
      pieceHeight
    );
    pieceIn.packing_shared_strip_edge_aligned = true;
    const pendingTarget = this.sharedStripAlignmentTarget;
    if (pendingTarget &&
        String(pendingTarget.sheet_id) === String(traverseIn.sheet_id) &&
        Math.abs(Number(pendingTarget.guest_width) - pieceWidth) <= eps &&
        Math.abs(Number(pendingTarget.guest_height) - pieceHeight) <= eps) {
      this.sharedStripAlignmentTarget = null;
    }
    console.log('[Shared-strip edge alignment] ' + JSON.stringify({
      sheet_id: Number(traverseIn.sheet_id),
      piece_id: pieceIn.piece_id,
      from_x: previousOriginX,
      to_x: originX,
      y: originY,
      width: pieceWidth,
      height: pieceHeight,
      exterior_remainder_width: Number(pieceIn.packing_shared_strip_gap),
      source: pieceIn.packing_shared_strip_alignment_source || 'piece_marker',
      planned_y: Number(pieceIn.packing_shared_strip_planned_y),
      actual_y: Number(pieceIn.packing_shared_strip_actual_y)
    }));
    return true;
  }

  // Función que gira las piezas de forma que quede el lado más largo horizontal y luego las ordena
  // según el valor de ese lado, siendo mayor quién mayor superficie horizontal tenga.
  orderByRotateHorizontal(arrayIn: any[], width_text: string, height_text: string, horizontal: boolean, invert: boolean) {

    console.log(' --> -> orderByRotateHorizontal entrada:');
    // console.log(arrayIn);

    let resultList = arrayIn.sort((a, b) => {

      if (a === null || a === undefined) {
        return -1;
      }

      if (b === null || b === undefined) {
        return 1;
      }

      let compare = 0;

      if (horizontal) {
        // Se giran ambas piezas para que su lado más largo sea el ancho estando la pieza horizontal.
        if (a[width_text] < a[height_text] && a[height_text] <= this.max_die_cutting) {

          // console.log(' -> orderByRotateHorizontal girando pieza A:');
          // console.log(a);

          let a_aux_w = a[width_text];
          a[width_text] = a[height_text];
          a[height_text] = a_aux_w;

          if (a.piece_rotation === 0 || a.piece_rotation === 180 || a.piece_rotation === null) {
            a.piece_rotation = 90;
          } else {
            a.piece_rotation = 0;
          }
        }

        if (b[width_text] < b[height_text] && b[height_text] <= this.max_die_cutting) {

          // console.log(' -> orderByRotateHorizontal girando pieza B:');
          // console.log(b);

          let b_aux_w = b[width_text];
          b[width_text] = b[height_text];
          b[height_text] = b_aux_w;

          if (b.piece_rotation === 0 || b.piece_rotation === 180 || b.piece_rotation === null) {
            b.piece_rotation = 90;
          } else {
            b.piece_rotation = 0;
          }
        }
      } else {
        // Se giran ambas piezas para que su lado más largo sea el alto estando la pieza vertical.
        if (a[width_text] > a[height_text] && a[height_text] <= this.max_die_cutting) {

          // console.log(' -> orderByRotateHorizontal girando pieza A:');
          // console.log(a);

          let a_aux_w = a[width_text];
          a[width_text] = a[height_text];
          a[height_text] = a_aux_w;

          if (a.piece_rotation === 0 || a.piece_rotation === 180 || a.piece_rotation === null) {
            a.piece_rotation = 90;
          } else {
            a.piece_rotation = 0;
          }
        }

        if (b[width_text] > b[height_text] && b[height_text] <= this.max_die_cutting) {

          // console.log(' -> orderByRotateHorizontal girando pieza B:');
          // console.log(b);

          let b_aux_w = b[width_text];
          b[width_text] = b[height_text];
          b[height_text] = b_aux_w;

          if (b.piece_rotation === 0 || b.piece_rotation === 180 || b.piece_rotation === null) {
            b.piece_rotation = 90;
          } else {
            b.piece_rotation = 0;
          }
        }
      } // End If horizontal

      // Será menor quien menos ancho tenga.
      // Si tuviesen el mismo ancho quien será menor quien menos alto tenga.

      if (a[width_text] < b[width_text]) {
        // console.log('--> A < B por anchura.');
        compare = -1;
      } else if (a[width_text] > b[width_text]) {
        // console.log('--> A > B por anchura.');
        compare = 1;
      } else { // Tienen el mismo ancho. Se compara el alto entonces.
        if (a[height_text] < b[height_text]) {
          // console.log('--> A < B por altura.');
          compare = -1;
        } else if (a[height_text] > b[height_text]) {
          // console.log('--> A > B por altura.');
          compare = 1;
        } else {
          // console.log('--> A y B tienen las mismas dimensiones.');
          compare = 0; // Son iguales.
        }
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByRotateHorizontal

  // Función para la ordenación elementos teniendo en cuenta su área.
  // Se pasa como parámetros el nombre de los campos de los elementos del array que se van
  // a usar para hacer las comparaciones.
  fitByDimension(a: any, b: any, width_text: string, height_text: string, invert: boolean) {

    console.log(' --> -> fitByDimension:');
    console.log(a);
    console.log(b);

    let result = 0;

    let area_a = a[width_text] * a[height_text];
    let area_b = b[width_text] * b[height_text];

    // Si el resultado es negativo quiere decir que la pieza A no cabe en B.
    // El resultado de la resta indica cuánto sobra despúes de colocar A dentro de B.
    result = area_b - area_a;

    // Si es mayor o igual la pieza A cabe dentro de la B.
    // if (result >= 0) {
    //   return true;
    // } else {
    //   return false;
    // }

    return result;

  } // End function fitByDimension
  
  orderByListOrder(arrayIn: any[], invert: boolean) {

    // console.log(' --> -> orderByListOrder entrada:');
    // console.log(arrayIn);

    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (a['list_order'] < b['list_order']) {
        // console.log('--> A < B.');
        compare = -1;
      } else if (a['list_order'] > b['list_order']) {
        // console.log('--> A > B.');
        compare = 1;
      } else {
          // console.log('--> A y B soniguales.');
          compare = 0; // Son iguales.
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByListOrder

  /*
  // Función que cambia la orientación de una pieza de entrada A para que quepa de la forma más ajustada
  // en una pieza de entrada B. Escoge la orientación que menos distancia sobre de algún lado.
  fitByDistance(a: any, b: any, a_text: string, b_text: string): any {

    console.log(' --> -> fitByDistance:');
    console.log(a);
    console.log(b);

    // Se hace una copia de la variable de la pieza.
    let a_aux = JSON.parse(JSON.stringify(a));

    let result = 0;

    let a_width_text = a_text + 'width';
    let a_height_text = a_text + 'height';
    let b_width_text = b_text + 'width';
    let b_height_text = b_text + 'height';
    let rotation_text = a_text + 'rotation';

    let area_a = a[a_width_text] * a[a_height_text];
    let area_b = b[b_width_text] * b[b_height_text];

    // Si el resultado es negativo quiere decir que la pieza A no cabe en B.
    // El resultado de la resta indica cuánto sobra despúes de colocar A dentro de B.
    result = area_b - area_a;

    // La pieza A colocada horizontalmente (primero ancho x alto).
    let horizontal_width_distance = 0; // Distancia sobrante de ancho con respecto a B para la orientación horizontal de A.
    let horizontal_height_distance = 0; // Distancia sobrante de alto con respecto a B para la orientación horizontal de A.

    // La pieza A colocada verticalmente (primero alto x ancho).
    let vertical_width_distance = 0; // Distancia sobrante de ancho con respecto a B para la orientación vertical de A.
    let vertical_height_distance = 0; // Distancia sobrante de alto con respecto a B para la orientación vertical de A.

    // NOTA: Hay que escoger la orientación donde se encuentre el valor
    // menor de estas cuatro variables de distancia declaradas arriba.

    let X_distance = 0;
    let Y_distance = 0;

    // Si es mayor o igual la pieza A cabe dentro de la B, por lo que se puede continuar.
    if (result >= 0) {

      horizontal_width_distance = b[b_width_text] - a[a_width_text];
      horizontal_height_distance = b[b_height_text] - a[a_height_text];

      vertical_width_distance = b[b_width_text] - a[a_height_text];
      vertical_height_distance = b[b_height_text] - a[a_width_text];

      if (horizontal_width_distance > horizontal_height_distance) {
        // Se asigna la distancia que sea menor.
        X_distance = horizontal_height_distance;
      } else {
        X_distance = horizontal_width_distance;
      }

      if (vertical_width_distance > vertical_height_distance) {
        // Se asigna la distancia que sea menor.
        Y_distance = vertical_height_distance;
      } else {
        Y_distance = vertical_width_distance;
      }

      // IMPORTANTE: Las distancias deben de ser mayor de cero para evitar que gire la pieza cuando se obtengan números negativos.
      if (X_distance > Y_distance && X_distance > 0  && Y_distance > 0) {

        console.log(' --> Se cambia la orientación de la pieza. X_distance = ' + X_distance + ' ;Y_distance = ' + Y_distance);

        // Se cambia la orientación de la pieza invirtiendo los valores de "ancho x alto" por "alto x ancho"
        let w_aux = a[a_width_text];
        let h_aux = a[a_height_text];
        a_aux[a_width_text] = h_aux;
        a_aux[a_height_text] = w_aux;

        // Indicamos que se ha tenido que rotar la pieza.
        a_aux[rotation_text] = 90;

      } else {

        console.log(' --> La pieza tiene la orientación adecuada.');
      }

    } else {

      console.log(' --> La pieza A no cabe en B.');
      return false;
    }

    return a_aux;

  } // End function fitByDistance */

  // Función que intenta encajar el elemento "a" (pieza) dentro del elemento "b" (marco vacío).
  // El parámetro "rotate" indica si se quiere dar la posibilidad de girar la pieza y el parámetro
  // "near" indica cuándo hacer ese giro (buscando la mínima distancia horizontal o vertical).
  async fitBy1(
	nextPieceIn: any,
	b: any, 
	a_text: string, 
	b_text: string, 
	diecutting: number, 
	set: boolean, 
	rotate: boolean, 
	turn: boolean, 
	near: boolean,
	format: string) {
    
    // console.log('->> fitBy1 pieza entrada:');
    // console.log(nextPieceIn);
    // console.log(b);
    
    let aIn = null;
    let next_a = null;
    let next_a_aux = null;
    
    if (nextPieceIn && nextPieceIn.length > 0) {
		
		// Pieza actual que se quiere colocar.
		aIn = JSON.parse(JSON.stringify(nextPieceIn[0]));;
		
		// console.log(' --> fitBy1 pieza actual:');
		// console.log(aIn);
		
		// Próxima pieza que se supone que irá después de la actual.
		if (nextPieceIn[1]) {
			
			next_a = JSON.parse(JSON.stringify(nextPieceIn[1]));
		
			next_a_aux = JSON.parse(JSON.stringify(next_a));
			
			if (next_a.draw_w) {
		        // console.log(' --> fitBy1: Próxima pieza con columnas internas: ' + next_a_aux.draw_w);
		    	next_a_aux.piece_width = next_a_aux.piece_width * next_a.draw_w;
		    } 
		    if (next_a.draw_h) {
		        // console.log(' --> fitBy1: Próxima pieza con filas internas: ' + next_a_aux.draw_h);
		        next_a_aux.piece_height = next_a_aux.piece_height * next_a.draw_h;
		    }
		 } // End If nextPieceIn[1].
		
		// console.log(' --> fitBy1 próxima pieza:');
		// console.log(next_a);
	}
	
    let a = null;
    
    // Si no hay pieza de entrada se devuelve directamente "false".
    if (aIn === undefined || aIn === null) {
      // console.log(' --> fitBy1: La pieza de entrada tiene valor nulo.');
      return null;
    }
    
    if (aIn.piece_cut) {
        // console.log(' --> fitBy1: La pieza ya ha sido colocada antes:');
        // console.log(a);
        // console.log(' --> fitBy1: No se intenta colocar en el marco vacío:');
        // console.log(b);
    	return null;
    }
    
    a = aIn;
    
    let promise_in_fit = new Promise(async (resolve, reject) => {
      // console.log('->> Inicio Promesa de fitBy1:');

      // Se hace una copia de la variable de la pieza.
      let a_aux = JSON.parse(JSON.stringify(a));
      
        let set_w = 1;
	    let set_h = 1;
	    
	    // Si tiene piezas internas se tiene en cuenta su distribución
	    // de filas y columnas para tener en cuenta la dimensión total del marco.
	    if (a_aux.draw_w) {
	        // console.log(' --> fitBy1: Pieza con columnas internas: ' + a_aux.draw_w);
	    	set_w = a_aux.piece_width * a.draw_w;
	    	a_aux.piece_width = set_w;
	    } 
	    if (a_aux.draw_h) {
	        // console.log(' --> fitBy1: Pieza con filas internas: ' + a_aux.draw_h);
	        set_h = a_aux.piece_height * a.draw_h;
	        a_aux.piece_height = set_h;
	        
	    } // */
	    
	    // console.log(' --> fitBy1 aux --> ' + set_w + ' x ' + set_h);
    	// console.log(a_aux);
      
      let result = 0;

      let a_width_text = a_text + 'width';
      let a_height_text = a_text + 'height';
      let b_width_text = b_text + 'width';
      let b_height_text = b_text + 'height';
      let rotation_text = a_text + 'rotation';
      
      let area_a = a_aux[a_width_text] * a_aux[a_height_text];
      let area_b = b[b_width_text] * b[b_height_text];

      let width_ko = false;
      let height_ko = false;
	  /*
	  // NOTA: Se comentan estas líneas porque hace que en ocasiones se pierda rendimiento.
	  // Si en el sobrante de la altura no cabe la siguiente pieza,
	  // entonces se ve si girando cabría al lado, y si es así ya se gira.
	  if (next_a && (b[b_height_text] - a_aux[a_height_text] < next_a_aux[a_height_text])) {
		  
		  if ((b[b_width_text] - a_aux[a_height_text] >= next_a_aux[a_width_text]) ||
		  	  (b[b_width_text] - a_aux[a_height_text] >= next_a_aux[a_height_text])) {
			
			// Se le da la vuelta si es posible y cabe en esa posición girada.
			if (a_aux[a_width_text] <= b[b_height_text]) {
				console.log(' --> Si giramos igual la siguiente cabe mejor.');
				
				// NOTA: De momento sólo se va a girar si la pieza es única, no forma un bloque de dos o más.
				if ((!a_aux.draw_w || !a_aux.draw_h ||
					(a_aux.draw_w && a_aux.draw_h && a_aux.draw_w === 1 && a_aux.draw_h === 1))) {
					
					//if (a_aux[a_height_text] < a_aux[a_width_text]) {
						console.log(' --> Se gira para acomodar la pieza siguinte.');
						console.log(b);
						console.log(a);
						console.log(next_a_aux);
						
						this.turnPiece(a_aux, a_width_text, a_height_text, rotation_text);
					//}
				}
				
			}
		  }
	  } // End If next_a. */

      // Si el resultado es negativo quiere decir que la pieza A no cabe en B.
      // El resultado de la resta indica cuánto sobra despúes de colocar A dentro de B.
      result = area_b - area_a;

      // Si cabe por área comprobamos que quepa por el ancho y por el alto.
      if (result < 0) {
		// console.log(' --> La pieza no cabe porque tiene un área mayor que el de la zona donde quiere colocarse.');
        resolve(null); // return null;
        return; // Se sale de la función.
      } // End If result
      
      // Indica si la pieza tratada es la última de un grupo de la optimización.
      let last_piece = false;
      
      if (this.max_die_cutting < a_aux[a_width_text]) {
        // console.log(' --> La pieza no cabe porque su anchura supera el máximo de travera.');
        // NOTA: Si es una "pieza maestra" entonces hay que intentar reducirla de dimensiones
        // quitando piezas internas para formar otra "pieza maestra" nueva con ellas.
        width_ko = true;
      }
      
      if (b[b_width_text] - a_aux[a_width_text] < diecutting && b[b_width_text] - a_aux[a_width_text] !== 0) {
        // console.log(' --> La pieza no cabe por anchura en su posición inicial.');
        // if (b[b_height_text] - a_aux[a_width_text] < diecutting && b[b_height_text] - a_aux[a_width_text] !== 0) {
          // console.log(' -> La pieza A tiene un ancho que no cabe en B en ninguna orientación: ' + a_aux.piece_num + ' ;Trav = ' + b.name);
          width_ko = true;
          // resolve(null);
          // return;
        // }
      }

      if (b[b_height_text] - a_aux[a_height_text] < diecutting && b[b_height_text] - a_aux[a_height_text] !== 0) {
        // console.log(' --> La pieza no cabe por altura en su posición inicial.');
        	// console.log(' b.width = ' + b[b_width_text]);
	        // console.log(' b.height = ' + b[b_height_text]);
	        // console.log(' a.width = ' + a[a_width_text]);
	        // console.log(' a.height = ' + a[a_height_text]);
	        
        // if (b[b_width_text] - a_aux[a_height_text] < diecutting && b[b_width_text] - a_aux[a_height_text] !== 0) {
          // console.log(' -> La pieza A tiene un alto que no cabe en B en ninguna orientación:' + a_aux.piece_num + ' ;Trav = ' + b.name);
          height_ko = true;
          // resolve(null);
          // return;
        // }
      }
      
      // NOTA: Aunque haya cabido, si es la última pieza de la optimización entonces
      // siempre se va a intentar colocarla con su lado más corto como base.
      // console.log(' --> ancho hoja menos desbande:');
      // console.log(this.nextSheet.width - this.nextSheet.disband.right);
      // console.log(' --> origen x travera + ancho pieza:');
      // console.log(b[b_width_text] + b.origin_x + this.nextSheet.disband.left);
      // console.log(' --> origen y travera: ' + b.origin_y);
      // console.log(this.nextSheet.disband.top);
      
      // IMPORTARTE: GIRAR cuando la pieza es la última dentro de un retal de cola.
      
      // Sólo se girará la pieza si es única (o no es un bloque con dos o más piezas agrupadas).
      // Se averigua si es la última pieza de uno de los grupos de optimización.
      last_piece = (this.nextSheet && nextPieceIn.length === 1 &&
      	  a_aux[a_height_text] < a_aux[a_width_text] &&
      	  b.origin_y === this.nextSheet.disband.top &&
      	  b[b_width_text] + b.origin_x + this.nextSheet.disband.left === this.nextSheet.width - this.nextSheet.disband.right)
			&& (!a_aux.draw_w || !a_aux.draw_h ||
				(a_aux.draw_w && a_aux.draw_h && a_aux.draw_w === 1 && a_aux.draw_h === 1));
			
	  // if (last_piece) {
		// console.log(' --> fitBy1 última pieza de grupo encontrada en un retal de cola:');
		// console.log(a_aux);
	  // }
	  
	  let original_fit_ok = false;
	  
	  if (!height_ko && !width_ko) original_fit_ok = true;
	  
      // Si en la primera comprobación no cabe por alto o por ancho,
      // se gira para ver si así podría caber.
      // Si es la última pieza también se intenta girar para tratar
      // de obtener un "retal de cola" más grande.
      if (height_ko || width_ko || last_piece) {
		
		// if (last_piece) {
		// 	console.log(' --> La pieza se intenta girar por ser la última en un retal de cola.');
		// }

        this.turnPiece(a_aux, a_width_text, a_height_text, rotation_text);

        width_ko = false;
        height_ko = false;

        // Se hace una segunda comprobación por si cabe ahora que se ha girado.
        
        if (this.max_die_cutting < a_aux[a_width_text]) {
	        // console.log(' --> La pieza no cabe porque su anchura tras girarla supera el máximo de travera.');
	        width_ko = true;
		}
		
		  if (b[b_width_text] - a_aux[a_width_text] < diecutting && b[b_width_text] - a_aux[a_width_text] !== 0) {
	        // console.log(' --> La pieza no cabe por anchura en su posición girada.');
	        // console.log(' b.width = ' + b[b_width_text]);
	        // console.log(' b.height = ' + b[b_height_text]);
	        // console.log(' a_aux.width = ' + a_aux[a_width_text]);
	        // console.log(' a_aux.height = ' + a_aux[a_height_text]);
	        // console.log(' a.width = ' + a[a_width_text]);
	        // console.log(' a.height = ' + a[a_height_text]);
	        // console.log(' w_aux = ' + w_aux);
	        // console.log(' h_aux = ' + h_aux);
	        
	          width_ko = true;
	      }
	
	      if (b[b_height_text] - a_aux[a_height_text] < diecutting && b[b_height_text] - a_aux[a_height_text] !== 0) {
	        // console.log(' --> La pieza no cabe por altura en su posición girada.');
	          height_ko = true;
	      }
      }
      
      // Si se ha conseguido hacer caber la pieza en alguna de sus orientaciones.
      if (!height_ko && !width_ko) {

        // console.log('->> Final Promesa de fitBy1 a_aux:');
      	// console.log(a_aux);
      	resolve(JSON.parse(JSON.stringify(a_aux)));

      } else if (original_fit_ok) {
		
		// Se vuelve girar poner la pieza en su posición inicial si en ella cabía.
		this.turnPiece(a_aux, a_width_text, a_height_text, rotation_text);
        
        resolve(JSON.parse(JSON.stringify(a_aux)));
		
	  }
	  else {
		
        // console.log(' --> La pieza A:');
        // console.log(aIn);
        // console.log(' --> no cabe en marco B:');
        // console.log(b);
        // console.log('Diferencia de areas (negativo indica pieza más grande que marco) = ' + result);
        resolve(null);
      }
      
    }); // End new promise_in_fit

	// Resultado final devuelto por fitBy1.
    return promise_in_fit.then((fit: any): PieceToEasel => {
      // console.log('->> fitBy1 promise_in_fit:');
      // console.log(fit);
      
      // Resultado devuelto tras resolver la creación (new) de la promesa promise_in_fit.
      return fit;
    });

  } // End function fitBy1
  
  // --------
  // Función quue intenta encajar una pieza de la mejor forma posible dentro
  // de alguna travera vacía de todas las disponibles en ese momento.
  fitPiece(
	nextPieceIn: any,
	b: any, 
	a_text: string, 
	b_text: string, 
	diecutting: number, 
	set: boolean, 
	rotate: boolean, 
	turn: boolean, 
	near: boolean,
	format: string) {
    
    // console.log('->> fitPiece pieza entrada:');
    // console.log(nextPieceIn);
    // console.log(b);
    
    let aIn = null;
    let next_a = null;
    let next_a_aux = null;
    
    if (nextPieceIn && nextPieceIn.length > 0) {
		
		// Pieza actual que se quiere colocar.
		aIn = JSON.parse(JSON.stringify(nextPieceIn[0]));;
		
		// console.log(' --> fitPiece pieza actual:');
		// console.log(aIn);
		
		// Próxima pieza que se supone que irá después de la actual.
		if (nextPieceIn[1]) {
			
			next_a = JSON.parse(JSON.stringify(nextPieceIn[1]));
		
			next_a_aux = JSON.parse(JSON.stringify(next_a));
			
			if (next_a.draw_w) {
		        // console.log(' --> fitPiece: Próxima pieza con columnas internas: ' + next_a_aux.draw_w);
		    	next_a_aux.piece_width = next_a_aux.piece_width * next_a.draw_w;
		    } 
		    if (next_a.draw_h) {
		        // console.log(' --> fitPiece: Próxima pieza con filas internas: ' + next_a_aux.draw_h);
		        next_a_aux.piece_height = next_a_aux.piece_height * next_a.draw_h;
		    }
		 } // End If nextPieceIn[1].
		
		// console.log(' --> fitPiece próxima pieza:');
		// console.log(next_a);
	}
	
    let a = null;
    
    // Si no hay pieza de entrada se devuelve directamente "false".
    if (aIn === undefined || aIn === null) {
      // console.log(' --> fitPiece: La pieza de entrada tiene valor nulo.');
      return null;
    }
    
    if (aIn.piece_cut) {
        // console.log(' --> fitPiece: La pieza ya ha sido colocada antes:');
        // console.log(a);
        // console.log(' --> fitPiece: No se intenta colocar en el marco vacío:');
        // console.log(b);
    	return null;
    }
    
    a = aIn;
    
    let promise_in_fit = new Promise(async (resolve, reject) => {
      // console.log('->> Inicio Promesa de fitPiece:');

      // Se hace una copia de la variable de la pieza.
      let a_aux = JSON.parse(JSON.stringify(a));
      
      let set_w = 1;
      let set_h = 1;
    
       // IMPORTANTE: Si es un bloque se va a tratar como un único elemento
      // que tiene como ancho y alto la suma de las medidas de sus piezas.
    
      // Si tiene piezas internas se tiene en cuenta su distribución
      // de filas y columnas para tener en cuenta la dimensión total del marco.
      if (a_aux.draw_w) {
        // console.log(' --> fitPiece: Pieza con columnas internas: ' + a_aux.draw_w);
    	set_w = a_aux.piece_width * a.draw_w;
    	a_aux.piece_width = set_w;
      } 
      if (a_aux.draw_h) {
        // console.log(' --> fitPiece: Pieza con filas internas: ' + a_aux.draw_h);
        set_h = a_aux.piece_height * a.draw_h;
        a_aux.piece_height = set_h;
        
      }
    
      // console.log(' --> fitPiece aux --> ' + set_w + ' x ' + set_h);
	  // console.log(a_aux);
      
      let result = 0;

      let a_width_text = a_text + 'width';
      let a_height_text = a_text + 'height';
      let b_width_text = b_text + 'width';
      let b_height_text = b_text + 'height';
      let rotation_text = a_text + 'rotation';
      
      let area_a = a_aux[a_width_text] * a_aux[a_height_text];
      let area_b = b[b_width_text] * b[b_height_text];

      let width_ko = false;
      let height_ko = false;
	  
      // Si el resultado es negativo quiere decir que la pieza A no cabe en B.
      // El resultado de la resta indica cuánto sobra despúes de colocar A dentro de B.
      result = area_b - area_a;

      if (result < 0) {
		// console.log(' --> La pieza no cabe porque tiene un área mayor que el de la zona donde quiere colocarse.');
        resolve(null); // return null;
        return; // Se sale de la función.
      } // End If result
      
      if (this.max_die_cutting < a_aux[a_width_text]) {
        // console.log(' --> La pieza no cabe porque su anchura supera el máximo de travera.');
        // NOTA: Si es una "pieza maestra" entonces hay que intentar reducirla de dimensiones
        // quitando piezas internas para formar otra "pieza maestra" nueva con ellas.
        width_ko = true;
      }
      
      
      // Si cabe por área comprobamos que quepa por el ancho y por el alto.
      if (b[b_width_text] - a_aux[a_width_text] < diecutting && b[b_width_text] - a_aux[a_width_text] !== 0) {
        // console.log(' --> La pieza no cabe por anchura en su posición inicial.');
        width_ko = true;
      }

      if (b[b_height_text] - a_aux[a_height_text] < diecutting && b[b_height_text] - a_aux[a_height_text] !== 0) {
        // console.log(' --> La pieza no cabe por altura en su posición inicial.');  
        height_ko = true;
      }
      
	  let original_fit_ok = false;
	  
	  if (!height_ko && !width_ko) original_fit_ok = true;
	  
      // Si en la primera comprobación no cabe por alto o por ancho,
      // se gira para ver si así podría caber.
      const oefRotationLocked = a_aux && a_aux.piece_oef_lock_rotation === true;
      if ((height_ko || width_ko) && !oefRotationLocked) {

        this.turnPiece(a_aux, a_width_text, a_height_text, rotation_text);

        width_ko = false;
        height_ko = false;

        // Se hace una segunda comprobación por si cabe ahora que se ha girado.
        
        if (this.max_die_cutting < a_aux[a_width_text]) {
	        // console.log(' --> La pieza no cabe porque su anchura tras girarla supera el máximo de travera.');
	        width_ko = true;
		}
		
		  if (b[b_width_text] - a_aux[a_width_text] < diecutting && b[b_width_text] - a_aux[a_width_text] !== 0) {
	        // console.log(' --> La pieza no cabe por anchura en su posición girada.');
	        // console.log(' b.width = ' + b[b_width_text]);
	        // console.log(' b.height = ' + b[b_height_text]);
	        // console.log(' a_aux.width = ' + a_aux[a_width_text]);
	        // console.log(' a_aux.height = ' + a_aux[a_height_text]);
	        // console.log(' a.width = ' + a[a_width_text]);
	        // console.log(' a.height = ' + a[a_height_text]);
	        // console.log(' w_aux = ' + w_aux);
	        // console.log(' h_aux = ' + h_aux);
	        
	          width_ko = true;
	      }
	
	      if (b[b_height_text] - a_aux[a_height_text] < diecutting && b[b_height_text] - a_aux[a_height_text] !== 0) {
	        // console.log(' --> La pieza no cabe por altura en su posición girada.');
	          height_ko = true;
	      }
      } // End If height_ko || width_ko.
      
      // Si se ha conseguido hacer caber la pieza en alguna de sus orientaciones.
      if (!height_ko && !width_ko) {

        // console.log('->> Final Promesa de fitBy1 a_aux:');
      	// console.log(a_aux);
      	resolve(JSON.parse(JSON.stringify(a_aux)));

      } else if (original_fit_ok) {
		
		// Se vuelve girar poner la pieza en su posición inicial si en ella cabía.
		this.turnPiece(a_aux, a_width_text, a_height_text, rotation_text);
        
        resolve(JSON.parse(JSON.stringify(a_aux)));
		
	  }
	  else {
		
        // console.log(' --> La pieza A:');
        // console.log(aIn);
        // console.log(' --> no cabe en marco B:');
        // console.log(b);
        // console.log('Diferencia de areas (negativo indica pieza más grande que marco) = ' + result);
        resolve(null);
      }
      
    }); // End new promise_in_fit

	// Resultado final devuelto por fitPiece.
    return promise_in_fit.then((fit: any): PieceToEasel => {
      // console.log('->> fitPiece promise_in_fit:');
      // console.log(fit);
      
      // Resultado devuelto tras resolver la creación (new) de la promesa promise_in_fit.
      return fit;
    });

  } // End function fitPiece.
  
  // --------
  
  // Función que gira una pieza.
  turnPiece(piece: any, width_text, height_text, rotation_text) {
	
	// console.log('-> Ejecutando función turnPiece:' + rotation_text);
	// console.log(piece);
	// console.log(width_text);
	// console.log(height_text);
	
	let w_aux = piece[width_text];
    let h_aux = piece[height_text];
    piece[width_text] = h_aux;
    piece[height_text] = w_aux;

  	if (piece[rotation_text] === 0 || piece[rotation_text] === 180) {
        // Se pone un + delante para forzar que sea numérico y no haya error de malinterpretación.
    	piece[rotation_text] = +90;
          
    } else {
    	piece[rotation_text] = +0;
    }
    
    return piece;

  } // End function turnPiece.

  // Función para la ordenación elementos teniendo en cuenta su área.
  // Se pasa como parámetros el nombre de los campos de los elementos del array que se van
  // a usar para hacer las comparaciones.
  orderByArea(arrayIn: any[], width_text: string, height_text: string, invert: boolean) {

    // console.log(' --> -> orderByArea entrada: ' + width_text + ' x ' + height_text + ' mm');
    // console.log(arrayIn);

    // Area: Es menor el elemento cuya multiplicación de "ancho x alto" sea más pequeña.

    // Premisa: el "ancho" será siempre el primer parámetro y el "alto" el segundo
    // (ancho x alto x largo ==> línea horizontal x línea vertical x línea de profundidad).

    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (a === null || a === undefined) {
        return -1;
      }

      if (b === null || b === undefined) {
        return 1;
      }

      let a_area = a[width_text] * a[height_text];
      let b_area = b[width_text] * b[height_text];

      // console.log('--> a = ' + a[width_text] + ' x ' + a[height_text] + ' = ' + a_area);
      // console.log('--> b = ' + b[width_text] + ' x ' + b[height_text] + ' = ' + b_area);

      if (a_area < b_area) {

        // console.log('--> A < B.');
        compare = -1;
      } else if (a_area > b_area) {

        // console.log('--> A > B.');
        compare = 1;
      } else {

        // console.log('--> A y B tienen el mismo area.');
        compare = 0; // Son iguales.
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByArea
  
  orderByLast(arrayIn: any[], width_text: string, height_text: string, invert: boolean) {

    // console.log(' --> -> orderByLast entrada: ' + width_text + ' x ' + height_text + ' mm');
    // console.log(arrayIn);

    // Area: Es menor el elemento cuya multiplicación de "ancho x alto" sea más pequeña.

    // Premisa: el "ancho" será siempre el primer parámetro y el "alto" el segundo
    // (ancho x alto x largo ==> línea horizontal x línea vertical x línea de profundidad).

    let resultList = arrayIn.sort((a, b) => {

      let compare = 0;

      if (a === null || a === undefined) {
        return -1;
      }

      if (b === null || b === undefined) {
        return 1;
      }

      let a_area = a[width_text] * a[height_text];
      let b_area = b[width_text] * b[height_text];

      // console.log('--> a = ' + a[width_text] + ' x ' + a[height_text] + ' = ' + a_area);
      // console.log('--> b = ' + b[width_text] + ' x ' + b[height_text] + ' = ' + b_area);

      if (a_area < b_area) {

        // console.log('--> A < B.');
        compare = -1;
      } else if (a_area > b_area) {

        // console.log('--> A > B.');
        compare = 1;
      } else {

        // console.log('--> A y B tienen el mismo area.');
        compare = 0; // Son iguales.
      }

      return compare;
    });

    // Se devuelve la ordenación invertida si así se ha solicitado.
    if (invert) {
      return resultList.reverse();
    } else {
      return resultList;
    }

  } // End function orderByLast

  // ---------------------------------
  //  FUNCIONES DE CARGA PARA PRUEBAS
  // ---------------------------------

  // ----------
  //  PLANCHAS
  // ----------
  createSheetList(listSheetIn: any): Sheet[] {

    console.log('--> createSheetList initialSheetList:');
    // console.log(JSON.parse(JSON.stringify(listSheetIn)));

    let cloneList = JSON.parse(JSON.stringify(listSheetIn));

    let initialList = [];

    // Se inicializa el contador de hojas.
    this.sheet_count = 1;
    // Se inicializa el contador de traveras.
    this.traverse_count = 0;
    // Se inicializa el contador de piezas.
    this.piece_count = 0;
    // Se inicializa el contador de retales.
    this.retal_count = 0;

    cloneList.forEach((sheet, index) => {
		
	  if (!sheet) {
		console.log ('-> Hoja a NULL.');
		
		// Se devuelve el listado como estuviese en hasta ese momento.
		return initialList;
	  }
	
      // Se introduce un elemento hoja por cada una de las "unidades" de la línea leída en el archivo.

      let num_sheet = 0;

      if (sheet['unit']) {
        num_sheet = Number(sheet['unit']);
      }

      let disband_aux = {
        left: sheet['disband_l'] ? Number(sheet['disband_l']) : 0,
        bottom: sheet['disband_b'] ? Number(sheet['disband_b']) : 0,
        right: sheet['disband_r'] ? Number(sheet['disband_r']) : 0,
        top: sheet['disband_t'] ? Number(sheet['disband_t']) : 0,
      }

      if (num_sheet >= 0) {

        for (let i = 1; i <= num_sheet; i++) {

          // console.log('->> Sumando hoja contada:' + this.sheet_count);

          initialList.push({
            id: this.sheet_count,
            mat_id: sheet['mat_id'] ? Number(sheet['mat_id']) : null,
            mat_name: sheet['mat_name'] ? sheet['mat_name'] : null,
            mat_desc: sheet['mat_desc'] ? sheet['mat_desc'] : null,
            retal: sheet['retal'] === 'true' ? true : false,
            barcode: sheet['barcode'] ? sheet['barcode'] : null,
            width: sheet['width'] ? Number(sheet['width']) : null,
            height: sheet['height'] ? Number(sheet['height']) : null,
            depth: sheet['depth'] ? Number(sheet['depth']) : null,
            weight: sheet['weight'] ? Number(sheet['weight']) : null,
            unit: 1,
            side: sheet['side'] ? sheet['side'] : null,
            id_process: sheet['id_process'] ? sheet['id_process'] : null,
            lager: sheet['lager'] ? sheet['lager'] : null,
            location: sheet['location'] ? sheet['location'] : null,
            reference: sheet['reference'] ? sheet['reference'] : null,
            disband: disband_aux,
            diecutting: sheet['diecutting'] ? Number(sheet['diecutting']) : null,
            max_diecutting: sheet['max_diecutting'] ? Number(sheet['max_diecutting']) : null,
            draws: [],
            used: false,
          });

          // Se incrementa el contador de hojas existentes.
          this.sheet_count++;
        }
      } else if ( num_sheet === -1) { // IMPORTANTE: Para planchas infinitas se usa el número "-1" (no cero).

        console.log('->> Sumando hoja infinita:' + this.sheet_count);

        // NOTA: Si el número de unidades es "-1" querrá
        // decir que se quiere disponer de "infinitas" planchas.
        initialList.push({
          id: this.sheet_count,
          mat_id: sheet['mat_id'] ? Number(sheet['mat_id']) : null,
          mat_name: sheet['mat_name'] ? sheet['mat_name'] : null,
          mat_desc: sheet['mat_desc'] ? sheet['mat_desc'] : null,
          retal: sheet['retal'] === 'true' ? true : false,
          barcode: sheet['barcode'] ? sheet['barcode'] : null,
          width: sheet['width'] ? Number(sheet['width']) : null,
          height: sheet['height'] ? Number(sheet['height']) : null,
          depth: sheet['depth'] ? Number(sheet['depth']) : null,
          weight: sheet['weight'] ? Number(sheet['weight']) : null,
          unit: -1,
          side: sheet['side'] ? sheet['side'] : null,
          id_process: sheet['id_process'] ? sheet['id_process'] : null,
          lager: sheet['lager'] ? sheet['lager'] : null,
          location: sheet['location'] ? sheet['location'] : null,
          reference: sheet['reference'] ? sheet['reference'] : null,
          disband: disband_aux,
          diecutting: sheet['diecutting'] ? Number(sheet['diecutting']) : null,
          max_diecutting: sheet['max_diecutting'] ? Number(sheet['max_diecutting']) : null,
          draws: [],
          used: false,
        });

        this.sheet_count++;

      } // End If num_sheet
    });

    // Se ordenan las hojas por dimensiones. Si se pasa el segundo parámetro a true se inviertá el orden.
    // initialList = this.orderBy2Dimensions(initialList, 'max_width', 'max_height', false);

    // Se asigna la lista a la variable que controla el contenido de la cola de planchas.
    this.setSheetList(initialList);

    // Sacamos la siguiente plancha para usar en la máquina.
    this.getNextSheet();

    // console.log('--> createSheetList initialList result:');
    // console.log(JSON.parse(JSON.stringify(initialList)));

    return initialList;

  } // End function createSheetList


  // -------------------------
  //  FUNCIONES DE APILACIÓN
  // -------------------------

  // ----------
  //  PLANCHAS
  // ----------

  setSheetList(listIn: Sheet[]) {
    console.log('--> OptiFunction: setSheetList = ');
    // console.log(listIn);

    this.sheetList = listIn;
    
    this.max_sheet_width = 0;
    this.max_sheet_height = 0;
    
    this.sheetList.forEach(s => {
		
		if (s.width > this.max_sheet_width) this.max_sheet_width = s.width;
		if (s.height > this.max_sheet_height) this.max_sheet_height = s.height;
	});
	
	// Se coloca la medida más larga como ancho de la hoja.
	if (this.max_sheet_height > this.max_sheet_width) {
		let aux = this.max_sheet_width;
		this.max_sheet_width = this.max_sheet_height;
		this.max_sheet_height = aux;
	}
		
	// console.log('--> setSheetList max_sheet_width = ' + this.max_sheet_width);
	// console.log('--> setSheetList max_sheet_height = ' + this.max_sheet_height);
	
    this.oldTraverseList = [];

  } // End function setSheetList

  getSheetList(): Sheet[] {
    console.log('--> OptiFunction: getSheetList = ');
    // console.log(this.sheetList);

    return this.sheetList;

  } // End function getSheetList

  getNextSheet(): Sheet {
    // console.log('--> OptiFunction: getNextSheet = ');

    let sheet = null;

    // if (this.sheetList && this.sheetList.length > 0) {
    //   sheet = this.sheetList.pop();

    // } else {
    //   console.log('--> OptiFunction: nextSheet: NO quedan planchas en el listado para colocar en máquina.');
    // }

    if (this.sheetList && this.sheetList.length > 0) {

      // IMPORTANTE: Aquí habrá que definir seguramente un sistema de selección más concreto.
      // Ahora mismo elige la primera hoja que encuentra que no esté usada.
      sheet = this.sheetList.find(item => {

        // console.log('-> Plancha:');
        // console.log(item);

        if (!item.used && item.unit > 0) {
		  
          return true;
          
        } else if (item.unit === -1 ) {

          // console.log('-> Encontrada Plancha infinita.');
          return true;
        }

        return false;
      });

    } else {
      console.log('--> OptiFunction: nextSheet: NO quedan planchas en el listado para colocar en máquina.');
    }

    // console.log('-> nextSheet: --> Plancha sheet obtenida:');
    // console.log(sheet);

    // Duplicamos hoja.
    if (sheet && sheet.unit === -1 ) {

      // console.log('-> Añadiendo plancha infinita:');

      let sheet_infinite = JSON.parse(JSON.stringify(sheet));

      sheet_infinite.unit = 1;
      // Se asigna el id a la nueva plancha.
      sheet_infinite.id = this.sheetList.length + 1; // this.sheet_count;

      this.sheetList.push(sheet_infinite);

      // Se incrimenta el contador de planchas.
      this.sheet_count++;

      this.nextSheet = sheet_infinite;

      // console.log('-> Añadida plancha infinita: ' + this.sheetList.length);
      // console.log(JSON.stringify(this.sheetList));

    } else if (sheet) {
		
        this.nextSheet = sheet;
        
        // console.log(' La próxima plancha seleccionada.');
        // console.log(this.nextSheet);
    } else {
		// console.log(' La próxima plancha aparece vacía...');
		// console.log(sheet);
		
		this.finalSheet = JSON.parse(JSON.stringify(this.nextSheet));
		this.nextSheet = null;
	}

    // console.log(this.nextSheet);

    return this.nextSheet;

  } // End function getNextSheet

  // ----------
  //  TRAVERAS
  // ----------

  setTraverseList(listIn: Traverse[]) {
    console.log('--> OptiFunction setTraverseList = ');
    console.log(listIn);

    this.traverseList = listIn;

  } // End function setTraverseList

  getTraverseList(): Traverse[] {
    console.log('--> OptiFunction getTraverseList = ');
    console.log(this.traverseList);

    return this.traverseList;

  } // End function getTraverseList

  // Función que añade la travera inicial equivalente a la plancha nueva colocada en mesa.
  // El segundo parámetro indica el eje y el tercero indica el desbande si existiese.
  addSheetTraverse(
		sheetIn: Sheet, 
		axisIn: string, 
		disbandIn: Disband | null, 
		diecuttingIn: number | null, 
		maxDiecuttingIn: number | null, 
		useOld: boolean,
		useBlocks: boolean
	) {
		
	// console.log('-> Ejecutando addSheetTraverse...');
    // console.log('--> OptiFunction addSheetTraverse = ' + axisIn);
    // console.log('--> addSheetTraverse nextPiece = ' + this.nextPiece.length);
    // console.log(JSON.parse(JSON.stringify(this.nextPiece)));
    // console.log('--> addSheetTraverse maxDiecuttingIn = ' + maxDiecuttingIn);
    // console.log('--> addSheetTraverse useBlocks = ' + useBlocks);

    this.useOldTraverses = useOld;
    
    this.useBlocks = useBlocks;

    this.traverse_count++;

    // Si no es la primera hoja que se carga en la máquina habrá que guardar la información de la anterior.
    if (this.traverseList && this.traverseList.length > 0) {

      // Añadimos al dibujo actual los puntos necesarios de los retales que han sobrado (traveras no usadas).
      let retalList = this.traverseList.filter(t_new => {

        // Si la travera no está usada y no es antigua.
        if (!t_new.used) { // && !t_new.old) {

          // Sólo se añade si no existe ya una con el mismo id. Además debe cumplir que
          // sea capaz de poder albergar la pieza más pequeña de la optimización (de nada
          // sirve tener en cuenta esa travera si no cumple esa condición mínima).
          if (this.useOldTraverses && !this.oldTraverseList.find(t_old => t_new.id === t_old.id)) {

            // console.log('*> Añadida travera al listado de "traveras antiguas".');

            // Se marca la travera como antigua.
            t_new.old = true;
            
            this.oldTraverseList.push(t_new);
          }

          return true;
        }

        return false;
      });

      this.nextSheet.used = true;

      // Cogemos cada travera y la incluímos en las traveras de la plancha de la que proviene,
      // para que luego sea dibujada esa hoja correctamente. La hoja no tiene por qué ser la actual
      // (que sería nextSheet), si no que puede ser una "antigua".
      retalList.forEach(t => {

        // console.log('*> Asignando RETAL a plancha: ' + t.id);
        // console.log(t);

        let sheetdrawn = this.sheetList.find(sheet => sheet.id === t.sheet_id);

        // console.log('*> Plancha: ');
        // console.log(sheetdrawn);

        if (sheetdrawn && !sheetdrawn.traverses) {
          sheetdrawn['traverses'] = [];
        }

        // Sólo se añade si no existe ya una con el mismo id.
        if (sheetdrawn && !sheetdrawn.traverses.find(item => t.id === item.id)) {
			
		  if (t.width > 0 && t.height > 0) {
			
				// console.log('-> Se añade retal a la hoja ' + sheetdrawn.id);
				sheetdrawn.traverses.push(t);
			}
        }

      }); // Fin For retalList */
      
      // Cogemos cada pieza y la incluímos en la plancha de la que proviene, que no tiene por qué
      // ser la actual (nextSheet) ya que pueden ser piezas colocadas en traveras "pasadas".
      this.pieceList.forEach(p => {

        let sheetdrawn = this.sheetList.find(sheet => sheet.id === p.sheet_id);

        // console.log('*> Asignando PIEZA a su plancha:');
        // console.log(p);

        if (sheetdrawn && !sheetdrawn.pieces) {
          sheetdrawn['pieces'] = [];
        }

        if (sheetdrawn && p.piece && !sheetdrawn.pieces.find(item => p.piece.piece_num === item.piece.piece_num)) {

          // Indicamos en la pieza que si no corresponde a la hoja actual quiere decir
          // que se ha colocado en una "hoja pasada", por lo que hay que actualizar el
          // valor del caballete al que va a ir esa pieza, que será el "caballete auxiliar".
          // p.piece.easel_num = 0; // El valor 0 indica que es un caballete auxiliar.
          // p.piece.easel_id = -1;
          // p.piece.easel_name = 'Auxiliar';
          // p.piece.piece_group = 'AUX'; // Si fuese necesario un grupo exclusivo para el caballete auxiliar.
          // p.piece.piece_cut = true;

          sheetdrawn.pieces.push(p);

        }

        // console.log(sheetdrawn.pieces);

      }); // Fin For pieceList */

      // this.nextSheet.traverses = retalList;
      // this.nextSheet.pieces = JSON.parse(JSON.stringify(this.pieceList));
      this.pieceList = [];
    }

    // Se inicializan las variables que van guardando los puntos de origen de las piezas y traveras.
    this.piece_draw = [];
    this.traverse_draw = [];

    // Se escoje la siguiente plancha candidata
    this.getNextSheet();

    // console.log('->> Se ha escogido la siguiente plancha de entre las candidatas:');
    // console.log(this.nextSheet);

    // Si se ha encontrado una hoja para cargar en el máquina.
    if (this.nextSheet) {
      // Se coloca el contador de travera a 1 para representar la travera total de la hoja completa cargada.
      // this.traverse_count = 1;
      this.disband = disbandIn;
      this.min_die_cutting = diecuttingIn;
      this.max_die_cutting = maxDiecuttingIn;
      this.axis = axisIn;

      let id = this.traverse_count;

      let traverse_width = this.nextSheet.width;
      let traverse_height = this.nextSheet.height;
      let traverse_depth = this.nextSheet.depth;

      // Se ajusta el ancho y alto de la travera según el desbande existente.
      if (disbandIn && disbandIn.left > 0) {
        traverse_width -= disbandIn.left;
      }
      if (disbandIn && disbandIn.right > 0) {
        traverse_width -= disbandIn.right;
      }
      if (disbandIn && disbandIn.bottom > 0) {
        traverse_height -= disbandIn.bottom;
      }
      if (disbandIn && disbandIn.top > 0) {
        traverse_height -= disbandIn.top;
      }
      
      let coordinates = [];
	      
      	// Coordenada esquina superior izquierda.
		coordinates.push({x: 0, y: 0});
		// Coordenada esquina inferior izquierda.
		coordinates.push({x: 0, y: traverse_height});
		// Coordenada esquina inferior derecha.
		coordinates.push({x: traverse_width, y: traverse_height});
		// Coordenada esquina superior derecha.
		coordinates.push({x: traverse_width, y: 0});

      let new_traverse = {
        id: id,
        sheet_id: this.nextSheet.id,
        sheet_width: this.nextSheet.width,
        sheet_height: this.nextSheet.height,
        name: 'T' + axisIn + '' + id,
        axis: axisIn,
        width: traverse_width,
        height: traverse_height,
        depth: traverse_depth,
        piece: null,
        father: 0,
        used: false,
        diecutting: diecuttingIn,
        max_diecutting: maxDiecuttingIn,
        disband: disbandIn,
        origin_x: 0, // Valor origen en el eje X.
        origin_y: 0, // Valor origen en el eje Y.
        draw: null,
        old: false,
        level: 0,
        level_h: 0,
        points: coordinates
      };

      // Se vacía la lista de traveras.
      this.traverseList = [];

      this.traverseList.push(new_traverse);

    } /* else { // NO hacen falta realmente estas líneas.
		
	  console.log('->> Se vacía la lista de traveras para indicar que ya no hay ninguna donde poder trabajar.');
		
      // Se vacía la lista de traveras (nuevas y antiguas) para indicar que ya no hay ninguna donde poder trabajar.
      this.traverseList = [];
      this.oldTraverseList = [];
    } */

  } // End function addSheetTraverse

  // Función que guarda en la hoja actual la información gráfica que haya recogida en ese momento para ella.
  saveSheet() {
    console.log('--> OptiFunction saveSheet = ');
    // console.log(this.nextSheet);
    // console.log(this.finalSheet);

    if (!this.nextSheet && !this.finalSheet) {
      return;
    }
    
    // Si existe una hoja que fue detectada como la "última" usada
    // entonces se asigna como la hoja actual de trabajo a "guardar",
    // que es la última con información conocida aún sin grabar.
    if (this.finalSheet) this.nextSheet = this.finalSheet;

    if (this.nextSheet.traverses &&
        this.nextSheet.traverses.length === 1 &&
        this.nextSheet.traverses[0].origin_x === 0 &&
        this.nextSheet.traverses[0].origin_y === 0) {

        console.log('--> Encontrada una hoja vacía.');
    } else if (this.nextSheet.traverses && this.nextSheet.traverses.length !== 1) {

      // Si no es la primera hoja que se carga en la máquina habrá que guardar la información de la anterior.
      if (this.traverseList && this.traverseList.length > 0) {

        // Añadimos al dibujo actual los puntos necesarios de los retales que han sobrado (traveras no usadas).
        let retalList = this.traverseList.filter(item => !item.used); // && !item.old);

		// console.log('*> Asignando RETALES a su plancha:');
        // console.log(retalList);
          
        this.nextSheet.traverses = retalList;

        this.pieceList.forEach(p => {

          let sheetdrawn = this.sheetList.find(sheet => sheet.id === p.sheet_id);

          // console.log('*> Asignando PIEZA a su plancha:');
          // console.log(p);

          if (sheetdrawn && !sheetdrawn.pieces) {
            sheetdrawn['pieces'] = [];
          }

          if (sheetdrawn && p.piece && !sheetdrawn.pieces.find(item => p.piece.piece_num === item.piece.piece_num)) {

            // Indicamos en la pieza que si no corresponde a la hoja actual quiere decir
            // que se ha colocado en una "hoja pasada", por lo que hay que actualizar el
            // valor del caballete al que va a ir esa pieza, que será el "caballete auxiliar".
            // p.piece.easel_num = 0; // El valor 0 indica que es un caballete auxiliar.
            // p.piece.easel_id = -1;
            // p.piece.easel_name = 'Auxiliar';
            // p.piece.piece_group = 'AUX'; // Si fuese necesario un grupo exclusivo para el caballete auxiliar.
            // p.piece.piece_cut = true;

            sheetdrawn.pieces.push(p);

          }
        });
        // this.nextSheet.pieces =  JSON.parse(JSON.stringify(this.pieceList));

        this.pieceList = [];
      }
    } // End IF no es una hoja vacía.

    if (this.nextSheet && this.nextSheet.pieces && this.nextSheet.pieces.length > 0) {
      this.nextSheet.used = true;
    }

  	// console.log('-> -> * Grabando traveras antiguas oldTraverseList:');
    // console.log(this.oldTraverseList);

    if (this.useOldTraverses && this.oldTraverseList && this.oldTraverseList.length > 0) {

      // Añadimos al dibujo actual los puntos necesarios de los retales que han sobrado (traveras no usadas).
      let oldRetalList = this.oldTraverseList.filter(item => !item.used);

	  // console.log('-> -> * Grabando oldRetalList:');
      // console.log(oldRetalList);
    
      oldRetalList.forEach(t => {
		
        let sheetdrawn = this.sheetList.find(sheet => sheet.id === t.sheet_id);

        // console.log('*> Plancha sheetdrawn:');
        // console.log(sheetdrawn);

        if (sheetdrawn && !sheetdrawn.traverses) {
          sheetdrawn['traverses'] = [];
        }
		let same_retal = sheetdrawn.traverses.find(item => t.id === item.id);
		
        // Sólo se añade si no existe ya una con el mismo id.
        if (sheetdrawn && !same_retal) {
		  
          if (t.width > 0 && t.height > 0) sheetdrawn.traverses.push(t);
          
        } // else {
		  // console.log('*> Encontrado retal con mismo id:');
		  // console.log(t);
		  // console.log(same_retal);
		// }
      }); // Fin For oldRetalList

      // Una vez asignadas las traveras antiguas a sus correspondientes hojas, se vacía su listado.
      this.oldTraverseList = [];
    }

    // Se inicializan las variables que van guardando los puntos de origen de las piezas y traveras.
    this.piece_draw = [];
    this.traverse_draw = [];

    // Se vacía la lista de traveras.
    this.traverseList = [];

  } // End function saveSheet

  // Es la función llamada desde "file-list.component.js" mediante un await.
  // Lo hace de forma recursiva mientras devuelva "true" (continúa cortando).
  async cutPieceInTraverse(axisIn: string,
                           diecuttingIn: number,
                           maxDiecuttingIn: number,
                           setIn: boolean,
                           rotateIn: boolean,
                           turnIn: boolean,
                           nearIn: boolean,
                           retalWidthIn: number,
                           retalHeightIn: number,
                           exportType: string,
                           maxLevelIn: any) {
    // console.log('--> OptiFunction cutPieceInTraverse. maxDiecuttingIn = ' + maxDiecuttingIn);
    // console.log('--> Tipo de exportación: ' + exportType);
	// console.log(maxLevelIn);
	
	if (maxLevelIn) {
		maxLevelIn = Number(maxLevelIn);
	} else {
		// console.log('--> No se ha especificado profundidad de corte. Se pone infinita.');
		maxLevelIn = this.infinite_level;
	}
	
	this.max_depth_level = maxLevelIn;
	
    // Se asignan las medidas para el retal mínimo en esta colocación de pieza.
    // IMPORTANTE: Hay que pasar los parámetro a números porque al venir de un formulario html aparecen como cadenas.
    this.retal_width = Number(retalWidthIn);
    this.retal_height = Number(retalHeightIn);
    this.max_die_cutting = Number(maxDiecuttingIn);

    let fit_piece = null;
    let new_traverse_A = null;
    let new_traverse_B = null;
    let new_traverse_C = null;
    let piece_exact = false;

    let promese_piece_exist = null;

    // Se recoge la siguiente pieza de la lista de piezas y se asigna como "siguiente pieza a tratar".
    // El resultdo es un listado de piezas candidatas, concretamente una para cada uno de los grupos existentes.
    promese_piece_exist = await this.getNextPieceList(this.last_piece).then(async function(pieces_cut: PieceToEasel[]) {

                // console.log('->> pieces_cut data => ');
                // console.log(pieces_cut);

                // return pieces_cut.filter( pz => !pz.piece_cut);
                return pieces_cut;
              });

    // console.log('->> promese_piece_exist: ');
    // console.log(promese_piece_exist);

    let total_count_T = 0;
    let continue_cut_count = 0;

    let traverse_exist = false;
    let old_traverse_exist = false;

    // Para almacenar todas las promesas que se vayan lanzando.
    let promises_list = [];
    let old_promises_list = [];

    // ---------
    // ---------

	// this.oldTraverseList = this.orderByXorigin(this.oldTraverseList, 'origin_x', 'origin_y', false);
	
    // Se filtra y se quitan las traveras antiguas que hayan podido ser usadas.
    this.oldTraverseList = this.oldTraverseList.filter(t => !t.used);
    
    fit_piece = null;
    new_traverse_A = null;
    new_traverse_B = null;
    new_traverse_C = null;
    piece_exact = false;
      
    // while (this.oldTraverseList.length > old_count_T && !old_traverse_exist) {
    for (let old_count_T = 0;
		 this.oldTraverseList.length > old_count_T
		 && !fit_piece
		 && !old_traverse_exist;
    	 //&& total_count_T < this.oldTraverseIterator;
		 old_count_T++) {

      total_count_T++;
      
      let traverse = this.oldTraverseList[old_count_T];
      
      let retal_ok = false;
      
      // if ((traverse.width >= this.piece_min.w && traverse.height >= this.piece_min.h) ||
		//   (traverse.width >= this.piece_min.h && traverse.height >= this.piece_min.w)) {
	  if (this.min_area <= traverse.width * traverse.height) {	
          retal_ok = true;
	  }//   else {
		//   console.log('*> Encontrado retal inservible. Demasiado pequeño para ser usado.');
		//   console.log(traverse);
	  // }
      
      let promise_in = null;
      
      if (retal_ok) { // promises_list.length < this.oldPromeseItertor) {

	      promise_in = new Promise(async (resolve, reject) => {
	        // console.log('->> cutPieceInTraverse: oldTraverseList inicio Promesa de setPieceInTraverse.');
	        
	        let addon_piece = null;
	        
	        let big_retal = true;
		        
	        if(traverse && this.nextPiece && this.nextPiece.length > 0 && 
			   ((traverse.width < this.nextPiece[0].piece_width && traverse.height < this.nextPiece[0].piece_width) ||
	           (traverse.width < this.nextPiece[0].piece_height && traverse.height < this.nextPiece[0].piece_height))
	        ) {
				// console.log('->> cutPieceInTraverse: oldTraverseList travera diminuta');
				big_retal = false;
			}
	        
	        if (big_retal && this.nextPiece && this.nextPiece.length > 0 && !fit_piece) {
				
			        if (this.useBlocks) {
						// console.log('->> cutPieceInTraverse: oldTraverseList useBlocks = ' + this.useBlocks);
						addon_piece = this.templateMatrixPiece(
							this.nextPiece[0], // this.breakBlock(this.nextPiece[0]), 
							traverse.width, 
							traverse.height,
							this.max_die_cutting,
							this.min_die_cutting
						);
					}
					
					this.globalCount++;
					
					try {
					
				        [fit_piece, new_traverse_A, new_traverse_B, new_traverse_C, piece_exact] = await this.setPieceInTraverse(
				          traverse,
				          this.nextPiece,
				          this.last_piece,
				          axisIn,
				          diecuttingIn,
				          setIn,
				          rotateIn,
				          turnIn,
				          nearIn,
				          exportType,
				          maxLevelIn,
				          this.globalCount);
			          
					} catch (reject_exit) {
						console.log('->> oldTraverseList setPieceInTraverse error try reject 1.');
					}
					
			}//  else {
				// console.log('->> oldTraverseList setPieceInTraverse reject 2.');
				// return reject();
			// }
	        // console.log('->> Final Promesa de setPieceInTraverse:');
	        resolve({ traverse: traverse,
					  piece: fit_piece,
					  addon_piece: addon_piece,
					  TA: new_traverse_A,
					  TB: new_traverse_B,
					  TC: new_traverse_C,
					  exact: piece_exact });
	      }).catch((error) => {
	        console.error('->> Error en cutPieceInTraverse promise_in:');
	        console.error(error);
	      });
	      
	      old_promises_list.push(promise_in);

	      promise_in.then((response) => {
	        // console.log('->> Respuesta de setPieceInTraverse travera antigua:');
	        // console.log(response);
	
	        // Se añaden las nuevas traveras creadas si es el caso.
	        if (response['exist'] || response['TA'] || response['TB'] || response['TC']) {
	          old_traverse_exist = true;
	        }
	
	        return old_traverse_exist;
	
	      }).catch((error) => {
	        console.log('->> Error en cutPieceInTraverse travera antigua:');
	        console.log(error);
	      });
	  } // End If retal_ok. // promises_list.length
	  
	  if (old_traverse_exist) {
		console.log('->> Salida del FOR oldTraverseList por break. globalCount = ' + this.globalCount);
		break;
	  }  
    } // End For oldTraverseList.

    // ---------
    
    // IMPORTANTE: Para poder usar las funciones de la clase dentro de declaraciones de funciones internas de promesas.
    let that = this;
    
    let continue_cut = false;
    
    let traverse_selected = null;
    
    // console.log(' -> Comienza la Promise.all old_promises_list:');

	// NOTA: Este es el resultado de vuelta final de la función cutPieceInTraverse.
	// Será "true" si se tiene que seguir continuando con la optimización, y "false" si
	// ha ocurrido algún evento que haga que ya no se pueda/necesite continuar con ella.
    return Promise.all(old_promises_list).then(async function(result_all_old) {
    // console.log(' -> Todos los marcos resultantes old_promises_list:');
    // console.log(result_all_old);

    // continue_cut_count++;
     
    // console.log('->> cutPieceInTraverse: continue_cut_count++ = ' + continue_cut_count);
    
	let traverse_old_list = result_all_old.filter(p => p && p.traverse && p.traverse.old === true);
	
	// De entre todas se coge el marco más antiguo (hoja con menos ID)
	// y que tenga el origen más cercano al origen de la hoja.
	traverse_old_list = that.orderTravByXorigin(traverse_old_list, 'origin_x', 'origin_y', false);
	
	// console.log(' -> Marcos ordenados por antigüedad:');
    // console.log(traverse_old_list);
	
	// Intentar buscar primero en los marcos antiguos.
	if (traverse_old_list.length > 0) {
		
		// console.log('->> Inspeccionando traveras antiguas = ' + traverse_old_list.length);
		
		if (!traverse_selected) {
			
			traverse_selected = traverse_old_list.find(item => {

	        if (item['traverse'] && !item['traverse'].used && item['piece']) { // Da errores al dibujar
              // console.log('> Retal antiguo encontrado para encajar la pieza:');
	          // console.log(item);
	          
	          return true;
		      
	        }
			return false;
	     });  
			
		}
       /*
           if (!traverse_selected) {
       		traverse_selected = traverse_old_list.find(item => {

		        if (item['TA'] && !item['TB'] && !item['TC']) {
				// if (item['traverse'] && !item['traverse'].used && item['piece']) { // Da errores al dibujar
	              // console.log('> 1 - Marco antiguo encontrado para encajar la pieza:');
		          // console.log(item);
		          
		          return true;
			      
		        }
				return false;
		     });       
       	 } // End If traverse_selected.
       	 
       	 if (!traverse_selected) {
       		traverse_selected = traverse_old_list.find(item => {

		        if (item['TA'] && item['TB'] && !item['TC']) {
	              // console.log('> 2 - Marco antiguo encontrado para encajar la pieza:');
		          // console.log(item);
		          
		          return true;
			      
		        }
				return false;
		     });       
       	 } // End If traverse_selected. */
    } // End If traverse_old_list.

     // NOTA: Es una colección de datos con información, no es una travera en sí solamente.
     // La travera principal de la colección está en el campo "traverse_selected.traverse".
     // console.log('--> cutPieceInTraverse traverse_selected = ');
     // console.log(traverse_selected);

     let fit_piece = null;
     let addon_piece = null;

     // Se usa la travera y se añaden las posible traveras resultantes del corte de la pieza.
     // Se incrementa el contador de traveras cada vez que se añada una.
     if (traverse_selected) { // && !traverse_selected['exact']) {
		
		  // console.log('--> La pieza se va a encajar en una travera antigua:');
		  // console.log(traverse_selected);	
	      
	      let traverse_list_aux = that.oldTraverseList;
	
	      fit_piece = traverse_selected.piece;
	      addon_piece = traverse_selected.addon_piece;
	      
	      // Se añade a la lista de "piezas candidatas" la pieza sobrante
	      // asociada a la pieza que se ha seleccionado para encajar.
	      if (addon_piece) {
			that.nextPiece.push(addon_piece);
		  }
	
	      // Se almacena en el "dibujo" el punto origen dónde se usó la travera, que
	      // coincidirá con el punto origen de la pieza que se ha cortado dentro de ella.
	      // that.piece_draw.push({ x: traverse_selected.traverse.origin_x, y: traverse_selected.traverse.origin_y} );
	      continue_cut = true;
	
	      if (traverse_selected['TA']) {
	        // console.log('--> nueva travera creada A = ');
	        traverse_list_aux.push(traverse_selected['TA']);
	        // traverse_selected['TA'].piece = null;
	        that.traverse_count++;
	      }
	
	      if (traverse_selected['TB']) {
	        // console.log('--> nueva travera creada B = ');
	        traverse_list_aux.push(traverse_selected['TB']);
	        // traverse_selected['TB'].piece = null;
	        that.traverse_count++;
	      }
	
	      if (traverse_selected['TC']) {
	        // console.log('--> nueva travera creada C = ');
	        traverse_list_aux.push(traverse_selected['TC']);
	        // traverse_selected['TC'].piece = null;
	        that.traverse_count++;
	      }
     } else if (!traverse_selected) {
        // Si no se encuentra en las traveras antiguas entonces se pasa a buscar en las actuales.
        // ---------

        // La pieza candidata ya se ha probado en todos los retales anteriores.
        // Si estamos ante una plancha nueva, la variante de anticipación puede
        // adelantar una serie repetida para que ambas compartan travera.
        that.prioritizeSharedStripAtSheetStart();

	    // IMPORTANTE CÓDIGO: NO sirve así si queremos luego usar "break".
	    //this.traverseList.forEach(traverse => {
	
		// this.traverseList = this.orderByXorigin(this.traverseList, 'origin_x', 'origin_y', false);
	
	    // En cuanto se encuentre una travera donde quepa la pieza se sale del bucle para no continuar buscando.
	    // NOTA: Hay que incluir en la lista de traveras las traveras no usadas en las hojas anteriores. Estas
	    // piezas son las que se colocarán después en el "caballete extra" exclusivo para tal fin.
	    
	    fit_piece = null;
	    new_traverse_A = null;
	    new_traverse_B = null;
	    new_traverse_C = null;
	    piece_exact = false;
	      
	    //while (this.traverseList.length > count_T && !traverse_exist) {
	    for (let count_T = 0;
			 that.traverseList.length > count_T
			 && !fit_piece
			 && !traverse_exist;
			 // && total_count_T < that.traverseIterator;
			 count_T++) {
	
	      total_count_T++;
	      
	      // console.log('-> traverseList total_count_T = ' + total_count_T);
	
	      let traverse = that.traverseList[count_T];
	
	      let promise_in = null;
	
		  // if (promises_list.length < that.promeseItertor) {
			
		      promise_in = new Promise(async (resolve, reject) => {
		        // console.log('->> cutPieceInTraverse: traverseList inicio Promesa de setPieceInTraverse.');
		        
		        let addon_piece = null;
		        
		        let bigger_retal = true;
		        
		        if(traverse && that.nextPiece && that.nextPiece.length > 0 && 
				   ((traverse.width < that.nextPiece[0].piece_width && traverse.height < that.nextPiece[0].piece_width) ||
		           (traverse.width < that.nextPiece[0].piece_height && traverse.height < that.nextPiece[0].piece_height))
		        ) {
					// console.log('->> cutPieceInTraverse: travera diminuta');
					bigger_retal = false;
				}
		        
		        if (bigger_retal && that.nextPiece && that.nextPiece.length > 0 && !fit_piece) {
					
				        if (that.useBlocks) {
							// console.log('->> cutPieceInTraverse: traverseList useBlocks = ' + that.useBlocks);
							addon_piece = that.templateMatrixPiece(
								that.nextPiece[0], // that.breakBlock(this.nextPiece[0]), // 
								traverse.width, 
								traverse.height,
								that.max_die_cutting,
								that.min_die_cutting
							);
						}
						
						that.globalCount++;
						try {
							
						
					        [fit_piece, new_traverse_A, new_traverse_B, new_traverse_C, piece_exact] = await that.setPieceInTraverse(
					          traverse,
					          that.nextPiece,
					          that.last_piece,
					          axisIn,
					          diecuttingIn,
					          setIn,
					          rotateIn,
					          turnIn,
					          nearIn,
					          exportType,
					          maxLevelIn,
					          that.globalCount);
				        } catch (reject_exit) {
							console.log('->> traverseList setPieceInTraverse error try reject 3.');
						} 
				          // if (fit_piece && (!new_traverse_A && !new_traverse_B && !new_traverse_C)) {
				             // console.log('_>> Encontrada pieza que encaja justa.');
				          // }
				} // else {
					// console.log('->> No hay nextPiece traverseList:');
					// console.log(that.nextPiece);
					
					// return reject();
				// }
				
		        // console.log('->> Final Promesa de setPieceInTraverse:');
		        resolve({ traverse: traverse,
						  piece: fit_piece,
						  addon_piece: addon_piece,
						  TA: new_traverse_A,
						  TB: new_traverse_B,
						  TC: new_traverse_C,
						  exact: piece_exact });
				
		      }); // End promesa promise_in.
		      
		      promises_list.push(promise_in);
	
		      promise_in.then((response) => {
		        // console.log('->> Respuesta de setPieceInTraverse:');
		        // console.log(response);
		
		        // Se añaden las nuevas traveras creadas si es el caso.
		        if (response['piece'] && (response['exist'] || response['TA'] || response['TB'] || response['TC'])) {
		          traverse_exist = true;
		        }
		
		        return traverse_exist;
		
		      }).catch((error) => {
		        console.error('->> Error en cutPieceInTraverse:');
		        console.error(error);
		      });
		  // } // End If promises_list.length
		  
		  if (traverse_exist) {
			console.log('->> Salida del FOR traverseList por break. globalCount = ' + that.globalCount);

			break;
		  }  
		  
	    } // End For traverseList.
        
          
        // -----------
        
        return Promise.all(promises_list).then(async function(result_all) {
		    // console.log(' -> Todos los marcos resultantes promises_list:' + result_all.length);
		    // console.log(result_all);
		
		    // continue_cut_count++;
		     
		    // console.log('->> cutPieceInTraverse: continue_cut_count++ = ' + continue_cut_count);
		    
			let traverse_list = result_all.filter(p => p.traverse.old === false);
			
			// De entre todas se coge el marco más antiguo (hoja con menos ID)
			// y que tenga el origen más cercano al origen de la hoja.
			traverse_list = that.orderTravByXorigin(traverse_list, 'origin_x', 'origin_y', false);
	        
	        // ----------
	        
	        // Intentar buscar primero en los marcos antiguos.
	
			traverse_selected = that.selectBestTraverseFit(traverse_list);
	       	 
	       	 // Se usa la travera y se añaden las posible traveras resultantes del corte de la pieza.
		     // NOTA: Si es "exacta" no hay que añadir traveras/retales resultantes.
		     // Se incrementa el contador de traveras cada vez que se añada una.
		     if (traverse_selected) {
				
			  // console.log('--> La pieza se va a encajar en una travera nueva:');
			  // console.log(traverse_selected);
		      
		      let traverse_list_aux = that.traverseList;
		
		      fit_piece = traverse_selected.piece;
		      addon_piece = traverse_selected.addon_piece;
		      
		      // Se añade a la lista de "piezas candidatas" la pieza sobrante
		      // asociada a la pieza que se ha seleccionado para encajar.
		      if (addon_piece) {
				that.nextPiece.push(addon_piece);
			  }
		
		      // Se almacena en el "dibujo" el punto origen dónde se usó la travera, que
		      // coincidirá con el punto origen de la pieza que se ha cortado dentro de ella.
		      // that.piece_draw.push({ x: traverse_selected.traverse.origin_x, y: traverse_selected.traverse.origin_y} );
		      continue_cut = true;
		      
		      // TA: es el retal que sale arriba.
		      // TB: es el retal que sale a la derecha.
		      if (traverse_selected['TA']) {
		        // console.log('--> nueva travera creada A = ');
		        traverse_list_aux.push(traverse_selected['TA']);
		        // traverse_selected['TA'].piece = null;
		        that.traverse_count++;
		      }
		      
		      if (traverse_selected['TB']) {
		        // console.log('--> nueva travera creada B = ');
		        traverse_list_aux.push(traverse_selected['TB']);
		        // traverse_selected['TB'].piece = null;
		        that.traverse_count++;
		      }
		      
		      if (traverse_selected['TC']) {
		        // console.log('--> nueva travera creada C = ');
		        traverse_list_aux.push(traverse_selected['TC']);
		        // traverse_selected['TC'].piece = null;
		        that.traverse_count++;
		      }
		     } // End IF traverse_selected
		     
		     // Si NO se ha encontrado travera donde encajar la pieza entonces sacamos la siguiente plancha para usar en la máquina.
		     // NOTA: Hay que comprobar también que exista alguna pieza en el listado de "próximas candidatas". Si no hay más piezas
		     // no hace falta sacar más planchas. Si no se hace esta última comprobación pintará todas planchas restantes vacías.
		     if (!continue_cut) { // && continue_cut_count < that.continueCutLimit) {
		
				// IMPORTANTE: Se debería ver si hay una siguiente próxima pieza candidata a colocar
				// antes de sacar una nueva plancha, si no se dejarán muchas planchas sin aprovechar bien
				// (aunque luego realmente se supone que cuando se va a colocar una pieza mira también en
				// los retales vacíos de planchas anteriores... por lo que no debería importar sacar la plancha).

				// console.log('->> cutPieceInTraverse: Pieza no encaja en las que hay. Nueva plancha. ');
				
				// console.log(continue_cut_count);
				// console.log(that.continueCutLimit);
				
		        // NOTA: Antes de incluir la nueva plancha debemos guardar la información necesaria que nos va a hacer falta
		        // después sobre la antigua plancha ya gastada donde no caben ninguna de las posibles siguientes piezas que tocan.
		        // (básicamente los puntos de origen de las traveras y piezas, que hay que incluirlos a los "dibujos" de la hoja).
		
		        if (that.nextSheet) {
					
				  // console.log('-> cutPieceInTraverse nextSheet = ');
				  // console.log(that.nextSheet);
				  
				  if (that.nextPiece[0]) {
					
					  if (!that.currentPiece['c_' + that.nextPiece[0].piece_id])
				  		that.currentPiece['c_' + that.nextPiece[0].piece_id] = 0;
	
					  that.currentPiece['c_' + that.nextPiece[0].piece_id]++;
					  
					  if (that.currentPiece['c_' + that.nextPiece[0].piece_id] > that.null_sheet_limit) {
						
						console.log('-> Se han sacado hojas muchas veces para la misma pieza. Se aborta la optimización.');
						console.log(that.currentPiece);
						
						continue_cut = false;
				  	
						// Salimos directamente de la función. No se continúa la optimización.
						return continue_cut;
						
					  }
					  
				  } else {
					
					  if (!that.currentPiece['c_null']) that.currentPiece['c_null'] = 0;
						  that.currentPiece['c_null']++;
						  
						  if (that.currentPiece['c_null'] > that.null_sheet_limit) {
						
							console.log('-> Pieza nula muchas veces obtenida. Se aborta la optimización.');
							console.log(that.currentPiece);
							
							continue_cut = false;
					  	
							// Salimos directamente de la función. No se continúa la optimización.
							return continue_cut;
					  }
				  }
				  
		      	  that.addSheetTraverse(
					that.nextSheet,
					that.axis,
					that.disband,
					that.min_die_cutting,
					that.max_die_cutting,
					that.useOldTraverses,
					that.useBlocks
				  );
				  
		          // NOTA: Hay que volver a incluir las piezas en el listado para que vuelvan
		          // a ser tenidas en cuenta al no haberse podido colocar en esta iteración.
		
		          // Se usa la función unshift para incluir la pieza al principio del array.
		          // console.log('->> Se incluye nuevamente en el listado las piezas que no han cabido.');
		          // that.nextPiece.forEach( item => {
		          //   that.pieceInfoList['g_' + item.piece_group].unshift(item);
		          // });
		          
				  // Se indica que se puede seguir con la optimización.
		          continue_cut = true;
		          
		          continue_cut_count++;
		          
		        } else {
		          console.log('->> cutPieceInTraverse: NO queda plancha que cargar en la máquina.');
		
		          // console.log('->> Se incluye nuevamente en el listado de "piezas pendientes" las piezas para las que no se ha encontrado hoja.');
		          // that.nextPiece.forEach( item => {
		          //   that.pieceInfoList['g_' + item.piece_group].unshift(item);
		          // });
		
		          // Se indica que se NO se va a poder seguir con la optimización.
		          continue_cut = false;
		        }
		          
		      } else {
		
		        // console.log('->> cutPieceInTraverse: Se ha encontrado travera para la pieza.');
		
		        // ----------------
		        //  ORDEN TRAVERAS
		        // ----------------
		        // IMPORTANTE: La ordenación de las travera influye luego a la hora de escoger cuál será la siguiente a usar.
		
		        // Ordenación por DEFECTO con buenos resultados.
		        // that.traverseList = that.orderBy2Dimensions(that.traverseList, 'width', 'height', true);
		        // that.oldTraverseList = that.orderBy2Dimensions(that.oldTraverseList, 'width', 'height', true);
		        
		        // A) Se ordena la lista de traveras para que la que tenga el ancho más pequeño se revise antes en la próxima asignación de pieza.
		        // that.traverseList = that.orderByArea(that.traverseList, 'width', 'height', false);
		        // that.orderBy2Dimensions(that.traverseList, 'width', 'height', true); // Coloca las piezas en "serpiente".
		
		        // B) Se ordena la lista de traveras para que fuera creada primero (un "id" menor) se revise antes.
		        // that.orderById(that.traverseList, false); // Coloca en escalón desde la derecha de la hoja.
		        // that.orderById(that.traverseList, true); // Coloca en escalón desde la izquierda de la hoja.
		
		        // C) Ordenación por Ajuste de Pieza.
		        // that.traverseList = that.orderByPieceAjust(fit_piece, that.traverseList, 'width', 'height', true);
		        // that.oldTraverseList = that.orderByPieceAjust(fit_piece, that.oldTraverseList, 'width', 'height', true);
		        
		        // D) Ordenar para escoger la travera más cercana al origen de la hoja.
		        // that.traverseList = that.orderByXorigin(that.traverseList, 'origin_x', 'origin_y', false);
		        // that.oldTraverseList = that.orderByXorigin(that.oldTraverseList, 'origin_x', 'origin_y', false);
		
		        // -----------------------
		
		        // Indicamos que la pieza ha sido colocada para el corte,
		        // pero sólo si sus piezas internas ya han sido también cortadas.
		        if (fit_piece) {
				// if (fit_piece.piece_set && !fit_piece.piece_set.find(pp => !pp.piece_cut)) {
		            // console.log('-> -> * Pieza con marco con todas las piezas ya cortadas:');
		            // console.log(fit_piece);
		           
		            fit_piece.piece_cut = true;
		        
			        // IMPORTANTE: Será la que coincide en grupo. Si no se ponen estas líneas
			        // seguiría poniendo piezas y piezas infinitamente (hasta acabar las planchas).
			        let aux_p = that.nextPiece.find(p => p.piece_group === fit_piece.piece_group);
			        if (aux_p) {
			          aux_p.piece_cut = true;
			        } 
		        }
		        
		        // PROBLEMA: Lugar para identificar piezas concretas problemática.
		        /* 
		        if (fit_piece.piece_width === 425 && fit_piece.piece_height === 2130) {
					console.log('->* Pieza cortada problema A:');
					console.log(fit_piece);	
					console.log(traverse_selected);	
				} // */
				
				// -------------
     
			    // Construimos los punto que definen las dimensiones de la hoja actual.
				let coordinates_aux = [];
			    
			    // Se añade ya la información de los vértices de la pieza en el gráfico
			    // de la hoja para poderla tener mientras se esté trabajando con ella y así
			    // no tener que esperar hasta que finalice la optimización de la hoja.
			    let aux_traverse = traverse_selected['traverse'];
			    that.applyPiecePlacementOverride(aux_traverse, fit_piece);
			    
			    // Coordenada esquina superior izquierda.
				coordinates_aux.push({x: aux_traverse.origin_x, y: aux_traverse.origin_y});
				// Coordenada esquina inferior izquierda.
				coordinates_aux.push({x: aux_traverse.origin_x, y: aux_traverse.origin_y + fit_piece.piece_height});
				// Coordenada esquina inferior derecha.
				coordinates_aux.push({x: aux_traverse.origin_x + fit_piece.piece_width, y: aux_traverse.origin_y + fit_piece.piece_height});
				// Coordenada esquina superior derecha.
				coordinates_aux.push({x: aux_traverse.origin_x + fit_piece.piece_width, y: aux_traverse.origin_y});
				
				// Se asignan a un nuevo campo "points"".
				fit_piece['points'] = coordinates_aux;
				
			    // -------------
		        
		        that.last_piece = JSON.parse(JSON.stringify(fit_piece));
		
		        // Se indica que se ha usado ya esa travera para no volver a utilizarla en la optimización.
		        traverse_selected['traverse'].used = true;
		
		        // Se indica la pieza que se colocó en esa travera (vendrá con sus valores volteados si hubo que girarla para encajarla).
		        traverse_selected['traverse'].piece = fit_piece;
		
		        // Se añade la pieza en la lista de piezas ya cortadas asignadas a una plancha.
		        // that.pieceList.push(that.nextPiece);
		        that.pieceList.push(traverse_selected['traverse']);
		
		        // Se eliminan las traveras ya usadas y se mergean las adyacentes,
		        // tanto de las "actuales" como de las "antiguas".
		        // Se pasa el parámetro a "false" para indicar que los retales puedan
		        // ser de cualquier tamaño (no tiene en cuenta el ancho máximo de travera).
		        // NOTA: se va a pasar a "true" porque siempre va a ser necesario controlarlo.
		        
		        // Hace falta mergear aquí también si queremos unir huecos entre colocación y colocación de piezas.
		        // if (exportType !== 'LSW') {
					
			        that.removeTraverseUsedAndMerge(true, that.max_depth_level);
			        that.removeOldTraverseUsedAndMerge(true, that.max_depth_level);
		        // }
		        
		        // IMPORTANTE: Para ajustar traveras cada vez que se coloca una pieza.
		        // Es necesario para que Lisec pueda colocar piezas en niveles altos.
		        if (that.traverseList) {
					// console.log(' -> Ajustes -> cutPieceInTraverse traverseList:' + that.nextSheet['width'] + ' x ' + that.nextSheet['height']);
		        	// console.log(that.traverseList);
		        	// console.log(' -> Ajustes -> cutPieceInTraverse pieceList:');
		        	// console.log(that.pieceList);
				
					let trav_X = [];
					
				    // Hacemos grupos según donde empieza la pieza en X.
				    if (that.pieceList) {
			              that.pieceList.forEach( p => {
				
						      let key = 'x_' + p.origin_x;
							  // Sólo las piezas que tocan la base de la hoja tienen un valor de X candidato a ser "Travera X".
							  if (p.origin_y === 0) {
					          	  if (!trav_X[key]) {
							        trav_X[key] = [];
							      }
							      
							      //trav_X['x_' + p.origin_x].push(p);
							      trav_X['x_' + p.origin_x].push(true);
				              }
						  });
			        }
			        
			        // Para ajustar los retales superiores de forma que cuadren con las traveras X principales de la hoja.
			        // NOTA: adjustRetalSheet es necesaria e importante aquí. No comentarla.
			        that.adjustRetalSheet(that.traverseList, that.nextSheet['width'], that.nextSheet['height'], trav_X, 1);
			        // TEST:
			        that.mergeRetalSheet(that.traverseList, that.nextSheet['height'], trav_X, 1);
			        that.improveRemainderAreas(
			          that.traverseList,
			          that.nextSheet['width'],
			          that.nextSheet['height'],
			          trav_X,
			          false
			        );
		        
		        } // End If that.nextSheet. // */
		
		        // Se indica que se puede seguir con la optimización.
		        continue_cut = true;
		        
		        // Se inicializa el contador de planchas que se pueden sacar seguidas sin colocar una pieza.
		        //continue_cut_count = 0;
		        
		      }  // else continue_cut.
		    
		    // -----------------
		     
			// ----------- Resultado final devuelto para cutPieceInTraverse.
			// console.log('--> Resultado final devuelto Promise.all(promises_list) = ' + continue_cut);
		    
		    return continue_cut;
	       	 
       	 }).catch((error) => {

	      console.error(' -> ERROR Promise.all(promises_list):');
	      console.error(error);
	      
	    }); // End Promise.all(promises_list).then
	    
     } // End If traverse_selected en el repaso de traveras antiguas.

	 // console.log('--> Resultado final devuelto Promise.all(old_promises_list) = ' + continue_cut);
	 
	 // -----------------------
		
     // Indicamos que la pieza ha sido colocada para el corte,
     // pero sólo si sus piezas internas ya han sido también cortadas.
     if (fit_piece) {
	 
        // console.log('-> -> * Pieza con marco con todas las piezas ya cortadas:');
        // console.log(fit_piece);
        
        // PROBLEMA: Lugar para identificar piezas concretas problemáticas.
		/*
        if (fit_piece.piece_width === 425 && fit_piece.piece_height === 2130) {
	        console.log('->* Pieza cortada problema B:');
			console.log(fit_piece);
        } // */
        
        // -------------
     
	    // Se añade ya la información de los vértices de la pieza en el gráfico
	    // de la hoja para poderla tener mientras se esté trabajando con ella y así
	    // no tener que esperar hasta que finalice la optimización de la hoja.
	    let aux_traverse = traverse_selected['traverse'];
	    that.applyPiecePlacementOverride(aux_traverse, fit_piece);
	    
	    // Construimos los punto que definen los vértices de la pieza en la hoja.
		let coordinates = [];
	    
	    // Coordenada esquina superior izquierda.
		coordinates.push({x: aux_traverse.origin_x, y: aux_traverse.origin_y});
		// Coordenada esquina inferior izquierda.
		coordinates.push({x: aux_traverse.origin_x, y: aux_traverse.origin_y + fit_piece.piece_height});
		// Coordenada esquina inferior derecha.
		coordinates.push({x: aux_traverse.origin_x + fit_piece.piece_width, y: aux_traverse.origin_y + fit_piece.piece_height});
		// Coordenada esquina superior derecha.
		coordinates.push({x: aux_traverse.origin_x + fit_piece.piece_width, y: aux_traverse.origin_y});
		
		// Se asignan a un nuevo campo "points"".
		fit_piece['points'] = coordinates;
		
		// console.log('->* Pieza añadidas coordenadas:');
		// console.log(fit_piece);
		
	    // -------------
        
        fit_piece.piece_cut = true;
        
        // IMPORTANTE: Será la que coincide en grupo. Si no se ponen estas líneas
        // seguiría poniendo piezas y piezas infinitamente (hasta acabar las planchas).
        let aux_p = that.nextPiece.find(p => p.piece_group === fit_piece.piece_group);
        if (aux_p) {
          aux_p.piece_cut = true;
        }
        
        that.last_piece = JSON.parse(JSON.stringify(fit_piece));
        
     } // End If fit_piece.
     
     // Se indica que se ha usado ya esa travera para no volver a utilizarla en la optimización.
     traverse_selected['traverse'].used = true;

     // Se indica la pieza que se colocó en esa travera (vendrá con sus valores volteados si hubo que girarla para encajarla).
     traverse_selected['traverse'].piece = fit_piece;

     // Se añade la pieza en la lista de piezas ya cortadas asignadas a una plancha.
     // that.pieceList.push(that.nextPiece);
     that.pieceList.push(traverse_selected['traverse']);

     // Se eliminan las traveras ya usadas y se mergean las adyacentes,
     // tanto de las "actuales" como de las "antiguas".
     // Se pasa el parámetro a "false" para indicar que los retales puedan
     // ser de cualquier tamaño (no tiene en cuenta el ancho máximo de travera).
     // NOTA: se va a pasar a "true" porque siempre va a ser necesario controlarlo.
    
     that.removeTraverseUsedAndMerge(true, that.max_depth_level);
     that.removeOldTraverseUsedAndMerge(true, that.max_depth_level);
     /*
     // PROBLEMA: Para ajustar traveras cada vez que se coloca una pieza.
     // No da buenos resultados (si se pone desbande superior optimiza mal).
     if (that.traverseList) {
		// console.log(' -> Ajustes -> cutPieceInTraverse traverseList:' + that.nextSheet['width'] + ' x ' + that.nextSheet['height']);
    	// console.log(that.traverseList);
    	// console.log(' -> Ajustes -> cutPieceInTraverse pieceList:');
    	// console.log(that.pieceList);
	
		let trav_X = [];
		
	    // Hacemos grupos según donde empieza la pieza en X.
	    if (that.pieceList) {
              that.pieceList.forEach( p => {
	
			      let key = 'x_' + p.origin_x;
				  // Candidatas a travera X:
				  // - piezas que tocan base, o
				  // - piezas ancladas a la izquierda (origin_x=0), aunque estén elevadas.
				  if (p.origin_y === 0 || p.origin_x === 0) {
		          	  if (!trav_X[key]) {
				        trav_X[key] = [];
				      }
				      
				      //trav_X['x_' + p.origin_x].push(p);
				      trav_X['x_' + p.origin_x].push(true);
	              }
			  });
        }
        
        // Para ajustar los retales superiores de forma que cuadren con las traveras X principales de la hoja.
        that.adjustRetalSheet(that.traverseList, that.nextSheet['width'], that.nextSheet['height'], trav_X, 1);
        that.mergeRetalSheet(that.traverseList, that.nextSheet['height'], trav_X, 1);
    
     } // End If that.nextSheet. // */

     // Se indica que se puede seguir con la optimización.
     continue_cut = true;
	
	 return continue_cut;
	 
    }).catch((error) => {

      console.error(' -> ERROR Promise.all(old_promises_list):');
      console.error(error);
      
    }); // End Promise.all(old_promises_list).then
    
     // -----------------

  } // End function cutPieceInTraverse
  
  
  // --------------------------------------- ONE SHEET
  
  // Función que guarda en la hoja actual la información gráfica que haya recogida en ese momento para ella.
  saveOneSheet() {
    console.log('--> OptiFunction saveOneSheet = ');
    console.log(this.nextSheet);
    console.log(this.finalSheet);

    if (!this.nextSheet && !this.finalSheet) {
      return;
    }
    
    // Si existe una hoja que fue detectada como la "última" usada
    // entonces se asigna como la hoja actual de trabajo a "guardar",
    // que es la última con información conocida aún sin grabar.
    if (this.finalSheet) this.nextSheet = this.finalSheet;

    if (this.nextSheet.traverses &&
        this.nextSheet.traverses.length === 1 &&
        this.nextSheet.traverses[0].origin_x === 0 &&
        this.nextSheet.traverses[0].origin_y === 0) {

        console.log('--> Encontrada una hoja vacía.');
    } else if (this.nextSheet.traverses && this.nextSheet.traverses.length !== 1) {

      // Si no es la primera hoja que se carga en la máquina habrá que guardar la información de la anterior.
      if (this.traverseList && this.traverseList.length > 0) {

        // Añadimos al dibujo actual los puntos necesarios de los retales que han sobrado (traveras no usadas).
        let retalList = this.traverseList.filter(item => !item.used); // && !item.old);

        this.nextSheet.traverses = retalList;

        this.pieceOneList.forEach(p => {

          let sheetdrawn = this.sheetList.find(sheet => sheet.id === p.sheet_id);

          // console.log('*> Asignando PIEZA a su plancha:');
          // console.log(p);

          if (sheetdrawn && !sheetdrawn.pieces) {
            sheetdrawn['pieces'] = [];
          }

          if (sheetdrawn && p.piece && !sheetdrawn.pieces.find(item => p.piece.piece_num === item.piece.piece_num)) {

            // Indicamos en la pieza que si no corresponde a la hoja actual quiere decir
            // que se ha colocado en una "hoja pasada", por lo que hay que actualizar el
            // valor del caballete al que va a ir esa pieza, que será el "caballete auxiliar".
            // p.piece.easel_num = 0; // El valor 0 indica que es un caballete auxiliar.
            // p.piece.easel_id = -1;
            // p.piece.easel_name = 'Auxiliar';
            // p.piece.piece_group = 'AUX'; // Si fuese necesario un grupo exclusivo para el caballete auxiliar.
            // p.piece.piece_cut = true;

            sheetdrawn.pieces.push(p);

          }
        });
        // this.nextSheet.pieces =  JSON.parse(JSON.stringify(this.pieceList));

        this.pieceOneList = [];
      }
    } // End IF no es una hoja vacía.

    if (this.nextSheet && this.nextSheet.pieces && this.nextSheet.pieces.length > 0) {
      this.nextSheet.used = true;
    }

  	// console.log('-> -> * Grabando traveras antiguas oldTraverseList:');
    // console.log(this.oldTraverseList);

    if (this.useOldTraverses && this.oldTraverseList && this.oldTraverseList.length > 0) {

      // Añadimos al dibujo actual los puntos necesarios de los retales que han sobrado (traveras no usadas).
      let oldRetalList = this.oldTraverseList.filter(item => !item.used);

	  // console.log('-> -> * Grabando oldRetalList:');
      // console.log(oldRetalList);
    
      oldRetalList.forEach(t => {
		
        let sheetdrawn = this.sheetList.find(sheet => sheet.id === t.sheet_id);

        // console.log('*> Plancha sheetdrawn:');
        // console.log(sheetdrawn);

        if (sheetdrawn && !sheetdrawn.traverses) {
          sheetdrawn['traverses'] = [];
        }
		let same_retal = sheetdrawn.traverses.find(item => t.id === item.id);
		
        // Sólo se añade si no existe ya una con el mismo id.
        if (sheetdrawn && !same_retal) {
		  
          if (t.width > 0 && t.height > 0) sheetdrawn.traverses.push(t);
          
        } // else {
		  // console.log('*> Encontrado retal con mismo id:');
		  // console.log(t);
		  // console.log(same_retal);
		// }
      }); // Fin For oldRetalList

      // Una vez asignadas las traveras antiguas a sus correspondientes hojas, se vacía su listado.
      this.oldTraverseList = [];
    }

    // Se inicializan las variables que van guardando los puntos de origen de las piezas y traveras.
    this.piece_draw = [];
    this.traverse_draw = [];

    // Se vacía la lista de traveras.
    this.traverseList = [];

  } // End function saveOneSheet
  
  // Función que contabiliza la información (piezas y retales) de la hoja actual.
  addOneSheetTraverse(
		sheetIn: Sheet, 
		axisIn: string, 
		disbandIn: Disband | null, 
		diecuttingIn: number | null, 
		maxDiecuttingIn: number | null, 
		useOld: boolean,
		useBlocks: boolean
	) {
		
	console.log('-> Ejecutando addOneSheetTraverse...');

    this.useOldTraverses = useOld;
    
    this.useBlocks = useBlocks;

    this.traverse_count++;

    // Si no es la primera hoja que se carga en la máquina habrá que guardar la información de la anterior.
    if (this.traverseList && this.traverseList.length > 0) {

      // Añadimos al dibujo actual los puntos necesarios de los retales que han sobrado (traveras no usadas).
      let retalList = this.traverseList.filter(t_new => {

        // Si la travera no está usada y no es antigua.
        if (!t_new.used) { // && !t_new.old) {

          // Sólo se añade si no existe ya una con el mismo id. Además debe cumplir que
          // sea capaz de poder albergar la pieza más pequeña de la optimización (de nada
          // sirve tener en cuenta esa travera si no cumple esa condición mínima).
          if (this.useOldTraverses && !this.oldTraverseList.find(t_old => t_new.id === t_old.id)) {

            // console.log('*> Añadida travera al listado de "traveras antiguas".');

            // Se marca la travera como antigua.
            t_new.old = true;
            
            this.oldTraverseList.push(t_new);
          }

          return true;
        }

        return false;
      });

      this.nextSheet.used = true;

      // Cogemos cada travera y la incluímos en las traveras de la plancha de la que proviene,
      // para que luego sea dibujada esa hoja correctamente. La hoja no tiene por qué ser la actual
      // (que sería nextSheet), si no que puede ser una "antigua".
      retalList.forEach(t => {

        // console.log('*> Asignando RETAL a plancha:');
        // console.log(t);

        let sheetdrawn = this.sheetList.find(sheet => sheet.id === t.sheet_id);

        // console.log('*> Plancha:');
        // console.log(sheetdrawn);

        if (sheetdrawn && !sheetdrawn.traverses) {
          sheetdrawn['traverses'] = [];
        }

        // Sólo se añade si no existe ya una con el mismo id.
        if (sheetdrawn && !sheetdrawn.traverses.find(item => t.id === item.id)) {
		  if (t.width > 0 && t.height > 0) sheetdrawn.traverses.push(t);
        }

      }); // Fin For retalList */

      // Cogemos cada pieza y la incluímos en la plancha de la que proviene, que no tiene por qué
      // ser la actual (nextSheet) ya que pueden ser piezas colocadas en traveras "pasadas".
      this.pieceList.forEach(p => {

        let sheetdrawn = this.sheetList.find(sheet => sheet.id === p.sheet_id);

        // console.log('*> Asignando PIEZA a su plancha:');
        // console.log(p);

        if (sheetdrawn && !sheetdrawn.pieces) {
          sheetdrawn['pieces'] = [];
        }

        if (sheetdrawn && p.piece && !sheetdrawn.pieces.find(item => p.piece.piece_num === item.piece.piece_num)) {

          // Indicamos en la pieza que si no corresponde a la hoja actual quiere decir
          // que se ha colocado en una "hoja pasada", por lo que hay que actualizar el
          // valor del caballete al que va a ir esa pieza, que será el "caballete auxiliar".
          // p.piece.easel_num = 0; // El valor 0 indica que es un caballete auxiliar.
          // p.piece.easel_id = -1;
          // p.piece.easel_name = 'Auxiliar';
          // p.piece.piece_group = 'AUX'; // Si fuese necesario un grupo exclusivo para el caballete auxiliar.
          // p.piece.piece_cut = true;

          sheetdrawn.pieces.push(p);

        }

        // console.log(sheetdrawn.pieces);

      }); // Fin For pieceList */

	  // Como las piezas que iban en la hoja ya se han
	  // contabilizado se vacía el listado que las almacenaba.
      this.pieceList = [];
      
    } else {
		
		console.log('-> addOneSheetTraverse hoja ONE cargada.');
		
		// Se carga la plancha.
    	this.getNextSheet();
		
		// Si se ha encontrado una hoja para cargar en el máquina.
	    if (this.nextSheet) {
	      // Se coloca el contador de travera a 1 para representar la travera total de la hoja completa cargada.
	      // this.traverse_count = 1;
	      this.disband = disbandIn;
	      this.min_die_cutting = diecuttingIn;
	      this.max_die_cutting = maxDiecuttingIn;
	      this.axis = axisIn;
	
	      let id = this.traverse_count;
	
	      let traverse_width = this.nextSheet.width;
	      let traverse_height = this.nextSheet.height;
	      let traverse_depth = this.nextSheet.depth;
	
	      // Se ajusta el ancho y alto de la travera según el desbande existente.
	      if (disbandIn && disbandIn.left > 0) {
	        traverse_width -= disbandIn.left;
	      }
	      if (disbandIn && disbandIn.right > 0) {
	        traverse_width -= disbandIn.right;
	      }
	      if (disbandIn && disbandIn.bottom > 0) {
	        traverse_height -= disbandIn.bottom;
	      }
	      if (disbandIn && disbandIn.top > 0) {
	        traverse_height -= disbandIn.top;
	      }
	      
	      let coordinates = [];
	      
	      	// Coordenada esquina superior izquierda.
			coordinates.push({x: 0, y: 0});
			// Coordenada esquina inferior izquierda.
			coordinates.push({x: 0, y: traverse_height});
			// Coordenada esquina inferior derecha.
			coordinates.push({x: traverse_width, y: traverse_height});
			// Coordenada esquina superior derecha.
			coordinates.push({x: traverse_width, y: 0});

	      let new_traverse = {
	        id: id,
	        sheet_id: this.nextSheet.id,
	        sheet_width: this.nextSheet.width,
	        sheet_height: this.nextSheet.height,
	        name: 'T' + axisIn + '' + id,
	        axis: axisIn,
	        width: traverse_width,
	        height: traverse_height,
	        depth: traverse_depth,
	        piece: null,
	        father: 0,
	        used: false,
	        diecutting: diecuttingIn,
	        max_diecutting: maxDiecuttingIn,
	        disband: disbandIn,
	        origin_x: 0, // Valor origen en el eje X.
	        origin_y: 0, // Valor origen en el eje Y.
	        draw: null,
	        old: false,
	        level: 0,
	        level_h: 0,
	        points: coordinates
	      };
	
	      // Se vacía la lista de traveras.
	      this.traverseList = [];
	
	      this.traverseList.push(new_traverse);
	
	    }
		
	} // End IF si es la primera hoja.

    // Se inicializan las variables que van guardando los puntos de origen de las piezas y traveras.
    this.piece_draw = [];
    this.traverse_draw = [];

  } // End function addOneSheetTraverse
  
  async getNextPieceMultiple(numListIn) {
    console.log('--> getNextPieceMultiple next_pieces:' + numListIn);

    let promise_in = new Promise((resolve, reject) => {
        // console.log('->> Inicio Promesa de getNextPieceMultiple:');

        let next_pieces = [...this.nextOnePiece];

        if (next_pieces[numListIn] && next_pieces[numListIn].length === 0) {
              
          next_pieces = this.pieceListMultiple[numListIn];
          
        } else {
          // console.log('--> getNextPieceMultiple: Ya existían piezas candidatas.');

          let next_pieces_aux = [];

          // Se quitan las piezas ya usadas del listado de candidatas.
          next_pieces.map( (pz, i) => {
            if (pz.piece_cut === true) {

              // console.log('--> getNextPieceMultiple: Detectada pieza usada. Se elimina.');
              next_pieces.splice(i, 1); // Quitamos el elemento.

              // Sacamos una pieza del mismo grupo de optimización de la pieza colocada.
              let group_piece = this.pieceListMultiple[numListIn].shift();

              if (group_piece) {
                next_pieces_aux.push(group_piece);
              }
            }
          });

          next_pieces_aux.forEach(new_p => {
            if (next_pieces.find(p => p.piece_num === new_p.piece_num)) {
              console.log('--> getNextPieceMultiple: Se ha intentado poner como candidata una pieza que ya está como tal.');
            } else {
              
			  if (new_p.piece_height > this.max_die_cutting && new_p.piece_width > this.max_die_cutting) {
              	console.log('--> getNextPieceMultiple: Se ha intentado poner una pieza que sobrepasaba el ancho máximo de travera permitido.');
              } else {
					// console.log('--> getOneNextPiece: Añadiendo pieza candidata:');
              		// console.log(new_p);
              		
                    next_pieces.push(new_p);
              }
            }
          });
        } // End next_pieces.length > 0

        if (next_pieces && next_pieces.length === 0) {
          this.end_pieces = true;
        }

        resolve(next_pieces);
      });

    // IMPORTANTE: getNextPiece al ser una función asíncrona tiene que devolver una
    // "resolución de promesa" para que pueda ser evaluada tras un "wait".
    return promise_in.then((response: PieceToEasel[]) => {
      console.log('->> Respuesta de getNextPieceMultiple:');
      console.log(response);

      // return response.filter(p => !p.piece_cut);
      return response;

    }).catch((error) => {
      console.log('->> Error en getNextPieceMultiple:');
      console.log(error);
    });

  } // End function getNextPieceMultiple.
  
  // Función que coge el listado de piezas (que está dividido en grupos de prioriadaes)
  // y las mete todas en nextOnePiece una a una, un grupo tras otro mientras los va vaciando.
  // MEJORA: Realmente ahora mismo sólo bastaría ejecutar esta función una vez (la que hace
  // la carga de piezas inicial completa) porque el resto de veces no está cargando ya nada.
  async getOneNextPiece() {
    console.log('--> getOneNextPiece next_pieces:');

    let promise_in = new Promise((resolve, reject) => {
        // console.log('->> Inicio Promesa de getOneNextPiece:');

        let next_pieces = [...this.nextOnePiece];

        if (next_pieces && next_pieces.length === 0) {
              
          // Se obtienen las siguientes piezas que se pueden sacar de cada grupo de optimización existente.
          for (let prop in this.pieceInfoList) {
          	let group_list = this.pieceInfoList[prop];
          	
          	group_list.forEach((pi, ind) => {
				
            	next_pieces.push(pi);
            	
            	console.log('--> getOneNextPiece próxima pieza escogida: ');
    			console.log(pi);
    			
            	let splice_piece = group_list.splice(ind, 1);
            	console.log('--> getOneNextPiece splice_piece: ');
    			console.log(splice_piece);
            	
            });
          } // End For pieceInfoList.
          
        } else {
          // console.log('--> getOneNextPiece: Ya existían piezas candidatas.');

          let next_pieces_aux = [];

          // Se quitan las piezas ya usadas del listado de candidatas.
          next_pieces.map( (pz, i) => {
            if (pz.piece_cut === true) {

              // console.log('--> getOneNextPiece: Detectada pieza usada. Se elimina.');
              next_pieces.splice(i, 1); // Quitamos el elemento.

              // Sacamos una pieza del mismo grupo de optimización de la pieza colocada.
              let group_piece = this.pieceInfoList[pz.piece_group].shift();

              if (group_piece) {
                next_pieces_aux.push(group_piece);
              }
            }
          });

          next_pieces_aux.forEach(new_p => {
            if (next_pieces.find(p => p.piece_num === new_p.piece_num)) {
              console.log('--> getOneNextPiece: Se ha intentado poner como candidata una pieza que ya está como tal.');
            } else {
              
			  if (new_p.piece_height > this.max_die_cutting && new_p.piece_width > this.max_die_cutting) {
              	console.log('--> getOneNextPiece: Se ha intentado poner una pieza que sobrepasaba el ancho máximo de travera permitido.');
              } else {
					// console.log('--> getOneNextPiece: Añadiendo pieza candidata:');
              		// console.log(new_p);
              		
                    next_pieces.push(new_p);
              }
            }
          });
        } // End next_pieces.length > 0

        if (next_pieces && next_pieces.length === 0) {
          this.end_pieces = true;
        }

        resolve(next_pieces);
      });

    // IMPORTANTE: getNextPiece al ser una función asíncrona tiene que devolver una
    // "resolución de promesa" para que pueda ser evaluada tras un "wait".
    return promise_in.then((response: PieceToEasel[]) => {
      console.log('->> Respuesta de getOneNextPiece:');
      console.log(response);

      // return response.filter(p => !p.piece_cut);
      return response;

    }).catch((error) => {
      console.log('->> Error en getOneNextPiece:');
      console.log(error);
    });

  } // End function getOneNextPiece
  
  // Es la función llamada desde "file-list.component.js" mediante un await.
  // Lo hace de forma recursiva mientras devuelva "true" (continúa cortando).
  async cutPieceInSheet(axisIn: string,
                           diecuttingIn: number,
                           maxDiecuttingIn: number,
                           setIn: boolean,
                           rotateIn: boolean,
                           turnIn: boolean,
                           nearIn: boolean,
                           retalWidthIn: number,
                           retalHeightIn: number,
                           exportType: string,
                           maxLevelIn: number,
                           numListIn: number) {
    console.log('--> OptiFunction cutPieceInSheet. numListIn = ' + numListIn);
    // console.log('--> Tipo de exportación: ' + exportType);

    // Se asignan las medidas para el retal mínimo en esta colocación de pieza.
    // IMPORTANTE: Hay que pasar los parámetro a números porque al venir de un formulario html aparecen como cadenas.
    this.retal_width = Number(retalWidthIn);
    this.retal_height = Number(retalHeightIn);
    this.max_die_cutting = Number(maxDiecuttingIn);

    let fit_piece = null;
    let new_traverse_A = null;
    let new_traverse_B = null;
    let new_traverse_C = null;
    let piece_exact = false;

    let promese_piece_exist = null;

    // Se recoge la siguiente pieza de la lista de piezas y se asigna como "siguiente pieza a tratar".
    // El resultdo es un listado de piezas candidatas, concretamente una lista para cada uno de los grupos existentes.
    //promese_piece_exist = await this.getOneNextPiece().then(async function(pieces_cut: PieceToEasel[]) {
	promese_piece_exist = await this.getNextPieceMultiple(numListIn).then(async function(pieces_cut: PieceToEasel[]) {
                // console.log('->> pieces_cut data => ');
                // console.log(pieces_cut);

                // return pieces_cut.filter( pz => !pz.piece_cut);
                return pieces_cut;
              });

    // console.log('->> promese_piece_exist: ');
    // console.log(promese_piece_exist);

    // Si no hay piezas candidatas.
    if (!promese_piece_exist || promese_piece_exist.length === 0) {

      console.log('->> cutPieceInSheet: No hay piezas candidatas disponibles.');
	  
	  if (!this.nextOnePiece[numListIn]) this.nextOnePiece[numListIn] = [];

    } else {
      this.nextOnePiece[numListIn] = promese_piece_exist;
    }

    console.log(' -> cutPieceInSheet nextOnePiece[numListIn]:' + numListIn);
    console.log(this.nextOnePiece[numListIn]);

    // let count_T = 0;
    // let old_count_T = 0;
    let total_count_T = 0;
    let continue_cut_count = 0;

    // let traverseListAux = [];
    // for (let traverse of this.traverseList) {
    //   traverseListAux.push(JSON.parse(JSON.stringify(traverse)));
    // }

    let traverse_exist = false;
    let old_traverse_exist = false;

    // Para almacenar todas las promesas que se vayan lanzando.
    let promises_list = [];
    let old_promises_list = [];

    // ---------
    // ---------

	// this.oldTraverseList = this.orderByXorigin(this.oldTraverseList, 'origin_x', 'origin_y', false);
	
    // Se filtra y se quitan las traveras antiguas que hayan podido ser usadas.
    this.oldTraverseList = this.oldTraverseList.filter(t => !t.used);
    
    fit_piece = null;
    new_traverse_A = null;
    new_traverse_B = null;
    new_traverse_C = null;
    piece_exact = false;
      
    // while (this.oldTraverseList.length > old_count_T && !old_traverse_exist) {
    for (let old_count_T = 0;
		 this.oldTraverseList.length > old_count_T
		 && !fit_piece
		 && !old_traverse_exist;
    	 //&& total_count_T < this.oldTraverseIterator;
		 old_count_T++) {

      total_count_T++;
      
      // console.log('-> oldTraverseList total_count_T = ' + total_count_T);

      let traverse = this.oldTraverseList[old_count_T];
      
      // console.log('--> old traverse = ' + old_count_T);
      // console.log(traverse);
      
      let retal_ok = false;
      
      // if ((traverse.width >= this.piece_min.w && traverse.height >= this.piece_min.h) ||
		//   (traverse.width >= this.piece_min.h && traverse.height >= this.piece_min.w)) {
	  if (this.min_area <= traverse.width * traverse.height) {	
          retal_ok = true;
	  }//   else {
		//   console.log('*> Encontrado retal inservible. Demasiado pequeño para ser usado.');
		//   console.log(traverse);
	  // }
      
      let promise_in = null;
      
      if (retal_ok) { // promises_list.length < this.oldPromeseItertor) {

	      promise_in = new Promise(async (resolve, reject) => {
	        // console.log('->> cutPieceInSheet: oldTraverseList inicio Promesa de setPieceInTraverse.');
	        
	        let addon_piece = null;
	        
	        if (traverse && this.nextOnePiece[numListIn] && this.nextOnePiece[numListIn].length > 0 && !fit_piece) {
					
					// Si se usa bloques hay que preparar la pieza.
			        if (this.useBlocks && this.nextOnePiece[numListIn] && this.nextOnePiece[numListIn][0]) {
						// console.log('->> cutPieceInSheet: oldTraverseList useBlocks = ' + this.useBlocks);
						addon_piece = this.templateMatrixPiece(
							this.nextOnePiece[numListIn][0], // this.breakBlock(this.nextOnePiece[numListIn][0]), 
							traverse.width, 
							traverse.height,
							this.max_die_cutting,
							this.min_die_cutting
						);
					}
					
					this.globalCount++;
					
					try {
					
				        [fit_piece, new_traverse_A, new_traverse_B, new_traverse_C, piece_exact] = await this.setPieceInTraverse(
				          traverse,
				          this.nextOnePiece[numListIn],
				          this.last_piece,
				          axisIn,
				          diecuttingIn,
				          setIn,
				          rotateIn,
				          turnIn,
				          nearIn,
				          exportType,
				          maxLevelIn,
				          this.globalCount);
			          
					} catch (reject_exit) {
						console.log('->> cutPieceInSheet oldTraverseList setPieceInTraverse error try reject 1.');
					}
					
			}//  else {
				// console.log('->> oldTraverseList setPieceInTraverse reject 2.');
				// return reject();
			// }
	        // console.log('->> Final Promesa de setPieceInTraverse:');
	        resolve({ traverse: traverse,
					  piece: fit_piece,
					  addon_piece: addon_piece,
					  TA: new_traverse_A,
					  TB: new_traverse_B,
					  TC: new_traverse_C,
					  exact: piece_exact });
	      }).catch((error) => {
	        console.error('->> Error en cutPieceInSheet promise_in:');
	        console.error(error);
	      });
	      
	      old_promises_list.push(promise_in);

	      promise_in.then((response) => {
	        // console.log('->> Respuesta de cutPieceInSheet travera antigua:');
	        // console.log(response);
	
	        // Se añaden las nuevas traveras creadas si es el caso.
	        if (response['exist'] || response['TA'] || response['TB'] || response['TC']) {
	          old_traverse_exist = true;
	        }
	
	        return old_traverse_exist;
	
	      }).catch((error) => {
	        console.log('->> cutPieceInSheet Error en cutPieceInTraverse travera antigua:');
	        console.log(error);
	      });
	  } // End If retal_ok. // promises_list.length
	  
	  if (old_traverse_exist) {
		console.log('->> cutPieceInSheet Salida del FOR oldTraverseList por break. globalCount = ' + this.globalCount);
		break;
	  }  
    } // End For oldTraverseList.

    // ---------
    
    // IMPORTANTE: Para poder usar las funciones de la clase dentro de declaraciones de funciones internas de promesas.
    let that = this;
    
    let continue_cut = false;
    
    let traverse_selected = null;
    
    // console.log(' -> Comienza la Promise.all old_promises_list:');

	// NOTA: Este es el resultado de vuelta final de la función cutPieceInSheet.
	// Será "true" si se tiene que seguir continuando con la optimización, y "false" si
	// ha ocurrido algún evento que haga que ya no se pueda/necesite continuar con ella.
    return Promise.all(old_promises_list).then(async function(result_all_old) {
    // console.log(' -> Todos los marcos resultantes old_promises_list:');
    // console.log(result_all_old);

    // continue_cut_count++;
     
    // console.log('->> cutPieceInSheet: continue_cut_count++ = ' + continue_cut_count);
    
	let traverse_old_list = result_all_old.filter(p => p && p.traverse && p.traverse.old === true);
	
	// De entre todas se coge el marco más antiguo (hoja con menos ID)
	// y que tenga el origen más cercano al origen de la hoja.
	traverse_old_list = that.orderTravByXorigin(traverse_old_list, 'origin_x', 'origin_y', false);
	//traverse_list = that.orderTravByXorigin(traverse_list, 'origin_x', 'origin_y', false);
	
	// console.log(' -> Marcos ordenados por antigüedad:');
    // console.log(traverse_old_list);
	
	// Intentar buscar primero en los marcos antiguos.
	if (traverse_old_list.length > 0) {
		
		// console.log('->> Inspeccionando traveras antiguas = ' + traverse_old_list.length);
		
		if (!traverse_selected) {
			
			traverse_selected = traverse_old_list.find(item => {

	        if (item['traverse'] && !item['traverse'].used && item['piece']) { // Da errores al dibujar
              // console.log('> Retal antiguo encontrado para encajar la pieza:');
	          // console.log(item);
	          
	          return true;
		      
	        }
			return false;
	     });  
			
		}
    } // End If traverse_old_list.

     // NOTA: Es una colección de datos con información, no es una travera en sí solamente.
     // La travera principal de la colección está en el campo "traverse_selected.traverse".
     // console.log('--> cutPieceInSheet traverse_selected = ');
     // console.log(traverse_selected);

     let fit_piece = null;
     let addon_piece = null;

     // Se usa la travera y se añaden las posible traveras resultantes del corte de la pieza.
     // Se incrementa el contador de traveras cada vez que se añada una.
     if (traverse_selected) { // && !traverse_selected['exact']) {
		
		  // console.log('--> La pieza se va a encajar en una travera antigua:');
		  // console.log(traverse_selected);	
	      
	      let traverse_list_aux = that.oldTraverseList;
	
	      fit_piece = traverse_selected.piece;
	      addon_piece = traverse_selected.addon_piece;
	      
	      // Se añade a la lista de "piezas candidatas" la pieza sobrante
	      // asociada a la pieza que se ha seleccionado para encajar.
	      if (addon_piece) {
			that.nextOnePiece.push(addon_piece);
		  }
	
	      // Se almacena en el "dibujo" el punto origen dónde se usó la travera, que
	      // coincidirá con el punto origen de la pieza que se ha cortado dentro de ella.
	      // that.piece_draw.push({ x: traverse_selected.traverse.origin_x, y: traverse_selected.traverse.origin_y} );
	      continue_cut = true;
	
	      if (traverse_selected['TA']) {
	        // console.log('--> nueva travera creada A = ');
	        traverse_list_aux.push(traverse_selected['TA']);
	        // traverse_selected['TA'].piece = null;
	        that.traverse_count++;
	      }
	
	      if (traverse_selected['TB']) {
	        // console.log('--> nueva travera creada B = ');
	        traverse_list_aux.push(traverse_selected['TB']);
	        // traverse_selected['TB'].piece = null;
	        that.traverse_count++;
	      }
	
	      if (traverse_selected['TC']) {
	        // console.log('--> nueva travera creada C = ');
	        traverse_list_aux.push(traverse_selected['TC']);
	        // traverse_selected['TC'].piece = null;
	        that.traverse_count++;
	      }
     } else if (!traverse_selected) {
        // Si no se encuentra en las traveras antiguas entonces se pasa a buscar en las actuales.
        // ---------

	    // En cuanto se encuentre una travera donde quepa la pieza se sale del bucle para no continuar buscando.
	    // NOTA: Hay que incluir en la lista de traveras las traveras no usadas en las hojas anteriores. Estas
	    // piezas son las que se colocarán después en el "caballete extra" exclusivo para tal fin.
	    
	    fit_piece = null;
	    new_traverse_A = null;
	    new_traverse_B = null;
	    new_traverse_C = null;
	    piece_exact = false;
	      
	    //while (this.traverseList.length > count_T && !traverse_exist) {
	    for (let count_T = 0;
			 that.traverseList.length > count_T
			 && !fit_piece
			 && !traverse_exist;
			 // && total_count_T < that.traverseIterator;
			 count_T++) {
	
	      total_count_T++;
	      
	      // console.log('-> traverseList total_count_T = ' + total_count_T);
	
	      let traverse = that.traverseList[count_T];
	
	      let promise_in = null;
	
		  // if (promises_list.length < that.promeseItertor) {
			
		      promise_in = new Promise(async (resolve, reject) => {
		        // console.log('->> cutPieceInSheet: traverseList inicio Promesa de setPieceInTraverse.');
		        
		        let addon_piece = null;
		        
		        if (traverse && that.nextOnePiece[numListIn] && that.nextOnePiece[numListIn].length > 0 && !fit_piece) {
					
				        if (that.useBlocks && that.nextOnePiece[numListIn] && that.nextOnePiece[numListIn][0]) {
							// console.log('->> cutPieceInSheet: traverseList useBlocks = ' + that.useBlocks);
							addon_piece = that.templateMatrixPiece(
								that.nextOnePiece[numListIn][0], // that.breakBlock(this.nextOnePiece[numListIn][0]), // 
								traverse.width, 
								traverse.height,
								that.max_die_cutting,
								that.min_die_cutting
							);
						}
						
						that.globalCount++;
						try {
							
						
					        [fit_piece, new_traverse_A, new_traverse_B, new_traverse_C, piece_exact] = await that.setPieceInTraverse(
					          traverse,
					          that.nextOnePiece[numListIn],
					          that.last_piece,
					          axisIn,
					          diecuttingIn,
					          setIn,
					          rotateIn,
					          turnIn,
					          nearIn,
					          exportType,
					          maxLevelIn,
					          that.globalCount);
				        } catch (reject_exit) {
							console.log('->> traverseList cutPieceInSheet error try reject 3.');
						} 
				          // if (fit_piece && (!new_traverse_A && !new_traverse_B && !new_traverse_C)) {
				             // console.log('_>> Encontrada pieza que encaja justa.');
				          // }
				} // else {
					// console.log('->> No hay nextPiece traverseList:');
					// console.log(that.nextOnePiece);
					
					// return reject();
				// }
				
		        // console.log('->> Final Promesa de setPieceInTraverse:');
		        resolve({ traverse: traverse,
						  piece: fit_piece,
						  addon_piece: addon_piece,
						  TA: new_traverse_A,
						  TB: new_traverse_B,
						  TC: new_traverse_C,
						  exact: piece_exact });
				
		      }); // End promesa promise_in.
		      
		      promises_list.push(promise_in);
	
		      promise_in.then((response) => {
		        // console.log('->> Respuesta de setPieceInTraverse:');
		        // console.log(response);
		
		        // Se añaden las nuevas traveras creadas si es el caso.
		        if (response['exist'] || response['TA'] || response['TB'] || response['TC']) {
		          traverse_exist = true;
		        }
		
		        return traverse_exist;
		
		      }).catch((error) => {
		        console.error('->> Error en cutPieceInTraverse:');
		        console.error(error);
		      });
		  // } // End If promises_list.length
		  
		  if (traverse_exist) {
			console.log('->> Salida del FOR traverseList por break. globalCount = ' + that.globalCount);

			break;
		  }  
		  
	    } // End For traverseList.
        
          
        // -----------
        
        return Promise.all(promises_list).then(async function(result_all) {
		    // console.log(' -> Todos los marcos resultantes promises_list:' + result_all.length);
		    // console.log(result_all);
		
		    // continue_cut_count++;
		     
		    // console.log('->> cutPieceInTraverse: continue_cut_count++ = ' + continue_cut_count);
		    
			let traverse_list = result_all.filter(p => p.traverse.old === false);
			
			// De entre todas se coge el marco más antiguo (hoja con menos ID)
			// y que tenga el origen más cercano al origen de la hoja.
			traverse_list = that.orderTravByXorigin(traverse_list, 'origin_x', 'origin_y', false);
	        
	        // ----------
	        
	        // Intentar buscar primero en los marcos antiguos.
	
	   		traverse_selected = traverse_list.find(item => {
	
		        if (item['TA'] && !item['TB'] && !item['TC']) {				
				  // console.log('> 1 - Marco nuevo encontrado para encajar la pieza:');
		          // console.log(item);
		          
		          return true;
			      
		        }
				return false;
		     });
	       	 
	       	 if (!traverse_selected) {
	       		traverse_selected = traverse_list.find(item => {
	
			        if (item['TA'] && item['TB'] && !item['TC']) {
		              // console.log('> 2 - Marco nuevo encontrado para encajar la pieza:');
			          // console.log(item);
			          
			          return true;
				      
			        }
					return false;
			     });       
	       	 } // End If traverse_selected.
	       	 
	       	 // Se usa la travera y se añaden las posible traveras resultantes del corte de la pieza.
		     // NOTA: Si es "exacta" no hay que añadir traveras/retales resultantes.
		     // Se incrementa el contador de traveras cada vez que se añada una.
		     if (traverse_selected && !traverse_selected['exact']) {
				
			  // console.log('--> La pieza se va a encajar en una travera nueva:');
			  // console.log(traverse_selected);
		      
		      let traverse_list_aux = that.traverseList;
		
		      fit_piece = traverse_selected.piece;
		      addon_piece = traverse_selected.addon_piece;
		      
		      // Se añade a la lista de "piezas candidatas" la pieza sobrante
		      // asociada a la pieza que se ha seleccionado para encajar.
		      if (addon_piece) {
				that.nextOnePiece.push(addon_piece);
			  }
		
		      // Se almacena en el "dibujo" el punto origen dónde se usó la travera, que
		      // coincidirá con el punto origen de la pieza que se ha cortado dentro de ella.
		      // that.piece_draw.push({ x: traverse_selected.traverse.origin_x, y: traverse_selected.traverse.origin_y} );
		      continue_cut = true;
		
		      if (traverse_selected['TA']) {
		        // console.log('--> nueva travera creada A = ');
		        traverse_list_aux.push(traverse_selected['TA']);
		        // traverse_selected['TA'].piece = null;
		        that.traverse_count++;
		      }
		
		      if (traverse_selected['TB']) {
		        // console.log('--> nueva travera creada B = ');
		        traverse_list_aux.push(traverse_selected['TB']);
		        // traverse_selected['TB'].piece = null;
		        that.traverse_count++;
		      }
		
		      if (traverse_selected['TC']) {
		        // console.log('--> nueva travera creada C = ');
		        traverse_list_aux.push(traverse_selected['TC']);
		        // traverse_selected['TC'].piece = null;
		        that.traverse_count++;
		      }
		     } // End IF traverse_selected
		     
		     // Si NO se ha encontrado travera donde encajar la pieza entonces sale.
		     // NOTA: Hay que comprobar también que exista alguna pieza en el listado de "próximas candidatas".
		     // Si no hubiera más piezas no hace falta seguir.
		     if (!continue_cut) {
				
				that.addOneSheetTraverse(
					that.nextSheet, 
					that.axis, 
					that.disband, 
					that.min_die_cutting, 
					that.max_die_cutting, 
					that.useOldTraverses,
					that.useBlocks
				  );
		
				console.log('->> cutPieceInSheet: Pieza no encaja en la hoja. Se obvia. ');

		        if (that.nextOnePiece && that.nextOnePiece.length > 0) {
				  // console.log('->> cutPieceInSheet: Se ha añadido la nueva plancha a la máquina.');
				  
				  // Quitamos la pieza actual que no ha cabido.
				  // that.nextOnePiece[0]['piece_cut'] === true;
				  that.nextOnePiece.splice(0, 1);
				  
				  // Se indica que se puede seguir con la optimización, para que en la
				  // siguiente llamada se pruebe con otra de las piezas aún existentes.
		          continue_cut = true;
		          
		          continue_cut_count++;
				  
		        } else {
		          console.log('->> cutPieceInSheet: NO queda espacio en la hoja.');
		
		          // Se indica que se NO se va a poder seguir con la optimización.
		          continue_cut = false;
		        }
		          
		      } else {
		
		        console.log('->> cutPieceInSheet: Se ha encontrado travera para la pieza.');
		
		        // Indicamos que la pieza ha sido colocada para el corte,
		        // pero sólo si sus piezas internas ya han sido también cortadas.
		        if (fit_piece) {
				// if (fit_piece.piece_set && !fit_piece.piece_set.find(pp => !pp.piece_cut)) {
		            // console.log('-> -> * Pieza con marco con todas las piezas ya cortadas:');
		            // console.log(fit_piece);
		           
		            fit_piece.piece_cut = true;
		        
			        // IMPORTANTE: Será la que coincide en grupo. Si no se ponen estas líneas
			        // seguiría poniendo piezas y piezas infinitamente (hasta acabar las planchas).
			        let aux_p = that.nextOnePiece.find(p => p.piece_group === fit_piece.piece_group);
			        if (aux_p) {
			          aux_p.piece_cut = true;
			        } 
		        } else {
		           
		           fit_piece.piece_cut = true;
		           
		           let aux_p = that.nextOnePiece.find(p => p.piece_group === fit_piece.piece_group);
			        if (aux_p && aux_p.piece_set) {
		              
		              let aux_p_in = aux_p.piece_set.find(p => p.piece_num === fit_piece.piece_num);
		              
		              if (aux_p_in) {
		                aux_p_in.piece_cut = true;
		              }
			        } 
		        } // End IF piece_set

		        that.applyPiecePlacementOverride(
		          traverse_selected['traverse'],
		          fit_piece
		        );
		        
		        that.last_piece = JSON.parse(JSON.stringify(fit_piece));
		
		        // Se indica que se ha usado ya esa travera para no volver a utilizarla en la optimización.
		        traverse_selected['traverse'].used = true;
		
		        // Se indica la pieza que se colocó en esa travera (vendrá con sus valores volteados si hubo que girarla para encajarla).
		        traverse_selected['traverse'].piece = fit_piece;
		
		        // Se añade la pieza en la lista de piezas ya cortadas asignadas a una plancha.
		        // that.pieceOneList.push(that.nextOnePiece);
		        that.pieceOneList.push(traverse_selected['traverse']);
		
		        // Se eliminan las traveras ya usadas y se mergean las adyacentes,
		        // tanto de las "actuales" como de las "antiguas".
		        // Se pasa el parámetro a "false" para indicar que los retales puedan
		        // ser de cualquier tamaño (no tiene en cuenta el ancho máximo de travera).
		        // NOTA: se va a pasar a "true" porque siempre va a ser necesario controlarlo.
		        
		        // Hace falta mergear aquí también si queremos unir huecos entre colocación y colocación de piezas.
		        that.removeTraverseUsedAndMerge(true, that.max_depth_level);
		        that.removeOldTraverseUsedAndMerge(true, that.max_depth_level);
		        
		        // Se indica que se puede seguir con la optimización.
		        continue_cut = true;
		      }  // else continue_cut.
		    
		    // -----------------
		     
			// ----------- Resultado final devuelto para cutPieceInTraverse.
			// console.log('--> Resultado final devuelto Promise.all(promises_list) = ' + continue_cut);
		    
		    return continue_cut;
	       	 
       	 }).catch((error) => {

	      console.error(' -> ERROR cutPieceInSheet Promise.all(promises_list):');
	      console.error(error);
	      
	    }); // End Promise.all(promises_list).then
	    
     } // End If traverse_selected en el repaso de traveras antiguas.

	 // console.log('--> Resultado final devuelto Promise.all(old_promises_list) = ' + continue_cut);
	 
	 // -----------------------
		
     // Indicamos que la pieza ha sido colocada para el corte,
     // pero sólo si sus piezas internas ya han sido también cortadas.
     if (fit_piece) {
		
        fit_piece.piece_cut = true;
        that.applyPiecePlacementOverride(
          traverse_selected['traverse'],
          fit_piece
        );
    
        // IMPORTANTE: Será la que coincide en grupo. Si no se ponen estas líneas
        // seguiría poniendo piezas y piezas infinitamente (hasta acabar las planchas).
        let aux_p = that.nextOnePiece.find(p => p.piece_group === fit_piece.piece_group);
        if (aux_p) {
          aux_p.piece_cut = true;
        }
        
        that.last_piece = JSON.parse(JSON.stringify(fit_piece));
        
     }
    
     // Se indica que se ha usado ya esa travera para no volver a utilizarla en la optimización.
     traverse_selected['traverse'].used = true;

     // Se indica la pieza que se colocó en esa travera (vendrá con sus valores volteados si hubo que girarla para encajarla).
     traverse_selected['traverse'].piece = fit_piece;

     // Se añade la pieza en la lista de piezas ya cortadas asignadas a una plancha.
     // that.pieceOneList.push(that.nextOnePiece);
     that.pieceOneList.push(traverse_selected['traverse']);

     // Se eliminan las traveras ya usadas y se mergean las adyacentes,
     // tanto de las "actuales" como de las "antiguas".
     // Se pasa el parámetro a "false" para indicar que los retales puedan
     // ser de cualquier tamaño (no tiene en cuenta el ancho máximo de travera).
     // NOTA: se va a pasar a "true" porque siempre va a ser necesario controlarlo.
    
     that.removeTraverseUsedAndMerge(true, that.max_depth_level);
     that.removeOldTraverseUsedAndMerge(true, that.max_depth_level);
    
     // Se indica que se puede seguir con la optimización.
     continue_cut = true;
	
	 return continue_cut;
	 
    }).catch((error) => {

      console.error(' -> ERROR cutPieceInSheet Promise.all(old_promises_list):');
      console.error(error);
      
    }); // End Promise.all(old_promises_list).then
    
     // -----------------

  } // End function cutPieceInSheet
  
  // --------------------------------------- END ONE SHEET

  // Función que dada una travera de entrada y una pieza que colocar en ella, obtiene la nueva travera resultante del supuesto corte.
  async setPieceInTraverse(traverseIn: Traverse,
						   pieceIn: PieceToEasel[],
						   lastPieceIn: PieceToEasel,
						   axisIn: string,
						   diecuttingIn: number,
						   setIn: boolean,
						   rotateIn: boolean,
						   turnIn: boolean,
						   nearIn: boolean,
						   exportTypeIn: string,
			          	   maxLevelIn: number,
			          	   globalCountIn: number) {
    // console.log('--> OptiFunction setPieceInTraverse axis = ' + axisIn);
    // console.log(traverseIn);
    // console.log(pieceIn);
    // console.log(maxLevelIn);
    
    let exact = false;
    
    // Nivel de profundidad máximo que se va a permitir.
    // let max_level = 100; // Controla la altura de las torres de piezas
    // let max_level_h = 100; // Controla el apilo lateral de piezas
    let depth_level = Number(maxLevelIn);
    
    // let last_piece_aux = JSON.parse(JSON.stringify(lastPieceIn));
    
    // Si la optimización está en modo "LISEC".
    // if (exportTypeIn === 'LSW') {
		// NOTA: Se coloca el nivel máximo a 0 para evitar errores en el simulador de LISEC
		// a la hora de expotar la optimización que se va a obtener. Cuanto más alto más
		// probabilidad de que se den colocaciones no permitidas por el simulador.
		// max_level_h = 0;
		// max_level = 0;
		
		// console.log('-> Tratando con lenguaje LISEC. Se cambia el valor del nivel máximo a ' + max_level_h);
	// }

    let count_aux = this.traverse_count;

    let new_traverse_A = null;
    let new_traverse_B = null;
    let new_traverse_C = null;

    // let count_fit_T = 0;

    // Si la travera ha sido ya usada se devuelve todo vacío porque no se va a poner ahí la pieza.
    if (traverseIn.used) {
      // console.log('--> La travera ya fue usada anteriormente.');
      // console.log(traverseIn);

      return [null, new_traverse_A, new_traverse_B, new_traverse_C, exact];
    }
    /*
    if (traverseIn.level > max_level && traverseIn.level_h > max_level_h) { // && pieceIn && pieceIn[0] && last_piece_aux && pieceIn[0].piece_id !== last_piece_aux.piece_id) {
      
      console.log('--> La travera sobrepasa el nivel de profundidad vertical = ' + traverseIn.level);
      console.log(traverseIn);

      return [null, new_traverse_A, new_traverse_B, new_traverse_C, exact];
    } */
  
    // IMPORTANTE: Para Lisec es necesario no colocar piezas en retales con nivel profundo.
    // que pueda incumplir sus "normas" de colocación para su fichero TRA3_NUE.fil.
    // Bottero tampoco soporta por ahora niveles mayores de Q (ya si).
    
    // if (exportTypeIn === 'LSW' || exportTypeIn === 'BTR') {
	if (exportTypeIn === 'LSW') {
		
	    // Obtener las Traveras X principales de la hoja donde está el retal actual estudiado.
		let trXList = this.getTX(traverseIn);
		
		let isTrX = trXList.includes(traverseIn.origin_x);
		
		let actual_sheet = false;
		let id_actual_sheet = this.nextSheet.id;
		if (id_actual_sheet === traverseIn.sheet_id) actual_sheet = true;
		
		// console.log('ID hoja acutal id_sheet = ' + id_actual_sheet);
		      
	    if (!isTrX) { // && traverseIn.level_h > max_level_h && traverseIn.level > 0) {
		  
		  let current_piece = null;
		  let ady_piece = null;
		  
		  if (pieceIn && pieceIn[0]) {
			
			current_piece = pieceIn[0];
			
			let piecesIn = [];
			let trv_sheet = null;

		  	// console.log('¿Estamos en la hoja actual? ' + actual_sheet);
			
			if (actual_sheet) {
				
				// Se recorren las piezas ya colocadas en la hoja actual para ver si hay una igual al lado.
				ady_piece = this.pieceList.find(pz => {
					
					// if (pz.piece.piece_width === current_piece.piece_width && 
					// 	pz.piece.piece_height === current_piece.piece_height &&
					// 	pz.origin_y === traverseIn.origin_y &&
					// 	pz.origin_x + current_piece.piece_width === traverseIn.origin_x) {
						
					// 	console.log('-> Pieza adyacente lateral es similar a la que se va a colocar. NO modifica nivel horizontal.');
						
					// 	return true;
					// }
					
					// if (pz.piece.piece_width === current_piece.piece_width && 
					// 	pz.piece.piece_height === current_piece.piece_height &&
					// 	pz.origin_x === traverseIn.origin_x &&
					// 	pz.origin_y + current_piece.piece_height === traverseIn.origin_y) {
						
					// 	console.log('-> Pieza adyacente superior es similar a la que se va a colocar. NO modifica nivel vertical.');
						
					// 	return true;
					// }
					
					if (pz.origin_y + pz.piece.piece_height === traverseIn.origin_y &&
						pz.origin_x === traverseIn.origin_x) {
						
						// console.log('-> Hay una pieza adyacente superior.');
						// console.log(traverseIn);
						// console.log(pz);
						
						return true;
						
					} else {
						// La travera pasa los "filtros de nivel" por lo que puede usarse para colocar una pieza.
						return false;
					}
				}); // End Find pieceList.
			} else {
				
				// console.log('getTX el retal pertenece a una hoja antigua.');
				trv_sheet = this.sheetList.find(sheet => sheet.id === traverseIn.sheet_id);
				
				if (trv_sheet && trv_sheet.pieces) {
					
					// console.log('-> Buscando en hoja antigua:');
					// console.log(trv_sheet);
					
					piecesIn = JSON.parse(JSON.stringify(trv_sheet.pieces));
					
					this.pieceList.forEach(pp => {
						if (pp.sheet_id === trv_sheet.id) {
							// console.log('-> Recuperando pieza de hoja antigua:');
							piecesIn.push(pp);
						}
					});
				}
				// Se recorren las piezas que fueron colocadas en la hoja antigua para ver si hay una igual al lado.
				ady_piece = piecesIn.find(pz => {

					if (pz.origin_y + pz.piece.piece_height === traverseIn.origin_y &&
						pz.origin_x === traverseIn.origin_x) {
						
						// console.log('-> Hay una pieza adyacente superior antigua.');
						// console.log(traverseIn);
						// console.log(pz);
						
						return true;
						
					} else {
						// La travera pasa los "filtros de nivel" por lo que puede usarse para colocar una pieza.
						return false;
					}
				}); // End Find piecesIn.
			} // End Else actual_sheet	
			
		  } // End If pieceIn[0] 
		  
		  if (ady_piece) {
			// console.log('-> Pieza superior detectada:');
			// console.log(ady_piece);
			
			// Si la travera tiene nivel horizontal no se podrá colocar en ella piezas
			// a no ser que sean iguales que la pieza superior detectada.
			
			if (ady_piece.piece.piece_width === current_piece.piece_width && 
				ady_piece.piece.piece_height === current_piece.piece_height) { 	
				// console.log('-> Pieza adyacente superior es similar a la que se va a colocar. NO modifica nivel vertical.');
			} else {
				
				// console.log('-> La travera no cumple los criterios de nivel para poder ser usada.');
				// console.log(traverseIn);
				// console.log(ady_piece);
				// console.log(current_piece);
				
				return [null, new_traverse_A, new_traverse_B, new_traverse_C, exact];
			}
		  }
	  } else { // End If isTrX. (Es una travera principal).
	  
	  	  // Sólo tenemos en cuenta esta parte si es una hoja antigua.
		  if (!actual_sheet) {
			
			  	// Si está en una "travera X principal" aún puede darse el caso de que no se pueda colocar
			  	// si es el "retal actual" pertenece a una hoja antigua y su esquina derecha no es travera X. 
			  	let isTrX_R = trXList.includes(traverseIn.origin_x + traverseIn.width);
			  	
			  	if (!isTrX_R) {
					//console.log('-> No es travera X a su derecha. No se coloca la pieza.');
					return [null, new_traverse_A, new_traverse_B, new_traverse_C, exact];
				}
		  } // End If actual_sheet
	  	
	  } // End Else isTrX.
	} // End if LSW  // */	

    // let count = 0;
    let exit = false;

    let fit_aux = null;

    // IMPORTANTE: Se ordenan las piezas candidatas y se coge la de mayor area.
    // pieceIn = this.orderByArea(pieceIn, 'piece_width', 'piece_height', false); // Primero la de menor área.
    // pieceIn = this.orderByArea(pieceIn, 'piece_width', 'piece_height', true); // Primero la de mayor área.

    let promises_list_fit = [];
    
    // while (pieceIn.length > 0 && pieceIn.length <= max_bucle_count && !exit && count < max_bucle_count) {
    // pieceIn.forEach(p => {
    //for (let j = 0; j < pieceIn.length ; j++) {

      // count_fit_T++;
      
      let promise_in_fit = new Promise(async (resolve, reject) => {
        // console.log('->> Inicio Promesa de setPieceInTraverse:');
        
        // NOTA: pieceIn[0] -> Están todas las piezas pertenecientes a un grupo (A, B, etc).
        
        //  try {
	        // Llamamos a la función que nos indica si se puede incluir una pieza en una travera concreta.
	        // Si la pieza hay que girarla para que entre entonces la pieza saldrá ya con sus valores cambiados.
	        // fit_aux = await this.fitBy1(pieceIn, traverseIn, 'piece_', '', diecuttingIn, setIn, rotateIn, turnIn, nearIn, exportTypeIn);
	        fit_aux = await this.fitPiece(pieceIn, traverseIn, 'piece_', '', diecuttingIn, setIn, rotateIn, turnIn, nearIn, exportTypeIn);
		
		// } catch(error_fit) {
			
			// console.log('->> setPieceInTraverse: fitBy1 try error');
			
			// return error_fit;
		// }
		
        // Si se ha conseguido encajar una de las piezas candidatas que existían se sale del bucle.
        if (fit_aux) {
          // console.log('->> setPieceInTraverse: Se ha conseguido encajar una pieza de entre las candidatas. Salimos en cuenta ' + count_fit_T);
          exit = true;
        }
        
        // console.log('->> Final Promesa de setPieceInTraverse:' + count_fit_T);
        resolve(fit_aux);
      });

      promises_list_fit.push(promise_in_fit);

      promise_in_fit.then((fit_result: PieceToEasel) => {
        // console.log('->> setPieceInTraverse -> Respuesta de fitBy1 fit_result: ' + count_fit_T);
        // console.log(fit_result);
        
        return fit_result;

      }).catch((error) => {
        console.error('->> Error en setPieceInTraverse fitBy1:');
        console.error(error);
      });

    //} // End for pieceIn

    // IMPORTANTE: Para poder usar las funciones de la clase dentro de declaraciones de funciones internas de promesas.
    let that = this;

// NOTA: La función principal setPieceInTraverse devuelve este valor final con "return Promise.all".
    return Promise.all(promises_list_fit).then(async function(result_fit_all) { //: [PieceToEasel, Traverse, Traverse, Traverse, boolean] {
      // console.log(' -> setPieceInTraverse: result_fit_all length = ' + result_fit_all.length);
      // console.log(result_fit_all);

      let fit = null;
      
      // IMPORTANTE: "result_fit_all" contiene una pieza candidata para cada grupo.
      if (result_fit_all && result_fit_all.length > 0) {

        // Se coje la última pieza que se consiguió comprobar.
        // fit = result_fit_all[result_fit_all.length - 1]; // Se coge el último elemento.
        
        // Se intenta coger primero el elemento que tenga un ID similar al ultimo colocado.
        // console.log(' -> setPieceInTraverse: last_piece_aux = ');
        // console.log(last_piece_aux);
        /*
        if (last_piece_aux) {
          fit = result_fit_all.find(p => {
          	if (p && p.piece_id === last_piece_aux.piece_id) {
              console.log(' -> -> Se elige una pieza igual a la anterior.');
              return true;
            }
          	return false;
          });
        } */
        /*
        if (result_fit_all && result_fit_all.length > 1) {
              
            console.log('-> setPieceInTraverse -> Varias opciones de colocación. Se busca el marco vacío más próximo al origen:');
        	// console.log(result_fit_all);
        	
        	result_fit_all.forEach(tt => {
                console.log('-> tt:');
        		console.log(tt); 
        		
        		fit = tt;    
            });
              
        } else if (!fit) {
              //console.log('-> setPieceInTraverse -> Sólo hay una combinación para colocar la pieza.');
              fit = result_fit_all[0]; // Se coge el primer elemento.
        } */
        
        fit = result_fit_all[0]; // Se coge el primer elemento.
        
      } // else {
        // console.log(' -> result_fit_all: No hay piezas para encajar.')
      // }

      // console.log('->> fitBy1 piece_selected in traverse ' + traverseIn.name);
      // console.log(fit);

      // Se parte de que se cumple la condición de tronzado mínimo.
      let die_cutting_ok = true;
      
      if (fit && that.nextSheet) {
        
        let traverse_width_aux = 0;
        let traverse_height_aux = 0;

        let piece_width_aux = 0;
        let piece_height_aux = 0;

        // Guardamos las dimensiones iniciales de las traveras y piezas. 
        if (traverseIn && traverseIn.width && traverseIn.height) {

          traverse_width_aux = traverseIn.width;
          traverse_height_aux = traverseIn.height;
        }
	      	
        if (fit.piece_width && fit.piece_height) {

          piece_width_aux = fit.piece_width;
          piece_height_aux = fit.piece_height;
        }

        // Caso específico de la anticipación de travera compartida: si la
        // invitada conserva la orientación y llega al marco creado por la
        // serie anfitriona, se apoya en el lado opuesto. El resto estrecho se
        // genera así en el borde exterior y no entre dos columnas de piezas.
        const placementEps = 0.001;
        const sharedStripGap = traverse_width_aux - piece_width_aux;
        const pendingAlignment = that.sharedStripAlignmentTarget;
        // La lista final puede reconstruir otra unidad equivalente y también
        // materializar menos anfitrionas antes de la invitada. El marco real,
        // sus dimensiones y la hoja identifican la operación sin depender
        // del objeto concreto ni de una cota Y predicha.
        const pendingGeometryMatches = !!(
          pendingAlignment &&
          Math.abs(piece_width_aux -
            Number(pendingAlignment.guest_width)) <= placementEps &&
          Math.abs(piece_height_aux -
            Number(pendingAlignment.guest_height)) <= placementEps
        );
        const alignmentTarget = pendingGeometryMatches
          ? pendingAlignment
          : (fit.packing_shared_strip_edge_align === true
            ? {
                sheet_id: fit.packing_shared_strip_parent_sheet_id,
                parent_origin_x:
                  fit.packing_shared_strip_parent_origin_x,
                parent_origin_y:
                  fit.packing_shared_strip_parent_origin_y,
                parent_width: fit.packing_shared_strip_parent_width,
                guest_width: fit.packing_shared_strip_guest_width,
                guest_height: fit.packing_shared_strip_guest_height
              }
            : null);
        const sharedStripEdgeAlign =
          !!alignmentTarget &&
          sharedStripGap > placementEps &&
          String(traverseIn.sheet_id) ===
            String(alignmentTarget.sheet_id) &&
          Math.abs(Number(traverseIn.origin_x) -
            Number(alignmentTarget.parent_origin_x)) <= placementEps &&
          Math.abs(traverse_width_aux -
            Number(alignmentTarget.parent_width)) <= placementEps &&
          Math.abs(piece_width_aux -
            Number(alignmentTarget.guest_width)) <= placementEps &&
          Math.abs(piece_height_aux -
            Number(alignmentTarget.guest_height)) <= placementEps;
        const pieceOriginX = sharedStripEdgeAlign
          ? Number(traverseIn.origin_x) + sharedStripGap
          : Number(traverseIn.origin_x);
        if (sharedStripEdgeAlign) {
          fit.packing_shared_strip_edge_align = true;
          fit.packing_origin_x_override = pieceOriginX;
          fit.packing_origin_y_override = Number(traverseIn.origin_y);
          fit.packing_shared_strip_gap = sharedStripGap;
          fit.packing_shared_strip_alignment_source = pendingGeometryMatches
            ? 'pending_geometry'
            : 'piece_marker';
          fit.packing_shared_strip_planned_y =
            Number(alignmentTarget.parent_origin_y);
          fit.packing_shared_strip_actual_y = Number(traverseIn.origin_y);
        }
        
        // Para obtener el tipo de travera.
        // let r_type = traverseIn.name.slice(1,2);
        
        // console.log('--> Retal tipo = ' + r_type);
        
        // Si el tipo es X quiere decir que es el retal princiapal de la hoja entera.
        // if (r_type === 'X') {
		// 	console.log('-> Retal X --> Hoja principal:');
		// 	console.log(traverseIn);
		// }
		      
        // Se calculan inicialmente las traveras para el valor por defecto de eje "X" (el más habitual).
        new_traverse_A = {
            id: 0,
            sheet_id: traverseIn.sheet_id,
            sheet_width: traverseIn.sheet_width,
        	sheet_height: traverseIn.sheet_height,
            name: 'TA' + axisIn + '' + 0,
            axis: axisIn,
            width: piece_width_aux,
            height: traverse_height_aux - piece_height_aux,
            depth: traverseIn.depth,
            piece: null,
            father: traverseIn.id,
            used: false,
            diecutting: that.min_die_cutting,
            max_diecutting: that.max_die_cutting,
            disband: that.disband,
            origin_x: pieceOriginX, // Coincide con el origen real de la pieza.
            origin_y: traverseIn.origin_y + piece_height_aux, // Valor del punto origen de la nueva travera para el eje Y.
            draw: null,
            old: traverseIn.old ? traverseIn.old : false,
            // level: piece_width_aux < traverse_width_aux ? (traverseIn.level + 1) : traverseIn.level,
            level: traverseIn.level + 1,
            level_h: traverseIn.level_h,
            points: null
          };
          
        that.setTrCoordinates(new_traverse_A);
        
        // Se comprueba si sería un retal de cola y si es así su nivel será cero.
        // NOTA: La travera new_traverse_A en un principio nunca va a llegar a ser un retal de cola.
        // if (new_traverse_A.origin_x + new_traverse_A.width + new_traverse_A.disband.left + new_traverse_A.disband.right  === traverseIn.sheet_width) {
			// console.log('* -> Retal de cola formado al cortar. Se inicializa su nivel a cero.');
			
			// new_traverse_A.level = 0;
		// }
		
        new_traverse_B = {
            id: 0,
            sheet_id: traverseIn.sheet_id,
            sheet_width: traverseIn.sheet_width,
        	sheet_height: traverseIn.sheet_height,
            name: 'TB' + axisIn + '' + 0,
            axis: axisIn,
            width: traverse_width_aux - piece_width_aux,
            height: traverse_height_aux,
            depth: traverseIn.depth,
            piece: null,
            father: traverseIn.id,
            used: false,
            diecutting: that.min_die_cutting,
            max_diecutting: that.max_die_cutting,
            disband: that.disband,
            origin_x: sharedStripEdgeAlign
              ? traverseIn.origin_x
              : traverseIn.origin_x + piece_width_aux,
            origin_y: traverseIn.origin_y, // Valor del punto origen de la nueva travera para el eje Y.
            draw: null,
            old: traverseIn.old ? traverseIn.old : false,
            level: traverseIn.level,
            level_h: traverseIn.level_h + 1,
            remainder_cut_ease_locked: sharedStripEdgeAlign,
            packing_shared_strip_exterior_remainder: sharedStripEdgeAlign,
            points: null
          };
          
        that.setTrCoordinates(new_traverse_B);
        
		// Se comprueba si sería un retal de cola y si es así su nivel será cero.
        if (new_traverse_B.origin_x + new_traverse_B.width + new_traverse_B.disband.left + new_traverse_B.disband.right === traverseIn.sheet_width) {
			// console.log('* -> Retal de cola formado al cortar. Se inicializa su nivel a cero.');
			
			new_traverse_B.level = 0;
			new_traverse_B.level_h = 0;
		}
		
        new_traverse_C = null;

        // Para los casos en que el eje no sea el "X" se recalcula las medidas de las nuevas traveras.
        // Si eje es igual a "Y" hay que usar traveras Y.
        if (axisIn === 'Y') {

          // console.log('--> OptiFunction setPieceInTraverse: eje Y.');

          // El corte de la travera Y formará dos nuevas traveras a partir del "sobrante" de la actual.
          new_traverse_A.width = traverse_width_aux;
          new_traverse_A.height = traverse_height_aux - piece_height_aux;
          new_traverse_A.origin_x = traverseIn.origin_x;

          new_traverse_B.width = traverse_width_aux - piece_width_aux;
          new_traverse_B.height = piece_height_aux;
          if (sharedStripEdgeAlign) {
            new_traverse_B.origin_x = traverseIn.origin_x;
          }
          
          that.setTrCoordinates(new_traverse_A);
          that.setTrCoordinates(new_traverse_B);

        } else if (axisIn === 'XY') { // Si el eje es igual a "XY" hay que usar traveras X e Y.

          // console.log('--> OptiFunction setPieceInTraverse: eje XY.');

          new_traverse_A.width = piece_width_aux;
          new_traverse_A.height = traverse_height_aux - piece_height_aux;
          new_traverse_A.origin_x = pieceOriginX;

          new_traverse_B.width = traverse_width_aux - piece_width_aux;
          new_traverse_B.height = piece_height_aux;
          if (sharedStripEdgeAlign) {
            new_traverse_B.origin_x = traverseIn.origin_x;
          }

          // Con XY sale una tercera travera adicional.

          new_traverse_C = {
            id: 0,
            sheet_id: traverseIn.sheet_id,
            sheet_width: traverseIn.sheet_width,
        	sheet_height: traverseIn.sheet_height,
            name: 'TC' + axisIn + '' + 0,
            axis: axisIn,
            width: traverse_width_aux - piece_width_aux,
            height: traverse_height_aux - piece_height_aux,
            depth: traverseIn.depth,
            piece: null,
            father: traverseIn.id,
            used: false,
            diecutting: that.min_die_cutting,
            max_diecutting: that.max_die_cutting,
            disband: that.disband,
            origin_x: sharedStripEdgeAlign
              ? traverseIn.origin_x
              : traverseIn.origin_x + piece_width_aux,
            origin_y: traverseIn.origin_y + piece_height_aux, // Valor del punto origen de la nueva travera para el eje Y.
            draw: null,
            old: traverseIn.old ? traverseIn.old : false,
            level: traverseIn.level + 1,
            level_h: traverseIn.level_h + 1,
            remainder_cut_ease_locked: sharedStripEdgeAlign,
            packing_shared_strip_exterior_remainder: sharedStripEdgeAlign,
            points: null
          };
          
          that.setTrCoordinates(new_traverse_C);
          
        } // End If axisIn

        // IMPORTANTE: Al crear una nueva travera hay que comprobar que sus dimensiones
        // no sobrepasen las dimensiones de la hoja donde se está trabajando actualmente
        // o, si va a estar en una hoja antigua, las dimensiones de esa hoja pasada.

        // IMPORTANTE: Las traveras nuevas nunca podrán ser más anchas o más largas que la travera padre de la que provienen.
    
    	// Los retales que tengan un alto que ocupe toda la altura de la hoja querrán decir que son
        // retales de cola, por lo que sus niveles tanto vertical como horizontal se reinician a cero.
		if (new_traverse_A && that.nextSheet.height - that.nextSheet.disband.bottom === new_traverse_A.height) {
            // Se reinicia el nivel al ser una nueva travera X de la hoja.
            // console.log('--> Travera A reinicia su nivel.');
            // console.log(new_traverse_A);
            
         	new_traverse_A.level = 0;
         	new_traverse_A.level_h = 0;
        }
             
		// Se quita cualquier travera nueva si alguna de sus medidas es cero.
        if (!new_traverse_A || new_traverse_A.width === 0 || new_traverse_A.height === 0 ||
            // Se quita la travera si no cumple la distancia mínima de tronzado.
            (new_traverse_A && new_traverse_A.width < that.min_die_cutting) ||
            (new_traverse_A && new_traverse_A.height < that.min_die_cutting) ||
            // Se quita la travera si sus dimensiones se salen de la hoja actual.
            (new_traverse_A && new_traverse_A.width + new_traverse_A.origin_x > traverseIn.sheet_width) ||
            (new_traverse_A && new_traverse_A.origin_x < 0) ||
            (new_traverse_A && new_traverse_A.height + new_traverse_A.origin_y > traverseIn.sheet_height) ||
            (new_traverse_A && new_traverse_A.origin_y < 0)
            ) {

		  // console.log('--> setPieceInTraverse new_traverse_A Se quita la travera. Sus dimensiones se salen de la hoja actual = ');
		  // console.log(new_traverse_A);
		  
          if ((new_traverse_A && new_traverse_A.width < that.min_die_cutting && new_traverse_A.width > 0) ||
              (new_traverse_A && new_traverse_A.height < that.min_die_cutting && new_traverse_A.height > 0)) {
            // console.log('--> OptiFunction new_traverse_A no puede usarse por la distancia mínima de tronzado = ' + that.min_die_cutting);
            die_cutting_ok = false;
          }
          // else {
          //   console.log('--> OptiFunction new_traverse_A NO existe por dimensiones 0.');
          // }
		  // console.log('--> La travera A = null 1');
		  
          new_traverse_A = null;
        } else {
          count_aux++;
          new_traverse_A.id = count_aux;
          new_traverse_A.name = 'TA' + axisIn + '' + count_aux;
          // new_traverse_A.piece = fit;

          if ((new_traverse_A && new_traverse_A.width > traverseIn.width) ||
            (new_traverse_A && new_traverse_A.height > traverseIn.height)) {

            // console.log('--> Se invierten las dimensiones de la travera nueva para encajarla en el padre.');
            let h_aux = new_traverse_A.height;
            let w_aux = new_traverse_A.width;

            new_traverse_A.height = w_aux;
            new_traverse_A.width = h_aux;

            // Se vuelven a comprobar nuevamente las medidas una vez cambiadas.
            if ((new_traverse_A.width > traverseIn.width) ||
                (new_traverse_A.height > traverseIn.height) ||
                (new_traverse_A && new_traverse_A.width + new_traverse_A.origin_x > traverseIn.sheet_width) ||
                (new_traverse_A && new_traverse_A.height + new_traverse_A.origin_y > traverseIn.sheet_height)) {

                // console.log('--> La travera A nueva no cabe de ningún modo en la travera padre.');
                // console.log(new_traverse_A);
                // console.log(traverseIn);
                
                // console.log('--> La travera A = null 2');
                new_traverse_A = null;
            }
          } // End If dimensiones travera
        }
        
        // Los retales que tengan un alto que ocupe toda la altura de la hoja querrán decir que son
        // retales de cola, por lo que sus niveles tanto vertical como horizontal se reinician a cero.
        if (new_traverse_B && that.nextSheet.height - that.nextSheet.disband.bottom === new_traverse_B.height) {
            // Se reinicia el nivel al ser una nueva travera X de la hoja.
            // console.log('--> Travera B reinicia su nivel.');
         	new_traverse_B.level = 0;
         	new_traverse_B.level_h = 0;
        }
        
        if (!new_traverse_B || new_traverse_B.width === 0 || new_traverse_B.height === 0 ||
            (new_traverse_B && new_traverse_B.width < that.min_die_cutting) ||
            (new_traverse_B && new_traverse_B.height < that.min_die_cutting) ||
            // Se quita la travera si sus dimensiones se salen de la hoja actual.
            (new_traverse_B && new_traverse_B.width + new_traverse_B.origin_x > traverseIn.sheet_width) ||
            (new_traverse_B && new_traverse_B.height + new_traverse_B.origin_y > traverseIn.sheet_height)) {

		  // console.log('--> OptiFunction new_traverse_B Se quita la travera si sus dimensiones se salen de la hoja actual = ');
		  // console.log(new_traverse_B);
		  
          if ((new_traverse_B && new_traverse_B.width < that.min_die_cutting && new_traverse_B.width > 0) ||
              (new_traverse_B && new_traverse_B.height < that.min_die_cutting &&  new_traverse_B.height > 0)) {
            // console.log('--> OptiFunction new_traverse_B no puede usarse por la distancia mínima de tronzado = ' + that.min_die_cutting);
            // console.log(' Travera -> anchura = ' + new_traverse_B.width + ' altura = ' + new_traverse_B.height);
            die_cutting_ok = false;
          }
          // else {
          //   console.log('--> OptiFunction new_traverse_B NO existe por dimensiones 0.');
          // }
		  // console.log('--> La travera B = null 1');
          new_traverse_B = null;
        } else {
          count_aux++;
          new_traverse_B.id = count_aux;
          new_traverse_B.name = 'TB' + axisIn + '' + count_aux;
          // new_traverse_B.piece = fit;

          if ((new_traverse_B && new_traverse_B.width > traverseIn.width) ||
            (new_traverse_B && new_traverse_B.height > traverseIn.height)) {

            // console.log('--> Se invierten las dimensiones de la travera nueva para encajarla en el padre.');
            let h_aux = new_traverse_B.height;
            let w_aux = new_traverse_B.width;

            new_traverse_B.height = w_aux;
            new_traverse_B.width = h_aux;

            // Se vuelven a comprobar nuevamente las medidas una vez cambiadas.
            if ((new_traverse_B.width > traverseIn.width) ||
                (new_traverse_B.height > traverseIn.height) ||
                (new_traverse_B && new_traverse_B.width + new_traverse_B.origin_x > traverseIn.sheet_width) ||
                (new_traverse_B && new_traverse_B.height + new_traverse_B.origin_y > traverseIn.sheet_height)) {

                // console.log('--> La travera B nueva no cabe de ningún modo en la travera padre.');
                // console.log('--> La travera B = null 2');
                new_traverse_B = null;
            }
          } // End If dimensiones travera
        }
        
        if (new_traverse_C && traverseIn.sheet_height - that.nextSheet.disband.bottom === new_traverse_C.height) {
            // Se reinicia el nivel al ser una nueva travera X de la hoja.
            // console.log('--> Travera C reinicia su nivel.');
         	new_traverse_C.level = 0;
         	new_traverse_C.level_h = 0;
        }
        
        if (!new_traverse_C || new_traverse_C.width === 0 || new_traverse_C.height === 0
          || (new_traverse_C && new_traverse_C.width < that.min_die_cutting) ||
            (new_traverse_C && new_traverse_C.height < that.min_die_cutting) ||
            // Se quita la travera si sus dimensiones se salen de la hoja actual.
            (new_traverse_C && new_traverse_C.width + new_traverse_C.origin_x > traverseIn.sheet_width) ||
            (new_traverse_C && new_traverse_C.height + new_traverse_C.origin_y > traverseIn.sheet_height)) {

          if ((new_traverse_C && new_traverse_C.width < that.min_die_cutting && new_traverse_C.width > 0) ||
              (new_traverse_C && new_traverse_C.height < that.min_die_cutting &&  new_traverse_C.height > 0)) {
            // console.log('--> OptiFunction new_traverse_C no puede usarse por la distancia mínima de tronzado = ' + that.min_die_cutting);
            // console.log(JSON.parse(JSON.stringify(new_traverse_C)));
            die_cutting_ok = false;
          }
          // else {
          // console.log('--> OptiFunction new_traverse_C NO existe por dimensiones 0.');
          // }
          // console.log('--> La travera C = null 2');
          new_traverse_C = null;
        } else {
          count_aux++;
          new_traverse_C.id = count_aux;
          new_traverse_C.name = 'T' + axisIn + '' + count_aux;
          // new_traverse_C.piece = fit;

          if ((new_traverse_C && new_traverse_C.width > traverseIn.width) ||
            (new_traverse_C && new_traverse_C.height > traverseIn.height)) {

            // console.log('--> Se invierten las dimensiones de la travera nueva para encajarla en el padre.');
            let h_aux = new_traverse_C.height;
            let w_aux = new_traverse_C.width;

            new_traverse_C.height = w_aux;
            new_traverse_C.width = h_aux;

            // Se vuelven a comprobar nuevamente las medidas una vez cambiadas.
            if ((new_traverse_C.width > traverseIn.width) ||
                (new_traverse_C.height > traverseIn.height) ||
                (new_traverse_C && new_traverse_C.width + new_traverse_C.origin_x > traverseIn.sheet_width) ||
                (new_traverse_C && new_traverse_C.height + new_traverse_C.origin_y > traverseIn.sheet_height)) {

                console.log('--> La travera C nueva no cabe de ningún modo en la travera padre.');
                // console.log('--> La travera C = null 3');
                new_traverse_C = null;
            }
          } // End If dimensiones travera
        }

        // Si no se cumple la condición de tronzado se devuelven todas las
        // traveras vacías para indicar que esta opción no va a ser válida.
        if (!die_cutting_ok) {
          console.log('--> No se cumple la condición mínima de tronzado:' + that.min_die_cutting);
          // console.log('--> Todas las traveras = null.');
          new_traverse_A = null;
          new_traverse_B = null;
          new_traverse_C = null;
          
          return [null, new_traverse_A, new_traverse_B, new_traverse_C, false];
          
        } else {
			
	        // Si la travera tiene las mismas medidas que la pieza entonces se encaja directamente.
	        if ((traverse_width_aux === piece_width_aux && traverse_height_aux === piece_height_aux)
	      		//|| (traverse_width_aux === piece_height_aux && traverse_height_aux === piece_width_aux)
	      		) {
	          	console.log('--> La travera y la pieza encajan justos.');
	          	
				exact = true;
	        } 
        }
        // ------- NIVEL DE PROFUNDIDAD ------
	    // Calcular el nivel de profundidad de los posibles retales que surgirían
	    // si se colocara la pieza actual que según sus dimensiones sí cabe.
		// Sólo se aplica si se exige un nivel de profundidad que no sea infinito.
		if (depth_level < that.infinite_level) {
			/*
		    if (fit.piece_num === 9) {
			 	console.log(' --> setPieceInTraverse: Encontrado elemento problema. id = ' + fit.piece_num);
				console.log(fit);
			} // */
			
			let test_level = true;
			
		    let tr_level = await that.getLevel(axisIn, fit, traverseIn, [new_traverse_A, new_traverse_B]);
		    
			tr_level.forEach(tr_elem => {
				
				// console.log('-> level = ' + tr_elem.level);
				
				// Si se supera el nivel de profundidad entonces
				// el retal no se usará para colocar una pieza.
				if (tr_elem && tr_elem.level > depth_level) {
					
					// console.log('-> Superado nivel = ' + tr_elem.level + ' ;max = ' + depth_level);
					// console.log(tr_elem);
					// console.log(fit);
					
					test_level = false;
				}
			}); // */
			
			// Para usar un nuevo método que utiliza la nueva estrucctura de niveles.
			// NOTA: Por ahora no funciona bien.
			// test_level = await that.testLevel(axisIn, fit, traverseIn, [new_traverse_A, new_traverse_B], depth_level);
		    
		    // console.log('-> resultado testLevel = ' + test_level);
			
			if (!test_level) {
				
				// console.log('-> No superado el test de nivel: ' + test_level);
				// console.log(fit);
				
				new_traverse_A = null;
	          	new_traverse_B = null;
	          	new_traverse_C = null;
	          	
	          	return [null, new_traverse_A, new_traverse_B, new_traverse_C, false];
			}
			// */
		} // End If depth_level.
		
	    // ------- FIN NIVEL DE PROFUNDIDAD ------
	    
	    // NOTA: Si colocando la pieza no se crea ningún elemento que supere
	    // la profundidad de corte máxima permitida, entonces se continúa.
    
        // Si era una "pieza marco" se le devuelve con sus dimensiones iniciales de pieza única.
	    // if (fit.piece_set && fit.piece_set.length > 0 && fit && fit.draw_w && fit.draw_h) {
		if (fit.piece_matrix && fit.piece_matrix.length > 0 && fit && fit.draw_w && fit.draw_h) {
                
            // NOTA ROTACIÓN:
			
            let p_in = fit.piece_matrix[0][0];
            
            // console.log('--> fit = ');
            // console.log(fit);
            
            // console.log('--> p_in = ');
            // console.log(p_in);
            
            // El ancho y alto de la pieza marco tiene que coincidir con el ancho y alto calculado.
            // console.log('--> Ancho pieza marco = ' + fit.piece_width);
	        // console.log('--> Alto pieza marco = ' + fit.piece_height);
		    // console.log('--> Ancho calculado = ' + p_in.piece_width * fit.draw_w);
		    // console.log('--> Alto calculado = ' + p_in.piece_height * fit.draw_h);
		    
	        if (p_in.piece_width * fit.draw_w !== fit.piece_width ||
	        	p_in.piece_height * fit.draw_h !== fit.piece_height) {
                
                // console.log('--> Fit marco ha llegado volteado SI.');
                
                fit.piece_flip = true;
                
				// Hay que invertir también el orden de la matriz de piezas internas.
				
				let new_piece_set = [];
				let m_colunm = [];
				
				// Se inicializa la matriz invertida.
				for (let i = 0; i < fit.draw_h; i++) {
                    
		        	for (let j = 0; j < fit.draw_w; j++) {
                                
                          m_colunm.push(j + 1); 
		            	  
		            }
		            
		            new_piece_set.push(m_colunm); 
		            
		            m_colunm = [];
		        }
				
				for (let i = 0; i < fit.piece_matrix.length; i++) {
                    
		        	for (let j = 0; j < fit.piece_matrix[i].length; j++) {
                            
		                  // console.log('--> fit pin[' + (i + 1) + '][' + (j + 1) + ']');
		            	  let fit_pin = fit.piece_matrix[i][j];
		            	  
		            	  fit_pin.piece_rotation = fit.piece_rotation;
		            	  fit_pin.piece_flip = true;
		            	  
		            	  // console.log(fit_pin);
		            	  
		            	  // Se asigna la pieza al correspondiente lugar de la matriz invertida.
		            	  new_piece_set[j][i] = fit_pin;  
		            }
		        }
		        
		        // console.log('--> new_piece_set filled = ');
		        // console.log(new_piece_set);
		        
		        fit.piece_matrix = new_piece_set;
		        
		        let aux_draw_w = fit.draw_w;
				let aux_draw_h = fit.draw_h;
				
				fit.draw_w = aux_draw_h;
				fit.draw_h = aux_draw_w;
			
				fit.piece_width = p_in.piece_height;
	        	fit.piece_height = p_in.piece_width;
	        	
            } else {
                // console.log('--> Fit marco ha llegado correcto. NO se ha volteado.');
            	// fit.piece_width = fit.piece_width / fit.draw_w;
	        	// fit.piece_height = fit.piece_height / fit.draw_h;
	        	
	        	fit.piece_width = p_in.piece_width;
	        	fit.piece_height = p_in.piece_height;
            } // End piece_rotation.  // */
	        
	    } // End encontrada pieza marco.

        // console.log('--> setPieceInTraverse: return 1.');
        // console.log([fit, new_traverse_A, new_traverse_B, new_traverse_C, exact]);
        
        return [fit, new_traverse_A, new_traverse_B, new_traverse_C, exact];
        
      } else {
		
        // console.log('--> La pieza NO cabe en la travera. globalCount = '  + globalCountIn);
        // console.log('--> setPieceInTraverse: return 2.');
       /* 
        // Si era una "pieza marco" se le devuelve con sus dimensiones iniciales de pieza única.
	    if (fit && fit.draw_w && fit.draw_h) {
	    	fit.piece_width = fit.piece_width / fit.draw_w;
	        fit.piece_height = fit.piece_height / fit.draw_h;
	    } */
	    
        return [fit, new_traverse_A, new_traverse_B, new_traverse_C, exact];
      } // End IF fit.

     // ----------------------

    }).catch((error) => {
      // console.log('->> setPieceInTraverse. Error en Promise.all:');
      // console.log(error);
    }); // End promises_list_fit

  } // End function setPieceInTraverse
  
  // -------------------------------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------------------

  // Función modifica el listado de traveras eliminando las que ya estén usadas.
  // Además mergea dos traveras que estén adyacentes entre sí en una única travera.
  // NOTA: Debe de tener en cuenta que si no es una travera de cola no hay que
  // mergearla si el resultado va a superar el ancho máximo de travera permitido.
  removeTraverseUsedAndMerge(max_traverse: boolean, depth_level: number) {
    // console.log('--> removeTraverseUsedAndMerge: ' + depth_level);

    // IMPORTANTE: Hay que trabajar directamente con el elemento "this.traverseList".
    // Si se pasa este listado como parátro entonces no funcionaría el algoritmo porque
    // realmente no se actualizarían bien las informaciones de las traveras (por la razón que sea).
    this.traverseList = this.traverseList.filter(item => !item.used);
// TEST:
    // NOTA: juntamos las traveras que estén adyacentes en una sola travera.
    let res = false;

    this.traverseList.some((tr1, i) => {
      // let a_p1 = { x: tr1.origin_x, y: tr1.origin_y };
      // let a_p2 = { x: tr1.origin_x, y: tr1.origin_y + tr1.height };
      // let a_p3 = { x: tr1.origin_x + tr1.width, y: tr1.origin_y + tr1.height };
      // let a_p4 = { x: tr1.origin_x + tr1.width, y: tr1.origin_y };

      let a_p1 = tr1.origin_x.toString() + ',' + tr1.origin_y.toString();
      let a_p2 = tr1.origin_x.toString() + ',' + (tr1.origin_y + tr1.height).toString();
      let a_p3 = (tr1.origin_x + tr1.width).toString() + ',' + (tr1.origin_y + tr1.height).toString();
      let a_p4 = (tr1.origin_x + tr1.width).toString() + ',' + tr1.origin_y.toString();

      this.traverseList.forEach((tr2, j) => {

        // console.log('->> removeTraverseUsedAndMerge: some i = ' + i + ' ;j = ' + j);

        // let b_p1 = { x: tr2.origin_x, y: tr2.origin_y };
        // let b_p2 = { x: tr2.origin_x, y: tr2.origin_y + tr2.height };
        // let b_p3 = { x: tr2.origin_x + tr2.width, y: tr2.origin_y + tr2.height };
        // let b_p4 = { x: tr2.origin_x + tr2.width, y: tr2.origin_y };

        let b_p1 = tr2.origin_x.toString() + ',' + tr2.origin_y.toString();
        let b_p2 = tr2.origin_x.toString() + ',' + (tr2.origin_y + tr2.height).toString();
        let b_p3 = (tr2.origin_x + tr2.width).toString() + ',' + (tr2.origin_y + tr2.height).toString();
        let b_p4 = (tr2.origin_x + tr2.width).toString() + ',' + tr2.origin_y.toString();

        if (a_p3 === b_p2 && a_p4 === b_p1) {
          // console.log('->> Coincide lado vertical de dos traveras. i = ' + i + ' ;j = ' + j);
          //if (tr1.width ===)
          
          if (!max_traverse || (tr2.width + tr1.width <= this.max_die_cutting)) {
	          res = true;
	          
	          // let tr1_aux = JSON.parse(JSON.stringify(tr1));
	          // let tr2_aux = JSON.parse(JSON.stringify(tr2));
	
	          // Se cambian las dimensiones de la segunda travera para que absorva a la primera.
	          // La altura será la misma para coincidencias de lados verticales.
	          tr2.origin_x = tr1.origin_x;
	          tr2.origin_y = tr2.origin_y;
	          tr2.width += tr1.width;
	          
	          this.setTrCoordinates(tr1);
	          this.setTrCoordinates(tr2);
	          
	          // Se le asocia también el padre del que provenía.
	          // tr2.father = tr1.father;
	
	          // Se elimina la primera travera.
	          this.traverseList.splice(i, 1);
	          
	          // console.log('--> removeTraverseUsedAndMerge: Mergeo Caso 1.');
	          
	          /*
	          if (depth_level < this.infinite_level) {
				
				let test_level = this.testSheetLevel(tr1.sheet_id, depth_level);
	          
		        if (!test_level) {
					console.log('--> removeTraverseUsedAndMerge: Mergeo sobrepasa el nivel. Caso 1.');
					
					// Se dejan las traveras como estaban antes de mergearlas.
					tr1 = tr1_aux;
					tr2 = tr2_aux;
					
					// Se vuelve a agregar la travera eliminada.
					this.traverseList.splice(i, 1, tr1);
				}
			  } // End If depth_level. // */
	
	          return true;
	      } // End If max_traverse.
        }

        if (a_p1 === b_p2 && a_p4 === b_p3) {
          // console.log('->> Coincide lado horizontal de dos traveras. i = ' + i + ' ;j = ' + j)

		  // if (!max_traverse || (tr2.height + tr1.height <= this.max_die_cutting)) {
          	  res = true;
          	  
          	  // let tr1_aux = JSON.parse(JSON.stringify(tr1));
	          // let tr2_aux = JSON.parse(JSON.stringify(tr2));

	          // Se cambian las dimensiones de la segunda travera para que absorva a la primera.
	          // La altura será la misma para coincidencias de lados verticales.
	          tr2.origin_x = tr1.origin_x;
	          tr2.origin_y = tr2.origin_y;
	          tr2.height += tr1.height;
	          
	          this.setTrCoordinates(tr1);
	          this.setTrCoordinates(tr2);
	          
	          // Se le asocia también el padre del que provenía.
	          // tr2.father = tr1.father;
	
	          // Se elimina la primera travera.
	          this.traverseList.splice(i, 1);
	          
	          // console.log('--> removeTraverseUsedAndMerge: Mergeo Caso 2.');
	          /*
	          if (depth_level < this.infinite_level) {
				
				let test_level = this.testSheetLevel(tr1.sheet_id, depth_level);
	          
		        if (!test_level) {
					console.log('--> removeTraverseUsedAndMerge: Mergeo sobrepasa el nivel. Caso 2.');
					
					// Se dejan las traveras como estaban antes de mergearlas.
					tr1 = tr1_aux;
					tr2 = tr2_aux;
					
					// Se vuelve a agregar la travera eliminada.
					this.traverseList.splice(i, 1, tr1);
				}
			  } // End If depth_level. // */
			  
	          return true;
          // }  // End If max_traverse.
        }
      });

      // console.log('->> removeTraverseUsedAndMerge: some resultado = ' + res + ' ;index = ' + i);
      return res;
    }); // */

    // console.log(' --> -> removeTraverseUsedAndMerge traverseList eliminadas traveras usadas:');
    // console.log(JSON.stringify(this.traverseList));

  } // End function removeTraverseUsedAndMerge

  removeOldTraverseUsedAndMerge(max_traverse: boolean, depth_level: number) {
    // console.log('--> removeOldTraverseUsedAndMerge: ' + depth_level);

    // IMPORTANTE: Hay que trabajar directamente con el elemento "this.oldTraverseList".
    // Si se pasara este listado como parámetro entonces no funcionaría el algoritmo porque
    // realmente no se actualizarían bien las informaciones de las traveras (por la razón que sea).
    this.oldTraverseList = this.oldTraverseList.filter(item => !item.used);
    
// TEST:
    // NOTA: juntamos las traveras que estén adyacentes en una sola travera.
    let res = false;

    // this.oldTraverseList.some((tr1, i) => {
    this.oldTraverseList.map((tr1, i) => {

      this.oldTraverseList.forEach((tr2, j) => {

        // console.log('->> removeOldTraverseUsedAndMerge: some i = ' + i + ' ;j = ' + j);

        if (tr1.sheet_id === tr2.sheet_id) {

          // console.log('->> Coincide traveras adyacentes en misma hoja. i = ' + i + ' ;j = ' + j);

          // let a_p1 = { x: tr1.origin_x, y: tr1.origin_y };
          // let a_p2 = { x: tr1.origin_x, y: tr1.origin_y + tr1.height };
          // let a_p3 = { x: tr1.origin_x + tr1.width, y: tr1.origin_y + tr1.height };
          // let a_p4 = { x: tr1.origin_x + tr1.width, y: tr1.origin_y };

          let a_p1 = tr1.origin_x.toString() + ',' + tr1.origin_y.toString();
          let a_p2 = tr1.origin_x.toString() + ',' + (tr1.origin_y + tr1.height).toString();
          let a_p3 = (tr1.origin_x + tr1.width).toString() + ',' + (tr1.origin_y + tr1.height).toString();
          let a_p4 = (tr1.origin_x + tr1.width).toString() + ',' + tr1.origin_y.toString();

          // let b_p1 = { x: tr2.origin_x, y: tr2.origin_y };
          // let b_p2 = { x: tr2.origin_x, y: tr2.origin_y + tr2.height };
          // let b_p3 = { x: tr2.origin_x + tr2.width, y: tr2.origin_y + tr2.height };
          // let b_p4 = { x: tr2.origin_x + tr2.width, y: tr2.origin_y };

          let b_p1 = tr2.origin_x.toString() + ',' + tr2.origin_y.toString();
          let b_p2 = tr2.origin_x.toString() + ',' + (tr2.origin_y + tr2.height).toString();
          let b_p3 = (tr2.origin_x + tr2.width).toString() + ',' + (tr2.origin_y + tr2.height).toString();
          let b_p4 = (tr2.origin_x + tr2.width).toString() + ',' + tr2.origin_y.toString();

          // CASO 1
          if (a_p3 === b_p2 && a_p4 === b_p1) {
            // console.log('->> Old CASO 1: Coincide lado vertical de dos traveras. i = ' + i + ' ;j = ' + j);
            
            if (!max_traverse || (tr2.width + tr1.width <= this.max_die_cutting)) {
	            
	            res = true;
	            
	            // let tr1_aux = JSON.parse(JSON.stringify(tr1));
	            // let tr2_aux = JSON.parse(JSON.stringify(tr2));
	
	            // Se cambian las dimensiones de la segunda travera para que absorva a la primera.
	            // La altura será la misma para coincidencias de lados verticales.
	            tr2.origin_x = tr1.origin_x;
	            tr2.origin_y = tr2.origin_y;
	            tr2.width += tr1.width;
	            
	            this.setTrCoordinates(tr1);
	            this.setTrCoordinates(tr2);
	
	            // Se elimina la primera travera.
	            this.oldTraverseList.splice(i, 1);
	            
	            // console.log('--> removeOldTraverseUsedAndMerge: Mergeo Caso 1.');
	            /*
	            if (depth_level < this.infinite_level) {
				
					let test_level = this.testSheetLevel(tr1.sheet_id, depth_level);
	          
			        if (!test_level) {
						console.log('--> removeOldTraverseUsedAndMerge: Mergeo sobrepasa el nivel. Caso 1.');
						
						// Se dejan las traveras como estaban antes de mergearlas.
						tr1 = tr1_aux;
						tr2 = tr2_aux;
						
						// Se vuelve a agregar la travera eliminada.
						this.oldTraverseList.splice(i, 1, tr1);
					}
				} // End If depth_level. // */
	
	            // return true; // Cuando se usa "some".
	            
	        }  // End If max_traverse.
          }

          // CASO 2
          if (a_p1 === b_p2 && a_p4 === b_p3) {
            // console.log('->> Old CASO 2: Coincide lado horizontal de dos traveras. i = ' + i + ' ;j = ' + j);
            
            // if (!max_traverse || (tr2.height + tr1.height <= this.max_die_cutting)) {
                  
                res = true;
                
                // let tr1_aux = JSON.parse(JSON.stringify(tr1));
	            // let tr2_aux = JSON.parse(JSON.stringify(tr2));

	            // Se cambian las dimensiones de la segunda travera para que absorva a la primera.
	            // La altura será la misma para coincidencias de lados verticales.
	            tr2.origin_x = tr1.origin_x;
	            tr2.origin_y = tr2.origin_y;
	            tr2.height += tr1.height;
	            
	            this.setTrCoordinates(tr1);
	            this.setTrCoordinates(tr2);
	
	            // Se elimina la primera travera.
	            this.oldTraverseList.splice(i, 1);
	            
	            // console.log('--> removeOldTraverseUsedAndMerge: Mergeo Caso 2.');
	            /*
	            if (depth_level < this.infinite_level) {
				
					let test_level = this.testSheetLevel(tr1.sheet_id, depth_level);
	          
			        if (!test_level) {
						console.log('--> removeOldTraverseUsedAndMerge: Mergeo sobrepasa el nivel. Caso 2.');
						
						// Se dejan las traveras como estaban antes de mergearlas.
						tr1 = tr1_aux;
						tr2 = tr2_aux;
						
						// Se vuelve a agregar la travera eliminada.
						this.oldTraverseList.splice(i, 1, tr1);
					}
				} // End If depth_level. // */
	
	            // return true; // Cuando se usa "some".              
            // }  // End If max_traverse.
          }

          // CASO 3
          // Las traveras están una dentro de otra por coincidir su lado vertical de inicio.
          if (tr1.origin_x === tr2.origin_x && tr1.origin_y === tr2.origin_y && tr1.id !== tr2.id) {
            // console.log('->> Old CASO 3: Coincide mismo lado vertical 1 de dos traveras. i = ' + i + ' ;j = ' + j);

            // if (tr2.width !== tr1.width) {
              // console.log('->> ------ Travera mismo ID diferentes tamaños.');
              // console.log(tr1);
              // console.log('->> -.');
              // console.log(tr2);
              // console.log('->> ------ -- -- -.');
            // }

            res = true;

            // NOTA: Necesario colocar alguna de las dos traveras solapadas como "usada" para que
            // no se dibuje y se quite del gráfico (o aparecerá dos traveras una dentro de otra).
            if (!tr1.used) {
              // console.log('->> TR1 no usada solapada --> se coloca como usada.');

              if (tr1.width < tr2.width) {
                // this.oldTraverseList.splice(i, 1);
                tr1.used = true;
                
                console.log('--> removeOldTraverseUsedAndMerge: Mergeo Caso 3.');
              }
            }
          }

        }
        // else {

        //   console.log('->> Traveras adyacentes pero en DISTINTAS hojas.');
        //   console.log(tr1);
        //   console.log(tr2);
        //   console.log('->> ------ -- -- -.');

        //   return false; // Cuando se usa "some".
        // }

      });

      // console.log('->> removeOldTraverseUsedAndMerge: some resultado = ' + res + ' ;index = ' + i);
      // return res;
    }); // */

    // console.log(' --> -> removeOldTraverseUsedAndMerge oldTraverseList eliminadas traveras usadas:');
    // console.log(JSON.stringify(this.oldTraverseList));

  } // End function removeOldTraverseUsedAndMerge
  
  // Función que corta el retal para formar una travera Y que separe dos piezas
  // de igual anchura pero diferente altura colocadas una encima de otra.
  // NOTA: Si tienen la misma altura no debe realizarse el corte.
  /*
  cutDiferenceHeight(sheetIn) {
        
    console.log('--> Entrando en cutDiferenceHeight:');
    // console.log(sheetIn);
    
    //sheetListIn.forEach((sheetIn, index) => {
      if (sheetIn.pieces) {
	  	sheetIn.pieces.forEach((tvr, i) => {
	      // console.log('--> p[' + (i + 1) + '] = ');
	      // console.log(tvr);
	      sheetIn.pieces.forEach((tvr2, k) => {
		      // A partir del segundo elemento comprobamos si la pieza anterior tiene su mismo ancho
		      // y proviene de la travera padre. Entonces se comprobará si tiene la misma altura también.
		      if (i > 1 && tvr2.id === tvr.father
		      		 && tvr2.piece.piece_width === tvr.piece.piece_width
		      		 && tvr2.piece.piece_height !== tvr.piece.piece_height
		      	) {
		      	// console.log('--> Encontradas piezas apiladas con mismo ancho pero diferente altura en hoja: ' + (i + 1));
		      	// console.log(tvr.piece);
		      	// console.log(tvr2.piece);
		      	// console.log('--> ID trozo padre de la pieza arriba = ');
		      	// console.log(tvr);
		      	// console.log('--> ID trozo padre de la pieza abajo = ');
		      	// console.log(tvr2);
		      	
		      	// console.log('--> Retales en esa hoja: ' + (i + 1));
		      	// console.log(sheetIn.traverses);
		      	
		      	let ret_clon = null;
		      	
		      	// Ahora hay que buscar en esa hoja el retal contiguo si existiera.
		      	// NOTA: Hay que controlar que el retal no sea el de "cola" de la plancha.
		      	
		      	sheetIn.traverses.forEach((ret, j) => {
	              // console.log('-->retal[' + (j + 1) + '] testeado = ');
		          // console.log(ret);
		          
		          let tail_retal = false;
		          
		          // NOTA: el desbande izquierdo no se tiene en cuenta aquí porque contamos la posición desde el origen del retal.
		          // if (ret.origin_x + ret.width + sheetIn.disband.left + sheetIn.disband.right === sheetIn.width) {
				  if (ret.origin_x + ret.width === sheetIn.width ||
				  	  ret.origin_x + ret.width + sheetIn.disband.right === sheetIn.width ||
				  	  // ret.origin_x + ret.width + sheetIn.disband.left === sheetIn.width ||
				  	  ret.origin_x + ret.width + sheetIn.disband.left + sheetIn.disband.right === sheetIn.width) {

					tail_retal = true;
					
					// console.log('-> cutDiferenceHeight: Encontrado retal de cola.');
				  }
				  
				  // Si es un retal de "cola" no se realiza.
		          if (!ret_clon && !tail_retal) {
					
					console.log('-> cutDiferenceHeight: No es retal de cola.');
					
		          	// Hay que dividirlo en dos a la altura de la unión de las piezas con un corte en el eje Y.
		          	if (ret.father === tvr.father
		          		//&& !(ret.origin_x + ret.width !== sheetIn.width) && !(tvr.origin_x + tvr.width !== sheetIn.width)
		          	) {
	                            
	                    console.log('--> caso 1: retal cercano.');
	                    console.log(ret);
	                    console.log(tvr);
	                    console.log(tvr2);
	                    
	                    ret_clon = JSON.parse(JSON.stringify(ret));
	                    
	                	ret_clon.origin_y = ret.origin_y + tvr2.piece.piece_height;
		          		ret_clon.height = ret.height - tvr2.piece.piece_height; // - ret.disband.bottom;
		          		
		          		if (ret_clon.height < 0) {
							ret_clon.height = ret.height;
						} else {
							ret.height = tvr2.piece.piece_height;
						}
		          		
	                } else if (ret.father === tvr2.father
	                	//&& !(ret.origin_x + ret.width !== sheetIn.width) && !(tvr.origin_x + tvr.width !== sheetIn.width)
	                	&& ret.origin_x > tvr.origin_x
	                ) {
	                      
	                    console.log('--> caso 2: retal alejado.');
	                    
	                    ret_clon = JSON.parse(JSON.stringify(ret));
	                    
	                    ret_clon.origin_y = tvr.origin_y;
		          		ret_clon.height = ret.height - (tvr.origin_y - ret.origin_y);
		          		
		          		// En el último paso ya sí se puede modificar la altura
		          		// del retal original sin que afecte al resto calculado.
		          		ret.height = tvr.origin_y - ret.origin_y;
		          		
		          		if (ret_clon.height < 0) {
							console.log('--> Se invierte altura: ' + ret_clon.height);
							ret.height -= -(ret_clon.height);
						}
		          		
	                } else if (
		          		ret.origin_x === tvr.origin_x + tvr.piece.piece_width
		      		 	&& ret.origin_y === tvr.origin_y - tvr.piece.piece_height
		          		
		          	) { 
						console.log('--> caso 3: retal ...');
						
	                    ret_clon = JSON.parse(JSON.stringify(ret));
	                    
	                	ret_clon.origin_y = ret.origin_y + tvr2.piece.piece_height;
		          		ret_clon.height = ret.height - tvr2.piece.piece_height; // - ret.disband.bottom;
		          		ret.height = tvr2.piece.piece_height;
		          		
	                } else if (
		          		ret.origin_x === tvr2.origin_x + tvr2.piece.piece_width
		      		 	&& ret.origin_y === tvr2.origin_y
		          		
		          	) {
						console.log('--> caso 4: retal ...');
						
	                    ret_clon = JSON.parse(JSON.stringify(ret));
	                    
	                	ret_clon.origin_y = ret.origin_y + tvr2.piece.piece_height;
		          		ret_clon.height = ret.height - tvr2.piece.piece_height; // - ret.disband.bottom;
		          		ret.height = tvr2.piece.piece_height;
	                } else {
						console.log('--> caso 5: retal finalmente no dividido.');
						console.log(ret);
						console.log(tvr);
						console.log(tvr2);
					}
	                
	                this.setTrCoordinates(ret);
		          	
		          	// Si el nuevo retal tiene que estar dentro de las
		          	// dimensiones de la hoja y tener ancho y alto suficiente.
		          	if (ret_clon && ret_clon.width > 0 && ret_clon.height > 0
		          		&& ret_clon.origin_x >= 0 && ret_clon.origin_x < ret_clon.sheet_width
		          		&& ret_clon.origin_y >= 0 && ret_clon.origin_y < ret_clon.sheet_height) {
						
					  // NOTA: Se modifica el nombre del nuevo retal añadiendo una "C" para poder distinguirlo luego.
	                  ret_clon.name = ret_clon.name + 'C';
	                  
	                  // IMPORTANTE: También hay que modificar su ID para distinguirlo al exportar a Turomas.
	                  this.traverse_count++;
	                  ret_clon.id = this.traverse_count;
	                  
	                  // console.log('--> Añadido retal clon[' + (j + 1) + '] = ');
	                  // console.log(ret_clon);
	                  
	                  this.setTrCoordinates(ret_clon);
	                  
	                  if (ret_clon.width === ret.width && ret_clon.height === ret.height
	                      && ret_clon.origin_x === ret.origin_x ) {
							
						console.log('--> No se mete el retal por ser similar al original:');
						// console.log(ret);
						// console.log(ret_clon);
						
					  } else {
						
						console.log('--> Se inserta el nuevo retal copia.');
						
						// Se inserta el nuevo retal copia.
						sheetIn.traverses.push(ret_clon);
					  }
		            }
		          } // End If tail_retal.
		        }); // End FOR retales en la hoja.
		      } // End IF padre.
	      }); // End FOR piezas segunda vuelta de la hoja. 
	    }); // End FOR piezas de la hoja.
	  } // End IF sheetIn.pieces
    // }); // End FOREACH sheetListIn
  } // End function cutDiferenceHeight */
  
  // Función que corta el retal para formar una travera Y que separe dos piezas
  // de igual anchura pero diferente altura colocadas una encima de otra.
  // NOTA: Si tienen la misma altura no debe realizarse el corte.
  cutDiferenceHeight2(sheetIn) {
        
    // console.log('--> Entrando en cutDiferenceHeight2:');
    // console.log(sheetIn);
    
    if (sheetIn.pieces) {
	  	sheetIn.pieces.forEach((tvr, i) => {
	      // console.log('--> p[' + (i + 1) + '] = ');
	      // console.log(tvr);
	      sheetIn.pieces.forEach((tvr2, k) => {
		      	
		      if (tvr.piece.piece_id !== tvr2.piece.piece_id &&
		      	  tvr.piece.piece_width === tvr2.piece.piece_width &&
		      	  tvr.piece.piece_height !== tvr2.piece.piece_height &&
		      	  tvr.piece.points[1].x === tvr2.piece.points[0].x &&
		      	  tvr.piece.points[1].y === tvr2.piece.points[0].y
		      	  
		      ) {
				// console.log('--> Encontradas piezas apiladas. tvr  ' + (i + 1) + ' y tvr2 ' + (k + 1));
			  	// console.log(tvr.piece);
		      	// console.log(tvr2.piece);
		      	
		      	let piece_down = tvr.piece;
		      	let piece_up = tvr2.piece;
		      	
		      	// Ahora hay que buscar en esa hoja el retal contiguo si existiera.
		      	// NOTA: Hay que controlar que el retal no sea el de "cola" de la plancha.
		      	let adyacent_ok = false;
		      	
		      	// sheetIn.traverses.forEach((ret, j) => {
				for (let j = 0; j < sheetIn.traverses.length; j++) {
					
					let ret = sheetIn.traverses[j];
					
	              	// console.log('-->retal[' + (j + 1) + '] testeado = ');
		          	// console.log(ret);
		          	
		          	let tail_retal = false;
		          	let ret_clon = null;
					
					if (ret.origin_x === piece_down.points[3].x &&
						ret.origin_y <= piece_down.points[3].y &&
						ret.origin_y + ret.height >= piece_up.points[2].y
					) {
						  // console.log('-> Encontrado retal adyacente:');
						  // console.log(ret);
						
						  // NOTA: el desbande izquierdo no se tiene en cuenta aquí porque contamos la posición desde el origen del retal.
				          // if (ret.origin_x + ret.width + sheetIn.disband.left + sheetIn.disband.right === sheetIn.width) {
						  if (ret.origin_x + ret.width === sheetIn.width ||
						  	  ret.origin_x + ret.width + sheetIn.disband.right === sheetIn.width ||
						  	  // ret.origin_x + ret.width + sheetIn.disband.left === sheetIn.width ||
						  	  ret.origin_x + ret.width + sheetIn.disband.left + sheetIn.disband.right === sheetIn.width) {
		
							tail_retal = true;
							
							// console.log('-> cutDiferenceHeight2: Encontrado retal de cola.');
							// console.log(ret);
						  }
						  
						  // Sólo se corta el retal si no es un retal de cola.
		          		  if (!tail_retal) {
							
							ret_clon = JSON.parse(JSON.stringify(ret));
	                    
		                    ret_clon.origin_x = piece_down.points[2].x;
		                    ret_clon.origin_y = piece_down.points[2].y;
			          		ret_clon.height = (ret.origin_y + ret.height) - piece_down.points[2].y;
			          		
			          		// En el último paso ya sí se puede modificar la altura
			          		// del retal original sin que afecte al resto calculado.
			          		ret.height = ret.height - ret_clon.height;
			          		
			          		this.setTrCoordinates(ret);
		          	
				          	// Si el nuevo retal tiene que estar dentro de las
				          	// dimensiones de la hoja y tener ancho y alto suficiente.
				          	if (ret_clon && ret_clon.width > 0 && ret_clon.height > 0
				          		&& ret_clon.origin_x >= 0 && ret_clon.origin_x < ret_clon.sheet_width
				          		&& ret_clon.origin_y >= 0 && ret_clon.origin_y < ret_clon.sheet_height) {
								
							  // NOTA: Se modifica el nombre del nuevo retal añadiendo una "C" para poder distinguirlo luego.
			                  ret_clon.name = ret_clon.name + 'C';
			                  
			                  // IMPORTANTE: También hay que modificar su ID para distinguirlo al exportar a Turomas.
			                  this.traverse_count++;
			                  ret_clon.id = this.traverse_count;
			                  
			                  // console.log('--> Añadido retal clon[' + (j + 1) + '] = ');
			                  // console.log(ret_clon);
			                  
			                  this.setTrCoordinates(ret_clon);
			                  
			                  if (ret_clon.width === ret.width && ret_clon.height === ret.height
			                      && ret_clon.origin_x === ret.origin_x ) {
									
								// console.log('--> No se mete el retal por ser similar al original:');
								// console.log(ret);
								// console.log(ret_clon);
								
							  } else {
								
								// console.log('--> Se inserta el nuevo retal copia:');
								
								adyacent_ok = true;
								
								// Se inserta el nuevo retal copia.
								sheetIn.traverses.push(ret_clon);
							  }
				            } // End If "dentro de dimensiones" de hoja.
						  } // End If !tail_retal.
					} // End If retal adyacente.
					
					if (adyacent_ok) {
						
						console.log('-> Retal modificado. Saliendo de la búsqueda de retal.');
						// console.log(ret);
						// console.log(ret_clon);
								
						break;
					}
				} // End For sheetIn.traverses
		      	
			  } // End If piezas apiladas.
	      }); // End FOR piezas segunda vuelta de la hoja. 
	    }); // End FOR piezas de la hoja.
	} // End IF sheetIn.pieces
    
    //[travXList, travXTotalList] = this.getLevelTraversesX(1, totalTravList, aux_array, sheet.points, 'X', false);
    
  } // End function cutDiferenceHeight2
  
  // Función que dadas las piezas de una hoja y los puntos representativos de una pieza,
  // devuelve un valor de X que parte la pieza en dos formando una travera X en la hoja.
  findTraverseXPoint(sheetIn: any, pointsIn: any, indexIn: number, maxTrav: number) {
    // console.log('--> findTraverseXPoint: ' + indexIn);
    // console.log(pointsIn);
    
    let cero_y = []; // Se guardan los X con altura cero.
    let same_x = []; // Se guardan los X con la mima altura que la pieza de entrada.
    
    sheetIn.forEach((elem, i) => {
          
      // console.log(' - elem: ' + i);
      // console.log(elem);
      // console.log(elem.piece);
      // console.log(elem.piece.draw.points);
      
      let chech_points = elem.piece.draw.points;
      
      if (chech_points[3].y === 0) {
            cero_y.push(chech_points[3].x);
      }
      
      // No puede buscarse los puntos en la misma pieza que se quiere dividir.
      //if (i !== indexIn) {
            if (chech_points[2].y === pointsIn[0].y) {
                  // Encontrado punto a la misma altura.
                  if (chech_points[2].x > pointsIn[0].x && chech_points[2].x < pointsIn[3].x) {
                  // La longitud del nuevo corte tiene que ser menor o igual que el máximo de travera.
                        if (chech_points[2].x - pointsIn[0].x <= maxTrav) {
                            // Encontrado punto en la misma línea.
                        	same_x.push(chech_points[2].x);
                        } // else {
                            // console.log(' * El punto no sirve porque deja una pieza aún grande: ' + chech_points[2].x);
                        // }
                  }
            }
      //} // End If indexIn.
    });
    
    console.log(' ->> same_x: ');
    console.log(same_x);
    console.log(' ->> cero_y: ');
    console.log(cero_y);
    
    let final_x = [];
    
    same_x.forEach((sx, i) => {          
        cero_y.forEach((zy, j) => {
        	if (sx === zy) {
                // Encontrada X de travera.
            	final_x.push(sx);
            }
    	});          
    });
    
    console.log(' ->> final_x: ');
    console.log(final_x);
    
    let x_result = 0;
    
    if (final_x.length > 1) {
    	x_result = final_x[Math.ceil((final_x.length - 1) / 2)];
    } else if (final_x.length === 1) {
        x_result = final_x[0];
    }
    
    console.log(' ->> findTraverseXPoint x_result: ');
    console.log(x_result);
    
    return x_result;
        
  } // End function findTraverseXPoint
  
  // Función que dadas las piezas de una hoja y los puntos representativos de un retal,
  // devuelve un valor de X que parte el retal en dos formando una travera X en la hoja.
  // Si el punto está entre dos piezas iguales entonces no se hace.
  findRetalXPoint(piecesIn: any, pointsIn: any, indexIn: number) {
    // console.log('--> findRetalXPoint: ' + indexIn);
    // console.log(pointsIn);
    
    let cero_y = []; // Se guardan los X con altura cero.
    let same_x = []; // Se guardan los X con la mima altura que la pieza de entrada.
    
    piecesIn.forEach((elem, i) => {
          
      // console.log(' - elem: ' + i);
      // console.log(elem);
      // console.log(elem.piece);
      // console.log(elem.piece.draw.points);
      
      let chech_points = elem.piece.points;
      
      if (chech_points[3].y === 0) {
            cero_y.push(chech_points[3].x);
      }
      
      // No puede buscarse los puntos en la misma pieza que se quiere dividir.
      //if (i !== indexIn) {
            if (chech_points[2].y === pointsIn[0].y) {
				
                  // Encontrado punto a la misma altura.
                  // console.log('--> same_x encontrado y: ' + chech_points[2].y);
                  // console.log(elem);
                   
                  if (chech_points[0].x > pointsIn[0].x && chech_points[0].x < pointsIn[3].x) {
                     
                    // Encontrado punto candidato en la misma línea.
                    // console.log('--> same_x encontrado x: ' + chech_points[0].x);
                    // console.log(elem);
                    
                	same_x.push( { x: chech_points[0].x, y: chech_points[2].y });
                        
                  }
            }
      //} // End If indexIn.
    });
    
    // console.log(' ->> same_x: ');
    // console.log(same_x);
    // console.log(' ->> cero_y: ');
    // console.log(cero_y);
    
    let final_x = [];
    
    same_x.forEach((sx, i) => {          
        cero_y.forEach((zy, j) => {
        	if (sx.x === zy) {
				
                // Encontrada X de travera.
            	final_x.push(sx);
            }
    	});          
    });
    
    // console.log(' ->> final_x: ');
    // console.log(final_x);
    
    let x_result = {x: 0, y: 0};
    
    if (final_x.length > 1) {
    	x_result = final_x[Math.ceil((final_x.length - 1) / 2)];
    } else if (final_x.length === 1) {
        x_result = final_x[0];
    }
    
    let before_p = null;
	let after_p = null;
		
    piecesIn.forEach((pz, i) => {
		
		let chech_points = pz.piece.points;

	    if (chech_points[1].x === x_result.x && chech_points[1].y === x_result.y) {
			
			// console.log('-> Pieza adyacente lateral posterior al punto de corte.');
			before_p = pz;
		}
		
		if (chech_points[2].x === x_result.x && chech_points[2].y === x_result.y) {
			
			// console.log('-> Pieza adyacente lateral anterior al punto de corte.');
			after_p = pz;
		}
    });
    
    if (before_p && after_p) {
		
		// console.log('-> El corte está entre dos piezas.');
		// console.log(before_p);
		// console.log(after_p);
		
		// El corte está entre dos piezas, entonces no se realiza.
		x_result = { x: 0, y: 0};
	}
    
    // console.log(' ->> findRetalXPoint x_result: ');
    // console.log(x_result);
    
    return x_result.x;
        
  } // End function findRetalXPoint
  
  // Función que dada una hoja la revisa y crea traveras X principales
  // en los lugares correctos a partir de dividir retales existentes en ella.
  createTraverseX() {
	
	console.log('--> Entrando en createTraverseX...');
	
	this.sheetList.forEach((sheet, i) => {
      // console.log(' --> sheet: ' + i);
      // console.log(sheet);
      
      let retals = sheet.traverses;
      let pieces = sheet.pieces;
      
      if (retals && pieces) {
	      for (let j = 0; j < retals.length; j++) {
	            
	          let elem = retals[j];
	          
	          // console.log('Retal: ' + j);
	      	  // console.log(elem);
	          
	          // Se clona el elemento.
	   	  	  let new_tr = JSON.parse(JSON.stringify(elem));
	   	  	  
	   	  	  if (elem.points) {
				
		   	  	  let points = elem.points;
		   	  	  
		   	  	  let new_points = JSON.parse(JSON.stringify(points));
		   	  	  
		   	  	  let width_aux = points[2].x - points[0].x;
		   	  	  let height_aux = points[2].y - points[0].y;
		   	  	  
		   	  	  let x_point = 0;
		  
			      // Si está colocado en el extremo superior.
			      // NOTA: hay que tener en cuenta los desbandes para comparar.
			      if (points[3].y + elem.height === elem.sheet_height - elem.disband.bottom - elem.disband.top) {
					
					// console.log('Retal en el extremo superior: ');
					// console.log(elem);
			        
			        // Se haya el punto por el que cortar si existiese.
			        x_point = this.findRetalXPoint(pieces, elem.points, j);
			        // console.log('--> x_point:');
			        // console.log(x_point);
			        
			        if (x_point) {
						
						// console.log('Existe punto donde cortar. Se modifica el retal para dividirlo en dos.');
		                
		            	// Modificamos el retal que se va a cortar.
		            	points[2].x = x_point;
		                points[3].x = x_point;
		                elem.width = x_point - points[0].x;
		                
		                this.setTrCoordinates(elem);
		                
		                // Nuevo retal sobrante.
		                new_tr.origin_x = x_point;
		                new_tr.points[0].x = x_point;
		                new_tr.points[1].x = x_point;
		            	// Se cambian las dimensiones del elemento.
		            	new_tr.width = new_tr.points[2].x - x_point;
		            	// Se le coloca un id de travera nuevo.
		            	this.traverse_count++;
		            	new_tr.id = this.traverse_count;
		            	
		            	this.setTrCoordinates(new_tr);
		            	
		            	// Se añade el nuevo elemento a la hoja.
		            	retals.push(new_tr);
		            	
		            } // End If x_point. */
		        } // End If y === 0
	          } // End If elem.draw.
	      } // End For retals.
	   } // End If retal/pieces.
    }); // End Foreach sheetList.
	
  } // End function createTraverseX.
  
  // NOTA: No se está usando.
  // Función que corta retales cuya longitud supere el ancho máximo de travera.
  // Tiene en cuenta que el corte coincida con algún corte ya hecho de forma
  // que uniéndolos se cree una travera X en la plancha.
  cutMaxTraverseSheet(maxTraverseIn: number) {
    console.log('--> cutMaxTraverseSheet sheetList:');
    // console.log(this.sheetList);
    
    this.sheetList.forEach((sheet, i) => {
      // console.log(' --> sheet: ' + i);
      // console.log(sheet);
      
      let retals = sheet.traverses;
      let pieces = sheet.pieces;
      
      //retals.forEach((elem, j) => { // NOTA: no se hace con "forEach" porque no reitera los "push" internos que se añadan.
      for (let j = 0; j < retals.length; j++) {
            
          let elem = retals[j];
            
          // console.log('Retal: ' + j);
      	  // console.log(elem);
            
          // Se clona el elemento.
   	  	  let new_tr = JSON.parse(JSON.stringify(elem));
   	  	  
   	  	  let points = elem.draw.points;
   	  	
   	  	  let new_points = JSON.parse(JSON.stringify(points));
   	  	  
   	  	  let width_aux = points[2].x - points[0].x;
   	  	  let height_aux = points[2].y - points[0].y;
   	  	  
   	  	  let x_point = 0;
  
	      // Para el eje X. Se encuentra un elemento más ancho de lo permitido.
	      // Hay que dividirlo en dos para que cumpla la condición de max travera.
	      if (maxTraverseIn < width_aux) {
	        
	        // Se haya el punto por el que cortar.
	        x_point = this.findTraverseXPoint(pieces, points, j, maxTraverseIn);
	        
	        if (x_point) {
                
            	// Modificamos el primer retal.
            	points[2].x = x_point;
                points[3].x = x_point;
                elem.width = elem.draw.width = x_point - points[0].x;
                elem.draw.area = (elem.width * elem.height) / 1000000;
                
                // Nuevo retal sobrante.
                new_tr.origin_x = x_point;
                new_tr.draw.points[0].x = x_point;
                new_tr.draw.points[1].x = x_point;
            	// Se cambian las dimensiones del elemento.
            	new_tr.width = new_tr.draw.width = new_tr.draw.points[2].x - x_point;
            	new_tr.draw.area = (new_tr.draw.width * new_tr.draw.height) / 1000000;
            	// Se le coloca un id de travera nuevo.
            	this.traverse_count++;
            	new_tr.id = this.traverse_count;
            	// Se añade el nuevo elemento a la hoja.
            	retals.push(new_tr);
            	
            } // End If x_point.
            
          } // End If maxTraverseIn.
            
        } // }); // End Foreach retals.
      
    }); // End Foreach sheetList.
        
  } // End function cutMaxTraverseSheet.
  
  // NOTA: no se usa de momento porque se controla en el mergeo.
  // Función que recorre las traveras de retales y las divide para que
  // no supere ancho máximo de travera permitido para la optimización.
  // Se parte de la premisa que las traveras adyacentes se unieron antes.
  cutMaxTraverse(maxTraverseIn: number) {
    console.log('--> cutMaxTraverse:' + maxTraverseIn);
    
    this.traverseList = this.traverseList.filter(item => !item.used);

    this.traverseList.forEach((tr1, i) => {
          
      // console.log(' --> -> tr1:');
   	  // console.log(JSON.stringify(tr1));

      let new_tr = JSON.parse(JSON.stringify(tr1));
      
      // Para el eje X.
      if (maxTraverseIn < tr1.width) {
            
        //this.findTraverseXPoint(tr1.origin_x, tr1.origin_y, tr1.sheet_id);
              
      	new_tr.width = tr1.width - maxTraverseIn;
      	tr1.width = maxTraverseIn;
      	
      	new_tr.origin_x = tr1.origin_x + maxTraverseIn;
      	
      	// Se incrementa el contador general de traveras.
      	this.traverse_count++;
      	
      	new_tr.id = this.traverse_count;
      	
      	this.setTrCoordinates(new_tr);
      	
      	// Se añade la nueva travera sobrante de cortar la travera que sobrepasaba el máximo.
      	this.traverseList.push(new_tr);
      	
      	// console.log(' --> -> cutMaxTraverse añadida nueva travera X:');
    	// console.log(new_tr);
    	// console.log(' --> -> cutMaxTraverse modificada antigua travera X:');
    	// console.log(JSON.stringify(tr1));
      }
    });
    
    this.oldTraverseList.forEach((tr1, i) => {
          
      // console.log(' --> -> old tr1:');
   	  // console.log(JSON.stringify(tr1));

      let new_tr = JSON.parse(JSON.stringify(tr1));
      
      // Para el eje X.
      if (maxTraverseIn < tr1.width) {
            
        //this.findTraverseXPoint(tr1.origin_x, tr1.origin_y, tr1.sheet_id);
              
      	new_tr.width = tr1.width - maxTraverseIn;
      	tr1.width = maxTraverseIn;
      	
      	new_tr.origin_x = tr1.origin_x + maxTraverseIn;
      	
      	// Se incrementa el contador general de traveras.
      	this.traverse_count++;
      	
      	new_tr.id = this.traverse_count;
      	
      	this.setTrCoordinates(new_tr);
      	
      	// Se añade la nueva travera sobrante de cortar la travera que sobrepasaba el máximo.
      	this.oldTraverseList.push(new_tr);
      	
      	// console.log(' --> -> cutMaxTraverse old añadida nueva travera X:');
    	// console.log(new_tr);
    	// console.log(' --> -> cutMaxTraverse old modificada antigua travera X:');
    	// console.log(JSON.stringify(tr1));
      }
    });

    // console.log(' --> -> cutMaxTraverse traverseList tras cortar traveras mayores que el máximo permitido:');
    // console.log(this.traverseList);
	// console.log(' --> -> cutMaxTraverse oldTraverseList tras cortar traveras mayores que el máximo permitido:');
    // console.log(this.oldTraverseList);
    
    // Se mergean nuevamente las adyacentes pero teniendo en cuenta que no se
    // sobrepase el máximo de ancho de travera X pasando el parámetro a "true".
    this.removeTraverseUsedAndMerge(true, this.max_depth_level);
    this.removeOldTraverseUsedAndMerge(true, this.max_depth_level);
    
  } // End function cutMaxTraverse (no se está usando esta función).
  
  modifyLastXTraverse(maxTraverseIn: number) {
    console.log('--> modifyLastXTraverse:' + maxTraverseIn);
    
    // Se quitan las hojas que no tengan traveras ni piezas.
    this.sheetList = this.sheetList.filter(s => (s.pieces || s.traverses) && s.unit !== -1);
    
    let last_sheet = this.sheetList[this.sheetList.length - 1];
    // let last_sheet = this.sheetList.pop();
    
    console.log('--> modifyLastXTraverse última hoja: ');
    console.log(last_sheet);
    
    // Buscamos el retal de cola en la última hoja.
    
    let retal_list = last_sheet.traverses;
    let piece_list = last_sheet.pieces;
    
    let travXList = null;
    let travXTotalList = null;
    
    // Construimos los punto que definen las dimensiones de la hoja actual.
	let coordinates = [];
	
	let extrem_sheet_w = last_sheet.width - last_sheet.disband.left - last_sheet.disband.right;
	let extrem_sheet_h = last_sheet.height - last_sheet.disband.top - last_sheet.disband.bottom;
	
	// Coordenada esquina superior izquierda.
	coordinates.push({x: 0, y: 0});
	// Coordenada esquina inferior izquierda.
	coordinates.push({x: 0, y: extrem_sheet_h});
	// Coordenada esquina inferior derecha.
	coordinates.push({x: extrem_sheet_w, y: extrem_sheet_h});
	// Coordenada esquina superior derecha.
	coordinates.push({x: extrem_sheet_w, y: 0});
	
	let framePoints = coordinates;
	
	let sum_pieces = [];
    
    [travXList, travXTotalList] = this.getLevelTraversesX(1, sum_pieces, piece_list, framePoints, 'X', false);
    
    
    console.log('--> modifyLastXTraverse sum_pieces:');
    console.log(sum_pieces);
    console.log('--> modifyLastXTraverse travXList:');
    console.log(travXList);
    console.log('--> modifyLastXTraverse travXTotalList:');
    console.log(travXTotalList);
    
    this.traverseList = this.traverseList.filter(item => !item.used);
    
    let axisIn = null;
    let disbandIn = null;
    let diecuttingIn = null;
    let maxDiecuttingIn = null;

	if (retal_list.length > 0) {
		
		axisIn = retal_list[0].axis;
    	disbandIn = retal_list[0].disband;
    	diecuttingIn = retal_list[0].diecutting;
    	maxDiecuttingIn = retal_list[0].max_diecutting;
	}
	
	/*
    retal_list.forEach((ret, i) => {
		
		console.log('--> Retal last:' + (i + 1));
    	console.log(ret);
    	
    	// this.traverseList.push(ret);
		
	}); // */
	
	let final_trav = null;
	// let final_piece = null;
	
	if (travXList.length > 0) {
		/*
		// Piezas de la última travera principal X antes de la cola.
		// Si encuentra alguna cuyo ancho sea mayor que su altura
		// entonces la gira para aumentar así el ancho del retal final.
		final_trav = travXList[0].pieces;
		
		final_trav.forEach(tr_p => {
			
			console.log('--> tr_p:');
	    	console.log(tr_p);
			
			if (tr_p.piece.piece_width > tr_p.piece.piece_height) {
			
				this.turnPiece(tr_p.piece,'piece_width', 'piece_height', 'piece_rotation');
				
				tr_p.piece['points'] = this.getPieceCoordinates(tr_p.origin_x, tr_p.origin_y, tr_p.piece.piece_width, tr_p.piece.piece_height);
			}
		}); // */
		
		let last_sheet_pieces = [];
		
		piece_list.forEach((p, i) => {
		//final_trav.forEach((p, i) => {
			
			console.log('--> Pieza last:' + (i + 1));
	    	console.log(p);
	    	/*
	    	let piece_finded = null;
	    	
	    	// Opción A) Sólo se giran las piezas que estaban en la última travera X.
	    	piece_finded = final_trav.find(tr_p => tr_p.piece.piece_num === p.piece.piece_num);
	    	
	    	if (piece_finded) {
				
				console.log('-> Pieza de cola para girar:');
				console.log(piece_finded);
				
				piece_finded.piece.piece_cut = false;
				
				this.nextPiece.push(piece_finded.piece);
				
			} else {
				p.piece.piece_cut = false;
				
				this.nextPiece.push(p.piece);
			} // End opción A. // */
			
	    	/*
	    	// Opción B) Se recolocan todas las piezas de la hoja para que el ancho sea el lado más corto.
	    	if (p.piece.piece_width > p.piece.piece_height) {
				
				console.log('-> Pieza en última hoja para girar:');
				console.log(p.piece);
				
				this.turnPiece(p.piece,'piece_width', 'piece_height', 'piece_rotation');
				
				if (p.piece.piece_set && p.piece.piece_set.length > 0) {
					
					p.piece.piece_set.forEach(p_in => {
						
						this.turnPiece(p_in,'piece_width', 'piece_height', 'piece_rotation');
						
						p_in['points'] = this.getPieceCoordinates(p.origin_x, p.origin_y, p_in.piece_width, p_in.piece_height);
						
					});
				}
				
				if (p.piece.piece_matrix && p.piece.piece_matrix.length > 0) {
					
					// Se recorre la matriz y se añade al piece_set.
	    			// Hay que tener en cuenta que la primera será la "pieza marco".
	    			for (let i = 0; i < p.piece.piece_matrix.length; i++) {
	                    
			        	for (let j = 0; j < p.piece.piece_matrix[i].length; j++) {
	                            
			                  // console.log('--> fit pin[' + (i + 1) + '][' + (j + 1) + ']');
			            	  let matrix_piece = p.piece.piece_matrix[i][j];
			            	  
			            	  this.turnPiece(matrix_piece,'piece_width', 'piece_height', 'piece_rotation');
			            	  
			            	  matrix_piece['points'] = this.getPieceCoordinates(p.origin_x, p.origin_y, matrix_piece.piece_width, matrix_piece.piece_height);
			            	  
			            } // End For piece_matrix j.
			        } // End For piece_matrix i.
			    } // End If piece_matrix.
				
				p.piece['points'] = this.getPieceCoordinates(p.origin_x, p.origin_y, p.piece.piece_width, p.piece.piece_height);
				
				p.piece.piece_cut = false;
				
				this.nextPiece.push(p.piece);
				
			} else {
				
				p.piece.piece_cut = false;
				
				this.nextPiece.push(p.piece);
				
			}  // End opción B. // */
			
			// Opción C)
			if (p.piece.piece_width > p.piece.piece_height) {
				if (p.piece.piece_matrix && p.piece.piece_matrix.length > 0) {
						
					// Se recorre la matriz y se añade al piece_set.
	    			// Hay que tener en cuenta que la primera será la "pieza marco".
	    			for (let i = 0; i < p.piece.piece_matrix.length; i++) {
	                    
			        	for (let j = 0; j < p.piece.piece_matrix[i].length; j++) {
	                            
		                  // console.log('--> fit pin[' + (i + 1) + '][' + (j + 1) + ']');
		            	  let matrix_piece = p.piece.piece_matrix[i][j];
		            	  
		            	  if (matrix_piece.piece_width > matrix_piece.piece_height) {
				
							console.log('-> Pieza bloque en última hoja para girar:');
							console.log(matrix_piece);
							
							this.turnPiece(matrix_piece,'piece_width', 'piece_height', 'piece_rotation');
						
							matrix_piece['points'] = this.getPieceCoordinates(p.origin_x, p.origin_y, matrix_piece.piece_width, matrix_piece.piece_height);
							
						  } // End If piece_width.
							
						  matrix_piece.piece_cut = false;
						
						  last_sheet_pieces.push(matrix_piece);
						  this.nextPiece.push(matrix_piece);
						  
						  console.log('-> Aumentando this.nextPiece con pieza bloque:');
						  console.log(this.nextPiece);
			            	  		            	  
			            } // End For piece_matrix j.
			        } // End For piece_matrix i.
	
				} else { // End If piece_matrix.
					
					console.log('-> Pieza única en última hoja para girar:');
					console.log(p.piece);
					
					this.turnPiece(p.piece,'piece_width', 'piece_height', 'piece_rotation');
				
					p.piece['points'] = this.getPieceCoordinates(p.origin_x, p.origin_y, p.piece.piece_width, p.piece.piece_height);
					
					last_sheet_pieces.push(p.piece);
					this.nextPiece.push(p.piece);
					
					console.log('-> Aumentando this.nextPiece con pieza única:');
					console.log(this.nextPiece);
					
				} // End Else piece_matrix.
			
			 } else {
				
				p.piece.piece_cut = false;
				
				last_sheet_pieces.push(p.piece);
				this.nextPiece.push(p.piece);
				
				console.log('-> Aumentando this.nextPiece con pieza única sin girar:');
				console.log(this.nextPiece);
				
			 } // End opción B. // */
			 // End opción C).

		}); // End Foreach piece_list.
		
		// last_sheet_pieces.forEach(lp => {
		// 	this.nextPiece.push(lp);
		// });
		
		console.log('-> Piezas para recolocar:');
		console.log(this.nextPiece);
		
	} // End If travXList.length.
	
	last_sheet.traverses = null;
	last_sheet.pieces = null;

    console.log('->> Siguiente plancha EXTRA:');
    console.log(this.nextSheet);

    if (last_sheet) {
      // Se coloca el contador de travera a 1 para representar la travera total de la hoja completa cargada.
	  
	  // Es indiferente este valor en el resultado.
	  last_sheet.used = false;
	  
      // let id = this.traverse_count;
      let id = last_sheet.id;

      let traverse_width = last_sheet.width;
      let traverse_height = last_sheet.height;
      let traverse_depth = last_sheet.depth;

      // Se ajusta el ancho y alto de la travera según el desbande existente.
      if (disbandIn && disbandIn.left > 0) {
        traverse_width -= disbandIn.left;
      }
      if (disbandIn && disbandIn.right > 0) {
        traverse_width -= disbandIn.right;
      }
      if (disbandIn && disbandIn.bottom > 0) {
        traverse_height -= disbandIn.bottom;
      }
      if (disbandIn && disbandIn.top > 0) {
        traverse_height -= disbandIn.top;
      }
      
      let coordinates = [];
	      
      	// Coordenada esquina superior izquierda.
		coordinates.push({x: 0, y: 0});
		// Coordenada esquina inferior izquierda.
		coordinates.push({x: 0, y: traverse_height});
		// Coordenada esquina inferior derecha.
		coordinates.push({x: traverse_width, y: traverse_height});
		// Coordenada esquina superior derecha.
		coordinates.push({x: traverse_width, y: 0});

      let new_traverse = {
        id: id,
        sheet_id: last_sheet.id,
        sheet_width: this.nextSheet.width,
        sheet_height: this.nextSheet.height,
        name: 'T' + axisIn + '' + id,
        axis: axisIn,
        width: traverse_width,
        height: traverse_height,
        depth: traverse_depth,
        piece: null,
        father: 0,
        used: false,
        diecutting: diecuttingIn,
        max_diecutting: maxDiecuttingIn,
        disband: disbandIn,
        origin_x: 0, // Valor origen en el eje X.
        origin_y: 0, // Valor origen en el eje Y.
        draw: null,
        old: false,
        level: 0,
        level_h: 0,
        points: coordinates
      };

      // Se vacía la lista de traveras.
      this.traverseList = [];
      this.oldTraverseList = [];
      this.pieceList = [];

	  // Se añade la travera vacía que ocupa todo el marco de la hoja
	  // a la lista de traveras candidatas (sólo estará esa).
      this.traverseList.push(new_traverse);
      
      console.log('--> Retal traverseList EXTRA:');
      console.log(this.traverseList);
      
      // Si no se hace el "pop()" arriba no es necesaria esta línea.
      // this.sheetList.push(last_sheet);
      
      this.nextSheet = last_sheet;

    } // End If last_sheet.
		
  } // End function modifyLastXTraverse.
  
  // Función que asigna las coordenadas gráficas en la hoja de los cuatro vértices de una travera.
  setTrCoordinates(traverseIn: Traverse) {
	
	let coordinates = [];
	      
  	// Coordenada esquina superior izquierda.
	coordinates.push({x: traverseIn.origin_x, y: traverseIn.origin_y});
	// Coordenada esquina inferior izquierda.
	coordinates.push({x: traverseIn.origin_x, y: traverseIn.origin_y + traverseIn.height});
	// Coordenada esquina inferior derecha.
	coordinates.push({x: traverseIn.origin_x + traverseIn.width, y: traverseIn.origin_y + traverseIn.height});
	// Coordenada esquina superior derecha.
	coordinates.push({x: traverseIn.origin_x + traverseIn.width, y: traverseIn.origin_y});

	// Se asignan a la travera.
	traverseIn.points = coordinates;
	
	//return coordinates;
  } // End function setTrCoordinates.
  
  // Función que devuelve las coordenadas gráficas en la hoja de los cuatro vértices de una pieza.
  getPieceCoordinates(originXIn: number, originYIn: number, pieceWidth: number, pieceHeight: number) {
	
	let coordinates = [];
	      
  	// Coordenada esquina superior izquierda.
	coordinates.push({x: originXIn, y: originYIn});
	// Coordenada esquina inferior izquierda.
	coordinates.push({x: originXIn, y: originYIn + pieceHeight});
	// Coordenada esquina inferior derecha.
	coordinates.push({x: originXIn + pieceWidth, y: originYIn + pieceHeight});
	// Coordenada esquina superior derecha.
	coordinates.push({x: originXIn + pieceWidth, y: originYIn});
	
	return coordinates;
  } // End function getPieceCoordinates.
  			

  // ----------
  //  GRÁFICOS
  // ----------

  // Función que dibuja las piezas que se colocaron en las hojas.
  drawGraphics(originIn: number): Draw[] {
    console.log('--> drawGraphics: ' + originIn);

    let graphicList = [];

    // Se recorren todas las hojas existenes en el listado de planchas candidatas
    // y se dibuja los gráficos de puntos que pudieran contener dentro.
    this.sheetList.forEach((sheet, index) => {

      // Primero siempre se va a dibujar el contorno de la hoja.
      if (sheet.used) {
        graphicList.push(this.drawSheet(sheet, index));
        
        if (sheet.traverses && sheet.traverses.length > 0) {
	        // console.log('--> sh[' + index + '] = ');
	        // console.log(sheet);
	
	        if (sheet.pieces && sheet.pieces.length === 0) {
	          sheet.used = false;
	        } else {
	          sheet.traverses.forEach((tvr, i) => {
	            // console.log('-->h[' + index + '] t[' + i + '] = ');
	            // console.log(tvr);
	            
	            // Se aplica la transformación al punto teniendo en cuenta la "esquina origen"" que se va a usar en la optimización.
	          	//this.applyTransform(tvr, originIn, sheet.width, sheet.height);
	
	            // Se añade el dibujo del elemento (será un gráfico cerrado para cada uno).
	            graphicList.push(this.drawElement(tvr, i, sheet.mat_name, sheet.mat_desc, sheet.mat_id, sheet.width, sheet.height, sheet.depth, originIn, sheet.disband));
	
	          });
	        }
	    }

	    if (sheet.pieces && sheet.pieces.length > 0) {
	        // console.log('--> sh[' + index + '] = ');
	        // console.log(sheet);
	
	        sheet.pieces.forEach((tvr, i) => {
	          // console.log('-->h[' + index + '] p[' + i + '] = ');
	          // console.log(tvr);
	          
	          // Se aplica la transformación al punto teniendo en cuenta la "esquina origen" que se va a usar en la optimización.
	          //this.applyTransform(tvr, originIn, sheet.width, sheet.height);
	
	          // Se añade el dibujo del elemento (será un gráfico cerrado para cada uno).
	          graphicList.push(this.drawElement(tvr, i, sheet.mat_name, sheet.mat_desc, sheet.mat_id, sheet.width, sheet.height, sheet.depth, originIn, sheet.disband));
	
	        });
	    }
        
      } else {
		console.log('--> Encontrada hoja no usada. Se salta y continuamos mirando hojas.');
		console.log(sheet);
		
		// Si se quisiera saltar sin mirar más hojas (suponer así que el resto tampoco estarían usadas).
		//return graphicList;
	  }
	  
    }); // End ForEach sheetList.

    return graphicList;

  } // End function drawGraphics
  
  // Función que transforma un punto en otro correspondiente a la relación con el tipo del "punto de origen"".
  changeOriginPoint(pointIn: any, sheetWidth: number, sheetHeight: number, disbandIn: any, originIn: number) {
    
    // console.log('--> changeOriginPoint originIn:' + originIn);
    // console.log(pointIn);
    
    let height_aux = 0;
    let width_aux = 0;
    
    switch (Number(originIn)) {
        case 2:
        	 height_aux = pointIn[1].y - pointIn[0].y;
      		
		     pointIn[0].y = sheetHeight - height_aux - pointIn[0].y - disbandIn.top - disbandIn.bottom;
		     pointIn[1].y = sheetHeight - pointIn[1].y + height_aux - disbandIn.top - disbandIn.bottom;
		     pointIn[2].y = sheetHeight - pointIn[2].y + height_aux - disbandIn.top - disbandIn.bottom;
		     pointIn[3].y = sheetHeight - height_aux - pointIn[3].y - disbandIn.top - disbandIn.bottom;
        
        break;
        
        case 3:
        	 height_aux = pointIn[1].y - pointIn[0].y;        	 
        	 width_aux = pointIn[3].x - pointIn[0].x;
        	 
        	 pointIn[0].x = sheetWidth - pointIn[0].x - disbandIn.right - disbandIn.left;
		     pointIn[1].x = sheetWidth - pointIn[1].x - disbandIn.right - disbandIn.left;
		     pointIn[2].x = sheetWidth - pointIn[2].x - disbandIn.right - disbandIn.left;
		     pointIn[3].x = sheetWidth - pointIn[3].x - disbandIn.right - disbandIn.left;
      		
		     pointIn[0].y = sheetHeight - height_aux - pointIn[0].y - disbandIn.top - disbandIn.bottom;
		     pointIn[1].y = sheetHeight - pointIn[1].y + height_aux - disbandIn.top - disbandIn.bottom;
		     pointIn[2].y = sheetHeight - pointIn[2].y + height_aux - disbandIn.top - disbandIn.bottom;
		     pointIn[3].y = sheetHeight - height_aux - pointIn[3].y - disbandIn.top - disbandIn.bottom;
		     
		     let p0_x_aux = pointIn[0].x;
		     let p0_y_aux = pointIn[0].y;
		     let p1_x_aux = pointIn[1].x;
		     let p1_y_aux = pointIn[1].y;
		     let p2_x_aux = pointIn[2].x;
		     let p2_y_aux = pointIn[2].y;
		     let p3_x_aux = pointIn[3].x;
		     let p3_y_aux = pointIn[3].y;
		     
		     pointIn[0].x = p3_x_aux;
		     pointIn[0].y = p3_y_aux;
		     pointIn[3].x = p0_x_aux;
		     pointIn[3].y = p0_y_aux;
		     
		     pointIn[1].x = p2_x_aux;
		     pointIn[1].y = p2_y_aux;
		     pointIn[2].x = p1_x_aux;
		     pointIn[2].y = p1_y_aux;
		     
        break;
        
        case 4:
              
        	 width_aux = pointIn[3].x - pointIn[0].x;
        	 
        	 pointIn[0].x = sheetWidth - pointIn[0].x - disbandIn.right - disbandIn.left;
		     pointIn[1].x = sheetWidth - pointIn[1].x - disbandIn.right - disbandIn.left;
		     pointIn[2].x = sheetWidth - pointIn[2].x - disbandIn.right - disbandIn.left;
		     pointIn[3].x = sheetWidth - pointIn[3].x - disbandIn.right - disbandIn.left;
		     
		     let p0_x_aux2 = pointIn[0].x;
		     let p0_y_aux2 = pointIn[0].y;
		     let p1_x_aux2 = pointIn[1].x;
		     let p1_y_aux2 = pointIn[1].y;
		     let p2_x_aux2 = pointIn[2].x;
		     let p2_y_aux2 = pointIn[2].y;
		     let p3_x_aux2 = pointIn[3].x;
		     let p3_y_aux2 = pointIn[3].y;
		     
		     pointIn[0].x = p3_x_aux2;
		     pointIn[0].y = p3_y_aux2;
		     pointIn[3].x = p0_x_aux2;
		     pointIn[3].y = p0_y_aux2;
		     
		     pointIn[1].x = p2_x_aux2;
		     pointIn[1].y = p2_y_aux2;
		     pointIn[2].x = p1_x_aux2;
		     pointIn[2].y = p1_y_aux2;
		     
        break;
        
  	} // End switch originIn.
/*  	
  	// let pointFinal = JSON.parse(JSON.stringify(pointIn));
  	let pointFinal = [];
  	
  	pointIn.forEach(p => {
              pointFinal.push({x: p.x, y: p.y} );
        });
  	
  	console.log('--> changeOriginPoint final:');
    console.log(pointFinal);
  	
  	return pointFinal; */
  } // End function changeOriginPoint
  
  applyTransform(trvIn: any, originIn: number, sheetWidth: number, sheetHeight: number) {
    console.log('--> applyTransform origin:' + originIn);
    console.log(trvIn);
    
    let points = [];
    
    if (trvIn.draw) {
      points = trvIn.draw.points;
    }
    
    
    switch (Number(originIn)) {
          case 1:
                
                break;
                
          case 2:
                
                break;
                
          case 3:
                
                break;
                               
          case 4:                
                
                break;
    } // End switch originIn
    
  } // End function applyTransform

  // Reparte de nuevo dos restos rectangulares contiguos que forman una L.
  //
  // En la fase de optimización sólo se permite cuando los dos rectángulos
  // originales tienen un lado menor que la pieza más estrecha. En la fase
  // final se prioriza eliminar franjas estrechas integrándolas en restos más
  // anchos; como criterio secundario puede prolongarse una franja sin hacerla
  // todavía más estrecha. En ambos casos la unión y el área se conservan.
  consolidateRemainderAreas(sheetTraverses: any[],
                            sheetWidthIn: number,
                            sheetHeightIn: number,
                            travXListIn: any,
                            preferCuttingEaseIn: boolean = false): number {
    if (!this.useRemainderConsolidation ||
        !Array.isArray(sheetTraverses) ||
        sheetTraverses.length < 2) {
      return 0;
    }

    const eps = 0.001;
    const sheetWidth = Number(sheetWidthIn);
    const sheetHeight = Number(sheetHeightIn);
    const usefulSide = Number(this.min_side);
    const preferCuttingEase = preferCuttingEaseIn === true;
    if (!(Number.isFinite(sheetWidth) && sheetWidth > eps &&
          Number.isFinite(sheetHeight) && sheetHeight > eps &&
          Number.isFinite(usefulSide) && usefulSide > eps)) {
      return 0;
    }

    const maxDieCutting = Number(this.max_die_cutting);
    const principalXCuts = Object.keys(travXListIn || {})
      .filter(key => key.indexOf('x_') === 0)
      .map(key => Number(key.substring(2)))
      .filter(value => Number.isFinite(value));
    const isPrincipalX = (valueIn: number): boolean =>
      principalXCuts.some(value => Math.abs(value - valueIn) <= eps);
    const near = (leftIn: number, rightIn: number): boolean =>
      Math.abs(leftIn - rightIn) <= eps;
    const shortSide = (rectIn: any): number =>
      Math.min(Number(rectIn.width), Number(rectIn.height));
    const rectArea = (rectIn: any): number =>
      Number(rectIn.width) * Number(rectIn.height);
    const validTraverse = (traverseIn: any): boolean => {
      if (!traverseIn || traverseIn.used || traverseIn.piece ||
          // El cierre estructural también es resto real. En la pasada final
          // puede absorber franjas estrechas si la nueva partición sigue
          // cubriendo exactamente la misma superficie libre.
          (!preferCuttingEase && traverseIn.fixed_cut === true) ||
          traverseIn.remainder_cut_ease_locked === true) {
        return false;
      }
      const x = Number(traverseIn.origin_x);
      const y = Number(traverseIn.origin_y);
      const width = Number(traverseIn.width);
      const height = Number(traverseIn.height);
      return Number.isFinite(x) && Number.isFinite(y) &&
        Number.isFinite(width) && Number.isFinite(height) &&
        width > eps && height > eps &&
        x >= -eps && y >= -eps &&
        x + width <= sheetWidth + eps &&
        y + height <= sheetHeight + eps;
    };
    const validOutput = (rectIn: any, maxSourceWidthIn: number): boolean => {
      if (!rectIn ||
          !(Number.isFinite(rectIn.x) && Number.isFinite(rectIn.y) &&
            Number.isFinite(rectIn.width) && Number.isFinite(rectIn.height)) ||
          rectIn.width <= eps || rectIn.height <= eps ||
          rectIn.x < -eps || rectIn.y < -eps ||
          rectIn.x + rectIn.width > sheetWidth + eps ||
          rectIn.y + rectIn.height > sheetHeight + eps) {
        return false;
      }

      // Nunca empeorar el límite de ancho de travera. Si el origen ya contenía
      // una travera mayor que el máximo configurado, tampoco se la agranda.
      const allowedWidth = Number.isFinite(maxDieCutting) && maxDieCutting > eps
        ? Math.max(maxDieCutting, maxSourceWidthIn)
        : maxSourceWidthIn;
      return rectIn.width <= allowedWidth + eps;
    };
    const quality = (rectanglesIn: any[]): any => {
      const usefulCount = rectanglesIn.filter(rect =>
        shortSide(rect) + eps >= usefulSide &&
        rectArea(rect) + eps >= Number(this.min_area || 0)
      ).length;
      const sideSum = rectanglesIn.reduce(
        (sum, rect) => sum + Math.min(usefulSide, shortSide(rect)),
        0
      );
      const minShortSide = Math.min.apply(
        null,
        rectanglesIn.map(rect => shortSide(rect))
      );
      return {
        usefulCount: usefulCount,
        sideSum: sideSum,
        minShortSide: minShortSide
      };
    };
    const isImprovement = (beforeIn: any, afterIn: any): boolean => {
      if (afterIn.usefulCount < beforeIn.usefulCount ||
          afterIn.minShortSide + eps < beforeIn.minShortSide) {
        return false;
      }
      return afterIn.usefulCount > beforeIn.usefulCount ||
        afterIn.sideSum > beforeIn.sideSum + eps;
    };
    const betterCandidate = (candidateIn: any, bestIn: any): boolean => {
      if (!bestIn) return true;
      if (preferCuttingEase) {
        // Para el operario importa antes eliminar una franja estrecha que
        // alargarla. Sólo después se compara la continuidad obtenida.
        if (candidateIn.narrowCountGain !== bestIn.narrowCountGain) {
          return candidateIn.narrowCountGain > bestIn.narrowCountGain;
        }
        if (!near(candidateIn.minSideGain, bestIn.minSideGain)) {
          return candidateIn.minSideGain > bestIn.minSideGain;
        }
        if (candidateIn.fixedCutGain !== bestIn.fixedCutGain) {
          return candidateIn.fixedCutGain > bestIn.fixedCutGain;
        }
        if (!near(candidateIn.operatorSpanGain, bestIn.operatorSpanGain)) {
          return candidateIn.operatorSpanGain > bestIn.operatorSpanGain;
        }
      }
      if (candidateIn.usefulGain !== bestIn.usefulGain) {
        return candidateIn.usefulGain > bestIn.usefulGain;
      }
      if (!near(candidateIn.sideGain, bestIn.sideGain)) {
        return candidateIn.sideGain > bestIn.sideGain;
      }
      if (!near(candidateIn.minSideGain, bestIn.minSideGain)) {
        return candidateIn.minSideGain > bestIn.minSideGain;
      }
      if (!near(candidateIn.cutGain, bestIn.cutGain)) {
        return candidateIn.cutGain > bestIn.cutGain;
      }
      if (candidateIn.firstIndex !== bestIn.firstIndex) {
        return candidateIn.firstIndex < bestIn.firstIndex;
      }
      return candidateIn.secondIndex < bestIn.secondIndex;
    };

    let changes = 0;
    const cuttingEaseTrace = [];
    const cuttingEaseTouched = [];
    const maxIterations = preferCuttingEase
      ? Math.max(1, sheetTraverses.length)
      : Math.max(1, sheetTraverses.length * sheetTraverses.length * 4);

    for (let iteration = 0; iteration < maxIterations; iteration++) {
      let best = null;

      for (let firstIndex = 0; firstIndex < sheetTraverses.length; firstIndex++) {
        const first = sheetTraverses[firstIndex];
        if (!validTraverse(first)) continue;

        for (let secondIndex = firstIndex + 1; secondIndex < sheetTraverses.length; secondIndex++) {
          const second = sheetTraverses[secondIndex];
          if (!validTraverse(second) || first.sheet_id !== second.sheet_id) continue;

          const firstRect = {
            x: Number(first.origin_x),
            y: Number(first.origin_y),
            width: Number(first.width),
            height: Number(first.height)
          };
          const secondRect = {
            x: Number(second.origin_x),
            y: Number(second.origin_y),
            width: Number(second.width),
            height: Number(second.height)
          };
          const beforeRects = [firstRect, secondRect];

          if (!preferCuttingEase) {
            // Durante la colocación de piezas la transformación se limita a
            // dos restos que no podían alojar ninguna pieza.
            if (beforeRects.some(rect => shortSide(rect) + eps >= usefulSide)) {
              continue;
            }
          }

          const beforeQuality = quality(beforeRects);
          const maxSourceWidth = Math.max(firstRect.width, secondRect.width);
          const includesFixedCut =
            first.fixed_cut === true || second.fixed_cut === true;
          const candidates = [];

          // Rectángulos contiguos lateralmente y alineados arriba o abajo:
          // la zona común pasa a ser una banda horizontal.
          let left = null;
          let right = null;
          if (near(firstRect.x + firstRect.width, secondRect.x)) {
            left = firstRect;
            right = secondRect;
          } else if (near(secondRect.x + secondRect.width, firstRect.x)) {
            left = secondRect;
            right = firstRect;
          }
          if (left && right &&
              !near(left.height, right.height) &&
              (!isPrincipalX(right.x) ||
                (preferCuttingEase && includesFixedCut))) {
            const alignedTop = near(left.y, right.y);
            const alignedBottom = near(
              left.y + left.height,
              right.y + right.height
            );
            if (alignedTop || alignedBottom) {
              const commonHeight = Math.min(left.height, right.height);
              const taller = left.height > right.height ? left : right;
              const commonY = alignedTop
                ? left.y
                : left.y + left.height - commonHeight;
              const common = {
                x: left.x,
                y: commonY,
                width: left.width + right.width,
                height: commonHeight
              };
              const residual = {
                x: taller.x,
                y: alignedTop ? taller.y + commonHeight : taller.y,
                width: taller.width,
                height: taller.height - commonHeight
              };
              candidates.push({
                rectangles: [common, residual],
                oldCutLength: commonHeight,
                newCutLength: taller.width
              });
            }
          }

          // Rectángulos apilados y alineados a izquierda o derecha:
          // la zona común pasa a ser una banda vertical.
          let top = null;
          let bottom = null;
          if (near(firstRect.y + firstRect.height, secondRect.y)) {
            top = firstRect;
            bottom = secondRect;
          } else if (near(secondRect.y + secondRect.height, firstRect.y)) {
            top = secondRect;
            bottom = firstRect;
          }
          if (top && bottom && !near(top.width, bottom.width)) {
            const alignedLeft = near(top.x, bottom.x);
            const alignedRight = near(
              top.x + top.width,
              bottom.x + bottom.width
            );
            if (alignedLeft || alignedRight) {
              const commonWidth = Math.min(top.width, bottom.width);
              const wider = top.width > bottom.width ? top : bottom;
              const rightEdge = top.x + top.width;
              const commonX = alignedLeft ? top.x : rightEdge - commonWidth;
              const common = {
                x: commonX,
                y: top.y,
                width: commonWidth,
                height: top.height + bottom.height
              };
              const residual = {
                x: alignedLeft ? wider.x + commonWidth : wider.x,
                y: wider.y,
                width: wider.width - commonWidth,
                height: wider.height
              };
              candidates.push({
                rectangles: [common, residual],
                oldCutLength: commonWidth,
                newCutLength: wider.height
              });
            }
          }

          candidates.forEach(candidate => {
            const outputRects = candidate.rectangles;
            if (!validOutput(outputRects[0], maxSourceWidth) ||
                !validOutput(outputRects[1], maxSourceWidth)) {
              return;
            }
            const areaBefore = rectArea(firstRect) + rectArea(secondRect);
            const areaAfter = rectArea(outputRects[0]) + rectArea(outputRects[1]);
            const areaTolerance = Math.max(eps, areaBefore * 0.0000001);
            if (Math.abs(areaBefore - areaAfter) > areaTolerance) {
              return;
            }

            const afterQuality = quality(outputRects);
            const beforeNarrowCount = beforeRects.filter(
              rect => shortSide(rect) + eps < usefulSide
            ).length;
            const afterNarrowCount = outputRects.filter(
              rect => shortSide(rect) + eps < usefulSide
            ).length;
            const narrowCountGain = beforeNarrowCount - afterNarrowCount;
            const minSideGain =
              afterQuality.minShortSide - beforeQuality.minShortSide;
            const beforeLongestSpan = Math.max.apply(
              null,
              beforeRects.map(rect => Math.max(rect.width, rect.height))
            );
            const operatorSpanGain =
              Math.max(outputRects[0].width, outputRects[0].height) -
              beforeLongestSpan;
            // La continuidad sólo es útil para el operario si la banda común
            // tiene también un ancho aprovechable. Una franja de 12 mm no se
            // convierte en un resto mejor por prolongarla muchos milímetros.
            const operatorCommonIsUseful =
              shortSide(outputRects[0]) + eps >= usefulSide;
            const removesNarrowRemainder =
              narrowCountGain > 0 && minSideGain > eps;
            const widensStructuralPartition =
              includesFixedCut && minSideGain > eps;
            if ((!preferCuttingEase && !isImprovement(beforeQuality, afterQuality)) ||
                // Nunca crear más restos estrechos de los que había.
                (preferCuttingEase && narrowCountGain < 0) ||
                // No fragmentar una banda común larga para mejorar únicamente
                // el lado corto. Es precisamente la representación unificada
                // que permite retirarla antes de tronzar las columnas.
                (preferCuttingEase && operatorSpanGain < -eps) ||
                // Dos mejoras finales posibles:
                // 1) desaparece al menos una franja estrecha al integrarla en
                //    restos más anchos (prioridad principal);
                // 2) se obtiene una continuidad ancha y muy superior sin
                //    empeorar la anchura mínima de los restos implicados.
                (preferCuttingEase &&
                  !removesNarrowRemainder &&
                  !widensStructuralPartition &&
                  (!operatorCommonIsUseful ||
                    operatorSpanGain + eps < usefulSide * 2 ||
                    minSideGain < -eps))) {
              return;
            }

            const evaluated = {
              firstIndex: firstIndex,
              secondIndex: secondIndex,
              rectangles: outputRects,
              usefulGain: afterQuality.usefulCount - beforeQuality.usefulCount,
              sideGain: afterQuality.sideSum - beforeQuality.sideSum,
              minSideGain: minSideGain,
              narrowCountGain: narrowCountGain,
              fixedCutGain:
                includesFixedCut &&
                (removesNarrowRemainder || widensStructuralPartition) ? 1 : 0,
              cutGain: candidate.oldCutLength - candidate.newCutLength,
              operatorSpanGain: operatorSpanGain
            };
            if (betterCandidate(evaluated, best)) {
              best = evaluated;
            }
          });
        }
      }

      if (!best) break;

      const first = sheetTraverses[best.firstIndex];
      const second = sheetTraverses[best.secondIndex];
      const commonLevel = Math.max(Number(first.level || 0), Number(second.level || 0));
      const commonLevelH = Math.max(Number(first.level_h || 0), Number(second.level_h || 0));
      const beforeTrace = preferCuttingEase
        ? [first, second].map(traverse => ({
            id: traverse.id,
            x: Number(traverse.origin_x),
            y: Number(traverse.origin_y),
            width: Number(traverse.width),
            height: Number(traverse.height)
          }))
        : null;
      [first, second].forEach((traverse, index) => {
        const rect = best.rectangles[index];
        traverse.origin_x = rect.x;
        traverse.origin_y = rect.y;
        traverse.width = rect.width;
        traverse.height = rect.height;
        traverse.level = commonLevel;
        traverse.level_h = commonLevelH;
        if (preferCuttingEase) {
          if (cuttingEaseTouched.indexOf(traverse) < 0) {
            cuttingEaseTouched.push(traverse);
          }
        } else {
          traverse.remainder_consolidated = true;
        }
        traverse.draw = null;
        this.setTrCoordinates(traverse);
      });
      if (preferCuttingEase) {
        cuttingEaseTrace.push({
          sheet_id: first.sheet_id,
          span_gain: best.operatorSpanGain,
          narrow_count_gain: best.narrowCountGain,
          min_side_gain: best.minSideGain,
          fixed_cut_gain: best.fixedCutGain,
          before: beforeTrace,
          after: [first, second].map(traverse => ({
            id: traverse.id,
            x: Number(traverse.origin_x),
            y: Number(traverse.origin_y),
            width: Number(traverse.width),
            height: Number(traverse.height)
          }))
        });
      }
      changes++;
    }

    // Se bloquean al terminar la fase, no después de cada pareja. De este modo
    // una franja recién prolongada puede absorber el siguiente resto contiguo
    // de la misma zona, pero una segunda representación no vuelve a repartirla.
    cuttingEaseTouched.forEach(traverse => {
      traverse.remainder_cut_ease_locked = true;
    });
    if (preferCuttingEase && cuttingEaseTrace.length > 0) {
      console.log('[Remainder cutting-ease] ' + JSON.stringify(cuttingEaseTrace));
    }
    return changes;
  }

  // Ejecuta la consolidación junto al merge histórico. Se repite unas pocas
  // veces porque una banda ensanchada puede dejar dos restos exactamente
  // alineados y el merge puede, a su vez, habilitar otra consolidación.
  improveRemainderAreas(sheetTraverses: any[],
                        sheetWidthIn: number,
                        sheetHeightIn: number,
                        travXListIn: any,
                        logChangesIn: boolean,
                        preferCuttingEaseIn: boolean = false): number {
    if (!this.useRemainderConsolidation || !Array.isArray(sheetTraverses)) {
      return 0;
    }

    let utilizationChanges = 0;
    for (let round = 0; round < 3; round++) {
      const roundChanges = this.consolidateRemainderAreas(
        sheetTraverses,
        sheetWidthIn,
        sheetHeightIn,
        travXListIn,
        false
      );
      utilizationChanges += roundChanges;
      if (roundChanges === 0) break;
      this.mergeRetalSheet(sheetTraverses, sheetHeightIn, travXListIn, 1);
    }

    const cuttingEaseChanges = preferCuttingEaseIn === true
      ? this.consolidateRemainderAreas(
          sheetTraverses,
          sheetWidthIn,
          sheetHeightIn,
          travXListIn,
          true
        )
      : 0;
    const totalChanges = utilizationChanges + cuttingEaseChanges;

    sheetTraverses.forEach(traverse => {
      if (traverse && !traverse.piece && !traverse.used &&
          Number(traverse.width) > 0 && Number(traverse.height) > 0) {
        this.setTrCoordinates(traverse);
      }
    });

    if (logChangesIn && totalChanges > 0) {
      console.log('[Remainder consolidation]', {
        sheet_id: sheetTraverses[0] ? sheetTraverses[0].sheet_id : null,
        changes: totalChanges,
        utilization_changes: utilizationChanges,
        cutting_ease_changes: cuttingEaseChanges,
        remainder_count: sheetTraverses.length
      });
    }
    return totalChanges;
  }

  // Aleja del retal estructural de cola las franjas estrechas que ocupan
  // exactamente la misma altura que una fila contigua de piezas. Se desplaza
  // la fila completa dentro de la misma envolvente rectangular y la franja
  // pasa al extremo interior. Así se conserva el retal principal completo,
  // no cambia el área libre y no se abren huecos entre piezas de la fila.
  shiftNarrowRemaindersAwayFromTail(sheetIn: any): number {
    if (!this.useRemainderConsolidation ||
        !sheetIn ||
        !Array.isArray(sheetIn.pieces) ||
        !Array.isArray(sheetIn.traverses) ||
        sheetIn.pieces.length < 1 ||
        sheetIn.traverses.length < 2) {
      return 0;
    }

    const eps = 0.001;
    const sheetWidth = Number(sheetIn.width);
    const sheetHeight = Number(sheetIn.height);
    const usefulSide = Number(this.min_side);
    if (!(Number.isFinite(sheetWidth) && sheetWidth > eps &&
          Number.isFinite(sheetHeight) && sheetHeight > eps &&
          Number.isFinite(usefulSide) && usefulSide > eps)) {
      return 0;
    }

    const near = (leftIn: number, rightIn: number): boolean =>
      Math.abs(leftIn - rightIn) <= eps;
    const freeTraverses = sheetIn.traverses.filter(traverse => {
      if (!traverse || traverse.used || traverse.piece) return false;
      const x = Number(traverse.origin_x);
      const y = Number(traverse.origin_y);
      const width = Number(traverse.width);
      const height = Number(traverse.height);
      return Number.isFinite(x) && Number.isFinite(y) &&
        Number.isFinite(width) && Number.isFinite(height) &&
        width > eps && height > eps &&
        x >= -eps && y >= -eps &&
        x + width <= sheetWidth + eps &&
        y + height <= sheetHeight + eps;
    });

    // El retal de cola es el mayor resto de altura completa situado en uno de
    // los bordes laterales. La regla no se aplica a restos interiores.
    const tailCandidates = freeTraverses
      .filter(traverse => {
        const x = Number(traverse.origin_x);
        const y = Number(traverse.origin_y);
        const width = Number(traverse.width);
        const height = Number(traverse.height);
        return near(y, 0) &&
          near(height, sheetHeight) &&
          (near(x, 0) || near(x + width, sheetWidth));
      })
      .sort((left, right) =>
        Number(right.width) * Number(right.height) -
        Number(left.width) * Number(left.height)
      );
    const tail = tailCandidates[0];
    if (!tail) return 0;

    const tailX = Number(tail.origin_x);
    const tailWidth = Number(tail.width);
    const tailLeft = tailX;
    const tailRight = tailX + tailWidth;
    const tailOnRight = near(tailRight, sheetWidth);
    const tailOnLeft = near(tailLeft, 0);
    if (!tailOnRight && !tailOnLeft) return 0;

    const isOefPiece = (pieceIn: any): boolean =>
      !!pieceIn && (
        pieceIn.piece_oef_generated === true ||
        (Array.isArray(pieceIn.piece_oef_internal_polygons) &&
          pieceIn.piece_oef_internal_polygons.length > 0)
      );
    const standardPiecePlacement = (placementIn: any): boolean => {
      const piece = placementIn && placementIn.piece
        ? placementIn.piece
        : null;
      if (!piece) return false;
      if (isOefPiece(piece)) return false;
      const matrix = Array.isArray(piece.piece_matrix)
        ? piece.piece_matrix
        : [];
      // Los bloques rectangulares repetidos son una sola colocación lógica,
      // pero visualmente constituyen una fila completa. Se pueden trasladar
      // como unidad siempre que ninguna celda sea una forma OEF.
      return !matrix.some(column =>
        (Array.isArray(column) ? column : []).some(pin => isOefPiece(pin))
      );
    };
    const pieceRect = (placementIn: any): any => {
      const piece = placementIn && placementIn.piece
        ? placementIn.piece
        : null;
      const matrix = piece && Array.isArray(piece.piece_matrix)
        ? piece.piece_matrix
        : [];
      const matrixColumns = matrix.length > 0
        ? matrix.length
        : 1;
      const matrixRows = matrix.length > 0
        ? matrix.reduce((maxRows, column) =>
            Math.max(maxRows, Array.isArray(column) ? column.length : 0), 0)
        : 1;
      const drawColumns = Number(piece && piece.draw_w);
      const drawRows = Number(piece && piece.draw_h);
      const columns = matrix.length > 0 &&
        Number.isFinite(drawColumns) && drawColumns > 0
        ? drawColumns
        : matrixColumns;
      const rows = matrix.length > 0 &&
        Number.isFinite(drawRows) && drawRows > 0
        ? drawRows
        : matrixRows;
      return {
        x: Number(placementIn && placementIn.origin_x),
        y: Number(placementIn && placementIn.origin_y),
        width: Number(piece && piece.piece_width) * columns,
        height: Number(piece && piece.piece_height) * rows
      };
    };
    const validPieceRect = (rectIn: any): boolean =>
      rectIn &&
      Number.isFinite(rectIn.x) && Number.isFinite(rectIn.y) &&
      Number.isFinite(rectIn.width) && Number.isFinite(rectIn.height) &&
      rectIn.width > eps && rectIn.height > eps;

    let changes = 0;
    const trace = [];
    const narrowCandidates = freeTraverses
      .filter(traverse => traverse !== tail &&
        Number(traverse.width) + eps < usefulSide &&
        (
          (tailOnRight &&
            near(Number(traverse.origin_x) + Number(traverse.width), tailLeft)) ||
          (tailOnLeft &&
            near(Number(traverse.origin_x), tailRight))
        )
      )
      .sort((left, right) =>
        Number(left.origin_y) - Number(right.origin_y)
      );

    narrowCandidates.forEach(remainder => {
      const remainderX = Number(remainder.origin_x);
      const remainderY = Number(remainder.origin_y);
      const remainderWidth = Number(remainder.width);
      const remainderHeight = Number(remainder.height);
      if (!(remainderWidth > eps && remainderHeight > eps)) return;

      const sameRow = sheetIn.pieces.filter(placement => {
        if (!standardPiecePlacement(placement)) return false;
        const rect = pieceRect(placement);
        return validPieceRect(rect) &&
          near(rect.y, remainderY) &&
          near(rect.height, remainderHeight);
      });
      let first = sameRow.find(placement => {
        const rect = pieceRect(placement);
        return tailOnRight
          ? near(rect.x + rect.width, remainderX)
          : near(rect.x, remainderX + remainderWidth);
      });
      if (!first) return;

      // Se incorpora toda la fila contigua en dirección contraria a la cola.
      const row = [first];
      let rowMinX = pieceRect(first).x;
      let rowMaxX = rowMinX + pieceRect(first).width;
      let found = true;
      while (found) {
        found = false;
        const next = sameRow.find(placement => {
          if (row.indexOf(placement) >= 0) return false;
          const rect = pieceRect(placement);
          return tailOnRight
            ? near(rect.x + rect.width, rowMinX)
            : near(rect.x, rowMaxX);
        });
        if (next) {
          const rect = pieceRect(next);
          row.push(next);
          rowMinX = Math.min(rowMinX, rect.x);
          rowMaxX = Math.max(rowMaxX, rect.x + rect.width);
          found = true;
        }
      }

      const beforeArea = remainderWidth * remainderHeight +
        row.reduce((sum, placement) => {
          const rect = pieceRect(placement);
          return sum + (rect.width * rect.height);
        }, 0);
      const deltaX = tailOnRight ? remainderWidth : -remainderWidth;
      const beforePieces = row.map(placement => {
        const rect = pieceRect(placement);
        return {
          id: placement.piece && placement.piece.piece_id,
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        };
      });

      row.forEach(placement => {
        const piece = placement.piece;
        placement.origin_x = Number(placement.origin_x) + deltaX;
        placement.draw = null;
        piece.points = this.getPieceCoordinates(
          Number(placement.origin_x),
          Number(placement.origin_y),
          Number(piece.piece_width),
          Number(piece.piece_height)
        );
      });
      remainder.origin_x = tailOnRight
        ? rowMinX
        : rowMaxX - remainderWidth;
      remainder.draw = null;
      remainder.remainder_shifted_from_tail = true;
      this.setTrCoordinates(remainder);

      const afterArea = remainderWidth * remainderHeight +
        row.reduce((sum, placement) => {
          const rect = pieceRect(placement);
          return sum + (rect.width * rect.height);
        }, 0);
      const areaTolerance = Math.max(eps, beforeArea * 0.0000001);
      if (Math.abs(beforeArea - afterArea) > areaTolerance) {
        // Sólo debería cambiar la posición. La comprobación evita dejar una
        // geometría parcial si en el futuro cambia la representación.
        row.forEach((placement, index) => {
          placement.origin_x = beforePieces[index].x;
          placement.piece.points = this.getPieceCoordinates(
            beforePieces[index].x,
            beforePieces[index].y,
            beforePieces[index].width,
            beforePieces[index].height
          );
        });
        remainder.origin_x = remainderX;
        remainder.remainder_shifted_from_tail = false;
        this.setTrCoordinates(remainder);
        return;
      }

      changes++;
      trace.push({
        sheet_id: Number(sheetIn.id),
        tail: {
          x: tailX,
          y: Number(tail.origin_y),
          width: tailWidth,
          height: Number(tail.height)
        },
        remainder_before: {
          id: remainder.id,
          x: remainderX,
          y: remainderY,
          width: remainderWidth,
          height: remainderHeight
        },
        remainder_after: {
          id: remainder.id,
          x: Number(remainder.origin_x),
          y: Number(remainder.origin_y),
          width: Number(remainder.width),
          height: Number(remainder.height)
        },
        pieces_before: beforePieces,
        pieces_after: row.map(placement => {
          const rect = pieceRect(placement);
          return {
            id: placement.piece && placement.piece.piece_id,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
          };
        })
      });
    });

    if (trace.length > 0) {
      console.log('[Tail-side remainder shift] ' + JSON.stringify(trace));
    }
    return changes;
  }
  
  // Función que ajusta los retales sobrantes de las hojas para
  // convertir traveras internas X en traveras internas Y.
  // No debe hacerlo si es un retal de "cola".
  // NOTA: Tampoco debe hacerlo si va a crear un subnivel dentro del retal en el que está.
  adjustRetalSheet(sheet_traverses, sheet_width, sheet_height, trav_x_list, num_rep) {
         
    // console.log('--> adjustRetalSheet sheetList. num_rep: ' + num_rep);
    // console.log(sheet_traverses);
     
    let adjust = false;
     
    // Se recorren todas las hojas existenes en el listado de planchas candidatas.
    sheet_traverses.forEach((tr1, index) => {
          
        // console.log('--> adjustRetalSheet trv: ');
     	// console.log(tr1);
     	
     	let tail_retal = false;
     	   
		// No puede ser un retal de cola.
	    if (tr1.origin_x + tr1.width + tr1.disband.left + tr1.disband.right === sheet_width) {
			// console.log('--> adjustRetalSheet: retal de cola encontrado en tr1.');
			tail_retal = true;
			
		} else {
			
			sheet_traverses.forEach((tr2, index2) => {
				
				tail_retal = false;
				
				// NOTA: Se comentan estas líneas porque al ponerlo parece que fallan ciertos casos (?¿).
				// NOTA2: Se dejan sin comentar porque no se puede permitir que existan casos que no dejen "tronzar".
				// No se va a realizar el corte hacia la izquierda para evitar trozos que no se puedan tronzar.
				if (tr1.origin_y < tr2.origin_y)
					// && !(tr1.origin_x > tr2.origin_x))
				 	// && (tr1.origin_y + tr1.height + tr1.disband.top + tr1.disband.bottom === sheet_height
				 		//|| tr2.origin_y + tr2.height + tr2.disband.top + tr2.disband.bottom === sheet_height)
				 	{
						// console.log('--> Retal no se corta: ');
						// console.log(tr1);
						// console.log(tr2);
						tail_retal = true;
					} // */
				
				if (tr2.origin_x + tr2.width + tr2.disband.left + tr2.disband.right === sheet_width) {
					// console.log('--> adjustRetalSheet: retal de cola encontrado en tr2.');
					tail_retal = true;
				}
				/*
				// Para no eliminar una travera X principal.
		     	let trXList = this.getTX(tr2);
		     	
		     	let isTrX_2 = trXList.includes(tr2.origin_x + tr2.width);
		     	
		     	if (isTrX_2){
					console.log('--> isTrX_2: ');
					tail_retal = true;
					console.log(trXList);
					
					tr1.width += tr2.width;
				    tr2.height -= tr1.height;
				    tr2.origin_y += tr1.origin_y;

				} // */
				
	        	if(!tail_retal && tr1 && tr2 && !(tr2.origin_y + tr2.height === sheet_height - tr2.disband.bottom && tr2.origin_y === 0) &&
	        		(tr1.origin_x + tr1.width === tr2.origin_x) &&
	        		(tr1.origin_y > tr2.origin_y) &&
	        		(tr1.origin_y + tr1.height === tr2.origin_y + tr2.height)
	        		// && !(tr1.origin_x + tr1.width !== sheet_width) && !(tr2.origin_x + tr2.width !== sheet_width)
	        		) {
	            	// console.log('--> traveras con lado superior contiguo. A es mayor que B:');
	            	// console.log(tr1);
	            	// console.log(tr2);
	            	// console.log('-------------');
	            	
	            	// Se cambian las dimensiones de las dos traveras para que queden una ocupando la zona
			        // de arriba y otra la zona de abajo (es decir, se cambia el corte en Y por un corte en X).
			        // NOTA: Para hacerlo hay que comprobar que el valor de tr1.origin_x + tr1.width no sea
			        // el valor de X de alguna de las traveras de la hoja, porque entonces hay que dejar ese corte.
			        if (!trav_x_list['x_' + tr2.origin_x]) {
				        tr1.width += tr2.width;
				        tr2.height -= tr1.height;
				        
				        this.setTrCoordinates(tr1);
						this.setTrCoordinates(tr2);
				        
				        adjust = true;
			        }
			        
	            } else if (!tail_retal && tr1 && tr2 && !(tr2.origin_y + tr2.height === sheet_height - tr2.disband.bottom && tr2.origin_y === 0) &&
	        		(tr1.origin_x + tr1.width === tr2.origin_x) &&
	        		(tr1.origin_y < tr2.origin_y) &&
	        		(tr1.origin_y + tr1.height === tr2.origin_y + tr2.height)
	        		// && !(tr1.origin_x + tr1.width !== sheet_width) && !(tr2.origin_x + tr2.width !== sheet_width)
	        		) {
	                
	                // console.log('--> traveras con lado superior contiguo. A es menor que B: ');
	                // console.log(tr1);
	            	// console.log(tr2);
	            	// console.log('-------------');
	                
	                if (!trav_x_list['x_' + tr2.origin_x]) {
				        tr2.width += tr1.width;
				        tr1.height -= tr2.height;
				        tr2.origin_x = tr1.origin_x
				        
				        this.setTrCoordinates(tr1);
						this.setTrCoordinates(tr2);
				        
				        adjust = true;
			        }
	            }
	        });
		} // End If retal de cola.
		
    	// Llamada recursiva si se ha tenido que reajustar algún retal.
    	// Es para volver a repasar si se ha formado un nuevo caso de reajuste.
    	if (index + 1 === sheet_traverses.length && adjust) {
			
	    	this.adjustRetalSheet(sheet_traverses, sheet_width, sheet_height, trav_x_list, num_rep + 1);
	    }
    });

  } // End function adjustRetalSheet.
  
  // Función que elimina cortes Y para crear traveras internas X.
  // Esto reduce el nivel de profundidad interno y permite que Lisec pueda cogerlo.
  adjustInternalRetalSheet(sheet_traverses, sheet_width, sheet_height, trav_x_list, num_rep) {
         
    // console.log('--> adjustInternalRetalSheet sheetList. num_rep: ' + num_rep);
    // console.log(sheet_traverses);
     
    let adjust = false;
     
    // Se recorren todas las hojas existenes en el listado de planchas candidatas.
    sheet_traverses.forEach((tr1, index) => {
          
        // console.log('--> adjustInternalRetalSheet trv: ');
     	// console.log(tr1);
     	
     	let tail_retal = false;
		          
		// No puede ser un retal de cola.
	    if (tr1.origin_x + tr1.width + tr1.disband.left + tr1.disband.right === sheet_width) {
			// console.log('--> adjustRetalSheet: retal de cola encontrado en tr1.');
			tail_retal = true;
			
		} else {
			
			sheet_traverses.forEach((tr2, index2) => {
			
				tail_retal = false;
				
				if (tr2.origin_x + tr2.width + tr2.disband.left + tr2.disband.right === sheet_width) {
					// console.log('--> adjustRetalSheet: retal de cola encontrado en tr2.');
					tail_retal = true;
				}
				
	        	if(!tail_retal && tr1 && tr2 && !(tr2.origin_y + tr2.height === sheet_height - tr2.disband.bottom && tr2.origin_y === 0) &&
	        		(tr1.origin_x + tr1.width === tr2.origin_x + tr2.width) &&
	        		(tr1.origin_y + tr1.height === tr2.origin_y)
	        		// && !(tr1.origin_x + tr1.width !== sheet_width) && !(tr2.origin_x + tr2.width !== sheet_width)
	        		) {
	            	console.log('--> traveras con lado superior contiguo. Corrección derecha: ');
	            	console.log(tr1);
	            	console.log(tr2);
	            	console.log('-------------');
	            	
	            	// Se cambian las dimensiones de las dos traveras para que queden una ocupando la zona
			        // de arriba y otra la zona de abajo (es decir, se cambia el corte en Y por un corte en X).
			        // NOTA: Para hacerlo hay que comprobar que el valor de tr1.origin_x + tr1.width no sea
			        // el valor de X de alguna de las traveras de la hoja, porque entonces hay que dejar ese corte.
			        if (!trav_x_list['x_' + tr2.origin_x]) {
				        tr1.height += tr2.height;
				        tr2.width -= tr1.width;
				        
				        adjust = true;
			        }
			        
	            } else if (!tail_retal && tr1 && tr2 && !(tr2.origin_y + tr2.height === sheet_height - tr2.disband.bottom && tr2.origin_y === 0) &&
	        		(tr1.origin_x === tr2.origin_x) &&
	        		(tr1.origin_y < tr2.origin_y) &&
	        		(tr1.origin_y + tr1.height === tr2.origin_y)
	        		// && !(tr1.origin_x + tr1.width !== sheet_width) && !(tr2.origin_x + tr2.width !== sheet_width)
	        		) {
	                
	                console.log('--> traveras con lado superior contiguo. Corrección izquierda: ');
	                console.log(tr1);
	            	console.log(tr2);
	            	console.log('-------------');
	                
	                if (!trav_x_list['x_' + tr2.origin_x]) {
				        tr1.height += tr2.height;
				        tr2.width -= tr1.width;
				        tr2.origin_x += tr1.width;
				        
				        adjust = true;
			        }
	            } // */
	        });
		} // End If retal de cola.
		
    	// Llamada recursiva si se ha tenido que reajustar algún retal.
    	// Es para volver a repasar si se ha formado un nuevo caso de reajuste.
    	if (index + 1 === sheet_traverses.length && adjust) {
	    	this.adjustInternalRetalSheet(sheet_traverses, sheet_width, sheet_height, trav_x_list, num_rep + 1);
	    }
    });

  } // End function adjustInternalRetalSheet.
  
  // Función que une retales sobrantes de las hojas que estén al lado lateralmente.
  mergeRetalSheet(sheet_traverses, sheet_height, trav_x_list, num_rep) {
         
    // console.log('--> mergeRetalSheet sheetList. num_rep: ' + num_rep);
    // console.log(sheet_traverses);
     
    let merge = false;
     
    // Se recorren todas las hojas existenes en el listado de planchas candidatas.
    sheet_traverses.forEach((tr1, index) => {
          
        // console.log('--> mergeRetalSheet trv: ');
     	// console.log(tr1);
     	
     	sheet_traverses.forEach((tr2, index2) => {
        	if( tr1 && tr2 && !(tr2.origin_y + tr2.height === sheet_height - tr2.disband.bottom && tr2.origin_y === 0) &&
        		(tr1.origin_x + tr1.width === tr2.origin_x)) {
            	// console.log('--> traveras con lado superior contiguo.');
            	// console.log(tr1);
            	// console.log(tr2);
            	// console.log('-------------');
            	
            	// Se cambian las dimensiones de las dos traveras para que queden una ocupando la zona
		        // de arriba y otra la zona de abajo (es decir, se cambia el corte en Y por un corte en X).
		        // NOTA: Para hacerlo hay que comprobar que el valor de tr1.origin_x + tr1.width no sea
		        // el valor de X de alguna de las traveras de la hoja, porque entonces hay que dejar ese corte.
                if (tr2.height === tr1.height) {
                      
                    // console.log('--> Traveras que pueden mergearse.');
                    
                    if (!trav_x_list['x_' + tr2.origin_x]) {
				        // console.log('--> mergeRetalSheet: No corresponde a una Travera X principal. Se mergea.');
				        tr1.width += tr2.width;
				        
				        // Se le asocia también el padre del que provenía.
	          			// tr1.father = tr2.father;
				        
				        // Se elimina la segunda travera.
		          		sheet_traverses.splice(index2, 1);
				        
				        merge = true;
			        }
		        }
		        
            }
        });
        
        // Llamada recursiva si se ha tenido que mergear algún retal.
    	// Es para volver a repasar si se ha formado un nuevo caso de mergeo.
    	if (index + 1 === sheet_traverses.length && merge) {
	    	this.mergeRetalSheet(sheet_traverses, sheet_height, trav_x_list, num_rep + 1);
	    }
    });

  } // End function mergeRetalSheet

  // Garantiza una travera estructural vertical (franja completa en altura)
  // cuando existe una banda de piezas a la izquierda y una franja libre a la derecha.
  // Es necesaria para exportaciones/máquina que requieren línea de corte vertical continua.
  // Las coordenadas de piezas/traveras pertenecen al área útil: el exportador
  // añadirá después los desbandes izquierdo e inferior.
  ensureRightVerticalCutStrip(sheetIn: any): void {
    if (!sheetIn || !Array.isArray(sheetIn.pieces) || sheetIn.pieces.length < 1) {
      return;
    }
    if (!Array.isArray(sheetIn.traverses)) {
      sheetIn.traverses = [];
    }

    const eps = 0.001;
    const sheetWidth = Number(sheetIn.width);
    const sheetHeight = Number(sheetIn.height);
    if (!(Number.isFinite(sheetWidth) && sheetWidth > 0 && Number.isFinite(sheetHeight) && sheetHeight > 0)) {
      return;
    }
    const leftDisband = Number((sheetIn && sheetIn.disband && sheetIn.disband.left) ? sheetIn.disband.left : 0);
    const rightDisband = Number((sheetIn && sheetIn.disband && sheetIn.disband.right) ? sheetIn.disband.right : 0);
    const topDisband = Number((sheetIn && sheetIn.disband && sheetIn.disband.top) ? sheetIn.disband.top : 0);
    const bottomDisband = Number((sheetIn && sheetIn.disband && sheetIn.disband.bottom) ? sheetIn.disband.bottom : 0);
    const usableWidth = sheetWidth - leftDisband - rightDisband;
    const usableHeight = sheetHeight - topDisband - bottomDisband;
    if (!(usableWidth > eps && usableHeight > eps)) {
      return;
    }

    const rightEdges = sheetIn.pieces
      .map(p => {
        const ox = Number(p && p.origin_x);
        const pw = Number(p && p.piece && p.piece.piece_width);
        if (!Number.isFinite(ox) || !Number.isFinite(pw)) {
          return null;
        }

        const pieceObj = p && p.piece ? p.piece : null;

        // Si la pieza es un marco matricial, el ancho del marco puede ser mayor que
        // el ancho realmente ocupado por celdas útiles. En ese caso calculamos el
        // borde derecho con las celdas existentes para no desplazar la travera.
        const matrix = pieceObj && Array.isArray(pieceObj.piece_matrix) ? pieceObj.piece_matrix : null;
        if (matrix && matrix.length > 0) {
          const cellW = Number(pieceObj && pieceObj.piece_width);
          let maxRightCell = null;
          if (Number.isFinite(cellW) && cellW > 0) {
            for (let i = 0; i < matrix.length; i++) {
              const col = Array.isArray(matrix[i]) ? matrix[i] : [];
              for (let j = 0; j < col.length; j++) {
                const pin = col[j];
                // Celdas vacías/null no ocupan ancho real.
                if (!pin) {
                  continue;
                }
                const pinW = Number(pin.piece_width);
                const w = (Number.isFinite(pinW) && pinW > 0) ? pinW : cellW;
                const cellRight = ox + (i * cellW) + w;
                if (!Number.isFinite(cellRight)) {
                  continue;
                }
                if (maxRightCell === null || cellRight > maxRightCell) {
                  maxRightCell = cellRight;
                }
              }
            }
          }
          if (maxRightCell !== null) {
            return maxRightCell;
          }
        }

        // Para primitivas OEF usamos el borde real de los polígonos internos
        // (triángulos) y no el bounding box completo, evitando hueco artificial
        // entre la última pieza útil y la línea de corte vertical.
        const polys = pieceObj && Array.isArray(pieceObj.piece_oef_internal_polygons)
          ? pieceObj.piece_oef_internal_polygons
          : null;
        const rotRaw = Number(pieceObj && pieceObj.piece_rotation);
        const rotNorm = Number.isFinite(rotRaw) ? ((((rotRaw % 360) + 360) % 360)) : 0;
        if (polys && polys.length > 0) {
          const w = Number(pieceObj && pieceObj.piece_width);
          const h = Number(pieceObj && pieceObj.piece_height);
          const xs = [];
          polys.forEach(poly => {
            if (Array.isArray(poly)) {
              poly.forEach(pt => {
                const px = Number(pt && pt.x);
                const py = Number(pt && pt.y);
                if (!(Number.isFinite(px) && Number.isFinite(py))) {
                  return;
                }

                let tx = px;
                // Transformación equivalente a la que se aplica al dibujar OEF.
                if (rotNorm === 90 && Number.isFinite(h)) {
                  tx = h - py;
                } else if (rotNorm === 180 && Number.isFinite(w)) {
                  tx = w - px;
                } else if (rotNorm === 270) {
                  tx = py;
                }

                if (Number.isFinite(tx)) {
                  xs.push(tx);
                }
              });
            }
          });
          if (xs.length > 0) {
            return ox + Math.max.apply(null, xs);
          }
        }

        return ox + pw;
      })
      .filter(v => Number.isFinite(v));

    if (!rightEdges.length) {
      return;
    }

    const xCut = Math.max.apply(null, rightEdges);
    if (!(xCut > eps && xCut < (usableWidth - eps))) {
      return;
    }

    const hasStructuralRightStrip = sheetIn.traverses.some(tr => {
      if (!tr || tr.piece) {
        return false;
      }
      const ox = Number(tr.origin_x);
      const oy = Number(tr.origin_y);
      const w = Number(tr.width);
      const h = Number(tr.height);
      if (!(Number.isFinite(ox) && Number.isFinite(oy) && Number.isFinite(w) && Number.isFinite(h))) {
        return false;
      }
      const sameCutX = Math.abs(ox - xCut) <= eps;
      const rightEdge = ox + w;
      const reachesRight =
        Math.abs(rightEdge - sheetWidth) <= eps ||
        Math.abs((rightEdge + rightDisband) - sheetWidth) <= eps ||
        Math.abs((rightEdge + leftDisband + rightDisband) - sheetWidth) <= eps;
      const fullHeight =
        (Math.abs(oy) <= eps && Math.abs((oy + h) - sheetHeight) <= eps) ||
        (Math.abs(oy) <= eps && Math.abs((h + topDisband + bottomDisband) - sheetHeight) <= eps) ||
        (Math.abs(oy - topDisband) <= eps && Math.abs((oy + h + bottomDisband) - sheetHeight) <= eps);
      return sameCutX && reachesRight && fullHeight;
    });

    if (hasStructuralRightStrip) {
      sheetIn.remainder_structural_strip_materialized = true;
      return;
    }

    // Si la franja está particionada en varios retales, materializar otro
    // rectángulo completo los solaparía. En ese caso conservamos los retales
    // reales; el cierre gráfico posterior puede representar la línea continua
    // sin contaminar el modelo que llegará al CNC.
    const rightStripOccupied = sheetIn.traverses.some(tr => {
      if (!tr || tr.piece || tr.used) {
        return false;
      }
      const ox = Number(tr.origin_x);
      const oy = Number(tr.origin_y);
      const w = Number(tr.width);
      const h = Number(tr.height);
      if (!(Number.isFinite(ox) && Number.isFinite(oy) &&
            Number.isFinite(w) && Number.isFinite(h) &&
            w > eps && h > eps)) {
        return false;
      }
      return ox < (usableWidth - eps) &&
        (ox + w) > (xCut + eps) &&
        oy < (usableHeight - eps) &&
        (oy + h) > eps;
    });
    if (rightStripOccupied) {
      sheetIn.remainder_structural_strip_materialized = false;
      console.log('[Remainder structural strip] no se materializa sobre retales existentes: ' + JSON.stringify({
        sheet_id: Number(sheetIn.id),
        x: xCut,
        width: usableWidth - xCut,
        height: usableHeight
      }));
      return;
    }

    this.traverse_count++;
    const newTraverse = {
      id: this.traverse_count,
      name: 'T' + this.traverse_count + 'V',
      sheet_id: Number(sheetIn.id),
      sheet_width: sheetWidth,
      sheet_height: sheetHeight,
      axis: 'Y',
      width: usableWidth - xCut,
      height: usableHeight,
      depth: Number(sheetIn.depth) > 0 ? Number(sheetIn.depth) : 1,
      origin_x: xCut,
      origin_y: 0,
      father: null,
      level: 0,
      level_h: 0,
      old: false,
      used: false,
      piece: null,
      diecutting: Number(this.min_die_cutting) > 0 ? Number(this.min_die_cutting) : 0,
      max_diecutting: Number(this.max_die_cutting) > 0 ? Number(this.max_die_cutting) : 0,
      disband: sheetIn.disband ? JSON.parse(JSON.stringify(sheetIn.disband)) : { left: 0, right: 0, top: 0, bottom: 0 },
      fixed_cut: true,
      draw: null,
      points: []
    };

    this.setTrCoordinates(newTraverse);
    sheetIn.traverses.push(newTraverse);
    sheetIn.remainder_structural_strip_materialized = true;
    console.log('[Remainder structural strip] ' + JSON.stringify({
      sheet_id: Number(sheetIn.id),
      id: newTraverse.id,
      x: newTraverse.origin_x,
      y: newTraverse.origin_y,
      width: newTraverse.width,
      height: newTraverse.height
    }));
  }

  // Función que dibuja las piezas pero las separa en un array para cada hoja.
	  drawGraphicsBySheet(originIn: number, exportTypeIn: string): Draw[][] {
	    console.log('--> drawGraphicsBySheet sheetList - origin: ' + originIn);
	    console.log(this.sheetList);

	    let total_graphicList = [];

    let count_sheet = 0;

	    if (!Array.isArray(this.sheetList)) {
	      this.sheetList = [];
	    }
	    // Se sanea el listado de hojas para evitar elementos inválidos y sin contenido.
	    this.sheetList = this.sheetList.filter(
	      s => !!s && typeof s === 'object' && (s.pieces || s.traverses) && s.unit !== -1
	    );

    // Se quitan las traveras que estén en "traverses" y que tengan pieza,
    // porque son las usadas para colocar piezas en traveras antiguas
    // (no deben ser dibujadas esas piezas).
    this.sheetList.forEach(f => {

      if (f.traverses) {
        // f.traverses = f.traverses.filter( tf => !tf.piece);

        // CASO 3
        // NOTA: Para asegurarse de no dibujar las traveras usadas ("líneas fantasma").
        f.traverses = f.traverses.filter( tf => !tf.piece && !tf.used);
      }
    });
    
    // console.log('--> drawGraphicsBySheet última hoja: ');
    // console.log(this.sheetList[this.sheetList.length - 1]);

    // Se reenumera el id de cada una de las hojas que han quedado como definitivas.
    // this.sheetList.forEach((f, i) => {
    //   f.id = i + 1;
    // });

    // Se recorren todas las hojas existenes en el listado de planchas candidatas
    // y se dibuja los gráficos de puntos que pudieran contener dentro.
    this.sheetList.forEach((sheet, index) => {
	  
	  let sheet_added = false;
	  
      // console.log('--> drawGraphicsBySheet sheet:');
      // console.log(sheet);
      
      // Se ponen los trazos de corte para piezas con mismo ancho pero diferente altura
      // que estén situadas una encima de la otra (necesario para lisec).
      this.cutDiferenceHeight2(sheet);
      
      let graphicList = [];

      // Primero siempre se va a dibujar el contorno de la hoja.
      // NOTA: Sólo se dibujan las planchas que lleven piezas.
      // if (sheet.used && ((sheet.traverses && sheet.traverses.length > 0) || (sheet.pieces && sheet.pieces.length > 0))) {
      if (sheet.used && (sheet.pieces && sheet.pieces.length > 0)) {

        // console.log('->> drawGraphicsBySheet sheet: ');
        // console.log(sheet);

        count_sheet++;
        graphicList.push(this.drawSheet(sheet, count_sheet));
        sheet_added = true;
      }

	  // DIBUJAR RETALES -----------
	  // Luego se van a dibujar los elementos "retal o desperdicio" que haya dentro de la hoja.
      if (sheet.traverses && sheet.traverses.length > 0) {
        // console.log('--> sh[' + index + '] = ');
        // console.log(sheet);

		// Si no hay piezas enumeradas dentro de su campo "pieces" entonces será un retal o un desperdicio.
        if (sheet.pieces && sheet.pieces.length === 0) {
          sheet.used = false;
        } else {
          
		    let trav_X = [];

        // Si una fila completa está separada del retal estructural por una
        // franja estrecha, se permutan fila y franja antes de construir las
        // traveras principales. El retal de cola conserva tamaño y posición.
        this.shiftNarrowRemaindersAwayFromTail(sheet);
		
		    // Hacemos grupos según donde empieza la pieza en X.
		    if (sheet.pieces) {
				
				// Se añade la hoja si no se había añadido antes aún.
				if (!sheet_added) {
					
					count_sheet++;
        			graphicList.push(this.drawSheet(sheet, count_sheet));
        			sheet_added = true;
				}
                
                sheet.pieces.forEach( p => {
			      const key = 'x_' + p.origin_x;
				  // Sólo las piezas que tocan la base de la hoja tienen un valor de X candidato a ser "Travera X".
				  if (p.origin_y === 0) {
		          	  if (!trav_X[key]) {
				        trav_X[key] = [];
				      }
				      
				      //trav_X['x_' + p.origin_x].push(p);
				      trav_X['x_' + p.origin_x].push(true);

                      // IMPORTANTE: Añadir también el borde derecho efectivo de la pieza.
                      // En primitivas OEF/matriz el cierre de travera puede depender del
                      // borde derecho y no sólo del origin_x de la pieza base.
                      let xRight = null;
                      const ox = Number(p && p.origin_x);
                      const pieceObj = p && p.piece ? p.piece : null;
                      const pw = Number(pieceObj && pieceObj.piece_width);
                      if (Number.isFinite(ox) && Number.isFinite(pw)) {
                        xRight = ox + pw;
                      }

                      const polygonsToLocalMaxX = (polysIn: any[]): number => {
                        let maxLocalX = Number.NEGATIVE_INFINITY;
                        const polys = Array.isArray(polysIn) ? polysIn : [];
                        polys.forEach(poly => {
                          const pts = Array.isArray(poly) ? poly : [];
                          pts.forEach(pt => {
                            if (!pt) return;
                            const px = Number(pt.x);
                            if (Number.isFinite(px) && px > maxLocalX) {
                              maxLocalX = px;
                            }
                          });
                        });
                        return Number.isFinite(maxLocalX) ? maxLocalX : null;
                      };

                      // Para OEF usar borde derecho real del polígono interno.
                      const pieceInnerPolys = Array.isArray(pieceObj && pieceObj.piece_oef_internal_polygons)
                        ? pieceObj.piece_oef_internal_polygons
                        : [];
                      const piecePolyMaxX = polygonsToLocalMaxX(pieceInnerPolys);
                      if (piecePolyMaxX !== null && Number.isFinite(ox)) {
                        xRight = ox + piecePolyMaxX;
                      }

                      const matrix = pieceObj && Array.isArray(pieceObj.piece_matrix) ? pieceObj.piece_matrix : null;
                      if (matrix && matrix.length > 0) {
                        const cellW = Number(pieceObj && pieceObj.piece_width);
                        let maxRightCell = null;
                        if (Number.isFinite(cellW) && cellW > 0 && Number.isFinite(ox)) {
                          for (let i = 0; i < matrix.length; i++) {
                            const col = Array.isArray(matrix[i]) ? matrix[i] : [];
                            for (let j = 0; j < col.length; j++) {
                              const pin = col[j];
                              if (!pin) continue;
                              const pinW = Number(pin.piece_width);
                              let useW = (Number.isFinite(pinW) && pinW > 0) ? pinW : cellW;
                              const pinPolys = Array.isArray(pin && pin.piece_oef_internal_polygons)
                                ? pin.piece_oef_internal_polygons
                                : [];
                              const pinPolyMaxX = polygonsToLocalMaxX(pinPolys);
                              if (pinPolyMaxX !== null && pinPolyMaxX > 0) {
                                useW = pinPolyMaxX;
                              }
                              const cellRight = ox + (i * cellW) + useW;
                              if (!Number.isFinite(cellRight)) continue;
                              if (maxRightCell === null || cellRight > maxRightCell) {
                                maxRightCell = cellRight;
                              }
                            }
                          }
                        }
                        if (maxRightCell !== null) {
                          xRight = maxRightCell;
                        }
                      }

                      if (Number.isFinite(xRight)) {
                        const eps = 0.001;
                        const sheetWidth = Number(sheet && sheet.width);
                        if (piecePolyMaxX !== null && Number.isFinite(pw) && Math.abs(pw - piecePolyMaxX) > 0.5) {
                          console.log('[OEF trav_X right-edge]', {
                            sheet_id: sheet && sheet.id,
                            piece_name: pieceObj && pieceObj.piece_name_id ? pieceObj.piece_name_id : '',
                            origin_x: ox,
                            width_box: pw,
                            width_poly: piecePolyMaxX,
                            x_right: xRight
                          });
                        }
                        if (xRight > eps && (!Number.isFinite(sheetWidth) || xRight < (sheetWidth - eps))) {
                          const rightKey = 'x_' + xRight;
                          if (!trav_X[rightKey]) {
                            trav_X[rightKey] = [];
                          }
                          trav_X[rightKey].push(true);
                        }
                      }
	              }
				});
            }

          // En hojas rectangulares se comprobará el cierre de cola después de
          // consolidar los retales. Hacerlo aquí podía materializar una franja
          // provisional que luego quedaba solapada con el retal definitivo.
          const sheetHasOefGeometry = (Array.isArray(sheet.pieces) ? sheet.pieces : [])
            .some(piecePlacement => {
              const piece = piecePlacement && piecePlacement.piece
                ? piecePlacement.piece
                : null;
              if (!piece) return false;
              if (piece.piece_oef_generated === true ||
                  (Array.isArray(piece.piece_oef_internal_polygons) &&
                    piece.piece_oef_internal_polygons.length > 0)) {
                return true;
              }
              const matrix = Array.isArray(piece.piece_matrix)
                ? piece.piece_matrix
                : [];
              return matrix.some(column =>
                (Array.isArray(column) ? column : []).some(pin =>
                  pin && (
                    pin.piece_oef_generated === true ||
                    (Array.isArray(pin.piece_oef_internal_polygons) &&
                      pin.piece_oef_internal_polygons.length > 0)
                  )
                )
              );
            });
            
          // console.log('--> drawGraphicsBySheet trav_X = ');
          // console.log(trav_X);
          
          // IMPORTANTE: Para ajustar los retales superiores de forma que cuadren con las traveras X principales de la hoja.
          // NOTA: Se comenta esta llamada a la función adjustRetalSheet porque crea problemas.
          // PROBLEMA: Se crean colocaciones que impiden el tronzado de piezas por no tener
		  // traveras X o traveras Y por donde el operario pueda tronzar correctamente.
		  // INCONVENIENTE: Puede que existan exportaciones a Lisec que no se puedan hacer bien
		  // si no se usa esta función.
		  // SOLUCIÓN: Intentar que esta función no actue si detecta que una pieza no va a poder tronzarse.
          
          if (exportTypeIn === 'BTR') {
			// Para evitar casos de piezas internas que no se puedan tronzar.
		   	// this.adjustInternalRetalSheet(sheet.traverses, sheet.width, sheet.height, trav_X, 1);
		   	// TEST:
		   	this.mergeRetalSheet(sheet.traverses, sheet.height, trav_X, 1);
		  
		  } else {
			// Para rebajar niveles transformando traveras internas X en Y y que Lisec pueda entenderlo. 
			// NOTA: adjustRetalSheet es necesaria e importante aquí. No comentarla.
			// Si no se usa saldrán retales muy largos y estrechos
  			// que además aumentan mucho el nivel de profundidad.
			this.adjustRetalSheet(sheet.traverses, sheet.width, sheet.height, trav_X, 1);
			// TEST:
			this.mergeRetalSheet(sheet.traverses, sheet.height, trav_X, 1);
			
		  } // End If exportTypeIn.

          // La misma geometría consolidada alimenta canvas, CNC y PDF.
          // La llamada es idempotente si ya se aplicó durante la optimización.
          this.improveRemainderAreas(
            sheet.traverses,
            sheet.width,
            sheet.height,
            trav_X,
            true,
            true
          );

          if (!sheetHasOefGeometry) {
            this.ensureRightVerticalCutStrip(sheet);
          }

          sheet.traverses.forEach((tvr, i) => {
            
            // Se aplica la transformación al punto teniendo en cuenta la "esquina origen"" que se va a usar en la optimización.
            //this.applyTransform(tvr, originIn, sheet.width, sheet.height);

            // Si la travera tiene "dibujo directo" es que es un retal y sí hay que dibujarla.
            // IMPORTANTE. Esta condición se pone porque puede colarse una travera antigua
            // con pieza que no hay que dibujar.
            if (tvr && !tvr.piece) {
              	// Se añade el dibujo del elemento (será un gráfico cerrado para cada uno).
              graphicList.push(this.drawElement(tvr, i, sheet.mat_name, sheet.mat_desc, sheet.mat_id, sheet.width, sheet.height, sheet.depth, originIn, sheet.disband));
            }
          });
        } // End Else sheet.pieces (hay piezas).
      } // End If traverses.

	  // DIBUJAR PIEZAS -----------
	  // Por último se van a dibujar los elementos "pieza" que haya dentro de la hoja.
      if (sheet.pieces && sheet.pieces.length > 0) {
        // console.log('--> sh[' + index + '] = ');
        // console.log(sheet);

        sheet.pieces.forEach((tvr, i) => {
          // console.log('-->h[' + index + '] p[' + i + '] = ');
          // console.log(tvr);

          this.piece_count++;
          
          // Se aplica la transformación al punto teniendo en cuenta la "esquina origen"" que se va a usar en la optimización.
          //this.applyTransform(tvr, originIn, sheet.width, sheet.height);

          // Se añade el dibujo del elemento (será un gráfico cerrado para cada uno).
          let new_draw = this.drawInElement(tvr, this.piece_count, sheet.mat_name, sheet.mat_desc, sheet.mat_id, sheet.width, sheet.height, sheet.depth, originIn, sheet.disband);

		  // El gráfico de la pieza marco inicial está ya dentro del draw_set.
		  if (!new_draw.draw_set || new_draw.draw_set.length === 0) {
                graphicList.push(new_draw);
          } else if (new_draw.draw_set && new_draw.draw_set.length > 0) {
          	// console.log('--> drawGraphicsBySheet encontrados gráficos internos del marco.');
          	new_draw.draw_set.forEach(dr => {
                // console.log('--> drawGraphicsBySheet dr = ');
                // console.log(dr);
            	graphicList.push(dr);
            });
          }
        });
      } // End If pieces.

      // Cierre estructural vertical:
      // se infiere desde la geometría realmente dibujada (incluye primitivas OEF expandidas).
      if (sheet.pieces && sheet.pieces.length > 0) {
        const eps = 0.5;
        const sheetWidth = Number(sheet.width);
        const sheetHeight = Number(sheet.height);
        if (Number.isFinite(sheetWidth) && Number.isFinite(sheetHeight) && sheetWidth > eps && sheetHeight > eps) {
          const pieceDraws = graphicList.filter(g => g && g.type === 'P' && Array.isArray(g.points) && g.points.length >= 4);
          const baseRightEdges = [];
          const oefRightEdges = [];
          let maxRightAll = 0;
          let maxRightAllBox = 0;
          const pieceRightByName = {};
          let baseSupportCount = 0;

          pieceDraws.forEach(g => {
            let minX = Number.POSITIVE_INFINITY;
            let maxX = Number.NEGATIVE_INFINITY;
            let minY = Number.POSITIVE_INFINITY;
            g.points.forEach(pt => {
              if (!pt) return;
              const px = Number(pt.x);
              const py = Number(pt.y);
              if (!Number.isFinite(px) || !Number.isFinite(py)) return;
              if (px < minX) minX = px;
              if (px > maxX) maxX = px;
              if (py < minY) minY = py;
            });
            if (!Number.isFinite(minX) || !Number.isFinite(maxX) || !Number.isFinite(minY)) return;
            if (maxX > maxRightAllBox) maxRightAllBox = maxX;
            let realMaxX = maxX;
            const innerPolygons = Array.isArray(g && g.oef_internal_polygons) ? g.oef_internal_polygons : [];
            if (innerPolygons.length > 0) {
              let maxInnerX = Number.NEGATIVE_INFINITY;
              innerPolygons.forEach(poly => {
                const pts = Array.isArray(poly) ? poly : [];
                pts.forEach(pt => {
                  if (!pt) return;
                  const px = Number(pt.x);
                  if (!Number.isFinite(px)) return;
                  const globalX = minX + px;
                  if (globalX > maxInnerX) {
                    maxInnerX = globalX;
                  }
                });
              });
              if (Number.isFinite(maxInnerX)) {
                realMaxX = maxInnerX;
              }
            }
            const pieceKey = String(g.name || g.num || '');
            if (pieceKey) {
              pieceRightByName[pieceKey] = realMaxX;
            }
            if (realMaxX > maxRightAll) maxRightAll = realMaxX;
            if (innerPolygons.length > 0) {
              oefRightEdges.push(Number(realMaxX.toFixed(3)));
            }
            // Se consideran bordes derechos de piezas en base o ancladas al borde izquierdo.
            if (Math.abs(minY) <= eps) {
              baseSupportCount++;
            }
            if (Math.abs(minY) <= eps || Math.abs(minX) <= eps) {
              baseRightEdges.push(Number(realMaxX.toFixed(3)));
            }
          });

          if (baseRightEdges.length > 0 && (sheetWidth - maxRightAll) > eps) {
            const sortedEdges = baseRightEdges.slice().sort((a, b) => a - b);
            let bestCount = 0;
            let bestMean = null;
            let clusterStart = sortedEdges[0];
            let clusterCount = 1;
            let clusterSum = sortedEdges[0];
            for (let i = 1; i < sortedEdges.length; i++) {
              const v = sortedEdges[i];
              if (Math.abs(v - clusterStart) <= eps) {
                clusterCount++;
                clusterSum += v;
              } else {
                if (clusterCount > bestCount) {
                  bestCount = clusterCount;
                  bestMean = clusterSum / clusterCount;
                }
                clusterStart = v;
                clusterCount = 1;
                clusterSum = v;
              }
            }
            if (clusterCount > bestCount) {
              bestCount = clusterCount;
              bestMean = clusterSum / clusterCount;
            }

            if (bestMean !== null && bestCount >= 2) {
              let xCut = Number(bestMean.toFixed(3));
              const hasOefPiece = pieceDraws.some(g => Array.isArray(g && g.oef_internal_polygons) && g.oef_internal_polygons.length > 0);
              const findBestEdgeCluster = (valuesIn: number[]): any => {
                const vals = (Array.isArray(valuesIn) ? valuesIn : [])
                  .filter(v => Number.isFinite(v))
                  .sort((a, b) => a - b);
                if (!vals.length) return null;
                let clusters = [];
                let clusterStart = vals[0];
                let clusterCount = 1;
                let clusterSum = vals[0];
                for (let i = 1; i < vals.length; i++) {
                  const v = vals[i];
                  if (Math.abs(v - clusterStart) <= eps) {
                    clusterCount++;
                    clusterSum += v;
                  } else {
                    clusters.push({ count: clusterCount, mean: (clusterSum / clusterCount) });
                    clusterStart = v;
                    clusterCount = 1;
                    clusterSum = v;
                  }
                }
                clusters.push({ count: clusterCount, mean: (clusterSum / clusterCount) });
                clusters.sort((a, b) => {
                  if (b.count !== a.count) return b.count - a.count;
                  return b.mean - a.mean;
                });
                return clusters[0];
              };
              const bestOefCluster = findBestEdgeCluster(oefRightEdges);
              if (hasOefPiece && bestOefCluster && bestOefCluster.count >= 2) {
                xCut = Number(bestOefCluster.mean.toFixed(3));
              }
              // Caso banda elevada (sin apoyo en base): usar el borde derecho real total
              // para cerrar la travera junto a las piezas, no en la primera columna izquierda.
              if (hasOefPiece && !bestOefCluster && baseSupportCount === 0 && Number.isFinite(maxRightAll) && maxRightAll > xCut + eps) {
                let preferredCut = Number(maxRightAll);
                // Si el borde del bbox del primitivo está muy cerca del borde real,
                // priorizar el bbox para alinear el cierre con el lateral del primitivo.
                if (Number.isFinite(maxRightAllBox) && maxRightAllBox > 0) {
                  const deltaBox = Math.abs(maxRightAllBox - maxRightAll);
                  if (deltaBox <= 2.5 && maxRightAllBox > preferredCut) {
                    preferredCut = maxRightAllBox;
                  }
                }
                xCut = Number(preferredCut.toFixed(3));
              }
              const minDie = Number(this.min_die_cutting) > 0 ? Number(this.min_die_cutting) : 0;
              const fullHeightTraverses = [];
              graphicList.forEach(g => {
                if (!g || (g.type !== 'T' && g.type !== 'R') || !Array.isArray(g.points) || g.points.length < 4) {
                  return;
                }
                let minX = Number.POSITIVE_INFINITY;
                let maxX = Number.NEGATIVE_INFINITY;
                let minY = Number.POSITIVE_INFINITY;
                let maxY = Number.NEGATIVE_INFINITY;
                g.points.forEach(pt => {
                  if (!pt) return;
                  const px = Number(pt.x);
                  const py = Number(pt.y);
                  if (!Number.isFinite(px) || !Number.isFinite(py)) return;
                  if (px < minX) minX = px;
                  if (px > maxX) maxX = px;
                  if (py < minY) minY = py;
                  if (py > maxY) maxY = py;
                });
                if (!Number.isFinite(minX) || !Number.isFinite(maxX) || !Number.isFinite(minY) || !Number.isFinite(maxY)) {
                  return;
                }
                const fullHeight = Math.abs(minY) <= eps && Math.abs(maxY - sheetHeight) <= eps;
                if (!fullHeight || (maxX - minX) <= eps) {
                  return;
                }
                fullHeightTraverses.push({ draw: g, minX: minX, maxX: maxX });
              });

              let nearestTraverse = null;
              let nearestDelta = Number.POSITIVE_INFINITY;
              fullHeightTraverses.forEach(tv => {
                const delta = tv.minX - xCut;
                if (delta < -eps) {
                  return;
                }
                if (delta <= (minDie + 1) && delta < nearestDelta) {
                  nearestDelta = delta;
                  nearestTraverse = tv;
                }
              });

              let hasVerticalClosure = fullHeightTraverses.some(tv => Math.abs(tv.minX - xCut) <= eps);
              let stripInvaded = pieceDraws.some(g => {
                const pieceKey = String(g && (g.name || g.num || ''));
                const maxX = pieceKey && Number.isFinite(pieceRightByName[pieceKey])
                  ? Number(pieceRightByName[pieceKey])
                  : Number.NEGATIVE_INFINITY;
                return Number.isFinite(maxX) && maxX > (xCut + eps);
              });

              // Si el corte candidato cae en la primera columna OEF y deja piezas a su derecha,
              // se corrige al borde derecho real del bloque para evaluar el cierre de travera.
              if (hasOefPiece && !bestOefCluster && !hasVerticalClosure && stripInvaded && Number.isFinite(maxRightAll) && (maxRightAll - xCut) > eps) {
                let preferredCut = Number(maxRightAll);
                if (Number.isFinite(maxRightAllBox) && maxRightAllBox > 0) {
                  const deltaBox = Math.abs(maxRightAllBox - maxRightAll);
                  if (deltaBox <= 2.5 && maxRightAllBox > preferredCut) {
                    preferredCut = maxRightAllBox;
                  }
                }
                xCut = Number(preferredCut.toFixed(3));
                stripInvaded = pieceDraws.some(g => {
                  const pieceKey = String(g && (g.name || g.num || ''));
                  const maxX = pieceKey && Number.isFinite(pieceRightByName[pieceKey])
                    ? Number(pieceRightByName[pieceKey])
                    : Number.NEGATIVE_INFINITY;
                  return Number.isFinite(maxX) && maxX > (xCut + eps);
                });
              }

              if (!hasVerticalClosure && nearestTraverse && nearestDelta > eps) {
                const invadedGap = pieceDraws.some(g => {
                  let pMinX = Number.POSITIVE_INFINITY;
                  let pMaxX = Number.NEGATIVE_INFINITY;
                  g.points.forEach(pt => {
                    if (!pt) return;
                    const px = Number(pt.x);
                    if (!Number.isFinite(px)) return;
                    if (px < pMinX) pMinX = px;
                    if (px > pMaxX) pMaxX = px;
                  });
                  if (!Number.isFinite(pMinX) || !Number.isFinite(pMaxX)) {
                    return false;
                  }
                  return pMaxX > (xCut + eps) && pMinX < (nearestTraverse.minX - eps);
                });

                if (!invadedGap) {
                  const tr = nearestTraverse.draw;
                  tr.points[0].x = xCut;
                  tr.points[1].x = xCut;
                  tr.points[2].x = nearestTraverse.maxX;
                  tr.points[3].x = nearestTraverse.maxX;
                  tr.width = Number((nearestTraverse.maxX - xCut).toFixed(3));
                  tr.label = Math.round(Number(tr.width)) + 'x' + Math.round(Number(tr.height));
                  hasVerticalClosure = true;
                }
              }

              const gap = Number((sheetWidth - xCut).toFixed(3));
              if (hasOefPiece) {
                console.log('[OEF close-traverse]', {
                  sheet_id: sheet && sheet.id,
                  xCut: xCut,
                  gap: gap,
                  bestCount: bestCount,
                  maxRightAll: Number(maxRightAll.toFixed(3)),
                  piece_count: pieceDraws.length
                });
              }
              if (!hasVerticalClosure &&
                  !stripInvaded &&
                  (sheet as any).remainder_structural_strip_materialized !== true &&
                  gap > Math.max(eps, minDie)) {
                const syntheticTraverse = {
                  id: -200000 - index,
                  sheet_id: Number(sheet.id),
                  sheet_width: Number(sheet.width),
                  sheet_height: Number(sheet.height),
                  name: 'T_SYN_' + (index + 1),
                  axis: 'Y',
                  width: gap,
                  height: Number(sheet.height),
                  depth: Number(sheet.depth) > 0 ? Number(sheet.depth) : 1,
                  piece: null,
                  father: null,
                  used: false,
                  diecutting: minDie,
                  max_diecutting: Number(this.max_die_cutting) > 0 ? Number(this.max_die_cutting) : 0,
                  disband: sheet.disband ? JSON.parse(JSON.stringify(sheet.disband)) : { left: 0, right: 0, top: 0, bottom: 0 },
                  origin_x: xCut,
                  origin_y: 0,
                  draw: null,
                  old: false,
                  level: 0,
                  level_h: 0,
                  points: []
                };
                this.setTrCoordinates(syntheticTraverse);
                graphicList.push(this.drawElement(
                  syntheticTraverse,
                  999,
                  sheet.mat_name,
                  sheet.mat_desc,
                  sheet.mat_id,
                  sheet.width,
                  sheet.height,
                  sheet.depth,
                  originIn,
                  sheet.disband
                ));
              }
            }
          }
        }
      }

      // console.log('--> drawGraphicsBySheet sheet graphicList:');
      // console.log(graphicList);

      // REVISAR: Se añade al listado de gráficos el construido para la nueva hoja
      // pero sólo si no está formado por un único retal (hoja vacía).
      if (graphicList.length === 1 && graphicList[0].type === 'R' ) {
		console.log('--> drawGraphicsBySheet encontrado gráfico de hoja con un único retal. No se incluye.');
	  } else {
		total_graphicList.push(graphicList);
	  }
		
    });

    return total_graphicList;

  } // End function drawGraphicsBySheet

  // Función que devuelve el dibujo del marco de una hoja.
  drawSheet(sheeIn: Sheet, indexIn: number): Draw {
    // console.log('--> drawSheet:');
    // console.log(sheeIn);

    let pointList = [];

    let P1 = { x: 0, y: 0 };
    let P2 = { x: 0, y: sheeIn.height };
    let P3 = { x:  sheeIn.width, y: sheeIn.height };
    let P4 = { x: sheeIn.width, y: 0 };

    pointList.push(P1, P2, P3, P4);

    let type_aux = 'S';

    if (!sheeIn.pieces || (sheeIn.pieces && sheeIn.pieces.length === 0)) {

      sheeIn.used = false;
      type_aux = 'U';
    }

    let m2 = Number(((sheeIn.width * sheeIn.height) / 1000000).toFixed(2));
    let kg = Number((this.kg_m2 * m2 * sheeIn.depth).toFixed(2));

    const sheetLabelW = Math.round(Number(sheeIn.width));
    const sheetLabelH = Math.round(Number(sheeIn.height));

    return {
      sheet_id: sheeIn.id,
      old: false,
      name: 'Hoja ' + indexIn,
      num: indexIn,
      //label: sheeIn.width + ' x ' + sheeIn.height,
      label: sheetLabelW + 'x' + sheetLabelH, // Medidas sin separación (mm enteros).
      steps: null,
      lot: null,
      sequence: null,
      sequence_unit: null,
      sequence_broked: false,
      total_unit: null,
      name_id: null,
      mat_id: sheeIn.mat_id,
      mat_name: sheeIn.mat_name,
      mat_desc: sheeIn.mat_desc.toString(),
      group: null,
      orderno: null,
      orderpos: null,
      paneno: null,
      easel: null,
      easel_id: null,
      easel_max_width: null,
      easel_max_height: null,
      easel_max_depth: null,
      easel_max_weight: null,
      easel_stacks: null,
      easel_sides: null,
      easel_flip: false,
      separator: null,
      side: null,
      stack: null,
      width: sheeIn.width,
      height: sheeIn.height,
      depth: sheeIn.depth,
      // Para hallar el área total servible de una plancha hay que quitar el area de desbande, no se quiere tener en cuenta.
      // area: Number((((sheeIn.width - 2 * this.disband) * (sheeIn.height - 2 * this.disband)) / 1000000).toFixed(2)),
      area: m2,
      weight: kg,
      points: pointList,
      type: type_aux,
      decoat: 0,
      id_line: 0,
      id_client: 0,
      client: null,
      rotation: 0,
      form_id: 0,
      form_L: 0,
      form_L1: 0,
      form_L2: 0,
      form_H: 0,
      form_H1: 0,
      form_H2: 0,
      form_R: 0,
      form_R2: 0,
      form_R3: 0,
      form_R4: 0,
      form_B1: 0,
      form_B2: 0,
      form_B3: 0,
      form_B4: 0,
      form_DXF_NAME: null,
      form_DXF_POINTS: null,
      form_DXF_W: 0,
      form_DXF_H: 0,
      num_of: 0,
      pos_of: 0,
      draw_set: null,
      flip: false
    };

  } // End function drawSheet

  // Función para dibujar los puntos de una pieza que se ha colocado (para ser cortada) en una travera .
  drawElement(
        traverseIn: Traverse, 
        indexIn: number, 
        sheetMaterialName: string,
        sheetMaterialDesc: string,
        sheetMaterialId: number,
        sheetWidth: number, 
        sheetHeight: number,
        sheetDepth: number,
        originIn: number, 
        disbandIn: any): Draw {
    // console.log('--> drawElement:');
    // console.log(traverseIn);

    let pointList = [];

    let piece = traverseIn.piece;

    // Si hay pieza se dibuja su contorno en relación a la posición de la travera donde se encuentra.
    if (piece) {
          
      let P1 = { x: traverseIn.origin_x, y: traverseIn.origin_y };
      let P2 = { x: traverseIn.origin_x, y: traverseIn.origin_y + piece.piece_height };
      let P3 = { x: traverseIn.origin_x + piece.piece_width, y: traverseIn.origin_y + piece.piece_height };
      let P4 = { x: traverseIn.origin_x + piece.piece_width, y: traverseIn.origin_y };
           
	  pointList.push(P1, P2, P3, P4);
	  
	  // Control del grosor del vidrio. Si no tiene valor se supondrá que el grosor será 1mm.
	  if (!sheetDepth) sheetDepth = 1;
	  if (!piece.piece_depth) piece.piece_depth = sheetDepth;

      let m2 = Number((((piece.piece_oef_effective_area ? Number(piece.piece_oef_effective_area) : (piece.piece_width * piece.piece_height))) / 1000000).toFixed(2));
      let kg = Number((this.kg_m2 * m2 * piece.piece_depth).toFixed(2));

      const pieceLabelW = Math.round(Number(piece.piece_width));
      const pieceLabelH = Math.round(Number(piece.piece_height));
      traverseIn.piece.draw = {
        sheet_id: traverseIn.sheet_id,
        old: traverseIn.old ? traverseIn.old : false,
        name: '' + indexIn.toString(), // piece.piece_num.toString(),
        num: indexIn,
        // label: piece.piece_width + ' x ' + piece.piece_height,
        label: pieceLabelW + 'x' + pieceLabelH, // Medidas sin separación (mm enteros).
        steps: piece.piece_steps,
        lot: piece.piece_lot,
        sequence: piece.piece_sequence,
        sequence_unit: piece.piece_sequence_unit,
        sequence_broked: piece.piece_sequence_broked,
        total_unit: piece.piece_total_unit,
        name_id: piece.piece_name_id,
        mat_id: piece.piece_mat_id,
        mat_name: piece.piece_material,
        mat_desc: piece.piece_material,
        group: piece.piece_group,
        orderno: piece.piece_orderno,
        orderpos: piece.piece_orderpos,
        priority: Number(piece.piece_priority) > 0 ? 1 : 0,
        paneno: piece.piece_paneno,
        easel: piece.piece_group + piece.easel_num.toString(),
        easel_id: piece.easel_id,
        easel_max_width: piece.easel_max_width,
        easel_max_height: piece.easel_max_height,
        easel_max_depth: piece.easel_max_depth,
        easel_max_weight: piece.easel_max_weight,
        easel_stacks: piece.easel_stack,
        easel_sides: piece.easel_side,
        easel_flip: piece.easel_flip,
        separator: piece.easel_separator,
        side: piece.easel_side,
        stack: piece.easel_stack,
        width: piece.piece_width,
        height: piece.piece_height,
        depth: piece.piece_depth,
        area: m2,
        weight: kg,
        points: pointList,
        type: 'P',
        decoat: piece.piece_decoat,
        id_line: piece.piece_id_line,
        id_client: piece.piece_id_client,
        client: piece.piece_client,
        rotation: piece.piece_rotation,
        form_id: (piece.piece_figure_input !== undefined && piece.piece_figure_input !== null) ? piece.piece_figure_input : piece.piece_figure,
        oef_base_form_id: (piece.piece_figure_input !== undefined && piece.piece_figure_input !== null) ? piece.piece_figure_input : piece.piece_figure,
        form_L: piece.piece_l,
        form_L1: piece.piece_l1,
        form_L2: piece.piece_l2,
        form_H: piece.piece_h,
        form_H1: piece.piece_h1,
        form_H2: piece.piece_h2,
        form_R: piece.piece_r,
        form_R2: piece.piece_r2,
        form_R3: piece.piece_r3,
        form_R4: piece.piece_r4,
        form_B1: piece.piece_b1,
        form_B2: piece.piece_b2,
        form_B3: piece.piece_b3,
        form_B4: piece.piece_b4,
        form_DXF_NAME: piece.piece_dxf_name,
        form_DXF_POINTS: piece.piece_dxf_points,
        form_DXF_W: piece.piece_dxf_w,
        form_DXF_H: piece.piece_dxf_h,
        oef_internal_polygons: piece.piece_oef_internal_polygons ? JSON.parse(JSON.stringify(piece.piece_oef_internal_polygons)) : null,
        oef_generated: piece.piece_oef_generated === true || (piece.piece_oef_internal_polygons && piece.piece_oef_internal_polygons.length > 0),
        oef_primitive_w: piece.piece_oef_primitive_w ? Number(piece.piece_oef_primitive_w) : 0,
        oef_primitive_h: piece.piece_oef_primitive_h ? Number(piece.piece_oef_primitive_h) : 0,
        oef_effective_area: piece.piece_oef_effective_area ? Number(piece.piece_oef_effective_area) : 0,
        oef_real_units: piece.piece_oef_real_units ? Number(piece.piece_oef_real_units) : 1,
        num_of: piece.piece_num_of,
        pos_of: piece.piece_pos_of,
        draw_set: null,
        flip: piece.piece_flip
      };

      return traverseIn.piece.draw;

    } else {

      // Es un retal porque no se le asignó pieza. Se dibuja toda la travera.
      let P1 = { x: traverseIn.origin_x, y: traverseIn.origin_y };
      let P2 = { x: traverseIn.origin_x, y: traverseIn.origin_y + traverseIn.height };
      let P3 = { x: traverseIn.origin_x + traverseIn.width, y: traverseIn.origin_y + traverseIn.height };
      let P4 = { x: traverseIn.origin_x + traverseIn.width, y: traverseIn.origin_y };
     
      pointList.push(P1, P2, P3, P4);

      let type_aux = 'T';
      let name_aux = traverseIn.name;

      // console.log('--> getNextPiece TW = ' + traverseIn.width + ' ;TH = ' + traverseIn.height);
      // console.log('--> getNextPiece RW = ' + this.retal_width + ' ;TH = ' + this.retal_height);

      // La travera será un retal si sus dimensiones son mayores que las mínimas exigidas para la optimización.
      if (traverseIn.width >= this.retal_width && traverseIn.height >= this.retal_height) {
        type_aux = 'R';
        name_aux = name_aux.replace('T', 'R');
      }

      let m2 = Number(((traverseIn.width * traverseIn.height) / 1000000).toFixed(2));
      let kg = Number((this.kg_m2 * m2 * traverseIn.depth).toFixed(2));
      
      // console.log('drawElement -> Metros y Peso de pieza tipo R:');
      // console.log(traverseIn);
      // console.log(m2);
      // console.log(kg);

      const traverseLabelW = Math.round(Number(traverseIn.width));
      const traverseLabelH = Math.round(Number(traverseIn.height));
      traverseIn.draw = {
        sheet_id: traverseIn.sheet_id,
        old: traverseIn.old ? traverseIn.old : false,
        name: name_aux,
        num: traverseIn.id,
        //label: traverseIn.width + ' x ' + traverseIn.height,
        label: traverseLabelW + 'x' + traverseLabelH, // Medidas sin separación (mm enteros).
        steps: null,
        lot: null,
        sequence: null,
        sequence_unit: null,
        sequence_broked: false,
        total_unit: null,
        name_id: null,
        mat_id: sheetMaterialId,
        mat_name: sheetMaterialName.toString(),
        mat_desc: sheetMaterialDesc.toString(),
        group: null,
        orderno: null,
        orderpos: null,
        paneno: null,
        easel: null,
        easel_id: null,
        easel_max_width: null,
        easel_max_height: null,
        easel_max_depth: null,
        easel_max_weight: null,
        easel_stacks: null,
        easel_sides: null,
        easel_flip: false,
        separator: null,
        side: null,
        stack: null,
        width: traverseIn.width,
        height: traverseIn.height,
        depth: traverseIn.depth,
        area: m2,
        weight: kg,
        points: pointList,
        type: type_aux,
        decoat: 0,
        id_line: 0,
        id_client: 0,
        client: null,
        rotation: 0,
        form_id: 0,
        form_L: 0,
        form_L1: 0,
        form_L2: 0,
        form_H: 0,
        form_H1: 0,
        form_H2: 0,
        form_R: 0,
        form_R2: 0,
        form_R3: 0,
        form_R4: 0,
        form_B1: 0,
        form_B2: 0,
        form_B3: 0,
        form_B4: 0,
        form_DXF_NAME: null,
        form_DXF_POINTS: null,
        form_DXF_W: 0,
        form_DXF_H: 0,
        num_of: 0,
        pos_of: 0,
        draw_set: null,
        flip: false
      };

      // El postprocesado específico de "retal central" trabaja después de
      // drawGraphicsBySheet. Conservamos en el gráfico la marca de la pasada
      // general para que no vuelva a repartir (y deshaga) una pareja de restos
      // que ya se consolidó expresamente para facilitar el tronzado.
      (traverseIn.draw as any).remainder_consolidated =
        (traverseIn as any).remainder_consolidated === true;
      (traverseIn.draw as any).remainder_cut_ease_locked =
        (traverseIn as any).remainder_cut_ease_locked === true;

      return traverseIn.draw;
    }

  } // End function drawElement
  
  // Función para dibujar los puntos de una "pieza marco" que tiene varias piezas en su interior .
  drawInElement(
        traverseIn: Traverse, 
        indexIn: number, 
        sheetMaterialName: string,
        sheetMaterialDesc: string,
        sheetMaterialId: number,
        sheetWidth: number, 
        sheetHeight: number,
        sheetDepth: number,
        originIn: number, 
        disbandIn: any): Draw {
    // console.log('--> drawInElement:');
    // console.log(traverseIn);

    let pointList = [];
    let drawListIn = [];
    
    let piece = null;
    
    // Si hay "marco de piezas" se pasa directamente a dibujar su contenido.
    if (traverseIn && traverseIn.piece) {
      piece = traverseIn.piece;    
    }
    
    // Si hay pieza se dibuja su contorno en relación a la posición de la travera donde se encuentra.
    if (piece) {
      
      if (piece.piece_matrix && piece.piece_matrix.length > 0) {
	  	// console.log('--> drawInElement. Encontrado marco interno de piezas. Rotación = ' + piece.piece_rotation);
	  	// console.log('--> draw_w = ' + piece.draw_w + ' ;draw_h = ' + piece.draw_h);
	  	let draw_w_aux = piece.draw_w;
	  	let draw_h_aux = piece.draw_h;
	  	/* // NOTA ROTACIÓN:
	  	if (piece.piece_rotation === 90 || piece.piece_rotation === 270) {
          	draw_w_aux = piece.draw_h;
	  		draw_h_aux = piece.draw_w;
        } // */
	  	
	  	// Se empieza el contador de "i" y "j" en 1 porque la "pieza marco"
	  	// no está incluída en "piece_set" pero hay que considerarla como que sí.
	  	for (let i = 0; i < draw_w_aux; i++) {
        	for (let j = 0; j < draw_h_aux; j++) {
                    
                  // console.log('--> pin[' + (i +1) + '][' + (j + 1) + ']');
            	  let pin = piece.piece_matrix[i][j];
            	  
            	  // console.log(pin);
            	  
		          let pointListIn = [];
		       
			      let aux_w = i * piece.piece_width;
			      let aux_h = j * piece.piece_height;
			      
			      // Se invierten los elementos de la matriz.
			      /* // NOTA ROTACIÓN:
			      if (piece.piece_rotation === 90 || piece.piece_rotation === 270) {
                  	aux_w = j * piece.piece_width;
			      	aux_h = i * piece.piece_height;   
                  } // */
			      
			      // Se obtienen los cuatro puntos del marco de la pieza.
			      let P1 = { x: traverseIn.origin_x + aux_w, y: traverseIn.origin_y + aux_h };
			      let P2 = { x: traverseIn.origin_x + aux_w, y: traverseIn.origin_y + aux_h + piece.piece_height };
			      let P3 = { x: traverseIn.origin_x + aux_w + piece.piece_width, y: traverseIn.origin_y + aux_h + piece.piece_height };
			      let P4 = { x: traverseIn.origin_x + aux_w + piece.piece_width, y: traverseIn.origin_y + aux_h };
			      
				  pointListIn.push(P1, P2, P3, P4);
				  
				  // Control del grosor del vidrio. Si no tiene valor se supondrá que el grosor será 1mm.
				  if (!sheetDepth) sheetDepth = 1;
				  if (!piece.piece_depth) piece.piece_depth = sheetDepth;
			
			      let m2 = Number((((pin.piece_oef_effective_area ? Number(pin.piece_oef_effective_area) : (piece.piece_width * piece.piece_height))) / 1000000).toFixed(2));
			      let kg = Number((this.kg_m2 * m2 * piece.piece_depth).toFixed(2));
			
				  // console.log('--> ----> pin.piece_num:');
    			  // console.log(pin.piece_num);
    			  // console.log(pin);
    
			      const pinLabelW = Math.round(Number(piece.piece_width));
			      const pinLabelH = Math.round(Number(piece.piece_height));
			      pin.draw = {
			        sheet_id: traverseIn.sheet_id,
			        old: traverseIn.old ? traverseIn.old : false,
			        name: '' + pin.piece_num, // ? pin.piece_num.toString() : pin.piece_num, // indexIn.toString(),
			        num: pin.piece_num, // ? pin.piece_num.toString() : pin.piece_num, // indexIn,
			        //label: piece.piece_width + ' x ' + piece.piece_height,
			        label: pinLabelW + 'x' + pinLabelH, // Medidas sin separación (mm enteros).
			        steps: pin.piece_steps,
			        lot: pin.piece_lot,
			        sequence: pin.piece_sequence,
			        sequence_unit: pin.piece_sequence_unit,
			        sequence_broked: pin.piece_sequence_broked,
			        total_unit: pin.piece_total_unit,
			        name_id: pin.piece_name_id,
			        mat_id: pin.piece_mat_id,
			        mat_name: pin.piece_material,
			        mat_desc: pin.piece_material,
			        group: pin.piece_group,
			        orderno: pin.piece_orderno,
			        orderpos: pin.piece_orderpos,
			        priority: Number(pin.piece_priority) > 0 ? 1 : 0,
			        paneno: pin.piece_paneno,
			        easel: pin.piece_group + pin.easel_num, // pin.easel_num.toString(),
			        easel_id: pin.easel_id,
			        easel_max_width: pin.easel_max_width,
			        easel_max_height: pin.easel_max_height,
			        easel_max_depth: pin.easel_max_depth,
			        easel_max_weight: pin.easel_max_weight,
			        easel_stacks: pin.easel_stack,
			        easel_sides: pin.easel_side,
			        easel_flip: pin.easel_flip,
			        separator: pin.easel_separator,
			        side: pin.easel_side,
			        stack: pin.easel_stack,
			        width: pin.piece_width,
			        height: pin.piece_height,
			        depth: pin.piece_depth,
			        area: m2,
			        weight: kg,
			        points: pointListIn, // NOTA: Se indica el listodo de puntos que dibujan a la pieza.
			        type: 'P',
			        decoat: pin.piece_decoat,
			        id_line: pin.piece_id_line,
			        id_client: pin.piece_id_client,
			        client: pin.piece_client,
			        rotation: pin.piece_rotation,
			        form_id: (pin.piece_figure_input !== undefined && pin.piece_figure_input !== null) ? pin.piece_figure_input : pin.piece_figure,
			        oef_base_form_id: (pin.piece_figure_input !== undefined && pin.piece_figure_input !== null) ? pin.piece_figure_input : pin.piece_figure,
			        form_L: pin.piece_l,
			        form_L1: pin.piece_l1,
			        form_L2: pin.piece_l2,
			        form_H: pin.piece_h,
			        form_H1: pin.piece_h1,
			        form_H2: pin.piece_h2,
			        form_R: pin.piece_r,
			        form_R2: pin.piece_r2,
              		form_R3: pin.piece_r3,
              		form_R4: pin.piece_r4,
			        form_B1: pin.piece_b1,
			        form_B2: pin.piece_b2,
			        form_B3: pin.piece_b3,
			        form_B4: pin.piece_b4,
			        form_DXF_NAME: pin.piece_dxf_name,
			        form_DXF_POINTS: pin.piece_dxf_points,
			        form_DXF_W: pin.piece_dxf_w,
			        form_DXF_H: pin.piece_dxf_h,
			        oef_internal_polygons: pin.piece_oef_internal_polygons ? JSON.parse(JSON.stringify(pin.piece_oef_internal_polygons)) : null,
			        oef_generated: pin.piece_oef_generated === true || (pin.piece_oef_internal_polygons && pin.piece_oef_internal_polygons.length > 0),
			        oef_primitive_w: pin.piece_oef_primitive_w ? Number(pin.piece_oef_primitive_w) : 0,
			        oef_primitive_h: pin.piece_oef_primitive_h ? Number(pin.piece_oef_primitive_h) : 0,
			        oef_effective_area: pin.piece_oef_effective_area ? Number(pin.piece_oef_effective_area) : 0,
			        oef_real_units: pin.piece_oef_real_units ? Number(pin.piece_oef_real_units) : 1,
			        num_of: pin.piece_num_of,
			        pos_of: pin.piece_pos_of,
			        flip: pin.piece_flip
			      };
			      
			      // Se añade el gráfico interno al listado.
			      drawListIn.push(pin.draw);
                  
        	} // End FOR draw_w.
            
        } // End FOR draw_w.
	  	
	  } // End IF piece_set. // */
	  
	  // Se obtienen los cuatro puntos del marco de la pieza.
      let P1 = { x: traverseIn.origin_x, y: traverseIn.origin_y };
      let P2 = { x: traverseIn.origin_x, y: traverseIn.origin_y + piece.piece_height };
      let P3 = { x: traverseIn.origin_x + piece.piece_width, y: traverseIn.origin_y + piece.piece_height };
      let P4 = { x: traverseIn.origin_x + piece.piece_width, y: traverseIn.origin_y };
           
	  pointList.push(P1, P2, P3, P4);
	  
	  // Control del grosor del vidrio. Si no tiene valor se supondrá que el grosor será 1mm.
	  if (!sheetDepth) sheetDepth = 1;
	  if (!piece.piece_depth) piece.piece_depth = sheetDepth;

      let m2 = Number((((piece.piece_oef_effective_area ? Number(piece.piece_oef_effective_area) : (piece.piece_width * piece.piece_height))) / 1000000).toFixed(2));
      let kg = Number((this.kg_m2 * m2 * piece.piece_depth).toFixed(2));

      const pieceSetLabelW = Math.round(Number(piece.piece_width));
      const pieceSetLabelH = Math.round(Number(piece.piece_height));
      traverseIn.piece.draw = {
        sheet_id: traverseIn.sheet_id,
        old: traverseIn.old ? traverseIn.old : false,
        name: '' + piece.piece_num.toString(), // indexIn.toString(),
        num: piece.piece_num, // indexIn,
        // label: piece.piece_width + ' x ' + piece.piece_height,
        label: pieceSetLabelW + 'x' + pieceSetLabelH, // Medidas sin separación (mm enteros).
        steps: piece.piece_steps,
        lot: piece.piece_lot,
        sequence: piece.piece_sequence,
        sequence_unit: piece.piece_sequence_unit,
        sequence_broked: piece.piece_sequence_broked,
        total_unit: piece.piece_total_unit,
        name_id: piece.piece_name_id,
        mat_id: piece.piece_mat_id,
        mat_name: piece.piece_material,
        mat_desc: piece.piece_material,
        group: piece.piece_group,
        orderno: piece.piece_orderno,
        orderpos: piece.piece_orderpos,
        priority: Number(piece.piece_priority) > 0 ? 1 : 0,
        paneno: piece.piece_paneno,
        easel: piece.piece_group + piece.easel_num.toString(),
        easel_id: piece.easel_id,
        easel_max_width: piece.easel_max_width,
        easel_max_height: piece.easel_max_height,
        easel_max_depth: piece.easel_max_depth,
        easel_max_weight: piece.easel_max_weight,
        easel_stacks: piece.easel_stack,
        easel_sides: piece.easel_side,
        easel_flip: piece.easel_flip,
        separator: piece.easel_separator,
        side: piece.easel_side,
        stack: piece.easel_stack,
        width: piece.piece_width,
        height: piece.piece_height,
        depth: piece.piece_depth,
        area: m2,
        weight: kg,
        points: pointList, // NOTA: Se indica el listodo de puntos que dibujan a la pieza.
        type: 'P',
        decoat: piece.piece_decoat,
        id_line: piece.piece_id_line,
        id_client: piece.piece_id_client,
        client: piece.piece_client,
        rotation: piece.piece_rotation,
        form_id: (piece.piece_figure_input !== undefined && piece.piece_figure_input !== null) ? piece.piece_figure_input : piece.piece_figure,
        oef_base_form_id: (piece.piece_figure_input !== undefined && piece.piece_figure_input !== null) ? piece.piece_figure_input : piece.piece_figure,
        form_L: piece.piece_l,
        form_L1: piece.piece_l1,
        form_L2: piece.piece_l2,
        form_H: piece.piece_h,
        form_H1: piece.piece_h1,
        form_H2: piece.piece_h2,
        form_R: piece.piece_r,
        form_R2: piece.piece_r2,
        form_R3: piece.piece_r3,
        form_R4: piece.piece_r4,
        form_B1: piece.piece_b1,
        form_B2: piece.piece_b2,
        form_B3: piece.piece_b3,
        form_B4: piece.piece_b4,
        form_DXF_NAME: piece.piece_dxf_name,
        form_DXF_POINTS: piece.piece_dxf_points,
        form_DXF_W: piece.piece_dxf_w,
        form_DXF_H: piece.piece_dxf_h,
        oef_internal_polygons: piece.piece_oef_internal_polygons ? JSON.parse(JSON.stringify(piece.piece_oef_internal_polygons)) : null,
        oef_generated: piece.piece_oef_generated === true || (piece.piece_oef_internal_polygons && piece.piece_oef_internal_polygons.length > 0),
        oef_primitive_w: piece.piece_oef_primitive_w ? Number(piece.piece_oef_primitive_w) : 0,
        oef_primitive_h: piece.piece_oef_primitive_h ? Number(piece.piece_oef_primitive_h) : 0,
        oef_effective_area: piece.piece_oef_effective_area ? Number(piece.piece_oef_effective_area) : 0,
        oef_real_units: piece.piece_oef_real_units ? Number(piece.piece_oef_real_units) : 1,
        num_of: piece.piece_num_of,
        pos_of: piece.piece_pos_of,
        draw_set: drawListIn,
        flip: piece.piece_flip
      };
      
      return traverseIn.piece.draw;

    } else if (traverseIn) {

      // Es un retal porque no se le asignó pieza. Se dibuja toda la travera.
      let P1 = { x: traverseIn.origin_x, y: traverseIn.origin_y };
      let P2 = { x: traverseIn.origin_x, y: traverseIn.origin_y + traverseIn.height };
      let P3 = { x: traverseIn.origin_x + traverseIn.width, y: traverseIn.origin_y + traverseIn.height };
      let P4 = { x: traverseIn.origin_x + traverseIn.width, y: traverseIn.origin_y };
     
      pointList.push(P1, P2, P3, P4);

      let type_aux = 'T';
      let name_aux = traverseIn.name;

      // console.log('--> getNextPiece TW = ' + traverseIn.width + ' ;TH = ' + traverseIn.height);
      // console.log('--> getNextPiece RW = ' + this.retal_width + ' ;TH = ' + this.retal_height);

      // La travera será un retal si sus dimensiones son mayores que las mínimas exigidas para la optimización.
      if (traverseIn.width >= this.retal_width && traverseIn.height >= this.retal_height) {
        type_aux = 'R';
        name_aux = name_aux.replace('T', 'R');
      }

      let m2 = Number(((traverseIn.width * traverseIn.height) / 1000000).toFixed(2));
      let kg = Number((this.kg_m2 * m2 * traverseIn.depth).toFixed(2));
      
      // console.log('drawInElement -> Metros y Peso de pieza tipo R:');
      // console.log(m2);
      // console.log(kg);

      const traverseInLabelW = Math.round(Number(traverseIn.width));
      const traverseInLabelH = Math.round(Number(traverseIn.height));
      traverseIn.draw = {
        sheet_id: traverseIn.sheet_id,
        old: traverseIn.old ? traverseIn.old : false,
        name: name_aux,
        num: traverseIn.id,
        // label: traverseIn.width + ' x ' + traverseIn.height,
        label: traverseInLabelW + 'x' + traverseInLabelH, // Medidas sin separación (mm enteros).
        steps: null,
        lot: null,
        sequence: null,
        sequence_unit: null,
        sequence_broked: false,
        total_unit: null,
        name_id: null,
        mat_id: sheetMaterialId,
        mat_name: sheetMaterialName,
        mat_desc: sheetMaterialDesc,
        group: null,
        orderno: null,
        orderpos: null,
        paneno: null,
        easel: null,
        easel_id: null,
        easel_max_width: null,
        easel_max_height: null,
        easel_max_depth: null,
        easel_max_weight: null,
        easel_stacks: null,
        easel_sides: null,
        easel_flip: false,
        separator: null,
        side: null,
        stack: null,
        width: traverseIn.width,
        height: traverseIn.height,
        depth: traverseIn.depth,
        area: m2,
        weight: kg,
        points: pointList,
        type: type_aux,
        decoat: 0,
        id_line: 0,
        id_client: 0,
        client: null,
        rotation: 0,
        form_id: 0,
        form_L: 0,
        form_L1: 0,
        form_L2: 0,
        form_H: 0,
        form_H1: 0,
        form_H2: 0,
        form_R: 0,
        form_R2: 0,
        form_R3: 0,
        form_R4: 0,
        form_B1: 0,
        form_B2: 0,
        form_B3: 0,
        form_B4: 0,
        form_DXF_NAME: null,
        form_DXF_POINTS: null,
        form_DXF_W: 0,
        form_DXF_H: 0,
        num_of: 0,
        pos_of: 0,
        draw_set: null,
        flip: false
      };

      return traverseIn.draw;
    }
    
    // En caso de que la travera de entrada fuera nulla devuelve también null.
    return null;

  } // End function drawInElement

  // --------
  //  PIEZAS
  // --------

// Función que coge el listado de piezas (que está dividido en grupos de prioriadaes)
// y las mete todas en nextPiece una a una, un grupo tras otro mientras los va vaciando.
// MEJORA: Realmente ahora mismo sólo bastaría ejecutar esta función una vez (la que hace
// la carga de piezas inicial completa) porque el resto de veces no está cargando ya nada.
  async getNextPiece(lastPieceIn: PieceToEasel, rotateIn: boolean) {
    // console.log('--> getNextPiece next_pieces:');
    // console.log('--> getNextPiece last_piece: ');
    // console.log(lastPieceIn);

    // let next_pieces = [];
    // next_pieces = [...this.nextPiece]; // JSON.parse(JSON.stringify(this.nextPiece));
    // console.log(next_pieces);

    // let result_pieces = [];

    let promise_in = new Promise((resolve, reject) => {
        // console.log('->> Inicio Promesa de getNextPiece:');

        let next_pieces = [...this.nextPiece];
        // let last_piece_aux = JSON.parse(JSON.stringify(lastPieceIn));
        
        // console.log('--> getNextPiece last_piece_aux: ');
    	// console.log(last_piece_aux);

        if (next_pieces && next_pieces.length === 0) {
			
		  console.log('--> getNextPiece next_pieces.length === 0.');
              
          // Se obtienen las siguientes piezas que se pueden sacar de cada grupo de optimización existente.
          for (let prop in this.pieceInfoList) {
          	let group_list = this.pieceInfoList[prop];
          	
          	// IMPORTANTE: ordenación de las piezas. Va a indicar el orden
          	// en que se intentaráncolocar en las planchas.
          	// Es indiferente hacer esta ordenación aquí.          	
          	//group_list = this.orderById(group_list, false);
          	//group_list = this.orderBy2Dimensions(group_list, 'piece_width', 'piece_height', true);
          	
          	group_list.forEach((pi, ind) => {
            	next_pieces.push(pi);
            	// console.log('--> getNextPiece próxima pieza escogida: ');
    			// console.log(pi);
    			
            	let splice_piece = group_list.splice(ind, 1);
            	// console.log('--> getNextPiece splice_piece: ');
    			// console.log(splice_piece);
            	
            });
          } // End For pieceInfoList.
          
        } else {
          console.log('--> getNextPiece: Ya existían piezas candidatas.');

          let next_pieces_aux = [];

          // Se quitan las piezas ya usadas del listado de candidatas.
          next_pieces.map( (pz, i) => {
            if (pz.piece_cut === true) { // && pz.piece_set && !pz.piece_set.find(pp => !pp.piece_cut)) {

              console.log('--> getNextPiece: Detectada pieza usada con todos sus elementos internos cortados. Se elimina.');
              next_pieces.splice(i, 1); // Quitamos el elemento.

              // Sacamos una pieza del mismo grupo de optimización de la pieza colocada.
              let group_piece = this.pieceInfoList[pz.piece_group].shift();
              // let group_piece = this.pieceInfoList[pz.piece_group].pop();

              if (group_piece) {
				
				console.log('--> getNextPiece: Se intenta sacar una segunda pieza del mimo grupo.');
				
                next_pieces_aux.push(group_piece);
                
                group_piece = this.pieceInfoList[pz.piece_group].shift();
                // group_piece = this.pieceInfoList[pz.piece_group].pop();
				
				// Se añade una segunda pieza para que exista "próxima pieza".
	            if (group_piece) {
	            	next_pieces_aux.push(group_piece);
	            }
              } else {
				
				console.log('--> getNextPiece: Se intenta sacar una segunda pieza de otro grupo.');
				
				// Se intenta sacar otra pieza de otro grupo.
				for (let prop in this.pieceInfoList) {
          			let group_aux = this.pieceInfoList[prop];
          			let elem_aux = null;
          			
          			elem_aux = group_aux.shift();
          			// elem_aux = group_aux.pop();
          			
          			if (elem_aux) {
						next_pieces_aux.push(elem_aux);
						
						// console.log('--> getNextPiece añadida pieza de otro grupo: ' + prop);
						// console.log(elem_aux);
						
						// Se añade una segunda pieza para que exista "próxima pieza".
						elem_aux = group_aux.shift();
						// elem_aux = group_aux.pop();
						
						if (elem_aux) {
							next_pieces_aux.push(elem_aux);
						}
						
						break; // Se sale del bucle for.
					}
          		}
			  }
            }  // End pz.piece_cut === true.
            // else {
            //   next_pieces_aux.push(pz);
            // }
          }); // End next_pieces.map

          next_pieces_aux.forEach(new_p => {
            if (next_pieces.find(p => p.piece_num === new_p.piece_num)) {
              console.log('--> getNextPiece: Se ha intentado poner como candidata una pieza que ya está como tal.');
            } else {
              
			  if (new_p.piece_height > this.max_die_cutting && new_p.piece_width > this.max_die_cutting) {
              	console.log('--> getNextPiece: Se ha intentado poner una pieza que sobrepasaba el ancho máximo de travera permitido.');
              } else {
					// console.log('--> getNextPiece: Añadiendo pieza candidata:');
              		// console.log(new_p);
              		
                    next_pieces.push(new_p);
                /*
                if (this.last_piece.piece_group === new_p.piece_group) {
                    console.log('--> getNextPiece: colocada pieza del mismo grupo que la anterior.');
                	next_pieces.push(new_p);
                } else {
                    console.log('--> getNextPiece: Se ha intentado poner una pieza que no es del mismo grupo que la anterior.'); 
                } */
                
              }
            }
          });

          // console.log('--> getNextPiece next_pieces_aux:');
          // console.log(JSON.parse(JSON.stringify(next_pieces_aux)));
          
        } // End Else next_pieces.

        if (next_pieces && next_pieces.length === 0) {
          this.end_pieces = true;
        }
		
		//console.log('--> getNextPiece this.nextPiece:');
        //console.log(JSON.parse(JSON.stringify(next_pieces)));
        //console.log('---------------**----------------');
		
        resolve(next_pieces);
    }); // End promise_in.

    // IMPORTANTE: getNextPiece al ser una función asíncrona tiene que devolver una
    // "resolución de promesa" para que pueda ser evaluada tras un "wait".
    return promise_in.then((response: PieceToEasel[]) => {
      // console.log('->> Respuesta de getNextPiece:');
      // console.log(response);

      // return response.filter(p => !p.piece_cut);
      return response;

    }).catch((error) => {
      console.log('->> Error en getNextPiece:');
      console.log(error);
    });

  } // End function getNextPiece
  
  // Función que filtra todas las piezas de la optimización para
  // devolver sólo las que aún no han sido cortadas, formando así
  // la nueva lista de "piezas pendientes por cortar".
  async getNextPieceList(lastPieceIn: PieceToEasel) {
    // console.log('--> getNextPieceList next_pieces:');
    // console.log('--> getNextPieceList last_piece: ');
    // console.log(lastPieceIn);

    //let next_pieces = [...this.nextPiece]; // JSON.parse(JSON.stringify(this.nextPiece));
    // console.log(next_pieces);

    let promise_in = new Promise((resolve, reject) => {
        // console.log('->> Inicio Promesa de getNextPiece:');
        
        // IMPORTANTE: Aquí se quitan las pieza ya cortadas filtrando
        // y sacando sólo las piezas aún no cortadas "piece_cut === false".
        if (this.nextPiece) {
			
			this.nextPiece = this.nextPiece.filter(p => !p.piece_cut);
      
	        if (this.nextPiece && this.nextPiece.length === 0) {
			
				console.log('->> getNextPieceList end_pieces.');
				this.end_pieces = true;
	        }
		}
		
        // Si se quisiera reordenar las piezas por si hubiese cambiado el orden inicial.
        // Normalmente esto no ocurre y casi siempre el resultado es el mismo, por eso
        // se comentan estas líneas.
        
        // this.nextPiece = this.orderBy2Dimensions(this.nextPiece, 'piece_width', 'piece_height', true);
        // this.nextPiece = this.orderById(this.nextPiece, false);
        // this.nextPiece = this.orderByLot(this.nextPiece, 'piece_', true);
        
        // MEJORA: Buscar la pieza con el ancho más grande y con una secuencia igual o menor.
        // Colocar esa pieza la primera del listado de piezas para que sea la siguiente.
        
        // NOTA: Ordenando aquí produce que pulsando el botón "Optimizar" sin cambiar
        // nada salgan distintas gráficas como resultado cada vez que se pulsa (extraño).
		// this.nextPiece = this.orderBy2Dimensions(this.nextPiece, 'piece_width', 'piece_height', true);
		
		let change_ok = true;
		// 
		// while (change_ok) {
			// change_ok = this.getLessSequence(lastPieceIn);
		// }
		
        resolve(this.nextPiece);
    }); // End promise_in.

    // IMPORTANTE: getNextPiece al ser una función asíncrona tiene que devolver una
    // "resolución de promesa" para que pueda ser evaluada tras un "wait".
    return promise_in.then((response: PieceToEasel[]) => {
      // console.log('->> Respuesta de getNextPieceList:');
      // console.log(response);

      return response;

    }).catch((error) => {
      console.log('->> Error en getNextPieceList:');
      console.log(error);
    });

  } // End function getNextPieceList
  
  // Función que cambia la posición de una pieza y la coloca
  // como "siguiente a cortar" si es igual que la que se desea
  // cortar ahora pero tiene una secuencia mayor que ésta.
  getLessSequence(lastPieceIn: any) {
	
	// console.log('--> getLessSequence...');
	// console.log(lastPieceIn);
	
	let change_ok = false;
	
	let next_piece = null;
	let next_piece_index = -1;
	
	next_piece = this.nextPiece.find((next, ind_next) => {
				
		if (ind_next !== 0 && // El primer elemento es ya la actual pieza candidata.
			next.piece_width === this.nextPiece[0].piece_width &&
			// next.piece_height === this.nextPiece[0].piece_height &&
			next.piece_sequence > this.nextPiece[0].piece_sequence
			// && lastPieceIn.piece_width >= next.piece_width
		) {
			
			next_piece_index = ind_next;
			
			return true;
		}
		
		return false;
	});
	
	if (next_piece) {
		// console.log('--> Última pieza colocada: ');
		// console.log(lastPieceIn);
		// console.log('->> Siguiente candidata:');
		// console.log(this.nextPiece[0].piece_num);
		// console.log('->> Encontrada mejor candidata en índice = ' +  next_piece_index);
		// console.log(next_piece);
		
		this.nextPiece.splice(next_piece_index, 1);
		
		// Se agrega la nueva pieza candidata al inicio del listado
		// de piezas para que sea la siguiente en intentarse colocar.
		this.nextPiece.unshift(next_piece);
		
		change_ok = true;
		
		// console.log('->> Actualizada candidata:');
		// console.log(this.nextPiece[0].piece_num);
		
	} // Endf If next_piece.
	
	return change_ok;
	
  } // End function getLessSequence.
  
  // Función que forma el listado inicial de las piezas para la optimización.
  // Lo hace a partir de la variable global "pieceInfoList" que las tiene separadas
  //  por grupos que van a los caballetes básicos iniciales.
  async chargePieceList() {
    // console.log('--> chargePieceList next_pieces:');
    // console.log('--> chargePieceList last_piece: ');
    // console.log(lastPieceIn);

    let next_pieces = [];
    next_pieces = [...this.nextPiece]; // JSON.parse(JSON.stringify(this.nextPiece));
    // console.log(next_pieces);

    let promise_in = new Promise((resolve, reject) => {
        // console.log('->> Inicio Promesa de getNextPiece:');
        
        // console.log('--> getNextPieceList last_piece_aux: ');
    	// console.log(last_piece_aux);

		// La primera vez que se llama a la función genera el listado
		// de piezas, que es lo que va a devolver como resultado.
        if (next_pieces && next_pieces.length === 0) {
              
          // Se obtienen las siguientes piezas que se pueden sacar de cada grupo de optimización existente.
          for (let prop in this.pieceInfoList) {
          	let group_list = this.pieceInfoList[prop];
          	
          	group_list.forEach((pi, ind) => {
            	next_pieces.push(pi);
            	// console.log('--> getNextPieceList próxima pieza escogida: ');
    			// console.log(pi);
    			
    			// Ya NO hace falta eliminarla del listado pieceInfoList.
            	// let splice_piece = group_list.splice(ind, 1);
            	
            });
          } // End For pieceInfoList.
          
          console.log('--> chargePieceList 0 next_pieces:');
          // console.log(next_pieces);
          
        } else {
			 console.log('--> chargePieceList next_pieces tiene ya piezas.');
		}
        
		
		//console.log('--> getNextPieceList this.nextPiece:');
        //console.log(JSON.parse(JSON.stringify(next_pieces)));
        //console.log('---------------**----------------');
		
        resolve(next_pieces);
    }); // End promise_in.

    // IMPORTANTE: chargePieceList al ser una función asíncrona tiene que devolver una
    // "resolución de promesa" para que pueda ser evaluada tras un "wait".
    return promise_in.then((response: PieceToEasel[]) => {
      // console.log('->> Respuesta de chargePieceList:');
      // console.log(response);
      
      response = response.filter(p => !p.piece_cut);
      
      if (response && response.length === 0) {
		
		  console.log('->> chargePieceList end_pieces.');
          this.end_pieces = true;
      }

      return response;

    }).catch((error) => {
      console.log('->> Error en chargePieceList:');
      console.log(error);
    });

  } // End function chargeNextPieceList
  
  //--------------------------------------------------
  //	SACAR PIEZAS PARA HOJA MÁS ÓPTIMIZADA
  //--------------------------------------------------
  
  getMultiplePieceList(piecesListIn: any[], areaIn: number, numListIn: number): any {
	
	console.log('-->> getMultiplePieceList piecesListIn. Ajustar a área = ' + areaIn);
    console.log(piecesListIn);
    
    let multipleList = [];
    
    let piecesListAux = [];
    
    let exit = false;
    
    let pieces = this.getPiecesOfGroups(piecesListIn);
    
    let cloneList = JSON.parse(JSON.stringify(pieces));
    
    let num_lists = 0;
    
    while (!exit) {
    
	    piecesListAux = this.fitPiecesInArea(cloneList, areaIn);
		
		multipleList.push(piecesListAux);
		
		num_lists++;
		
		// Modificamos el orden de la lista.
		this.alterList(cloneList);
		
		if (num_lists >= numListIn) exit = true;
	
    } // End While exit.
    
    return (multipleList);

  } // End function getMultiplePieceList.
  
  // Función que modifica el orden de los elementos de una lista
  // quitando el primer elemento y colocándolo al final.
  alterList(listIn) {
	
	listIn.push(listIn.splice(0, 1));
	
  } // End function alterList.
  
  getPiecesOfGroups(piecesListIn) {
	
	console.log('-->>getPiecesOfGroups ejecutando...');
	
	let pieces = [];
	
	for (let prop in piecesListIn) {
	  	let group_list = piecesListIn[prop];
  	
		group_list.forEach(pi => {
			// console.log('-->>getPiecesOfGroups Pieza:');
    		// console.log(pi);
    		
    		pieces.push(pi);
    		
		}); // End ForEach group_list
			
	} // End For piecesListIn
	
	return pieces;

  } // End function getPiecesOfGroups
  
  // Función que dado un listado ordenado de piezas saca un subconjunto de ellas
  // cuya suma de áreas no sobrepasa el valor del área pasada como segundo parámetro.
  fitPiecesInArea(piecesIn: any[], areaIn: number): any {
	
	console.log('-->> fitPiecesInArea piecesListIn. Ajustar a área = ' + areaIn);
    console.log(piecesIn);
    
    let fit_pieces = [];
    let pieces_area = 0;
    
    //let exit = false;
    
    piecesIn.forEach( pi => {
		if (pieces_area + pi.piece_area <= areaIn) {
			console.log('-> Cabe la pieza. Se añade su área.');
			
			pieces_area += pi.piece_area;
			
			// let pi_clon = JSON.parse(JSON.stringify(pi));
			
			fit_pieces.push(pi);
			
			console.log('-> Área acumulada = ' + pieces_area);
			
		} // End If pieces_area.
	});
    
    return fit_pieces;
	
  } // End function fitPiecesInArea.
  
  //--------------------------------------------------
  //			BLOQUES
  //--------------------------------------------------
  
  // ------------------------------------------------
  //  Función para agrupar piezas iguales. Transforma la lista de piezas
  //  de entrada de forma que sólo deja las piezas diferentes (piezas "marco")
  //  y mete dentro de ellas el resto de piezas iguales que se hubiesen encontrado.
  // ------------------------------------------------
  groupSimilarPieces(piecesListIn: any[]): any {

    // console.log('-->> groupSimilarPieces piecesListIn:');
    // console.log(piecesListIn);
    
    let piecesListIn_aux = [];
    
    for (let prop in piecesListIn) {
	  	let group_list = piecesListIn[prop];
	  	
	  	// console.log('-->> Grupo ' + prop);
    	// console.log(group_list);
    	
    	let group_list_aux = JSON.parse(JSON.stringify(group_list));
	  	
	  	group_list_aux.forEach((pi, ind) => {
        // for (let ind = 0;  i < group_list_aux.length; i++) {
          // let pi = group_list[ind];

        	// console.log('-->> Pieza ' + ind + ' en grupo ' + prop);
    		// console.log(pi);
    		
    		// Se buscan piezas iguales que se puedan agrupar con esta pieza en un mismo conjunto.
    		// let similar_pieces = 
    		group_list.forEach((sim, ind2) => {
          /*
          		if (sim.piece_material === pi.piece_material
					&& ((sim.piece_width === pi.piece_width && sim.piece_height === pi.piece_height ||
						sim.piece_width === pi.piece_height && sim.piece_height === pi.piece_width))
					&& sim.piece_num !== pi.piece_num
					) { */
	                
	                // console.log('-->> Pieza similar encontrada: ');
	                // console.log(sim);
	                if (!pi['piece_set']) {
              			pi['piece_set'] = [];
              		}
              		
              		let key_string = 'label_' + sim.piece_material + '_' + sim.piece_width + 'x' + sim.piece_height;
              		
              		if (!piecesListIn_aux[key_string])
                    		piecesListIn_aux[key_string] = [];
                    		
                    // Se incluye la pieza en un marco interno si no había sido ya incluída en uno anteriormente.
              		if (sim.piece_num && !piecesListIn_aux[key_string].includes(sim.piece_num)) {
                    	
                    	// console.log('-->> Elemento NO MARCO para agrupar: ');
	                	// console.log(sim);
                    	
                    	piecesListIn_aux[key_string].push(sim.piece_num);
                    	
                    	pi.piece_set.push(sim);
                    	
                    	// Si la pieza es introducida en un marco interno entonces se quita del listado inicial.
    					// group_list.splice(ind2, 1);
    					group_list_aux.splice(ind2, 1);
    				
    					//return true;
                    } // else {
                      // console.log('-->> Pieza ya repetida en el marco: ' + sim.piece_num + ' en grupo ' + prop);
                    // }
	           // } // End If sim.piece_material
	            
	            //return false;
          	});
	    });
	    
	    let marks = [];
	    
	    for (let prop in piecesListIn_aux) {
		  	let pieces_mark = piecesListIn_aux[prop];
		  	
		  	let num_pieces = group_list.length;
		  	// console.log('-->> num_pieces =');
			// console.log(num_pieces);
		  	
		  	// Número máximo de piezas por bloque por defecto.
			// NOTA: tras muchas pruebas se ha comprobado que con
			// bloques de mayor número la aplicación se relentiza.
			// Diez piezas por bloque es un número suficiente para optimizar bien.
			let p_block_max = 50;
			
			// Según el número total de piezas se adecúa el valor máximo de piezas por bloque.
			// Esto se hace para controlar el tiempo final de optimización, que no se eternice.
			if (num_pieces >= 1000) {
				p_block_max = 2; // Es como si no se agruparan piezas en bloques.
			} else if (num_pieces >= 500) {
				p_block_max = 4;
			} else if (num_pieces >= 250) {
				p_block_max = 8;
			} else if (num_pieces >= 100) {
				p_block_max = 10;
			} else if (num_pieces >= 50) {
				p_block_max = 20;
			} else if (num_pieces >= 25) {
				p_block_max = 30;
			} // */
			
			// console.log('-->> p_block_max =');
			// console.log(p_block_max);
		  	
		  	if(!marks[prop]) marks[prop] = [];
		  	
		  	pieces_mark.forEach( m => {
	          	let piece_find = group_list.find((pz, ind3) => {
                	// console.log('-->> pz:');
					// console.log(pz);
	        		if (pz.piece_num === m) {
						
						let p_ind = marks[prop].length - 1;
						
						// Se halla el número máximo de piezas por bloque teniendo en cuenta
						// el máximo que cabrían en una hoja vacía de las que se van a usar.
						// let p_block_max = Math.ceil((this.nextSheet.width * this.nextSheet.height) / (pz.piece_width * pz.piece_height));
						
						// Si caben más de 20 piezas entonces se reduce a la mitad para reducir tiempos.
						// if (p_block_max > 20) p_block_max = Math.ceil(p_block_max / 2);
						
                		if (marks[prop].length > 0 && marks[prop][p_ind].piece_set && marks[prop][p_ind].piece_set.length < p_block_max) {
                      	  // Se incluye la pieza repetida en la "pieza maestro".
                      	  if (!marks[prop][p_ind].piece_set) marks[prop][p_ind].piece_set = [];
                      	  
                      	  // console.log('-->> Se incluye la pieza repetida en la pieza maestro:');
						  // console.log(marks[prop][0]);
						  // console.log('-->> Pieza repetida incluida dentro:');
						  // console.log(pz);
					
	                      marks[prop][p_ind].piece_set.push(pz);

	                      group_list.splice(ind3, 1);
	                      
	                    } else {
                        	// Las "piezas maestro" se conserva en el group_list para que el resto
                        	// de repetidas vayan incluídas dentro de su marco interno de piezas.
                        	pz.piece_set = [];
                        	marks[prop].push(pz);
                        }
	                	return true;
	                }
	                return false;
	        	});
	        });	
		}
		
		// console.log('-->> groupSimilarPieces marks:');
		// console.log(marks);
	    
	} // End For pieceInfoList.

	// console.log('-->> groupSimilarPieces piecesListIn_aux:');
	// console.log(piecesListIn_aux);
	
  } // End function groupSimilarPieces
  
  // -------------------------------------------------------------------------------------------
  //  Función para desagrupar en piezas sueltas un bloque existente dentro de una pieza marco.
  // -------------------------------------------------------------------------------------------
  // URGENTE: Al usar esta función está entrando en bucle.
  breakBlock(pi: any): any {
	
	console.log('-->> breakBlock pieceIn:');
	// console.log(pi);

	// Se clona la pieza de entrada.
	// NOTA: Si se utiliza el auxiliar no afecta a los resultados.
	// let pi_aux = JSON.parse(JSON.stringify(pi));
	// pi_aux.piece_set = [];
	// pi_aux.piece_matrix = null;
	
	let set_aux = JSON.parse(JSON.stringify(pi.piece_matrix));
	
	// Condición: tiene que llegar con "matriz" de filas y columnas.
	// if (pi.piece_matrix && pi.piece_matrix.length > 0) {
	if (set_aux && set_aux.length > 0) {
		console.log('-->> breakBlock Pieza marco. Interior = ');
		console.log(pi.piece_matrix);
		
		pi.piece_set = [];
		pi.piece_matrix = null;
		
		// Se recorre la matriz y se añade al piece_set.
		// Hay que tener en cuenta que la primera será la "pieza marco".
		for (let i = 0; i < set_aux.length; i++) {
            
        	for (let j = 0; j < set_aux[i].length; j++) {
                    
                  // console.log('--> fit pin[' + (i + 1) + '][' + (j + 1) + ']');
            	  // let matrix_piece = pi.piece_matrix[i][j];
            	  let matrix_piece = set_aux[i][j];

				  if (j === 0 && i === 0) {
					console.log('-->> breakBlock Pieza marco encontrada. No se incluye en el bloque.');

				  } else {
					console.log('-->> breakBlock Pieza interior asignada a pieza marco.');
					
					// Si no existe un bloque de piezas se inicializa uno.
					if (!pi.piece_set) pi.piece_set = [];
					// pi_aux.piece_set.push(matrix_piece);
					pi.piece_set.push(matrix_piece);
				  }
            } // End For piece_matrix j.
            
            // if (pi.piece_matrix.length === i + 1) {
				// Al finalizar se pone a null el campo piece_matrix para
		        // indicar que no se ha hecho una "plantilla de bloque" para ella
		        // (es decir, que habría que volver a pasarla por la función
		        // templatePieces para que la adapte a una hoja/zona).
		        // pi.piece_matrix = [];
			// }
        } // End For piece_matrix i.
	} // End If piece_matrix.

	console.log('-->> breakBlock pieza resultante tras romper el bloque:');
	//console.log(pi_aux);
	console.log(pi);
	
	// return pi_aux;
	return pi;
	
  } // End function breakBlock.
  
  
  // Función que rompe todos los bloques existentes en una lista general pasada como parámetro.
  breakBlocks(piecesListIn: any[]): any {
	
	console.log('-->> breakBlocks piecesListIn:');
	console.log(JSON.stringify(piecesListIn));
	
	let piecesListIn_aux = [];
	
	for (let prop in piecesListIn) {
	  	let group_list = piecesListIn[prop];
	  	
	  	group_list.forEach((pi, ind) => {

        	console.log('-->> breakBlocks Pieza ' + ind + ' en grupo ' + prop);
    		console.log(pi);
    		
    		if (pi.piece_matrix && pi.piece_matrix.length > 0) {
				console.log('-->> breakBlocks Pieza marco. Interior = ');
    			console.log(pi.piece_matrix);
    			
    			pi.piece_set = null;
    			
    			// Se recorre la matriz y se añade al piece_set.
    			// Hay que tener en cuenta que la primera será la "pieza marco".
    			for (let i = 0; i < pi.piece_matrix.length; i++) {
                    
		        	for (let j = 0; j < pi.piece_matrix[i].length; j++) {
                            
		                  // console.log('--> fit pin[' + (i + 1) + '][' + (j + 1) + ']');
		            	  let matrix_piece = pi.piece_matrix[i][j];
		            	  
		            	  if (pi.piece_set === null) {
							pi.piece_set = [];
							
							// NOTA: La primera pieza sirve de "pieza marco",
							// así que no se coloca dentro del set.
							// pi.piece_set.push();
						  } else {
							pi.piece_set.push(matrix_piece);
						  }
		            } // End For piece_matrix j.
		        } // End For piece_matrix i.
		        
		        // Al finalizar se pone a null el campo piece_matrix para
		        // indicar que no se ha hecho una "plantilla de bloque" para ella
		        // (es decir, que habría que volver a pasarla por la función
		        // templatePieces para que la adapte a una hoja/zona).
		        pi.piece_matrix = null;
		        
			} // End If piece_matrix.
    		
    	});
    	
	} // End For pieceInfoList.
	
	let piecesListIn_aux_aux = JSON.parse(JSON.stringify(piecesListIn_aux));
	
	console.log('-->> breakBlocks piecesListIn_aux_aux:');
	console.log(JSON.stringify(piecesListIn_aux_aux));
	
	// Se reasigna la lista de "pendientes".
	piecesListIn = piecesListIn_aux;
	
  } // End function breakBlocks
  
  // Función que dada la dimensión de una pieza y su número de repeticiones devuelve el número de filas
  // y de columnas de una matriz que cabe en las dimensiones de una "hoja/zona" contenedora. También
  // devuelve las dimensiones del bloque, su área y el número de piezas sobrantes si no cupieron todas.
  blockDimension(
	wIn: number, 
	hIn: number, 
	numIn: number, 
	blockWidth: number, 
	blockHeight: number,
	maxDiecuttingIn: number,
	minDiecuttingIn: number
	): any {
    
      let num_pieces = numIn;
	  let aux_w = wIn;
	  let aux_h = hIn;
	  let p_width = wIn;
	  let p_height = hIn;
	  let num_w = 1;
	  let num_h = 1;
	  let num_h_final = 1;
	  
	  // console.log('-->> blockDimension: Piezas para encajar en el marco = ' + num_pieces);
	  // console.log('-->> p_width = ' + p_width);
	  // console.log('-->> p_height = ' + p_height);
	  // console.log('-->> blockWidth = ' + blockWidth);
	  // console.log('-->> blockHeight = ' + blockHeight);
	  // console.log('-->> maxDiecutting = ' + maxDiecuttingIn);
	  // console.log('-->> minDiecutting = ' + minDiecuttingIn);
	  
	  let count_pieces = 1; // La pieza marco es la uno.
	  
	  for (let i = 0; i < num_pieces - 1; i++) {
	    
	    // NOTA: Hay que impedir aquí que lleguen piezas maestras con mayor dimensión
	    // que el ancho máximo de travera que se esté usando para esta optimización.
	    // Si no se hace se quedará colgada la aplicación intentando meter la pieza
	    // en nuevas planchas vacías (si tienen número infinito de unidades de stock).
	    
	    // IMPORTANTE: Hay que tener en cuenta que el sobrante mida como mínimo
	    // el valor marcado para la variable "mínima distancia de tronzado".
	    
	  	if (p_height <= blockHeight &&  p_height + aux_h <= blockHeight && blockHeight - (p_height + aux_h) >= minDiecuttingIn) {
	    
	    	// console.log('-->> Comprobando filas: ' + (blockHeight - (p_height + aux_h)));
	    	
	    	if (maxDiecuttingIn > 0 && p_height + aux_h <= maxDiecuttingIn) {
	    	  // console.log('-->> Aumentando fila: ' + (p_height + aux_h));
	    	  
	          aux_h += p_height;
	          num_h++;
	          count_pieces++;
	        } else {
	          // console.log('-->> La pieza marco supera el ancho máximo de travera por el alto A.');
	        }
	        
	    } else if (p_height > blockHeight) {
	      // console.log('-->> La altura mínima del bloque no cabe.');
	      break;
	        
	    } else if (p_width + aux_w <= blockWidth && blockWidth - (p_width + aux_w) >= minDiecuttingIn) {
	    
	    	// console.log('-->> Comprobando columnas: ' + (blockWidth - (p_width + aux_w)));
	    	
	    	if (maxDiecuttingIn > 0 && p_width + aux_w <= maxDiecuttingIn) {
	          // console.log('-->> Aumentando columana: ' + (p_width + aux_w));
	          
	          // Se reinicia el contador de la distancia de filas.
	          aux_h = p_height;
	          num_h_final = num_h;
	          num_h = 1;
	          aux_w += p_width;
	          num_w++;
	          count_pieces++;
	        } else {
	          // console.log('-->> La pieza marco supera el ancho máximo de travera por el ancho A.');
	        }
	    
	    } else {
	      // console.log('-->> No caben más piezas en el bloque.');
	      break;
	    }
	    
	  } // End FOR piece_set.
	  
	  let retal_pieces = 0;
	  
	  if (count_pieces === num_pieces) {
	    // console.log('-->> Caben todas las piezas en un bloque.');
	  	
	  } else if (count_pieces < num_pieces) {
	  	// console.log('-->> Van a sobrar piezas que no caben en el bloque.');
	  	retal_pieces = num_pieces - count_pieces;
	  }
	  
	  // Si sólo existe una columna se asigna el contador de filas actual como total de filas.
	  if (num_w === 1) num_h_final = num_h;
	  
	  // console.log('-->> num_w = ' + num_w + ' ;num_h = ' + num_h_final);
	  // console.log('-->> Piezas encajadas en el marco = ' + count_pieces);
	  // console.log('-->> Piezas sobrantes = ' + retal_pieces);
	  
      let count_while = 0;
      let exit_while = 50;
      
      // Se equilibra el número de columnas y filas hasta obtener una proporción que cuadre.
      while (num_w * num_h_final > count_pieces && num_h_final > 0 && num_w > 0  && count_while < exit_while) {
        if (num_h_final >= num_w) {
          num_h_final--;
        } else if (num_w > num_h_final) {
          num_w--;
        }
        
        count_while++;
      } // End While
      
      if (count_while === exit_while) console.log('-->> While sobrepasado = ' + count_while);

	  if (num_w <= 0) num_w = 1;
	  if (num_h <= 0) num_h = 1;
	  if (num_h_final <= 0) num_h_final = 1;
	  
	  retal_pieces = num_pieces - (num_h_final * num_w);
	  
	  // console.log('-->> num_w = ' + num_w + ' ;num_h = ' + num_h_final);
	  // console.log('-->> Piezas encajadas en el marco = ' + count_pieces);
	  // console.log('-->> Piezas sobrantes = ' + retal_pieces);
	  
	  // Dimensiones del bloque obtenido.
	  let t_w = num_w * p_width;
	  let t_h = num_h_final * p_height;
	  /*
	  // Si se sobrepasara alguna de las dimensiones de la zona
	  // entonces se va a considerar el resultado de "una pieza".
	  if ((t_w > blockWidth && num_w > 1) || (t_h > blockHeight  && num_h > 1)) {
		
		console.log('-> Sobrepasadas dimensiones de zona.');
		
		num_w = 1;
		num_h = 1;
		t_w = p_width;
		t_h = p_height;
		retal_pieces = numIn - 1;
	  } // */
	  /*
	  if (t_w > blockWidth && num_w > 1) {
		
		// console.log('-> Sobrepasadas dimensiones del ancho de zona.');
		console.log('t_w = ' + t_w + ' ;s_w = ' +  blockWidth );
		// Se quita una columna para reducir el ancho del bloque.
		num_w -= 1;
		
		if (num_w <= 0) {
			console.log('-> Cero w.');
			num_w = 1;
			retal_pieces = numIn - 1;
		} else {
			// Se aumenta el número de piezas que han sobrado igual
			// a las piezas que hay en la columna que hemos quitado.
			retal_pieces += num_h;
		}
		
		t_w = num_w * p_width;
		
	  }
	  
	  if (t_h > blockHeight && num_h > 1) {
		
		// console.log('-> Sobrepasadas dimensiones del alto de zona.');
		console.log('t_h = ' + t_h + ' ;s_h = ' +  blockHeight );
		// Se quita una fila para reducir el alto del bloque.
		num_h -= 1;
		
		if (num_h <= 0) {
			console.log('-> Cero h.');
			num_h = 1;
			retal_pieces = numIn - 1;
		} else {
			// Se aumenta el número de piezas que han sobrado igual
			// a las piezas que hay en la fila que hemos quitado.
			retal_pieces += num_w;
		}
		
		t_h = num_h * p_height;
		
	  } // */
	  // ---------
	  
	  let result = { draw_w: num_w,
		   draw_h: num_h_final, 
		   retal: retal_pieces, 
		   t_w: t_w, 
		   t_h: t_h,
		   area: (t_w * t_h) / 1000000
  		 };
  		 
  	  // console.log('-->> blockDimension result = ');
  	  // console.log(result);
	  
	  return result;
    
  } // End function blockDimension.
  
  // Función que recoloca las hileras de la matriz que describe las dimensiones en
  // piezas del bloque para que quepa en el retal. Si tiene que quitar piezas, entonces
  // forma y añade un nuevo bloque al listado general de piezas de la optimización.
  templateMatrixPiece(
	pi: any, 
	retalWidth: number, 
	retalHeight: number,
	maxDiecuttingIn: number,
	minDiecuttingIn: number
	): any {
    // console.log('-->> templateMatrixPiece in retal: ' + retalWidth + ' x ' + retalHeight);
    // console.log(pi);
    
    // Albergará la posible "pieza marco" sobrante de la pieza de entrada.
    let new_master_piece = null;
    
    let num_pieces = 0;
    
   	if (pi.piece_set && pi.piece_set.length > 0) {
		
		num_pieces = pi.piece_set.length + 1
		
		// Ya se puede vaciar la matrix porque se rellenará nuevamente.
		pi.piece_matrix = [];
      
      let dim_result_A = this.blockDimension(
         pi.piece_width,
         pi.piece_height,
         num_pieces,
         retalWidth,
         retalHeight,
		 maxDiecuttingIn,
		 minDiecuttingIn
      );
      
      let dim_result_B = this.blockDimension(
         pi.piece_height,
         pi.piece_width,
         num_pieces,
         retalWidth,
         retalHeight,
		 maxDiecuttingIn,
		 minDiecuttingIn
       );
      
      // ---------------
      /*
      if (pi.piece_num === 8 && retalWidth === 1346) {
		console.log('-->> templateMatrixPiece pieza = ');
      	console.log(pi.piece_num);
      	console.log(retalWidth);
      	console.log(retalHeight);
		console.log('-->> templateMatrixPiece dim_result_A = ');
      	console.log(dim_result_A);
      	console.log('-->> templateMatrixPiece dim_result_B = ');
      	console.log(dim_result_B);
	  } //  */

      let w_aux = pi.piece_width;
      let h_aux = pi.piece_height;
 /*     
      // Se va a escoger la opción que abarca más area.
      if (dim_result_A.area > dim_result_B.area) {
        console.log('-->> templateMatrixPiece dim_result_A es mayor.');
        pi.draw_w = dim_result_A.draw_w;
      	pi.draw_h = dim_result_A.draw_h;
      	
      	// console.log('-->> templateMatrixPiece dim_result_A pi = ');
      	// console.log(pi);
      	
      } else if (dim_result_B.area > dim_result_A.area) {
        console.log('-->> templateMatrixPiece dim_result_B es mayor.');
        // Si se elige la versión B entonces invertimos las dimensiones de la pieza.
		pi.piece_width = h_aux;
		pi.piece_height = w_aux;
		pi.piece_rotation = (pi.piece_rotation === 90 || pi.piece_rotation === 270 ? 0 : 90);
        pi.draw_w = dim_result_B.draw_w;
      	pi.draw_h = dim_result_B.draw_h;
      	
      	// console.log('-->> templateMatrixPiece dim_result_B pi = ');
      	// console.log(pi);
      	
      } else { // Las áreas son igules.
      	console.log('-->> templateMatrixPiece dim_result_A y dim_result_B son iguales. Tienen el mismo número de piezas.');
*/
			// Se escoge la versión que es menos ancha (dejará una cola más grande).
			// console.log('	pi.piece_width = ' + pi.piece_width);
            // console.log('	pi.piece_height = ' + pi.piece_height);
            // console.log('	retalHeight = ' + retalHeight);
            // console.log('	dim_result_B.draw_h = ' + dim_result_B.draw_h);
            
            // Se va a dar prioridad si hay un resultado donde no sobran piezas.
            if (dim_result_B.retal < dim_result_A.retal && dim_result_B.retal === 0) {
				
				// console.log('-->> templateMatrixPiece resultado B con menos sobrantes = ' + dim_result_B.retal);
				pi.piece_width = h_aux;
		    	pi.piece_height = w_aux;
		    	pi.piece_rotation = (pi.piece_rotation === 90 || pi.piece_rotation === 270 ? 0 : 90);		
				pi.draw_w = dim_result_B.draw_w;
			    pi.draw_h = dim_result_B.draw_h;
			     
			} else if (dim_result_A.retal < dim_result_B.retal && dim_result_A.retal === 0) {
				
				// console.log('-->> templateMatrixPiece resultado A con menos sobrantes = ' + dim_result_A.retal);
				pi.draw_w = dim_result_A.draw_w;
			    pi.draw_h = dim_result_A.draw_h;
			    
			} else { // En ambos casos sobran las mismas piezas internas.
			
				// console.log('-->> templateMatrixPiece resultados con mismo número de sobrantes = ' + dim_result_B.retal);

	            if (dim_result_B.t_w < dim_result_A.t_w ) {
	                // console.log('-->> templateMatrixPiece dim_result_B es menos ancha.');
	                
	                // NOTA: Escoge la más ancha si con ello puede caber de algún modo la
					// siguiente pieza candidata, que podría ser una de sus piezas "sobrantes".
					
					// Sólo se considera alterar la posición del bloque si tiene aún piezas aún sin poner
	                // y girándolo podría dar posibilidad de seguir colocando después otras de sus piezas.
	                if (dim_result_A.retal > 0) {
						
						// Si caben piezas sobrantes en el retal sobrante de su lado.
	            		if ((retalWidth - (pi.piece_height * dim_result_A.draw_h) > pi.piece_height &&
	            		  !(retalWidth - (pi.piece_width * dim_result_B.draw_h) > pi.piece_height)) || 
	            		  ((retalWidth - (pi.piece_height * dim_result_A.draw_h) > pi.piece_width) &&
	            		  !(retalWidth - (pi.piece_width * dim_result_B.draw_h) > pi.piece_width))
	                	) {
							// Si se elige la versión B, entonces invertimos las dimensiones de la pieza.
			    			pi.piece_width = h_aux;
			    			pi.piece_height = w_aux;
			    			pi.piece_rotation = (pi.piece_rotation === 90 || pi.piece_rotation === 270 ? 0 : 90);
			                pi.draw_w = dim_result_B.draw_w;
			              	pi.draw_h = dim_result_B.draw_h;
						
						} else {
							// Si caben piezas sobrantes en el retal sobrante de abajo.
							if ((retalHeight - (pi.piece_height * dim_result_A.draw_h) > pi.piece_height &&
		            		  !(retalHeight - (pi.piece_width * dim_result_B.draw_h) > pi.piece_height)) || 
		            		  ((retalHeight - (pi.piece_height * dim_result_A.draw_h) > pi.piece_width) &&
		            		  !(retalHeight - (pi.piece_width * dim_result_B.draw_h) > pi.piece_width))
		                	) {
								// console.log('-->> Pero dim_result_A permite meter luego piezas sobrantes y dim_result_B no.');
			                	pi.draw_w = dim_result_A.draw_w;
			              		pi.draw_h = dim_result_A.draw_h;
		              		} else {
								// Si se elige la versión B, entonces invertimos las dimensiones de la pieza.
				    			pi.piece_width = h_aux;
				    			pi.piece_height = w_aux;
				    			pi.piece_rotation = (pi.piece_rotation === 90 || pi.piece_rotation === 270 ? 0 : 90);
				                pi.draw_w = dim_result_B.draw_w;
				              	pi.draw_h = dim_result_B.draw_h;
							}
						}
						
					} else {
						
						// console.log('-->> templateMatrixPiece dim_result_B es menos ancha directamente.');
						
						// Si no había piezas internas sobrantes se escoje el resultado B que es el menos ancho.
						pi.piece_width = h_aux;
		    			pi.piece_height = w_aux;
		    			pi.piece_rotation = (pi.piece_rotation === 90 || pi.piece_rotation === 270 ? 0 : 90);
		    			pi.draw_w = dim_result_B.draw_w;
			            pi.draw_h = dim_result_B.draw_h;
						
					} // End If dim_result_A.retal
	              	
	            } else {
	                // console.log('-->> templateMatrixPiece dim_result_A es menos ancha o igual.');
	                // Sólo se considera alterar la posición del bloque si tiene aún piezas sin poner
	                // y girándolo podría dar posibilidad de seguir colocando después otras de sus piezas.
	                if (dim_result_B.retal > 0) {
		              	// Si caben piezas sobrantes en el retal sobrante de su lado.
		        		if ((retalWidth - (pi.piece_height * dim_result_B.draw_h) > pi.piece_height &&
		        		  !(retalWidth - (pi.piece_width * dim_result_A.draw_h) > pi.piece_height)) || 
		        		  ((retalWidth - (pi.piece_height * dim_result_B.draw_h) > pi.piece_width) &&
		        		  !(retalWidth - (pi.piece_width * dim_result_A.draw_h) > pi.piece_width))
		            	) {
							pi.draw_w = dim_result_A.draw_w;
			              	pi.draw_h = dim_result_A.draw_h;
			            
						} else {
							// Si caben piezas sobrantes en el retal sobrante de abajo.
							if ((retalHeight - (pi.piece_height * dim_result_B.draw_h) > pi.piece_height &&
		            		  !(retalHeight - (pi.piece_width * dim_result_A.draw_h) > pi.piece_height)) || 
		            		  ((retalHeight - (pi.piece_height * dim_result_B.draw_h) > pi.piece_width) &&
		            		  !(retalHeight - (pi.piece_width * dim_result_A.draw_h) > pi.piece_width))
		                	) {
								// Si se elige la versión B, entonces invertimos las dimensiones de la pieza.
				    			pi.piece_width = h_aux;
				    			pi.piece_height = w_aux;
				    			pi.piece_rotation = (pi.piece_rotation === 90 || pi.piece_rotation === 270 ? 0 : 90);
				                pi.draw_w = dim_result_B.draw_w;
				              	pi.draw_h = dim_result_B.draw_h;
								
		              		} else {
								// console.log('-->> Pero dim_result_A permite meter luego piezas sobrantes y dim_result_B no.');
			                	pi.draw_w = dim_result_A.draw_w;
			              		pi.draw_h = dim_result_A.draw_h;
							}
						}
					} else {
						
						// console.log('-->> templateMatrixPiece dim_result_A es menos ancha directamente.');
						
						// Si no había piezas internas sobrantes se escoje el resultado A que es el menos ancho.
						pi.draw_w = dim_result_A.draw_w;
			            pi.draw_h = dim_result_A.draw_h;
						
					} // End If dim_result_B.retal
	            } // */ // End Else tw.
	        } // End Else sobran las mismas piezas internas.
		
      	
      // } // End Else area.
      
      // ---------------
      
      // Colocación interna de las piezas en el "marco" --------------------------------
      let matriz_pieces = [];
	  let count_piece = 0;
	  
        for (let ww = 0; ww < pi.draw_w; ww++) {
          
          matriz_pieces[ww] = [];
          
          for (let hh = 0; hh < pi.draw_h; hh++) {
        	if (hh === 0 && ww === 0) {
            	matriz_pieces[ww][hh] = JSON.parse(JSON.stringify(pi));
            } else {
				
              	matriz_pieces[ww][hh] = JSON.parse(JSON.stringify(pi.piece_set[count_piece]));
              	matriz_pieces[ww][hh].piece_rotation = pi.piece_rotation;
              	matriz_pieces[ww][hh].piece_width = pi.piece_width;
              	matriz_pieces[ww][hh].piece_height = pi.piece_height;
              	
              	count_piece++;
            }
          }
        }
        if (matriz_pieces && matriz_pieces[0] && matriz_pieces[0][0])
        	matriz_pieces[0][0].piece_set = null;
        
        let addon_pieces = [];
        // console.log('-->> templateMatrixPiece addon_pieces = ' + count_piece);
        // console.log('-->> pi.piece_set.length = ' + pi.piece_set.length);
        
        // Con las piezas sobrantes hay que crear una nueva "pieza maestra".
       	for (let j = count_piece; j < pi.piece_set.length; j++) {
			
			// console.log('-->> Añadiendo pieza sobrante al piece_set:');
        	// console.log(pi.piece_set[j]);

        	addon_pieces.push(JSON.parse(JSON.stringify(pi.piece_set[j])));	
		}
        
        // La nueva "pieza marco" que se va a añadir al listado de piezas candidatas para cortar.
        // Dentro de su "piece_set" deberá tener todas las piezas sobrantes sin contarse a ella misma.
        
        // console.log('-->> addon_pieces:');
        // console.log(addon_pieces);
        
        // Si han quedado piezas sobrantes fuera del bloque.
        if (addon_pieces.length > 0) {
          let addon = addon_pieces.shift();
          
          // La pieza marco será la primera sobrante.
          new_master_piece = JSON.parse(JSON.stringify(addon));
          // El resto de piezas si las hubiese formarían su campo "piece_set".
          new_master_piece.piece_set = addon_pieces;
          
          new_master_piece.draw_w = null;
          new_master_piece.draw_h = null;
          
        }
        
        // Ahora se rellena la matriz de elementos internos y se deja
		// el piece_set como haya quedado (no se pone a null).
        // pi.piece_set = null;
        pi.piece_matrix = matriz_pieces; //[0][0]; // matriz_pieces[0][0].piece_matrix;
        pi.draw_w = matriz_pieces.length;
        pi.draw_h = matriz_pieces[0].length;
        
        // console.log('-->> templateMatrixPiece: pi = ');
        // console.log(pi);
        
    } // End IF piece_set.
    
    // console.log('-->> templateMatrixPiece: new_master_piece = ');
    // console.log(new_master_piece);

	return new_master_piece;
	
  } // End function templateMatrixPiece.
  
  //--------------------	FIN BLOQUES

} // End class OptiFunction
